import React, { useState, useEffect, useRef, use } from "react";
import { message, Modal, Form, Drawer, Row, Col, Collapse, Table, Button, DatePicker, Tag, Card, Input, Radio, Checkbox, Spin } from "antd";
import { ExclamationCircleOutlined, ArrowLeftOutlined, ClockCircleOutlined, PrinterOutlined, CalendarOutlined, CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { clock, timeStamp, timeValidator, currentDay, dateValidator } from "../../../utility/clock";
import { useHistory } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { v4 as uuidv4 } from "uuid";
import useDebounce from "../../../lib/hooks/useDebounce";
import DefaultProductImage from "../../../assets/images/default-product.webp";
import db from "../../../database";
import Axios from "axios";
import { debounce, set } from "lodash";
import { getOAuthHeaders } from "../../../constants/oAuthValidation";
import moment from "moment";
import { SyncData } from "../Restaurant/Tables-Management/SyncData";
import { useEventBus } from "../../../lib/hooks/EventBusProvider";

// OMS Orders Modal Imports //
import NewWhite from "../../../assets/images/pending.svg";
import PreparingWhite from "../../../assets/images/parkedOrder.svg";
import ReadyWhite from "../../../assets/images/completed.svg";
import CompletedWhite from "../../../assets/images/prepared.svg";
import New from "../../../assets/images/new.svg";
import Preparing from "../../../assets/images/preparing.svg";
import Ready from "../../../assets/images/ready.svg";
import Completed from "../../../assets/images/todayOrders.svg";
import _ from "lodash";
import CoreModals from "./coreModals";
import ReturnBill from "./returnBill";
import { CheckoutTotalManualDiscount } from "./PricingRules/CheckoutTotalManualDiscount";
import { CheckoutFlatDiscount } from "./PricingRules/CheckoutFlatDiscount";
import { CheckoutPercentageDiscount } from "./PricingRules/CheckoutPercentageDiscount";
import { createCustomer, getCustomer, updateCustomer } from "./customer";
import { pricingRuleController } from "./PricingRules/pricingRuleController";
import { barcodeScaner } from "./scaner";
import { TotalBillDiscount } from "./PricingRules/totalBillDiscount";
import { TotalBillFreeProductDiscount } from "./PricingRules/totalBillFreeProductDiscount";
import { paymentProcess } from "./payment/paymentProcess";
import { addProductToCart } from "./cart";
import { useTranslation } from "react-i18next";
import { addAmount, completePayment } from "./payment/paymentController";
import { stock } from "./stock";
import PoleDisplay from "../../../lib/printer/poleDisplay";
import PrintController from "../../../lib/printer/printController";
import upsertPOSLog from "../Retail/posLog";
import PointOfSuperMarketModals from "../Retail/SuperMarket/SuperMarketModal";
import NotFoundImg from "../../../assets/images/NotFoundImg.svg";
import CWPoleDisplay from "../../../lib/printer/CWPoleDisplay";
import { numberToWords } from "../../../utility/numberToWords";
import styles from "../../../constants/styles.json";
import { getWorkflowData } from "../../../utility/getWorkflowData";
import Close from "../../../assets/images/close-x.svg";
import TextArea from "antd/lib/input/TextArea";
import Keyboard from "react-simple-keyboard";
import {
  checkGiftCard,
  confirmPOSLayawayOrder1,
  discardCouponService,
  generateGiftVoucher,
  getNewOmsOrder,
  orderHistoryService,
  posConfigService,
  posOrderProcessor1,
  RFIDTag,
  salesHistoryService,
  updateOmsOrder,
  upsertGiftCardTransaction,
  upsertLoyaltyTransaction,
  upsertPOSLogService,
  verifyCouponsService,
  verifyGiftCardService,
  upsertSupplierPayment,
  getCustomerWallet,
  externalCoupon,
  upsertCart,
  upsertStoreDiscount,
  discardGiftCard,
  getStockForProductService,
  verifyReturn,
  upsertFinFundsTransfer,
  upsertWalletTransactionService,
  syncSingleProductByValue,
  getEInvoiceDetails,
  getEInvoiceURLs,
} from "../../../services";
import MenuLayout from "../Restaurant/MenuLayout";
import { WarningOutlined } from "@ant-design/icons";
import messages from "../../../errors/messages.en-IN.json";
import { getApplicablePrice } from "../../../utility/getPriceList";
import { getB2BCustomers, validateGSTNumber, validatePANNo } from "../../../services/index";

function roundTo(value, decimals = 2) {
  return Number(Math.round(Number(value + "e" + decimals)) + "e-" + decimals);
}

// PointOfsaleCore Component Start
const PointOfsaleCore = (props) => {
  const { t } = useTranslation();
  const serverUrl = process.env.REACT_APP_serverUrl;
  const edcUrl = process.env.REACT_APP_edcUrl;
  const RenderComponent = props.component;
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController);
  const tillLayout = parseInt(tillaccess?.layout === null || undefined ? 1 : tillaccess?.layout);
  const precision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2;
  const tokens = JSON.parse(localStorage.getItem("tokens"));
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const receiptlessReturn2Enabled = posConfig?.enableReceiptlessReturn2 === "Y";
  const defaultCustomer = tillData.tillAccess.csBunit.b2cCustomer;
  const tillDocumentSequence = parseFloat(localStorage.getItem("documentSequence"));
  const isPrintModeXML = tillData.tillAccess.cwrTill.hardwareController.printReceipt === "Y" ? true : false;
  const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData")) || {};
  let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
  const ObFlag = tillData.tillAccess.cwrTill.printTemplate.obController === "Y" ? true : false;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;
  const tillDataPaymentMethods = tillData.tillAccess.csBunit.paymentMethodList;
  const [saleTypeProducts, setSaleTypeProducts] = useState([]);
  const [showProducts, setShowProducts] = useState(false);
  const [couponVerificationData, setCouponVerificationData] = useState(null);
  const [discountVerificationData, setDiscountVerifictionData] = useState(null);
  const [showCustomerWallet, setShowCustomerWallet] = useState(false);
  const [customersData, setCustomersData] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const [showCouponOtpPopup, setShowCouponOtpPopup] = useState(false);
  const [couponOtp, setCouponOtp] = useState(Array(6).fill(""));
  const [couponOtpError, setCouponOtpError] = useState(false);
  const [couponResendTimer, setCouponResendTimer] = useState(0);
  const [couponCanResend, setCouponCanResend] = useState(true);
  const [verificationCouponStatus, setVerificationCouponStatus] = useState(false);
  const { RangePicker } = DatePicker;
  const dateRef = useRef(null);
  let notesInputRef = useRef();
  const returnProcessRef = useRef();
  const authHeaders = getOAuthHeaders();
  const history = useHistory();
  const qs = require("querystring");
  const tillValue = JSON.parse(localStorage.getItem("tillValue"));
  const { dispatchEvent, discountApproval, dispatchItemSelection, dispatchQRCodeEvent, closeQRCodeModal, dispatchWeight } = useEventBus();
  // let setAuthTokens;
  const paymentModalInputRef = useRef();
  const customerSearchInputRef = useRef();
  const quantityInputRef = useRef();
  const metaDataRef = useRef([]);
  const redeemNumberRef = useRef(null);
  const loyaltyInputRef = useRef(null);
  const setDefaultImage = (e) => {
    e.target.src = DefaultProductImage;
  };
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const [tillLink, setTillLink] = useState(false);
  const [currencyType, setCurrencyType] = useState({
    currSymbolLeft: "₹",
    currSymbolRight: "",
    stdPrecision: 2,
  });
  const enableMultiPrintTemplates = tillData?.tillAccess?.cwrTill?.enableMultiPrintTemplates === "Y";

  // CLOCK BLOCK START
  const [displayClock, setDisplayClock] = useState(clock());
  useEffect(async () => {
    const timerId = setInterval(() => setDisplayClock(clock()), 1000);
    return () => {
      clearTimeout(timerId);
    };
  }, []);
  // CLOCK BLOCK END

  // KeyBord changes start
  const [orderHistoryInput, setOrderHistoryInput] = useState("");
  const [keyboardType, setKeyboardType] = useState({
    product: false,
    parkedBill: false,
    salesHistoryDoc: false,
    salesHistoryCus: false,
    searchCus: false,
    productSearch: false,
    giftCardSearch: false,
    addCustomer: false,
  });
  const [layout, setLayout] = useState("default");
  const [loading, setLoading] = useState(false);
  const [inputName, setInputName] = useState("");
  const [inputFocused, setInputFocused] = useState(null);
  const [filterDrawer, setFilterDrawer] = useState(false);
  const [filtersFlag, setFiltersFlag] = useState(false);
  const [filteredDate, setFilterdDate] = useState(null);
  const [searchHistoryInput, setSearchhistoryInput] = useState("");
  const keyboardProduct = useRef(null);
  const keyboardParkbill = useRef(null);
  const keyboardRef = useRef(null);
  const orderHistorySearchInputRef = useRef(null);
  const [notesValue, setNotesValue] = useState("");
  const [exchangeNotesValue, setExchangeNotesValue] = useState("");
  const [activeCartTable, setActiveCartTable] = useState("");
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedProductForNotes, setSelectedProductForNotes] = useState(null);
  const [open, setOpen] = useState(false);
  const productSearchInputRef = useRef(null);
  const giftCardRef = useRef(null);
  const salesRepRef = useRef(null);
  const [layoutName, setLayoutName] = useState("default");
  const [searchTerm, setSearchTerm] = useState("");
  const [salesRepValue, setSalesRepValue] = useState("");
  const [productStock, setProductStock] = useState(false);
  const [productBOMStock, setProductBOMStock] = useState(false);
  const [productBOMStockData, setProductBOMStockData] = useState([]);
  const [currenciesData, setCurrenciesData] = useState(tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => b.value - a.value) || []);
  const [selectedDocumentType, setSelectedDocumentType] = useState("Invoice");
  const [showDocumentPopup, setShowDocumentPopup] = useState(false);
  const [currentInput, setCurrentInput] = useState(null);
  const [tableCards, setTableCards] = useState([]);
  const [inputValues, setInputValues] = useState({
    name: "",
    lastName: "",
    email: "",
    mobile: "",
    pincode: "",
    street: "",
    city: "",
    pincode1: "",
    taxID: "",
    cardNumber: "",
  });
  const [keyboardInputFields, setKeyboardInputFields] = useState({});
  const printerURL = tillData?.tillAccess?.cwrTill?.hardwareController?.imageUrl;

  const refs = {
    name: useRef(null),
    lastName: useRef(null),
    email: useRef(null),
    mobile: useRef(null),
    pincode: useRef(null),
    street: useRef(null),
    city: useRef(null),
    pincode1: useRef(null),
    taxID: useRef(null),
    cardNumber: useRef(null),
  };

  const keyboard = useRef(null);
  const [keyValue, setKeyValue] = useState("0");
  const [isCardPaymentLoading, setIsCardPaymentLoading] = useState(false);
  const [cardPaymnetError, setCardPaymnetError] = useState(false);
  const [cardPaymnetStatus, setCardPaymnetStatus] = useState(false);
  const [metaData, setMetaData] = useState([]);
  const [saleType, setSaleType] = useState("");
  const [showCustomMix, setShowCustomMix] = useState(false);
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
  const [additionalInfo, setAdditionalInfo] = useState([]);
  const [discountAdditionalInfo, setDiscountAdditionalInfo] = useState([]);
  const [showCouponApproval, setShowCouponApproval] = useState(false);
  const [couponApprovals, setCouponApprovals] = useState([]);
  const [totalBillDiscountData, setTotalBillDiscountData] = useState({});
  const [options, setOptions] = useState([]);
  const searchInputRef = useRef(null);
  const [activeInput, setActiveInput] = useState("search");
  const qtyInputRef = useRef(null);
  const [showCompleteSaleStock, setShowCompleteSaleStock] = useState(false);
  const [completeSaleStockData, setCompleteSaleStockData] = useState([]);
  const tillSession = JSON.parse(localStorage.getItem("tillSession"));
  const [syncLoad, setSyncLoad] = useState(false);
  const [selectedItemsModalOpen, setSelectedItemsModalOpen] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [cardPaymnetStatusPLB, setCardPaymnetStatusPLB] = useState(false);
  const [showCardPaymnteModal, setShowCardPaymnteModal] = useState(false);
  const [callCenterVisible, setCallCenterVisible] = useState(false);
  const [isCallCenterFlow, setIsCallCenterFlow] = useState(false);
  const [showCallCenterPage, setShowCallCenterPage] = useState(false);
  const [guestForm] = Form.useForm();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [holdQueue, setHoldQueue] = useState(() => {
    const saved = localStorage.getItem("callCenterHoldQueue");
    return saved ? JSON.parse(saved) : [];
  });
  const [copyKOTVisible, setCopyKOTVisible] = useState(false);
  const [groupedFiredItems, setGroupedFiredItems] = useState({});
  const [selectedCopyItems, setSelectedCopyItems] = useState({});
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [totalBillCouponData, setTotalBillCouponData] = useState({});
  const couponInputRef = useRef(null);
  const previousTcsRef = useRef(0);
  const [integratedPaymentStatus, setIntegratedPaymentStatus] = useState({
    status: "",
    message: "",
    txnId: "",
    paymentMode: "",
    amount: "",
  });
  const [isParkedBill, setIsparkedBill] = useState(false);
  const customerConfig = JSON.parse(localStorage.getItem("customerConfigs"));
  // const activeConfig = customerConfig.find((cfg) => cfg.isactive === "Y");
  // const customerConfigData = activeConfig ? JSON.parse(activeConfig.configuration) : {};
  const customerConfigData = customerConfig ? JSON.parse(customerConfig[0]?.configuration) : {};
  const retailCustomerTabs = customerConfigData?.tabs || [];
  const retailCustomerFields = customerConfigData?.fields || [];
  const retailCustomerGroups = customerConfigData?.fieldGroups || [];
  const retailCustomerRules = customerConfigData?.conditionalRules || [];
  const retailCustomerb2bSettings = customerConfigData?.b2bSettings || [];
  const retailCustomerApiDataSources = customerConfigData?.apiDataSources || [];
  const retailCustomerOperationalSettings = customerConfigData?.operationalSettings || [];
  // console.log("customerConfigData ------------>", customerConfigData);

  const [activeTab, setActiveTab] = useState(retailCustomerTabs ? retailCustomerTabs[0]?.id : "");
  const [activeTabName, setActiveTabName] = useState("");
  const [isB2BEnabled, setIsB2BEnabled] = useState(false);
  const [formDataCache, setFormDataCache] = useState({});
  const [expandedGroups, setExpandedGroups] = useState({});
  const [switchToggle, setSwitchToggle] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [viewCustomerValues, setViewCustomerValues] = useState({});
  const [isSubmittingCustomer, setIsSubmittingCustomer] = useState(false);
  const [isCustomerDrawerOpen, setIsCustomerDrawerOpen] = useState(false);
  const [customerSearchTrigger, setCustomerSearchTrigger] = useState("normal");
  const [lastSearchedValue, setLastSearchedValue] = useState("");
  const [selectedB2BCustomer, setSelectedB2BCustomer] = useState(null);
  const [customerForm] = Form.useForm();
  const [isPanCustomer, setIsPanCustomer] = useState(false);
  const [panCustomerInfo, setPanCustomerInfo] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [isPanUpdateMode, setIsPanUpdateMode] = useState(false);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  const [isCreditSale, setIsCreditSale] = useState(false);
  // Print Template Selection Modal State
  const [showPrintTemplateModal, setShowPrintTemplateModal] = useState(false);
  const [selectedPrintTemplate, setSelectedPrintTemplate] = useState(null);
  const [pendingOrderParam, setPendingOrderParam] = useState(null);
  const [pendingDocumentNo, setPendingDocumentNo] = useState(null);
  const [pendingIsSynced, setPendingIsSynced] = useState(null);
  const [isPendingDirectApproved, setIsPendingDirectApproved] = useState(false);
  const [isPendingSyncOrder, setIsPendingSyncOrder] = useState(false);
  const printTemplates = tillData?.tillAccess?.cwrTill?.printTemplates ? JSON.parse(tillData?.tillAccess?.cwrTill?.printTemplates) : [];
  const [pendingRefundCustomer, setPendingRefundCustomer] = useState(null);
  const [isRefundCustomerEdit, setIsRefundCustomerEdit] = useState(false);
  const [selectedReturnOrder, setSelectedReturnOrder] = useState({});
  const [dataSource, setDataSource] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [retrunSearchType, setReturnSearchType] = useState("orderNo");
  const [showReturnPurchase, setShowReturnPurchase] = useState(false);
  const [showReturnOptions, setShowReturnOptions] = useState(false);
  const [isPurchaseReturn, setIsPurchaseReturn] = useState(false);
  const [selectedReturnType, setSelectedReturnType] = useState(() => {
    const value = localStorage.getItem("selectedReturnType");
    return value && value !== "null" ? value : null;
  });
  const [exchangeCart, setExchangeCart] = useState(JSON.parse(localStorage.getItem("exchangeCartObj")) || {});
  const returnThisReceipt = localStorage.getItem("returnThisReceipt");
  const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE" && !returnThisReceipt;
  const [notesPopup, setNotesPopup] = useState(false);
  const [rejectQuotation, setRejectQuotation] = useState(false);
  const [modalEditState, setModalEditState] = useState(false);
  const [isNriBilling, setIsNriBilling] = useState(false);
  // const [paymentType, setPaymentType] = useState(tillDataPaymentMethods);
  const [paymentType, setPaymentType] = useState("edc");
  const [panDrawerMode, setPanDrawerMode] = useState(null);
  const [showManualBatchPopup, setShowManualBatchPopup] = useState(false);
  const [manualBatchNo, setManualBatchNo] = useState("");
  const [manualBatchProduct, setManualBatchProduct] = useState(null);
  const [occupiedDataTablesData, setOcupiedTablesData] = useState([]);
  const [tableList, setTableList] = useState([]);
  const [reservedTablesData, setReservedTablesData] = useState([]);
  const [gstInfo, setGstInfo] = useState(null);
  const [exchangeCartTcs, setExchangeCartTcs] = useState(false);
  const [bankTransferContext, setBankTransferContext] = useState("payment");
  const [supplyRegionProceed, setSupplyRegionProceed] = useState(false);
  const [currentCardInput, setCurrentCardInput] = useState("");
  const [currentCashInput, setCurrentCashInput] = useState("");
  const [currentUPIInput, setCurrentUPIInput] = useState("");
  const [dynamicPaymentInput, setDynamicPaymentInput] = useState("");
  const [topupAmount, setTopupAmount] = useState("");
  const [cashTendered, setCashTendered] = useState(0);
  const [isProcessingTopup, setIsProcessingTopup] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [showTopupModal, setShowTopupModal] = useState(false);
  const [showCardAmountInput, setShowCardAmountInput] = useState(false);
  const [cardPaymentForm] = Form.useForm();
  const [walletFlowPending, setWalletFlowPending] = useState(false);
  const [walletFlowData, setWalletFlowData] = useState(null);
  const [showGiftCardTopup, setShowGiftCardTopup] = useState(false);
  const [giftCardTopupAmount, setGiftCardTopupAmount] = useState("");
  const [giftCardTopupPaymentMethod, setGiftCardTopupPaymentMethod] = useState(null);
  const [giftCardTopupCashInput, setGiftCardTopupCashInput] = useState("");
  const [giftCardTopupCardInput, setGiftCardTopupCardInput] = useState("");
  const [giftCardTopupUPIInput, setGiftCardTopupUPIInput] = useState("");
  const [giftCardGenericInput, setGiftCardGenericInput] = useState("");
  const [giftCardNumber, setGiftCardNumber] = useState("");
  const [giftCardPin, setGiftCardPin] = useState("");
  const [giftCardTopupPaymentPage, setGiftCardTopupPaymentPage] = useState(0);
  const [giftCardTopupFocusedField, setGiftCardTopupFocusedField] = useState("topupAmount");
  const [giftCardTopupDenomKeyboard, setGiftCardTopupDenomKeyboard] = useState(false);
  const [giftCardTopupShowCardAmountInput, setGiftCardTopupShowCardAmountInput] = useState(false);
  const [giftCardTopupCardForm] = Form.useForm();
  const [isCheckingBalance, setIsCheckingBalance] = useState(false);
  // const [showOrderCompleteFlag, setShowOrderCompleteFlag] = useState(false);
  const [showIRNModal, setShowIRNModal] = useState(false);
  const [irnStatus, setIrnStatus] = useState("PENDING");
  const [irnNumber, setIrnNumber] = useState("");
  const [irnPdfUrl, setIrnPdfUrl] = useState("");
  const [irnLoading, setIrnLoading] = useState(false);
  const [completedOrderId, setCompletedOrderId] = useState(null);
  const [invoiceProcessing, setInvoiceProcessing] = useState("PENDING");
  const [invoicePrinted, setInvoicePrinted] = useState("PENDING");
  const [irnGenerating, setIrnGenerating] = useState("PENDING");
  const [irnDownloadReady, setIrnDownloadReady] = useState("PENDING");
  const [pendingIRNOrderId, setPendingIRNOrderId] = useState(null);
  const [irnFailureMessage, setIrnFailureMessage] = useState("");
  const debounceRef = useRef(null);
  const enterRef = useRef(false);
  const onAddNotes = () => {
    let updatedCart;
    const activeCart = activeCartTable === "EXCHANGE" ? JSON.parse(localStorage.getItem("exchangeCartObj")) : cart;
    if (selectedProductForNotes !== null && activeCart.items.length > 0) {
      updatedCart = { ...activeCart };
      let index = updatedCart.items.findIndex((res) => res.lineId === selectedProductForNotes.lineId);
      if (index >= 0) {
        updatedCart.items[index].notes = activeCartTable === "EXCHANGE" ? exchangeNotesValue : notesValue;
      }
      if (activeCartTable === "EXCHANGE") {
        setExchangeNotesValue("");
      } else {
        setNotesValue("");
      }
    } else {
      updatedCart = {
        ...activeCart,
        description: activeCartTable === "EXCHANGE" ? exchangeNotesValue : notesValue,
      };
      // setNotesValue()
    }
    setSelectedProductForNotes(null);
    if (activeCartTable === "EXCHANGE") {
      localStorage.setItem("exchangeCartObj", JSON.stringify(updatedCart));
    } else {
      setCart(updatedCart);
      localStorage.setItem("cartObj", JSON.stringify(updatedCart));
    }
    setNotesPopup(false);
    setIsInputFocused(false);
    let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
      ? JSON.parse(localStorage.getItem("orderTimeDetails"))
      : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
    if (updatedCart.items.length === 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === updatedCart.customer.cwrCustomerId) {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
        orderStartTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"), // Update orderStartTime to current time
      };
    } else if (updatedCart.items.length > 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId !== updatedCart.customer.cwrCustomerId) {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
      };
    }
    if (updatedCart.description === "") {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
        orderStartTime: "",
      };
    }
    localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onAddNotes();
    }
  };

  const onChangeInputKeyboard = (event) => {
    const input = event.target.value;

    if (activeCartTable === "EXCHANGE") {
      setExchangeNotesValue(input);
    } else {
      setNotesValue(input);
    }

    if (keyboardRef.current) {
      keyboardRef.current.setInput(input);
    }
  };

  useEffect(() => {
    if (activeTabName === "") {
      setActiveTabName("contact");
    }
  }, [retailCustomerFields]);

  useEffect(() => {
    const notesValueInput = document.getElementById("notes-input");
    if (notesPopup) {
      notesValueInput.focus();
    } else {
      notesValueInput?.blur(); // Remove focus
      setIsInputFocused(false);
    }
  }, [notesPopup]);

  const onChange = (input) => {
    if (input !== "Enter") {
      if (activeCartTable === "EXCHANGE") {
        setExchangeNotesValue(input);
      } else {
        setNotesValue(input);
      }
    }
  };
  const handleShift = () => {
    layoutName === "default" ? setLayoutName("shift") : setLayoutName("default");
  };
  const toCamelCaseMetaData = (str) => {
    return str
      .replace(/[^a-zA-Z0-9 ]/g, "") // remove non-alphanumeric except space
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (index === 0 ? word.toLowerCase() : word.toUpperCase()))
      .replace(/\s+/g, ""); // remove whitespace
  };

  const groupedFields = (() => {
    const grouped = retailCustomerGroups
      .filter((group) => group.tabId === activeTab && group.visible)
      .sort((a, b) => a.order - b.order)
      .map((group) => {
        const fieldsInGroup = retailCustomerFields
          .filter((field) => {
            const isVisible = field.visible;
            const isCurrentTab = field.tabId === activeTab;
            const isBusinessTab = activeTabName.toLowerCase() === "business";
            const allowBusinessFields = !isBusinessTab || (isBusinessTab && isB2BEnabled);
            const isInGroup = field.groupId === group.id;

            return isVisible && isCurrentTab && allowBusinessFields && isInGroup;
          })
          .sort((a, b) => a.order - b.order);

        return {
          groupId: group.id,
          groupName: group.name || "",
          fields: fieldsInGroup,
          collapsible: group.collapsible,
          defaultExpanded: group.defaultExpanded,
          description: group.description,
        };
      });

    // Handle ungrouped fields
    const ungroupedFields = retailCustomerFields
      .filter((field) => {
        const isVisible = field.visible;
        const isCurrentTab = field.tabId === activeTab;
        const isBusinessTab = activeTabName.toLowerCase() === "business";
        const allowBusinessFields = !isBusinessTab || (isBusinessTab && isB2BEnabled);
        const isUngrouped = !field.groupId;

        return isVisible && isCurrentTab && allowBusinessFields && isUngrouped;
      })
      .sort((a, b) => a.order - b.order);

    if (ungroupedFields.length > 0) {
      grouped.unshift({
        groupId: "",
        groupName: "",
        fields: ungroupedFields,
        collapsible: false,
        defaultExpanded: true,
        description: "",
      });
    }

    return grouped.filter((group) => group.fields.length > 0);
  })();

  const normalizeStaticSelectValue = (value, staticJson) => {
    if (!value || !staticJson) return value;

    try {
      const parsed = JSON.parse(staticJson);

      if (parsed[value]) return value;

      const reverseMap = Object.fromEntries(Object.entries(parsed).map(([k, v]) => [v, k]));

      return reverseMap[value] || value;
    } catch {
      return value;
    }
  };

  const convertMetaDataToKeyValue = (customer) => {
    const metaKeyValues = (customer.metaData || []).reduce((acc, { key, value }) => {
      const isGroupKey = /^group_\d+$/i.test(key);
      if (isGroupKey) {
        try {
          const parsedGroup = JSON.parse(value);
          const groupCamelCased = {};

          for (const groupKey in parsedGroup) {
            let fieldValue = parsedGroup[groupKey];
            const camelKey = toCamelCaseMetaData(groupKey);

            // 🔧 Normalize static select fields
            const fieldConfig = groupedFields.flatMap((g) => g.fields).find((f) => toCamelCase(f.name) === camelKey);

            if (fieldConfig?.type === "select" && fieldConfig?.dataSource?.type === "static") {
              fieldValue = normalizeStaticSelectValue(fieldValue, fieldConfig.defaultValue);
            }
            groupCamelCased[toCamelCaseMetaData(groupKey)] = fieldValue;
          }

          acc[key] = groupCamelCased; // Keep original group key as-is (e.g. group_1753247928267)
        } catch (e) {
          console.error("Failed to parse group value:", value);
        }
      } else {
        const camelKey = toCamelCaseMetaData(key);
        let fieldValue = value;

        const fieldConfig = groupedFields.flatMap((g) => g.fields).find((f) => toCamelCase(f.name) === camelKey);

        if (fieldConfig?.type === "select" && fieldConfig?.dataSource?.type === "static") {
          fieldValue = normalizeStaticSelectValue(fieldValue, fieldConfig.defaultValue);
        }

        acc[camelKey] = fieldValue;
        // acc[camelKey] = value;
      }
      return acc;
    }, {});
    return {
      ...metaKeyValues,
      ...customer,
      metaData: [],
    };
  };

  const autoEnablePanCustomer = (formValues) => {
    const panField = groupedFields
      ?.flatMap((g) =>
        g.fields.map((f) => ({
          name: f.name,
          groupId: g.groupId,
        }))
      )
      .find((f) => f.name?.toLowerCase().startsWith("pan"));

    if (!panField) return;

    const key = toCamelCase(panField.name);

    let panValue;

    if (panField.groupId) {
      panValue = formValues?.[String(panField.groupId).toLowerCase()]?.[key];
    } else {
      panValue = formValues?.[key];
    }

    if (panValue && panValue.trim() !== "") {
      setIsPanCustomer(true);
    }
  };

  const autoEnableNriBilling = (formValues) => {
    const nriField = groupedFields
      ?.flatMap((g) =>
        g.fields.map((f) => ({
          name: f.name,
          groupId: g.groupId,
        }))
      )
      .find((f) => {
        const fieldName = f.name?.toLowerCase().replace(/\s+/g, "");
        return fieldName?.startsWith("passport") || fieldName?.startsWith("immigration") || fieldName?.startsWith("visa");
      });

    if (!nriField) return;

    const key = toCamelCase(nriField.name);

    let nriValue;

    if (nriField.groupId) {
      nriValue = formValues?.[String(nriField.groupId).toLowerCase()]?.[key];
    } else {
      nriValue = formValues?.[key];
    }

    if (nriValue && nriValue.trim() !== "") {
      setIsNriBilling(true);
      setIsPanCustomer(false);
    }
  };

  // keep localStorage in sync
  useEffect(() => {
    localStorage.setItem("callCenterHoldQueue", JSON.stringify(holdQueue));
  }, [holdQueue]);
  useEffect(() => {
    const handleKeyDown = (event) => {
      const activeElement = document.activeElement;
      const isInputFocused = activeElement && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA" || activeElement.isContentEditable);

      const isDrawerOrModalOpen = !!document.querySelector(".ant-drawer-open") || !!document.querySelector(".ant-modal-mask") || document.body.classList.contains("ant-modal-open");
      if (!isInputFocused && !isDrawerOrModalOpen && !event.ctrlKey && !event.altKey && !event.metaKey) {
        if (event.key.length === 1 || event.key === "Backspace" || event.key === "Delete" || event.key === "ArrowLeft" || event.key === "ArrowRight") {
          setActiveInput("search");
          if (searchInputRef?.current) {
            searchInputRef?.current?.focus();
          }
        }
      }
    };

    if (activeInput === "search") {
      if (searchInputRef?.current) {
        searchInputRef?.current?.focus();
      }
    } else if (activeInput === "weightPopup") {
      const productSearchInput = document.getElementById("sm-weight-popup-input");
      if (productSearchInput) {
        productSearchInput.focus();
      }
    } else if (activeInput === "qty") {
      qtyInputRef.current?.focus();
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [activeInput]);

  const clearReturnCartData = (record) => {
    if (cart.items.length > 0) {
      Modal.confirm({
        title: "Clear The Cart Items ?",
        icon: <ExclamationCircleOutlined />,
        content: <div>Do you want to clear the bill?</div>,
        okText: "Yes",
        cancelText: "No",
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        onOk() {
          let setAuthTokens;
          setSelectedDocumentType("Invoice");
          let PaymentMethods = getFilteredPaymentMethods() || [];
          let payments =
            PaymentMethods.length > 5
              ? _.sortBy(PaymentMethods, "sequenceNo").slice(
                  0,
                  tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
                )
              : PaymentMethods;

          setShowPayments(payments);
          if (authHeaders && authHeaders.access_token) {
            setAuthTokens = authHeaders.access_token;
          }
          const serverUrl = process.env.REACT_APP_serverUrl;
          if (cart?.couponInput?.length > 0) {
            const couponsData = [...cart.couponInput];

            // Function to discard a coupon
            const discardCoupon = async (coupon) => {
              try {
                const response = await discardCouponService(coupon.couponCode, coupon.referenceId);
              } catch (error) {
                console.error(`Error discarding coupon ${coupon.couponCode}:`, error);
              }
            };

            // Iterate over each coupon code in couponsData and make the API call
            couponsData.forEach((coupon) => {
              discardCoupon(coupon);
            });
          }
          let data = [];
          if (giftCardData.length > 0) {
            let details = [];
            giftCardData.map((ele) => {
              details.push(`{
                  cardNo: ${ele.number ? `"${ele.number}"` : null}
                  type: "TO"
                  referenceNo: "${cart.referenceId}"
                  amount: ${ele.amount * -1}
                  cardPin: ${data.pin ? `"${data.pin}"` : null}
                  tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
                  b2c_Customer_Id: ${cart.customer.cwrCustomerId ? `"${cart.customer.cwrCustomerId}"` : null}
                      }`);
            });
            data = {
              query: `
                  mutation {
                    upsertGiftCardTransaction(giftCardTransactions: [${details}]) {
                      status
                      message
                    }
                  }`,
            };
          }
          upsertGiftCardTransaction(data);
          let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
            ? JSON.parse(localStorage.getItem("orderTimeDetails"))
            : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
          orderTimeDetails = {
            ...orderTimeDetails,
            paymentStartTime: "",
            orderStartTime: "", // Update orderStartTime to current time
          };
          localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
          deleteCart(true, true);
          localStorage.removeItem("exchangeCartObj");
          localStorage.removeItem("selectedReturnType");
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
              setOpen(false);
            }, 500);
          }
        },
        onCancel() {
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
              setOpen(false);
            }, 300);
          }
          // selectParkedBill(record, "management");
        },
      });
    }
  };

  const statesData = JSON.parse(localStorage.getItem("statesData")) || [];
  const getStateId = (stateValue) => {
    if (!stateValue) return "";
    const isId = statesData.some((state) => state.RecordID === stateValue);
    if (isId) return stateValue;
    return statesData.find((state) => state.Name?.toLowerCase().trim() === stateValue.toLowerCase().trim())?.RecordID || "";
  };

  const tillId = tillData.tillAccess?.cwrTill?.cwrTillID;
  const userData = JSON.parse(localStorage.getItem("userData"));
  const documentTypes = [
    { type: "Invoice", isEnabled: true, isVisible: true },
    {
      type: "Advance",
      isVisible: posConfig?.requireCustomerforLayaway === "Y",
      // isVisible: true,
      isEnabled: JSON.parse(localStorage.getItem("saleTypeData"))?.cwrSaletype?.enableLayaway === "Y",
    },
    { type: "Quotation", isEnabled: posConfig?.enableQuotation === "Y", isVisible: posConfig?.enableQuotation === "Y" },
  ];

  useEffect(() => {
    if (productStock) {
      console.log("Product stock is low");
      setProductStock(true);

      // Hide the modal after 1.5 seconds
      const timer = setTimeout(() => {
        setProductStock(false);
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [productStock]);

  const handleKeyPress = (button) => {
    if (button === "{shift}" || button === "{caps}") setLayout("shift");
    if (button === "{default}" || button === "{small}") setLayout("default");
    if (button === "{numbers}") setLayout("numbers");
    if (button === "{number}") setLayout("number");
    if (button === "{done}") {
      switch (true) {
        case keyboardType.parkedBill:
          searchParkedBill();
          break;
        case keyboardType.salesHistoryDoc:
          searchOrderHistory();
        case keyboardType.salesHistoryCus:
          searchOrderHistory();
          break;
        case keyboardType.product:
          // getSearchedProducts();
          break;
        // Add more cases as needed
        default:
          // Handle the default case or do nothing
          break;
      }
    }
  };

  const handleKeyboardInput = (inputs) => {
    if (keyboardType.parkedBill === true) {
      setProductSearchInput("");
      localStorage.removeItem("productName");
      setParkedBillSearchInput(inputs.default);
    } else if (keyboardType.product === true) {
      if (inputs.default === "") {
        clearProductSearchResults();
      } else {
        setProductSearchInput(inputs.default);
      }
    } else if (keyboardType.salesHistoryDoc === true) {
      setOrderHistoryInput(inputs.default);
    } else if (keyboardType.salesHistoryCus === true) {
      setOrderHistoryInput(inputs.default);
    }
  };

  // KeyBord changes End

  // ORDER TYPE BLOCK START
  const [orderType, setOrderType] = useState();
  const [posSaleTypes, setPosSaleTypes] = useState([]);
  const [displaySetOrderType, setDisplayOrderType] = useState(false);
  const changeOrderType = (type) => {
    setDisplayOrderType(false);
    setOrderType(type);
  };

  useEffect(() => {
    const totalRecords = 12;
    let filledCurrencies = currenciesData;
    while (filledCurrencies.length < totalRecords) {
      filledCurrencies.push({ id: `placeholder-${filledCurrencies.length}`, value: 999999 });
    }
    setCurrenciesData(filledCurrencies?.sort((a, b) => b.value - a.value));
    db.posSaletypes.toArray().then((saleType) => {
      setPosSaleTypes([...saleType]);
      const saleIndex = saleType.findIndex((st) => st.cwrSaletype.isdefault === "Y");
      setOrderType(saleType[saleIndex]);
    });
  }, []);
  // ORDER TYPE BLOCK END

  // Cash Management Start
  const [cashAddInFlag, setCashAddInFlag] = useState(false);
  const [cashManagementForm] = Form.useForm();
  // const [cashIn, setCashOut] = useState(true);
  const [cashIn, setCashIn] = useState(true);
  const [cashOut, setCashOut] = useState(false);
  const [pettyCashIn, setPettyCashIn] = useState(false);
  const [pettyCashOut, setPettyCashOut] = useState(false);
  const [bankTransfer, setBankTransfer] = useState(false);
  const [bankTransferDocument, setBankTransferDocument] = useState(null);
  const [uploadingDocs, setUploadingDocs] = useState(false);
  const [financialDocument, setFinancialDocument] = useState(null);
  const [financialDocs, setFinancialDocs] = useState([]);
  const [financialForm] = Form.useForm();
  const [financialDocUploaded, setFinancialDocUploaded] = useState(false);
  const [addCashFlag, setAddCashFlag] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [giftCardFlag, setGiftCardFlag] = useState(false);
  const [isGiftCardFlag, setIsGiftCardFlag] = useState(false);
  const [isWalletFlag, setIswalletFlag] = useState(false);
  const [isNewGiftCardFlag, setIsNewGiftCardFlag] = useState(false);
  const [isCardPaymentFlag, setIsCardPaymentFlag] = useState(false);
  const [isRefundWalletOpen, setIsRefundWalletOpen] = useState(false);
  const [CardPaymentForm] = Form.useForm();
  const [showSaleType, setShowSaleType] = useState(() => (posConfig?.enableSaleType === "Y" ? true : false));
  const [isSaleTypeFlag, setIsSaleTypeFlag] = useState(false);
  const [selectedSaleType, setSelectedSaleType] = useState(() => {
    if (localStorage.getItem("saleTypeData") !== null) {
      const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData"));
      return saleTypeData?.cwrSaletype?.name;
    } else {
      return "";
    }
  });
  const [selectedSaleTypeData, setSelectedSaleTypeData] = useState(() => {
    if (localStorage.getItem("saleTypeData") !== null) {
      const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData"));
      return saleTypeData;
    } else {
      return "";
    }
  });
  const [isRevenueCategoryFlag, setIsRevenueCategoryFlag] = useState(false);
  const [selectedRevenueCategoryName, setSelectedRevenueCategoryName] = useState(() => {
    if (localStorage.getItem("selectedRevenueCategory") !== null) {
      const revenueCategoryData = JSON.parse(localStorage.getItem("selectedRevenueCategory"));
      return revenueCategoryData?.name;
    } else {
      return "";
    }
  });
  const [splitCarts, setSplitCarts] = useState([]);
  const [showAddonsCustomizePopup, setShowAddonsCustomizePopUp] = useState(false);
  const [addonSourceItem, setAddonSourceItem] = useState(null);
  const [addonRepeatDisabled, setAddonRepeatDisabled] = useState(false);
  const [isBankTransferOpen, setIsBankTransferOpen] = useState(false);
  const [selectedInvoiceAddress, setSelectedInvoiceAddress] = useState(null);
  const [selectedDeliveryAddress, setSelectedDeliveryAddress] = useState(null);
  //Additional Charges
  // const [additionalCharges, setAdditionalCharges] = useState(false);
  // const [serviceChargeEnabled, setServiceChargeEnabled] = useState(false);
  // const [serviceChargePercentage, setServiceChargePercentage] = useState(5);
  // const [tipMode, setTipMode] = useState("Percentage");
  // const [tipPercentage, setTipPercentage] = useState(0);
  // const [tipAmount, setTipAmount] = useState(0);
  // const [deliveryCharge, setDeliveryCharge] = useState(0);
  // const [packingCharge, setPackingCharge] = useState(0);
  // const [roundingOption, setRoundingOption] = useState("No Rounding");
  // const [serviceChargeAmount, setServiceChargeAmount] = useState(() => {
  //   const localCart = JSON.parse(localStorage.getItem("cartObj"));
  //   if (localCart) {
  //     if (localCart?.serviceCharge) {
  //       return localCart?.serviceCharge;
  //     } else {
  //       return 0;
  //     }
  //   } else {
  //     return 0;
  //   }
  // });
  // const [tipTotal, setTipTotal] = useState(() => {
  //   const localCart = JSON.parse(localStorage.getItem("cartObj"));
  //   if (localCart) {
  //     if (localCart?.tip) {
  //       return localCart?.tip;
  //     } else {
  //       return 0;
  //     }
  //   } else {
  //     return 0;
  //   }
  // });
  // const [deliveryChargeAmount, setDeliveryChargeAmount] = useState(() => {
  //   const localCart = JSON.parse(localStorage.getItem("cartObj"));
  //   if (localCart) {
  //     if (localCart?.deliveryCharge) {
  //       return localCart?.deliveryCharge;
  //     } else {
  //       return 0;
  //     }
  //   } else {
  //     return 0;
  //   }
  // });
  // const [packingChargeAmount, setPackingChargeAmount] = useState(() => {
  //   const localCart = JSON.parse(localStorage.getItem("cartObj"));
  //   if (localCart) {
  //     if (localCart?.packingCharge) {
  //       return localCart?.packingCharge;
  //     } else {
  //       return 0;
  //     }
  //   } else {
  //     return 0;
  //   }
  // });

  const [customMixItems, setCustomMixItems] = useState([]);
  const [existingGroupItems, setExistingGroupItems] = useState(true);
  const [selectedCustomMix, setSelectedCustomMix] = useState([]);
  const [groupQty, setGroupQty] = useState(1);
  const [selectedUser, setSelectedUser] = useState();
  const [additionalInfoForm] = Form.useForm();
  const [discountAdditionalInfoForm] = Form.useForm();

  const handleCashInOut = async (data) => {
    let formData = cashManagementForm.getFieldsValue(true);
    formData.key = uuidv4().replace(/-/g, "").toUpperCase();
    formData.id = uuidv4().replace(/-/g, "").toUpperCase();
    formData.date = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    if (cashAddInFlag === true) {
      if (formData.type === "cashOut" || !formData.type) {
        formData.type = "cashOut";
      } else if (formData.financialAccount) {
        formData.type = "bankTransfer";
        formData.cashOut = false;
        formData.pettyCashOut = false;
        formData.bankTransfer = true;
      } else {
        formData.type = "pettyCashOut";
      }
    } else {
      if (formData.type === "cashIn" || !formData.type) {
        formData.type = "cashIn";
      } else {
        formData.type = "pettyCashIn";
      }
    }
    // formData.notes = data.note
    if (formData.type === "cashIn") {
      upsertPOSLog(formData, "CAI");
    } else if (formData.type === "cashOut") {
      upsertPOSLog(formData, "CAO");
    }
    setPettyCashIn(false);
    setCashOut(true);
    const pettyCashOut = [formData].filter((item) => item.type === "pettyCashOut" && !item?.financialAccount);

    if (pettyCashOut.length > 0) {
      const buildRequestString = (data) => {
        const paymentLineString = data
          .map(
            (line) => `      {
            expCategoryId: "${line.expenseCategory}"
            description: "${(line.note || "").replace(/"/g, '\\"')}"
            amount: "${line.amount}"
          }`
          )
          .join(",\n");

        return `{
        bunitId: "${tillData.tillAccess.csBunit.csBunitId}"
        date: "${moment(new Date()).format("YYYY-MM-DD")}"
        description: null
        supplierId: null
        paymentLine: [
    ${paymentLineString}
        ]
      }`;
      };

      const newStringRequest = buildRequestString(pettyCashOut);

      upsertSupplierPayment(newStringRequest);
    }

    const bankTransferData = [formData].filter((item) => item?.financialAccount);

    if (bankTransferData.length > 0) {
      const paymentMethodList = tillData?.tillAccess?.csBunit?.paymentMethodList || [];
      const buildBankTransferRequest = (data) => {
        return `{
      bunitId: "${tillData.tillAccess.csBunit.csBunitId}"
      transferDate: "${moment(new Date()).format("YYYY-MM-DD")}"
      toFinancialAcctId: "${data[0].financialAccount}"
      fromFinancialAcctId: "${paymentMethodList?.find((payment) => payment?.name === "Cash")?.finFinancialAccountId}"
      amount: ${parseFloat(data[0].amount)}
      attachmentUrl: "${data[0].financialFile}"
      description: null
    }`;
      };

      const bankTransferRequest = buildBankTransferRequest(bankTransferData);

      upsertFinFundsTransfer(bankTransferRequest);
    }
    db.cashInCashOut.add(formData);
    cashManagementForm.resetFields();
    setAddCashFlag(false);

    let obj = { cashIn: 0, cashOut: 0, pettyCashIn: 0, pettyCashOut: 0 };
    let cashDetails = await db.cashInCashOut.toArray();

    cashDetails.map((item) => {
      if (item.type === "cashIn") {
        obj.cashIn += parseFloat(item.amount);
      } else if (item.type === "cashOut") {
        obj.cashOut += parseFloat(item.amount);
      }
      if (item.type === "pettyCashIn") {
        obj.pettyCashIn += parseFloat(item.amount);
      }
      if (item.type === "pettyCashOut") {
        obj.pettyCashOut += parseFloat(item.amount);
      }
    });
    const tillSession = JSON.parse(localStorage.getItem("tillSession"));
    db.tillEvents
      .where("tillSessionId")
      .equals(tillSession.tillSessionId)
      .modify((tillEvent) => {
        tillEvent.cashInOutData = obj;
      });
    setCashIn(false);
    setCashOut(false);
    setPettyCashIn(false);
    setPettyCashOut(false); // reset the "Expenses" checkbox
    setBankTransfer(false);
    setAddCashFlag(false);
    setBankTransferDocument(null);
    setUploadingDocs(false);
  };

  const handleCahInOut = async (data) => {
    const { workflowRules, approvers } = await getWorkflowData();
    const cashManagementRequestRule = workflowRules.find((res) => res.eventName === "Cash Management Request");
    if (cashManagementRequestRule) {
      dispatchEvent(cashManagementRequestRule.eventName, cashManagementRequestRule.ruleName, cashManagementRequestRule.ruleCondition, approvers, data, async (eventData) => {
        if (eventData?.approvalGranted) {
          await handleCashInOut(data);
        } else {
          Modal.error({
            title: "Approval Required",
            content: "The cash management request was not approved.",
          });
        }
      });
    } else {
      await handleCashInOut(data);
    }
  };

  const onChangeCheckbox = (e) => {
    const eventId = e.target.id;
    const checkedValue = e.target.checked;
    let formData = cashManagementForm.getFieldsValue(true);
    if (cashAddInFlag) {
      if (eventId === "cashOut") {
        if (checkedValue === true) {
          setCashOut(checkedValue);
          setPettyCashOut(false);
          setBankTransfer(false);
          setUploadingDocs(false);
          setBankTransferDocument(null);
          formData.type = "cashOut";
          cashManagementForm.setFieldsValue({ pettyCashOut: false, bankTransfer: false });
        }
      }
      if (eventId === "pettyCashOut") {
        if (checkedValue === true) {
          formData.type = "pettyCashOut";
          setPettyCashOut(checkedValue);
          setCashOut(false);
          setBankTransfer(false);
          setUploadingDocs(false);
          setBankTransferDocument(null);
          cashManagementForm.setFieldsValue({ cashOut: false, bankTransfer: false });
        }
      }
      if (eventId === "bankTransfer") {
        if (checkedValue === true) {
          formData.type = "bankTransfer";
          setBankTransfer(checkedValue);
          setCashOut(false);
          setPettyCashOut(false);
          cashManagementForm.setFieldsValue({ cashOut: false, pettyCashOut: false });
        }
      }
    } else {
      if (eventId === "cashIn") {
        if (checkedValue === true) {
          formData.type = "cashIn";
          setCashIn(checkedValue);
          setPettyCashIn(false);
          cashManagementForm.setFieldsValue({ pettyCashIn: false });
        }
      }
      if (eventId === "pettyCashIn") {
        if (checkedValue === true) {
          formData.type = "pettyCashIn";
          setCashIn(false);
          setPettyCashIn(checkedValue);
          cashManagementForm.setFieldsValue({ cashIn: false });
        }
      }
    }
    cashManagementForm.setFieldsValue(formData);
  };

  // Cash Management End
  const [giftCardForm] = Form.useForm();
  const [giftCardItems, setGiftCardItems] = useState([]);
  const [giftCardType, setGiftCardType] = useState("giftCard");
  const [selectGiftCardItem, setSelectGiftCardItem] = useState({});
  const [validateGiftCard, setValidateGiftCard] = useState(false);
  const [giftCardData, setGiftCardData] = useState([]);
  const [giftCardBalance, setGiftCardBalance] = useState(0);
  const [validateGiftCardForm] = Form.useForm();
  const [realPrice, setRealPrice] = useState(0);
  const [firstInputValue, setFirstInputValue] = useState(false);
  const exchangeCartData = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
  const selectedReturnTypeLocal = localStorage.getItem("selectedReturnType");

  const handleGiftCardDetails = async (data) => {
    try {
      const setAuthTokens = authHeaders?.access_token || "";
      const returnFlag = cart.isReturn === true || cart.isReturn === "Y" ? data.amount <= Math.abs(cart.total) : true;

      if (!returnFlag || data.amount <= 0) {
        message.error(`The ${giftCardType} ${messages.errors.gift_card.amount_exceeds_return}`);
        return;
      }

      const matchedGiftCardData = await findMatchedGiftCardData();
      if (!matchedGiftCardData) return;

      const refId = generateRefId();
      const giftCardResponse = await verifyGiftCard(data, matchedGiftCardData, refId, setAuthTokens);

      if (giftCardResponse?.status === "200") {
        processVerifiedGiftCard(data, matchedGiftCardData, refId, giftCardResponse);
      } else {
        handleGiftCardError(data, refId, matchedGiftCardData, giftCardResponse);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  // Helper Functions

  const findMatchedGiftCardData = async () => {
    const giftCardData = await db.giftCardData.toArray();
    return giftCardData.find((giftcard) => giftcard.mProductId === selectGiftCardItem.mProductId);
  };

  const generateRefId = () => uuidv4().replace(/-/g, "").toUpperCase();

  const verifyGiftCard = async (data, matchedGiftCardData, refId, setAuthTokens) => {
    const query = {
      query: `
      mutation {
        verifyGiftCard(giftCards: [{
          cwrGiftcardTypeId: "${matchedGiftCardData?.cwrGiftcardTypeId}"
          cardNo: ${data.number ? `"${data.number}"` : null}
          referenceNo: "${refId}"
          b2cCustomerId: "${cart.customer?.cwrCustomerId || null}"
          cardPin: ${data.cardPin ? `"${data.cardPin}"` : null}
          currentBalance: ${parseFloat(data.amount)}
        }]) {
          status
          message
          cardNo
          expiryDate
        }
      }`,
    };

    const response = await verifyGiftCardService(query);
    if (response.data.data.verifyGiftCard.status !== "200") {
      message.error(response.data.data.verifyGiftCard.message);
    }
    return response.data.data.verifyGiftCard;
  };

  const processVerifiedGiftCard = (data, matchedGiftCardData, refId, giftCardResponse) => {
    setValidateGiftCard(false);
    setGiftCardBalance("0.00");

    const futureDate = moment().add(matchedGiftCardData.validity, "days");
    const updatedItem = {
      ...selectGiftCardItem,
      isGiftCard: true,
      realPrice: parseFloat(data.amount),
      total: parseFloat(data.amount),
      nettotal: parseFloat(data.amount),
      salePrice: parseFloat(data.amount),
      discAmount: 0,
      taxRate: 0,
      taxAmount: 0,
      interTaxId: "",
      interTaxRate: 0,
      interTaxName: "",
      unitPrice: parseFloat(data.amount),
      giftCardType: matchedGiftCardData.type,
      cardNo: matchedGiftCardData.type === "PHY" ? data.number : giftCardResponse.cardNo,
      expiryGiftCard: futureDate.format("DD-MM-YYYY"),
      grosslist: parseFloat(data.amount),
      grossstd: selectGiftCardItem.sunitprice,
      grossunit: parseFloat(data.amount),
      linegross: selectGiftCardItem.nettotal,
      linenet: parseFloat(data.amount),
      linetax: 0,
      listPrice: parseFloat(data.amount),
      netList: parseFloat(data.amount),
      netunit: parseFloat(data.amount),
    };

    const cardDetails = [
      ...giftCardData,
      {
        number: updatedItem.cardNo,
        amount: parseFloat(data.amount),
        refId,
      },
    ];
    if (!isExchange) {
      setCart({ ...cart, giftCardData: cardDetails });
      localStorage.setItem("cartObj", JSON.stringify({ ...cart, giftCardData: cardDetails }));
    }
    setGiftCardData(cardDetails);
    upsertPOSLog(cart, "GCI");
    addProduct(updatedItem, 1, false, 0, false, false);
  };

  const handleGiftCardError = (data, refId, matchedGiftCardData, response) => {
    Sentry.captureException(new Error("Verify gift card failed"), {
      extra: JSON.stringify({
        cwrGiftcardTypeId: matchedGiftCardData?.cwrGiftcardTypeId || null,
        cardNo: data.number ? `"${data.number}"` : null,
        referenceNo: refId,
        b2cCustomerId: cart.customer?.cwrCustomerId || null,
        cardPin: data.cardPin ? `"${data.cardPin}"` : null,
        currentBalance: data.amount || null,
        response,
      }),
    });
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const redeemGiftCard = async (data) => {
    setIsSubmitting(true);
    const uniqId = uuidv4().replace(/-/g, "").toUpperCase();
    let giftCardAmount = 0;
    let giftCardGroup = "";
    const setAuthTokens = authHeaders?.access_token ?? "";

    try {
      const query = {
        query: `
          query {
            checkGiftCardBalance(cardNo: "${data.number}", cardPin: ${data.pin ? `"${data.pin}"` : null}) {
              currentBalance
              cardGroup
              status
              message
            }
          }`,
      };

      const giftCardResponse = await checkGiftCard(query);

      const balanceData = giftCardResponse?.data?.data?.checkGiftCardBalance?.[0];
      if (balanceData?.status === "200") {
        giftCardAmount = balanceData.currentBalance ?? 0;
        giftCardGroup = giftCardResponse.data.data.checkGiftCardBalance[0].cardGroup;
      }
    } catch (err) {
      message.error(err);
      setIsSubmitting(false);
      return;
    }
    if (selectedPaymentMethod.name.toLowerCase() !== giftCardGroup.toLowerCase()) {
      message.error(`${giftCardGroup} redemption is not allowed through ${selectedPaymentMethod.name}`);
      setIsSubmitting(false);
      return;
    }
    if (cart?.total - cart?.paid >= data?.amount && data?.amount > 0) {
      try {
        const data1 = {
          query: `
            mutation {
              upsertGiftCardTransaction(giftCardTransactions: [{
                cardNo: "${data.number}"
                type: "RD"
                referenceNo: "${uniqId}"
                amount: ${parseFloat(data.amount)?.toFixed(precision)}
                cardPin: ${data.pin ? `"${data.pin}"` : null}
                tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
                b2c_Customer_Id: ${cart.customer.cwrCustomerId ? `"${cart.customer.cwrCustomerId}"` : null}
              }]) {
                status
                message
              }
            }`,
        };
        const upsertGiftCard = await upsertGiftCardTransaction(data1);

        const transactionData = upsertGiftCard?.data?.data?.upsertGiftCardTransaction;
        if (transactionData?.status === "200") {
          setGiftCardFlag(false);
          giftCardForm.resetFields();
          setGiftCardBalance(0);

          const cardDetails = [...(giftCardData ?? [])];
          const giftCardIndex = cardDetails.findIndex((item) => item.number === data.number);

          if (giftCardIndex >= 0) {
            cardDetails[giftCardIndex] = {
              ...cardDetails[giftCardIndex],
              number: data.number,
              amount: Math.min(data.amount, giftCardAmount + (cardDetails[giftCardIndex]?.amount ?? 0)),
              redemptionId: uniqId,
              pin: data.pin ?? null,
            };
          } else {
            cardDetails.push({
              number: data.number,
              amount: Math.min(data.amount, giftCardAmount),
              redemptionId: uniqId,
              pin: data.pin ?? null,
            });
          }
          // const filteredGiftCardNumbers = cardDetails.filter((card) => card.amount > 0).map((card) => card.number);
          const activeGiftCards = cardDetails.filter((card) => card.amount > 0);
          const latestRedemptionCards = cardDetails.filter((card) => card.redemptionId === uniqId && card.amount > 0);
          const combinedNumbers = [...new Set([...activeGiftCards.map((card) => card.number), ...latestRedemptionCards.map((card) => card.number)])];
          const updatedCart = { ...cart, giftCardData: cardDetails, giftCardNumbers: combinedNumbers };
          if (!isExchange) {
            setCart(updatedCart);
            localStorage.setItem("cartObj", JSON.stringify(updatedCart));
          }
          setGiftCardData(cardDetails);
          requestPayment(selectedPaymentMethod, Math.min(data.amount, giftCardAmount), null, null, null, updatedCart);
          upsertPOSLog(cart, "GCR");
          setIsSubmitting(false);
        } else {
          setIsSubmitting(false);
          message.error(transactionData?.message ?? `${messages.errors.gift_card.transaction_failed}`);
          Sentry.captureException(new Error("Gift card transaction failed"), {
            extra: {
              cardNo: data.number,
              type: "RD",
              referenceNo: uniqId,
              amount: data.amount,
              cardPin: data.pin ?? null,
              response: transactionData,
            },
          });
        }
      } catch (err) {
        setIsSubmitting(false);
        Sentry.captureException(err);
        message.error(err);
      }
    } else if (cart?.total - cart?.paid > data?.amount) {
      message.warn(`${messages.errors.cart.overpayment_not_allowed}`);
      setIsSubmitting(false);
    } else {
      message.error(`${messages.errors.gift_card.amount_exceeds_balance}`);
      setIsSubmitting(false);
    }
  };

  const handleGiftCard = async (data) => {
    try {
      const formData = giftCardForm.getFieldsValue(true);
      const setAuthTokens = authHeaders?.access_token || "";

      if (!formData.number) {
        message.error(`${messages.errors.gift_card.number_required}`);
        return;
      }

      const giftCardResponse = await checkGiftCardBalance(formData, setAuthTokens);

      if (giftCardResponse?.status === "200") {
        setGiftCardBalance(giftCardResponse.currentBalance);
      } else {
        message.error(giftCardResponse?.message || `${messages.errors.gift_card.balance_fetch_failed}`);
      }
    } catch (error) {
      message.error(error.message || `${messages.errors.gift_card.processing_error}`);
    }
  };

  // Helper Function
  const checkGiftCardBalance = async (formData, setAuthTokens) => {
    const query = {
      query: `
      query {
        checkGiftCardBalance(
          cardNo: "${formData.number}",
          cardPin: ${formData.pin ? `"${formData.pin}"` : null}
        ) {
          currentBalance
          cardGroup
          status
          message
        }
      }`,
    };

    const response = await checkGiftCard(query);

    return response.data.data.checkGiftCardBalance[0];
  };

  const getFinalPayableAmount = () => {
    const cartObj = JSON.parse(localStorage.getItem("cartObj") || "{}");
    const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");

    const cartTotal = parseFloat(cartObj?.total || 0);
    const exchangeTotal = parseFloat(exchangeCartObj?.total || 0);

    return cartTotal + exchangeTotal;
  };

  const walletFunc = async () => {
    const finalAmount = getFinalPayableAmount();

    // 🔴 REFUND CASE (0 or negative)
    if (finalAmount <= 0) {
      setIsRefundWalletOpen(true);
      return;
    }

    // 🟢 PAYMENT CASE (positive)
    setIswalletFlag(true);
    await fetchWalletData(true);
  };

  const bankTransferFunc = async () => {
    const finalAmount = getFinalPayableAmount();
    if (finalAmount > 0) {
      setBankTransferContext("payment");
      setIsBankTransferOpen(true);
    }
  };

  // CUSTOMER  SEARCH AND SELECTION BLOCK START
  const [displayCustomerSearch, setDisplayCustomerSearch] = useState(false);
  const [displayUAECustomerSearch, setDisplayUAECustomerSearch] = useState(false);
  const [displayUAECustomer, setDisplayUAECustomer] = useState(false);
  const [customerSearchType, setCustomerSearchType] = useState(() => (posConfig?.defaultCustomerSearch === "Search Key" ? "searchKey" : "mobile"));
  const [customerSearchInput, setCustomerSearchInput] = useState("");
  const [customerSearchResults, setCustomerSearchResults] = useState();
  const [closeCustomerFlag, setCloseCustomerFlag] = useState(false);
  const [properties, setProperties] = useState("");
  const [kioskUI, setKioskUI] = useState(parseFloat(localStorage.getItem("kioskUI")) ? parseFloat(localStorage.getItem("kioskUI")) : 0);
  const [kioskLogin] = Form.useForm();
  const [layoutType, setLayoutType] = useState(parseFloat(localStorage.getItem("layoutType")) ? parseFloat(localStorage.getItem("layoutType")) : 0);
  const [addToBagProducts, setAddToBagProducts] = useState([]);
  const [addToBagFlag, setAddToBagFlag] = useState(false);
  const [onlineBatches, setOnlineBatches] = useState([]);
  const [calendarVisibleMap, setCalendarVisibleMap] = useState({});
  const [showOrderCompleteFlag, setShowOrderCompleteFlag] = useState(false);

  useEffect(() => {
    const handleCustomEvent = (event) => {
      const dynamoDBValue = event.detail.newValue;
      if (event.detail.key === "kioskUI") {
        setKioskUI(dynamoDBValue ? dynamoDBValue : parseFloat(localStorage.getItem("kioskUI")) || 0);
      } else if (event.detail.key === "layoutType") {
        setLayoutType(dynamoDBValue ? dynamoDBValue : parseFloat(localStorage.getItem("layoutType")) || 0);
      }
    };

    db.products
      .filter((product) => product.isactive === true)
      .toArray()
      .then((productsFetched) => {
        let items = [];
        let bagItems = [];
        productsFetched.map(async (item) => {
          if (item.productSegment === "GC") {
            const giftCardData = await db.giftCardData.toArray();
            const matchingGiftCard = giftCardData.filter((giftcard) => giftcard.mProductId === item.mProductId);
            item.matchingGiftCard = matchingGiftCard;
            items.push(item);
          } else if (item.productSegment === "BG") {
            bagItems.push(item);
          }
        });
        setAddToBagProducts(bagItems);
        setGiftCardItems(items);
      });
    window.addEventListener("customStorageChange", handleCustomEvent);

    return () => {
      window.removeEventListener("customStorageChange", handleCustomEvent);
    };
  }, []);

  const debouncedCustomerSearch = useDebounce(customerSearchInput, 350);
  useEffect(() => {
    if (debouncedCustomerSearch !== "") {
      handleCustomerSearch(debouncedCustomerSearch);
    } else {
      setCustomerSearchResults([]);
    }
  }, [debouncedCustomerSearch]);

  const closeCustomerSearch = (obj) => {
    setDisplayCustomerSearch(false);
    setDisplayUAECustomerSearch(false);
    setCustomerSearchInput("");
    setCustomerSearchResults();
    setIsInputFocused(false);
    setCustomerSearchTrigger("normal");
    if (searchInputRef?.current) {
      searchInputRef?.current?.focus();
    }
    // const productSearchInput = documentde.getElementById("sm-product-search");
    // if (productSearchInput) {
    //   productSearchInput.focus();
    // }
  };
  const handleCustomerSearch = async (searchValue) => {
    await getCustomer(
      form,
      tillLayout,
      searchValue,
      setKioskUI,
      setCustomerSearchResults,
      kioskLogin,
      tillData,
      pendingRefundCustomer,
      setPendingRefundCustomer,
      isRefundCustomerEdit,
      setIsRefundCustomerEdit
    );
    setLoading(false);
  };

  const [orderTimeDetails, setOrderTimeDetails] = useState({ orderStartTime: "", orderEndTime: "", paymentStartTime: "" });

  const handleDeletePayment = (payment) => {
    let paid = 0;
    Promise.all(
      cart.payments.map(async (pay) => {
        if (payment.name.toLowerCase() === "gift card" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          let setAuthTokens;
          if (authHeaders && authHeaders.access_token) {
            setAuthTokens = authHeaders.access_token;
          }
          const upsertDetails = giftCardData.map((ele) => ({
            cardNo: ele.number ? ele.number : null,
            type: "RD",
            referenceNo: cart.referenceId,
            amount: ele.amount * -1,
            cardPin: ele.pin ? ele.pin : null,
          }));

          const upsertDetailsStrings = upsertDetails.map(
            (detail) => `{
            cardNo: ${detail.cardNo ? `"${detail.cardNo}"` : null},
            type: "${detail.type}",
            referenceNo: "${detail.referenceNo}",
            amount: ${detail.amount},
            cardPin: ${detail.cardPin ? `"${detail.cardPin}"` : null}
            tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
            b2c_Customer_Id: ${cart.customer.cwrCustomerId ? `"${cart.customer.cwrCustomerId}"` : null}
          }`
          );

          const data = {
            query: `
                mutation {
                  upsertGiftCardTransaction(giftCardTransactions: [${upsertDetailsStrings}]) {
                    status
                    message
                  }
                }`,
          };

          const response = await upsertGiftCardTransaction(data);
          let cardDetails = [...giftCardData];
          let uniqId = uuidv4().replace(/-/g, "").toUpperCase();
          if (response.data.data.upsertGiftCardTransaction.status == 200) {
            upsertDetails.forEach((detail) => {
              cardDetails.push({
                number: detail.cardNo,
                amount: detail.amount,
                redemptionId: uniqId,
                pin: detail.cardPin ? detail.cardPin : null,
              });
            });
          }
          setGiftCardData(cardDetails);
        } else if (payment.name.toLowerCase() === "loyalty" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          await handleLoyaltyPayment(payment, cart);
        } else if (pay.name !== payment.name && payment.name.toLowerCase() !== "card") {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (payment.name.toLowerCase() === "card" && (payment.authorization ? pay.authorization !== payment.authorization : true)) {
          paid = paid + parseFloat(pay.amount);
          return pay;
        }
      })
    )
      .then((results) => {
        // Filter out undefined results (where payment name matched)
        cart.payments = results.filter((result) => result !== undefined);
        cart.paid = paid + (cart?.advancePayment || 0);
        setAmount(parseFloat((cart.total - cart.paid).toFixed(pricePrecision)));
        if (payment?.name?.toLowerCase() === "cash") {
          cart.tenderedAmount = cart.tenderedAmount - payment.amount;
        }
        if (!isExchange) {
          localStorage.setItem("cartObj", JSON.stringify(cart));
          setCart(cart);
        }
      })
      .catch((error) => {
        // Handle errors
        console.error(error);
      });
  };

  const fetchWalletData = async (flag) => {
    try {
      const wallets = await getCustomerWallet(cart?.customer?.cwrCustomerId);

      // Fallback customer data if no wallets are present
      const defaultCustomerData = {
        id: cart.customer.code || "",
        name: cart.customer.name || "",
        phone: cart.customer.mobileNo || "",
        email: cart.customer.email || null,
        currentBalance: 0,
        totalSpent: 0,
        transactions: [],
      };

      // Map wallet data if wallets exist, otherwise use default customer data
      const mappedData =
        wallets?.wallets?.length > 0
          ? wallets.wallets.map((wallet) => ({
              id: cart.customer.code || "",
              name: cart.customer.name || "",
              phone: cart.customer.mobileNo || "",
              email: cart.customer.email || null,
              currentBalance: wallet.balance_amt || 0,
              totalSpent: wallet.deposit_amt || 0,
              joinDate: wallet.created || new Date().toISOString().split("T")[0],
              lastTransaction: wallet.laxt_trxdate || new Date().toISOString().split("T")[0],
              transactions: (wallet.transactions || []).map((trx) => {
                let type = "Debit";
                let description = "Purchase Payment";

                if (trx.trx_type === "DP") {
                  type = "Credit";
                  description = "Wallet Top-up";
                }

                if (trx.trx_type === "REF") {
                  type = "Credit";
                  description = "Wallet Refund";
                }

                if (trx.trx_type === "WD") {
                  type = "Debit";
                  description = "Purchase Payment";
                }

                return {
                  id: trx.cwr_wallet_trx_id,
                  date: trx.created.split(" ")[0],
                  time: new Date(trx.created).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  }),
                  type,
                  amount: Math.abs(trx.trx_value),
                  description,
                  reference: trx.cwr_wallet_trx_id,
                  balance: trx.closing_amt ?? wallet.balance_amt ?? 0,
                };
              }),
            }))
          : [defaultCustomerData];

      setSelectedCustomer(mappedData);
      setCustomersData(mappedData);
      if (!flag) {
        setShowCustomerWallet(true); // Enable wallet display
      }
      setTillLink(false);
    } catch (error) {
      message.error(`${messages.errors.customer.wallet_load_failed}`);
    }
  };

  const fetchOnlineBatches = async (productSet) => {
    const batches = Array.isArray(productSet) && productSet.length > 0 ? productSet : batchSetAvailable;
    if (!Array.isArray(batches) || batches.length === 0) return;

    const bUnitId = tillData?.tillAccess?.csBunit?.csBunitId;
    const productId = batches[0]?.productId;

    try {
      const payload = {
        query: `
          query {
            getStockForProduct(
              bUnitId: "${bUnitId}",
              productId: "${productId}"
            )
          }
        `,
      };

      const response = await getStockForProductService(payload);

      let raw = response?.data?.data?.getStockForProduct;
      if (!raw) return;

      raw = raw.replace(/([0-9]{4}-[0-9]{2}-[0-9]{2} [0-9:.]+)/g, '"$1"');

      const parsed = JSON.parse(raw);
      const receiptlessReturn2Enabled = posConfig?.enableReceiptlessReturn2 === "Y";
      const activeCart = isExchange ? JSON.parse(localStorage.getItem("exchangeCartObj")) : cart;
      const returnEnabled = receiptlessReturn2Enabled && activeCart?.isReturn === true && activeCart?.isBlindReceipt === true;

      // 1️⃣ No batches returned
      if (!Array.isArray(parsed?.batches) || parsed.batches.length === 0) {
        console.log("No batches returned from API for product");

        const base = batches[0];

        if (returnEnabled) {
          // Directly add to cart for receiptless return
          selectProductToCart(base, 1);
        } else {
          // Show stock popup for normal sale
          setProductStock(true);
        }

        return;
      }
      const base = batches[0];
      console.log("base ------------>", base);
      const applicablePrice = getApplicablePrice({
        priceList: base?.priceList,
        selectedUomId: base?.uomData?.[0]?.csUomId,
        sPriceListId: cart?.customer?.sPriceListId,
        alternateUom: base?.alternateUom || [],
        primaryUomId: base?.uom || null,
      });

      const unitPrice = applicablePrice?.pricestd ?? applicablePrice?.pricelist ?? base?.sunitprice ?? 0;

      const mapped = parsed.batches.map((b) => ({
        ...base,

        mBatchId: b?.m_batch_id,
        batchno: b?.batchno,

        salePrice: unitPrice,
        realPrice: unitPrice,

        mrpPrice: base.listPrice ?? 0,

        stock: b?.qtyonhand,
        upc: b?.batchupc,

        listPrice: base?.listPrice ?? 0,
        listprice: b?.listprice ?? 0,
        purchasePrice: b?.purchaseprice,

        purchaseDate: b?.purchase_date || b?.startdate,
      }));

      // 2️⃣ Map API batches into full product object
      // const mapped = parsed.batches.map((b) => ({
      //   ...base, // preserves tax, uom, priceList, etc.
      //   mBatchId: b?.m_batch_id,
      //   batchno: b?.batchno,
      //   salePrice: b?.price ?? base.salePrice ?? 0,
      //   realPrice: b?.price ?? base.realPrice ?? 0,
      //   mrpPrice: offlineStd ?? b?.listprice ?? b?.price ?? 0,
      //   stock: Number(b?.qtyonhand ?? 0),
      //   upc: b?.batchupc ?? null,
      //   listPrice: b?.listprice ?? base.listPrice ?? 0,
      //   purchasePrice: b?.purchaseprice ?? 0,
      //   purchaseDate: b?.purchase_date || b?.startdate || null,
      // }));

      const inStockBatches = mapped.filter((b) => b.stock > 0);

      if (inStockBatches.length === 0) {
        setOnlineBatches([]);
        console.log("All batches are out of stock for product");
        setProductStock(true);
        return;
      }

      if (inStockBatches.length === 1) {
        const onlyBatch = inStockBatches[0];
        console.log("onlyBatch --------->", onlyBatch);
        selectProductToCart(onlyBatch, 1); // qty = 1
        return; // stop here, don't open drawer
      }

      setOnlineBatches(inStockBatches);
      setDisplayBatchSelection(true);
    } catch (err) {
      console.error("Batch fetch error:", err);
    }
  };

  // const validateAndSavePanForCustomer = async (customer) => {
  //   const panValue = extractPanFromMeta(customer?.metaData);
  //   if (!panValue) return null;
  //   setLoading(true);
  //   try {
  //     const panApi = await validatePANNo(panValue);
  //     if (!panApi) return null;

  //     const realStatus = getPanRealStatus({
  //       isValid: panApi.valid,
  //       aadhaarSeedingStatusCode: panApi.aadhaarSeedingStatusCode,
  //       isBusiness: panApi.isBusiness,
  //     });

  //     return {
  //       panNo: panApi.panNo,
  //       panStatus: panApi.panStatus,
  //       aadhaarSeedingStatusCode: panApi.aadhaarSeedingStatusCode,
  //       isValid: panApi.valid,
  //       realStatus,
  //     };
  //   } catch (err) {
  //     console.error("PAN validation failed:", err);
  //     return null;
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const calendarContent = (record) => (
    <DatePicker
      showTime={{ format: "hh:mm A" }}
      format="DD-MM-YYYY hh:mm A"
      onChange={handleDateSelect(record)}
      disabledDate={(current) => {
        return current && current < moment().startOf("day");
      }}
      value={selectedDate}
      style={{ width: 250 }}
    />
  );

  const renderDeliveryDate = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          padding: "3px 6px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          color: "white",
          cursor: "pointer",
          width: "fit-content",
        }}
      >
        <CalendarOutlined
          style={{
            fontSize: "0.85rem",
            cursor: "pointer",
            paddingBottom: "0.1em",
          }}
        />
        <span style={{ fontSize: "0.7rem" }}>{cart?.deliveryDate || "Delivery Date"}</span>
      </div>
    );
  };

  const handleDateSelect = (record) => (date, dateString) => {
    let updatedCart;
    setSelectedDate(date); // Store the selected date (you can use it elsewhere)

    setCalendarVisible(false); // Close the calendar after selection
    if (searchInputRef?.current) {
      searchInputRef?.current.focus();
    }
    if (record !== null && cart.items.length > 0) {
      updatedCart = { ...cart };
      let index = updatedCart.items.findIndex((res) => res.lineId === record.lineId);
      if (index >= 0) {
        updatedCart.items[index].deliveryDate = date && date.format("DD-MM-YYYY HH:mm:ss");
      }
      toggleCalendar(record.lineId);
    } else {
      updatedCart = {
        ...cart,
        deliveryDate: (date && date.format("DD-MM-YYYY HH:mm:ss")) || "",
        deliveryDatePromised: (date && dateString) || "", // Update the delivery date in the cart
      };
    }
    setSelectedProductForNotes(null);
    setCart(updatedCart);
    localStorage.setItem("cartObj", JSON.stringify(updatedCart));
    setIsInputFocused(false);
    let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
      ? JSON.parse(localStorage.getItem("orderTimeDetails"))
      : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
    if (updatedCart.items.length === 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === updatedCart.customer.cwrCustomerId) {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
        orderStartTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"), // Update orderStartTime to current time
      };
    } else if (updatedCart.items.length > 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId !== updatedCart.customer.cwrCustomerId) {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
      };
    }
    if (updatedCart.description === "") {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
        orderStartTime: "",
      };
    }
    localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
  };

  const toggleCalendar = (key) => {
    setCalendarVisibleMap((prev) => ({
      ...prev,
      [key]: !prev[key] || false, // Toggle or default to false
    }));
  };

  const validateAndSavePanForCustomer = async (customer) => {
    const panValue = customer?.metaData?.find((m) => m.key === "Pan Card")?.value;
    if (!panValue) return null;

    setLoading(true);
    try {
      const panApi = await validatePANNo(panValue);
      if (!panApi) return null;

      const realStatus = getPanRealStatus({
        panStatusCode: panApi.panStatusCode,
        aadhaarSeedingStatusCode: panApi.aadhaarSeedingStatusCode,
        isIndividual: panApi.isIndividual,
      });

      // PAN is usable only for VALID cases
      const isPanUsable = realStatus === "VALID & OPERATIVE" || realStatus === "VALID & INOPERATIVE";

      return {
        panNo: panApi.panNo,
        panStatus: panApi.panStatus,
        aadhaarSeedingStatusCode: panApi.aadhaarSeedingStatusCode,
        isValid: isPanUsable,
        realStatus,
      };
    } catch (err) {
      console.error("PAN validation failed:", err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const extractPanFromMeta = (metaData = []) => {
    if (!Array.isArray(metaData)) return null;

    const panEntry = metaData.find((item) => typeof item.key === "string" && item.key.toLowerCase().includes("pan") && typeof item.value === "string" && item.value.trim() !== "");

    return panEntry?.value?.trim() || null;
  };

  const getPanRealStatus = ({ panStatusCode, aadhaarSeedingStatusCode, isIndividual }) => {
    const disabledPanStatusMap = {
      N: "INVALID PAN",
      I: "PAN INOPERATIVE",
      X: "PAN DEACTIVATED",
      F: "FAKE PAN",
      D: "PAN DELETED",
      EA: "PAN AMALGAMATION",
      EC: "PAN ACQUISITION",
      ED: "DEATH OF PAN HOLDER",
      EI: "PAN DISSOLVED",
      EL: "PAN LIQUIDATED",
      EM: "PAN MERGER",
      EP: "PAN PARTITION",
      ES: "PAN SPLIT",
      EU: "PAN UNDER LIQUIDATION",
    };

    // ❌ Disabled PAN cases
    if (disabledPanStatusMap[panStatusCode]) {
      return disabledPanStatusMap[panStatusCode];
    }

    // ✅ Valid PAN
    if (panStatusCode === "E") {
      // Aadhaar Successful
      if (aadhaarSeedingStatusCode === "Y") {
        return "VALID & OPERATIVE"; // TCS 1%
      }

      // Aadhaar Not Applicable
      if (aadhaarSeedingStatusCode === "NA" || aadhaarSeedingStatusCode == null || isIndividual === false) {
        return "VALID & OPERATIVE"; // TCS 1%
      }

      // Aadhaar Not Successful
      return "VALID & INOPERATIVE"; // TCS 5%
    }

    return "INVALID PAN";
  };

  const proceedWithCustomerSelection = async (selectedCustomer, index) => {
    const hasPassport = selectedCustomer?.metaData?.some((m) => m?.key?.toLowerCase().includes("passport") && m?.value);
    const hasVisa = selectedCustomer?.metaData?.some((m) => {
      const key = m?.key?.toLowerCase() || "";
      return (key.includes("immigration") || key.includes("visa")) && m?.value !== null && m?.value !== undefined && m?.value !== "";
    });
    const isNRI = hasPassport && hasVisa;
    if (isExchange && isPanCustomer) {
      setExchangeCartTcs(true);
      setSelectedEditOldCustomer(selectedCustomer);
      await removeCutomer();
      setIsPanCustomer(false);
      previousTcsRef.current = 0;
    } else if (isExchange) {
      setSelectedEditOldCustomer(selectedCustomer);
    }
    if (localStorage.getItem("refundCustomerEdit") === "Y" && cart?.isReturn === true) {
      localStorage.setItem("refundReturnCustomerId", JSON.stringify(selectedCustomer));

      localStorage.removeItem("refundCustomerEdit");
      setIsRefundWalletOpen(true);
      closeCustomerSearch(); // close search drawer
      return; // 🚨 EXIT BEFORE ANY CART LOGIC
    }
    setCustomerFlag(false);
    let latestData = removeAllDiscounts(false, true);
    const truncateDecimal = (num, decimalPlaces) => {
      // Convert the number to a string
      let numStr = num.toString();

      // Find the position of the decimal point
      let decimalIndex = numStr.indexOf(".");

      // If there is no decimal point or if there are less decimal places than desired, return the number as is
      if (decimalIndex === -1 || numStr.length - decimalIndex - 1 <= decimalPlaces) {
        return num;
      }

      // Truncate the string to the desired number of decimal places
      numStr = numStr.slice(0, decimalIndex + decimalPlaces + 1);

      // Parse the truncated string back to a number
      return parseFloat(numStr);
    };

    let num = customerSearchResults[index]?.retlLoyaltyBalance || 0;
    let truncatedNum = truncateDecimal(num, 2);

    customerSearchResults[index].retlLoyaltyBalance = truncatedNum;
    const saleTypeData1 = JSON.parse(localStorage.getItem("saleTypeData") || "{}");
    const selectedPriceListId1 = customerSearchResults[index]?.sPriceListId ?? saleTypeData1?.customer?.sPriceListId;
    const cartObj = {
      ...latestData,
      customer: {
        ...customerSearchResults[index],
        sPriceListId: selectedPriceListId1,
        nriBilling: isNRI,
      },
    };
    let updatedCart = cartObj;

    if (cartObj.items.length > 0) {
      await Promise.all(
        cartObj.items.map(async (ele) => {
          let addToCart = ele;
          console.log("addToCart before price update", addToCart);
          let matchedPriceIndex = [];
          if (defaultCustomer?.cwrCustomerId !== updatedCart?.customer?.cwrCustomerId && addToCart?.priceList?.length > 0) {
            const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData")) || {};
            let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
            // matchedPriceIndex = addToCart?.priceList.filter((i) => i.sPricelistId === updatedCart.customer.sPriceListId);
            // if (matchedPriceIndex.length > 0) {
            //   addToCart.price = matchedPriceIndex[0].pricestd;
            //   addToCart.salePrice = matchedPriceIndex[0].pricestd;
            //   addToCart.realPrice = matchedPriceIndex[0].pricestd;
            //   addToCart.sunitprice = matchedPriceIndex[0].pricestd;
            // } else if (!updatedCart.customer.sPriceListId) {
            //   addToCart.price = addToCart?.originalPrice;
            //   addToCart.salePrice = addToCart?.originalPrice;
            //   addToCart.realPrice = addToCart?.originalPrice;
            //   addToCart.sunitprice = addToCart?.originalPrice;
            // }

            const selectedPrice = getApplicablePrice({
              priceList: addToCart.priceList,
              selectedUomId: addToCart.uomData[0]?.csUomId,
              sPriceListId: updatedCart.customer.sPriceListId,
              alternateUom: addToCart.alternateUom || [],
              primaryUomId: addToCart.uom,
            });

            if (selectedPrice && addToCart?.posPriceEdit !== "Y") {
              addToCart.price = selectedPrice.pricestd;
              addToCart.salePrice = selectedPrice.pricestd;
              addToCart.realPrice = selectedPrice.pricestd;
              addToCart.sunitprice = selectedPrice.pricestd;
            } else if (!updatedCart.customer.sPriceListId) {
              addToCart.price = addToCart.originalPrice;
              addToCart.salePrice = addToCart.originalPrice;
              addToCart.realPrice = addToCart.originalPrice;
              addToCart.sunitprice = addToCart.originalPrice;
            }
            const addOnsPriceSum = _.sumBy(addToCart?.selectedAddons, "price");
            const mrp = (parseFloat(addToCart.salePrice) + addOnsPriceSum * addToCart.weight) * parseFloat(addToCart.weight);
            const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addToCart.taxRate / 100) : mrp * (addToCart.taxRate / 100);
            // addToCart.taxAmount = tax;
            // addToCart.nettotal =
            //   taxIncludeFlag === "Y"
            //     ? mrp - parseFloat(parseFloat(addToCart.discount ? addToCart.discount : 0)?.toFixed(precision))
            //     : mrp - parseFloat(parseFloat(addToCart.discount ? addToCart.discount : 0) + tax)?.toFixed(precision);
            addToCart.nettotal = parseFloat(
              parseFloat(
                (taxIncludeFlag === "Y"
                  ? mrp - parseFloat((addToCart.discount || 0).toFixed(precision))
                  : mrp - parseFloat((addToCart.discount || 0).toFixed(precision)) + tax
                ).toFixed(precision)
              )
            );
          }

          updatedCart = await pricingRuleController(addToCart, cartObj, cartObj, setCart, cartObj, orderType);
          console.log("updatedCart after price update", updatedCart);
          return updatedCart;
        })
      );
    } else {
      let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
        ? JSON.parse(localStorage.getItem("orderTimeDetails"))
        : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
      orderTimeDetails = {
        ...orderTimeDetails,
        orderStartTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"), // Update orderStartTime to current time
      };
      localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
    }

    if (updatedCart?.couponInput?.length > 0) {
      let addToCart = cartObj.items[0];
      await Promise.all(
        updatedCart.couponInput.map(async (coupon) => {
          const matchingPricingRules = await db.pricingRules.where("mPricingrulesId").equalsIgnoreCase(coupon.mPricingruleId).toArray();
          if (matchingPricingRules[0].type !== "TD" && matchingPricingRules[0].type !== "TDF") {
            updatedCart = await pricingRuleController(
              addToCart,
              updatedCart,
              cart,
              setCart,
              cartRef,
              orderType,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          } else {
            updatedCart = await processBillDiscounts(
              matchingPricingRules[0],
              updatedCart,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          }
        })
      );
    }
    if (cartObj.totalDiscountFlag) {
      await openPaymentModalByCustomer(updatedCart);
    }
    let updatedTotalTax = 0;
    let updatedTotalPrice = 0;
    let updatedTotalItemsQty = 0;
    let updatedTotalDiscounts = 0;

    if (updatedCart?.manualDiscountData?.lineLevelDiscount?.length > 0) {
      updatedCart.manualDiscountData.lineLevelDiscount.map(async (item) => {
        const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
        let productSelected = updatedCart.items.filter((cartItem) => cartItem.productId === item.productId);
        if (pricingRule?.type === "FD") {
          try {
            const newCart = await CheckoutFlatDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying flat discount:", err);
          }
        } else if (pricingRule?.type === "PD") {
          try {
            const newCart = await CheckoutPercentageDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying percentage discount:", err);
          }
        }
      });
    }

    if (updatedCart?.manualDiscountData?.totalLevelDiscount?.length > 0) {
      updatedCart.manualDiscountData.totalLevelDiscount.map(async (item) => {
        const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
        if (pricingRule?.type === "TD") {
          try {
            const newCart = await CheckoutTotalManualDiscount(pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying Total discount:", err);
          }
        }
      });
    }

    const itemSummery = {
      decimalItems: { totalQty: 0, totalAmount: 0 },
      nonDecimalItems: { totalQty: 0, totalAmount: 0 },
      itemsQty: 0,
      items: 0,
    };

    // Group items by tax rate
    const allItems = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));

    const groupedItems = allItems.reduce((acc, item) => {
      const key = item.tax?.rate ?? item.taxRate ?? "0";
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    // Calculate tax totals with SGST and CGST
    const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
      const totalTaxAmount = items.reduce((sum, item) => {
        const taxValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.taxAmount : item.taxAmount) || 0;
        return sum + parseFloat(parseFloat(taxValue)?.toFixed(precision));
      }, 0);

      const totalNetTotal = items.reduce((sum, item) => {
        const netValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.nettotal : item.nettotal) || 0;
        return parseFloat(parseFloat(sum).toFixed(precision)) + parseFloat(parseFloat(netValue).toFixed(precision));
      }, 0);

      // Calculate SGST and CGST (assuming they're either explicitly provided or half of total tax)
      const totalSgstAmount = items.reduce((sum, item) => {
        const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(sgstValue)?.toFixed(precision));
      }, 0);

      const totalCgstAmount = items.reduce((sum, item) => {
        const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(cgstValue)?.toFixed(precision));
      }, 0);

      return {
        taxRate,
        totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount)?.toFixed(precision)),
        totalLinetax: parseFloat(parseFloat(totalTaxAmount)?.toFixed(precision)),
        totalLinegross: parseFloat(parseFloat(totalNetTotal)?.toFixed(precision)),
        totalSgst: parseFloat(parseFloat(totalSgstAmount)?.toFixed(precision)),
        totalCgst: parseFloat(parseFloat(totalCgstAmount)?.toFixed(precision)),
      };
    });

    updatedCart.items = updatedCart.items.map((item, i) => {
      const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
      const nettotalFixed = parseFloat(parseFloat(item?.nettotal)?.toFixed(precision));
      const taxAmountFixed = parseFloat(parseFloat(item?.taxAmount)?.toFixed(precision));
      const discountFixed = item.discount ? parseFloat(parseFloat(item?.discount)?.toFixed(precision)) : 0;

      // Update totals
      updatedTotalPrice += nettotalFixed;
      updatedTotalItemsQty += item.weight;
      updatedTotalTax += taxAmountFixed;
      updatedTotalDiscounts += discountFixed;

      item.discount = discountFixed;
      item.key = i;

      if (!item.isGiftCard) {
        const unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;

        const lineTax = item.listPrice * (1 + (item.taxRate || 0) / 100);
        const stdTax = item.sunitprice * (1 + (item.taxRate || 0) / 100);
        const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
        const netList =
          taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision)) : item.listPrice;
        const gross_list = taxIncludeFlag === "Y" ? item.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision));
        const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : stdTax;
        // const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : item.sunitprice + taxAmountFixed;

        Object.assign(item, {
          linetax: nettotalFixed ? taxAmountFixed : 0,
          linenet: nettotalFixed ? parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision)) : 0,
          linegross: nettotalFixed || 0,
          linestd: nettotalFixed ? parseFloat(parseFloat(grossStd * item.weight)?.toFixed(precision)) : 0,
          netunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
          listprice: nettotalFixed ? item.listPrice : 0,
          grossunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0,
          grossstd: nettotalFixed ? parseFloat(parseFloat(grossStd)?.toFixed(precision)) : 0,
          grosslist: nettotalFixed ? roundTo(gross_list, precision) : 0,
          netList: nettotalFixed ? netList : 0,
          unitPrice: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
          taxAmount: nettotalFixed ? taxAmountFixed : 0,
        });
      }

      // Update summary
      if (Array.isArray(item.children) && item.children.length > 0 && item.companion !== "Y") {
        item.children.forEach((child) => {
          const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
          const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

          itemSummery.itemsQty += child.weight;
          itemSummery.items += 1;
          itemSummery[summaryKey].totalQty += child.weight;
          itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(child.nettotal)?.toFixed(precision));
        });
      } else {
        const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
        const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

        itemSummery.itemsQty += item.weight;
        itemSummery.items += 1;
        itemSummery[summaryKey].totalQty += item.weight;
        itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      }
      return item;
    });

    const sumLineTotals = (lines) => {
      let totalLineGross = 0;
      let totalLineTax = 0;

      lines.forEach((line) => {
        totalLineGross += line.nettotal;
        totalLineTax += line.taxAmount;
      });

      return { totalLineGross, totalLineTax };
    };
    // Compare and Adjust Order Totals
    const adjustOrderTotals = (order, lines) => {
      const { totalLineGross, totalLineTax } = sumLineTotals(lines);
      let adjustedOrderGross = order.total;
      let adjustedOrderTax = order.tax;

      const grossDifference = totalLineGross - adjustedOrderGross;
      const taxDifference = totalLineTax - adjustedOrderTax;

      if (Math.abs(grossDifference) > 0.01) {
        adjustedOrderGross += grossDifference;
      }

      if (Math.abs(taxDifference) > 0.01) {
        adjustedOrderTax += taxDifference;
      }

      return {
        ...order,
        total: adjustedOrderGross,
        tax: adjustedOrderTax,
      };
    };
    updatedCart = adjustOrderTotals(updatedCart, updatedCart.items);
    // const updatedTotalStd = updatedCart.items.reduce((sum, item) => sum + item.linestd, 0);
    const allItemsInCart = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
    const updatedTotalStd = allItemsInCart.reduce((sum, item) => sum + (item.linestd || 0), 0);
    const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData") || "{}");
    const selectedPriceListId = customerSearchResults[index]?.sPriceListId ?? saleTypeData?.customer?.sPriceListId;
    const panResult = await validateAndSavePanForCustomer(selectedCustomer);
    let finalCartObj = {
      ...updatedCart,
      items: [...updatedCart.items],
      discount: updatedTotalDiscounts,
      totalQty: updatedTotalItemsQty,
      total: parseFloat(parseFloat(updatedTotalPrice).toFixed(precision)),
      tax: updatedTotalTax,
      customer: {
        ...customerSearchResults[index],
        sPriceListId: selectedPriceListId,
        nriBilling: isNRI,
        ...(panResult && {
          customerProperties: {
            panNo: panResult.panNo,
            panStatus: panResult.panStatus,
            aadhaarSeedingStatusCode: panResult.aadhaarSeedingStatusCode,
            isValid: panResult.isValid,
            realStatus: panResult.realStatus,
          },
        }),
      },
      totalStd: updatedTotalStd,
      itemsSummery: itemSummery,
      groupedItemsByTaxRate: groupedItemsByTaxRate,
    };
    if (isExchange) {
      localStorage.setItem("exchangeCartObj", JSON.stringify(finalCartObj));
    } else {
      localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
      setCart({ ...finalCartObj });
    }
    try {
      guestForm.setFieldsValue({
        guestName: customerSearchResults[index]?.name || "",
        contactNumber: customerSearchResults[index]?.mobileNo || "",
      });
    } catch (e) {
      console.log("Guest form not open or not initialized");
    }
    if (isCallCenterFlow && tillLayout === 2) {
      history.push("/call-center");
      setCallCenterVisible(true);
      setShowCallCenterPage(false);
      setDisplayAddNewCustomer(false);
      setDisplayCustomerSearch(false);
      setCustomerSearchInput("");
      return;
    }
    closeCustomerSearch(finalCartObj, true);
    setShowPaymentMethods(false);
    setIsInputFocused(false);
    upsertPOSLog(finalCartObj, "ACT");
    setActiveInput("search");
    if (searchInputRef?.current) {
      searchInputRef?.current?.focus();
    }
  };

  const selectCustomer = async (index) => {
    const selectedCustomer = customerSearchResults[index];
    if (!selectedCustomer?.mobileNo && retailCustomerFields && retailCustomerFields.length > 0) {
      Modal.confirm({
        title: "No Mobile Number",
        content: "Do you want to add customer without mobile number?",
        okText: "Proceed",
        cancelText: "Cancel",
        okButtonProps: { style: { display: "inline-block" } },
        onOk: async () => {
          await proceedWithCustomerSelection(selectedCustomer, index);
        },
        onCancel() {
          // console.log("User cancelled");
        },
      });
      return;
    }
    await proceedWithCustomerSelection(selectedCustomer, index);
    // setOpen(false);
  };
  // CUSTOMER  SEARCH AND SELECTION BLOCK END

  // ADD NEW CUSTOMER BLOCK START
  const [form] = Form.useForm();
  const [UAECustomerForm] = Form.useForm();
  const [displayAddNewCustomer, setDisplayAddNewCustomer] = useState(false);

  const showAddNewCustomerFields = async () => {
    setDisplayCustomerSearch(false);

    const searchResult = customerSearchInput || keyboardInputFields?.search;
    let customerSearchType = "name";
    const isAlphaNumericNoSpace = (value) => /[a-zA-Z]/.test(value) && /[0-9]/.test(value);

    if (/^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/.test(searchResult)) {
      customerSearchType = "email";
    } else if (/^\d+$/.test(searchResult)) {
      customerSearchType = "mobile";
    } else if (isAlphaNumericNoSpace(searchResult)) {
      customerSearchType = "pan";
    } else {
      customerSearchType = "name";
    }

    const defaultAddress = {
      country: tillData.tillAccess.csBunit.customerAddress?.csCountry?.name,
      state: tillData.tillAccess.csBunit.customerAddress?.csRegion?.name,
    };

    let fieldValues = {
      // type: "addCustomerForm",
      ...defaultAddress,
    };

    if (retailCustomerFields && retailCustomerFields.length > 0) {
      const fieldMap = {
        name: null,
        mobile: null,
        email: null,
        pan: null,
      };
      const isPanField = (name) => {
        const clean = name.toLowerCase().replace(/\s+/g, "");
        return clean === "pancard" || clean === "panno" || clean === "pannumber";
      };

      retailCustomerFields.forEach((field) => {
        const fieldName = field.name.toLowerCase().replace(/\s+/g, "");

        if (fieldName.includes("name")) fieldMap.name = field.name;
        if (fieldName.includes("mobile") || fieldName.includes("phone")) fieldMap.mobile = field.name;
        if (fieldName.includes("email")) fieldMap.email = field.name;
        if (isPanField(field.name)) fieldMap.pan = field.name;
      });

      if (customerSearchType === "mobile" && fieldMap.mobile) {
        fieldValues[fieldMap.mobile] = searchResult;
      }

      if (customerSearchType === "name" && fieldMap.name) {
        fieldValues[fieldMap.name] = searchResult;
      }

      if (customerSearchType === "email" && fieldMap.email) {
        fieldValues[fieldMap.email] = searchResult;
      }

      if (customerSearchType === "pan" && fieldMap.pan) {
        fieldValues[fieldMap.pan] = searchResult;
      }
    } else {
      fieldValues = {
        mobile: customerSearchType === "mobile" ? searchResult : "",
        name: customerSearchType === "name" ? searchResult : "",
        email: customerSearchType === "email" ? searchResult : "",
        gstNo: customerSearchType === "pan" ? searchResult : "",
        type: "addCustomerForm",
        ...defaultAddress,
      };
    }
    setKeyboardInputFields(fieldValues);
    customerForm.setFieldsValue(fieldValues);

    const loyaltyData = await db.loyalityData.toArray();
    const defaultLoyalty = loyaltyData.find((item) => item.isDefault === "Y");

    if (defaultLoyalty) {
      customerForm.setFieldsValue({
        program: defaultLoyalty.loyaltylevelId,
        loyaltyLevel: defaultLoyalty.loyaltylevelId,
      });
    }
    setDisplayAddNewCustomer(true);
  };

  const showAddNewUAECustomerFields = async () => {
    setDisplayUAECustomerSearch(false);

    const customerSearchType = /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/.test(customerSearchInput)
      ? "email"
      : /^\d+$/.test(customerSearchInput)
        ? "mobile"
        : "name";

    const defaultAddress = {
      country: tillData.tillAccess.csBunit.customerAddress?.csCountry?.name,
      state: tillData.tillAccess.csBunit.customerAddress?.csRegion?.name,
    };

    const fieldValues = {
      mobile: customerSearchType === "mobile" ? customerSearchInput : "",
      name: customerSearchType === "name" ? customerSearchInput : "",
      email: customerSearchType === "email" ? customerSearchInput : "",
      type: "UAECustomerForm",
      ...defaultAddress,
    };
    setKeyboardInputFields(fieldValues);
    UAECustomerForm.setFieldsValue(fieldValues);

    const loyaltyData = await db.loyalityData.toArray();
    const defaultLoyalty = loyaltyData.find((item) => item.isDefault === "Y");

    if (defaultLoyalty) {
      form.setFieldsValue({ program: defaultLoyalty.loyaltylevelId });
    }

    setDisplayUAECustomer(true);
  };

  const addNewCustomer = async (data) => {
    const mobileValue = data?.mobileno ?? data?.contactNumber ?? "";
    if (retailCustomerFields && retailCustomerFields.length > 0 && (!mobileValue || mobileValue.trim() === "")) {
      return new Promise((resolve, reject) => {
        Modal.confirm({
          title: "No Mobile Number",
          content: "Do you want to add customer without mobile number?",
          okText: "Proceed",
          cancelText: "Cancel",
          okButtonProps: { style: { display: "inline-block" } },
          onOk: async () => {
            try {
              if (navigator.onLine) {
                await createCustomer(
                  data,
                  cart,
                  setCart,
                  form,
                  tillLayout,
                  closeCustomerSearch,
                  tillData,
                  posLogActivity,
                  setKioskUI,
                  setDisplayAddNewCustomer,
                  UAECustomerForm,
                  customerForm,
                  setTillLink,
                  setCustomerLoading,
                  setDisplayUAECustomer,
                  isCallCenterFlow,
                  setCallCenterVisible,
                  setIsCallCenterFlow,
                  history,
                  setIsSubmittingCustomer,
                  setLastSearchedValue,
                  setSelectedB2BCustomer,
                  selectedB2BCustomer,
                  setSwitchToggle,
                  setFormDataCache,
                  isPanCustomer,
                  setIsPanCustomer,
                  isB2BEnabled,
                  setPanCustomerInfo,
                  panCustomerInfo,
                  pendingRefundCustomer,
                  setPendingRefundCustomer,
                  isRefundCustomerEdit,
                  setIsRefundCustomerEdit,
                  isRefundWalletOpen,
                  setIsRefundWalletOpen,
                  isNriBilling,
                  setIsNriBilling,
                  isCreditSale,
                  setIsCreditSale,
                  panDrawerMode,
                  documents,
                  setGstInfo,
                  retailCustomerFields,
                  gstInfo,
                  selectedInvoiceAddress,
                  selectedDeliveryAddress,
                  setSelectedInvoiceAddress,
                  setSelectedDeliveryAddress,
                  switchToggle
                );
              } else {
                errorMessage("Sync Failed", "Please check your network connection and try again");
              }
              resolve(true);
            } catch (err) {
              reject(err);
            }
          },
          onCancel: () => resolve(false),
        });
      });
    } else {
      if (navigator.onLine) {
        await createCustomer(
          data,
          cart,
          setCart,
          form,
          tillLayout,
          closeCustomerSearch,
          tillData,
          posLogActivity,
          setKioskUI,
          setDisplayAddNewCustomer,
          UAECustomerForm,
          customerForm,
          setTillLink,
          setCustomerLoading,
          setDisplayUAECustomer,
          isCallCenterFlow,
          setCallCenterVisible,
          setIsCallCenterFlow,
          history,
          setIsSubmittingCustomer,
          setLastSearchedValue,
          setSelectedB2BCustomer,
          selectedB2BCustomer,
          setSwitchToggle,
          setFormDataCache,
          isPanCustomer,
          setIsPanCustomer,
          isB2BEnabled,
          setPanCustomerInfo,
          panCustomerInfo,
          pendingRefundCustomer,
          setPendingRefundCustomer,
          isRefundCustomerEdit,
          setIsRefundCustomerEdit,
          isRefundWalletOpen,
          setIsRefundWalletOpen,
          isNriBilling,
          setIsNriBilling,
          isCreditSale,
          setIsCreditSale,
          panDrawerMode,
          documents,
          setGstInfo,
          retailCustomerFields,
          gstInfo,
          selectedInvoiceAddress,
          selectedDeliveryAddress,
          setSelectedInvoiceAddress,
          setSelectedDeliveryAddress,
          switchToggle
        );
      } else {
        errorMessage("Sync Failed", "Please check your network connection and try again");
      }
    }
  };
  // ADD NEW CUSTOMER BLOCK END

  // EDIT CUSTOMER BLOCK END
  const [displayEditOldCustomer, setDisplayEditOldCustomer] = useState(false);
  const [selectedEditOldCustomer, setSelectedEditOldCustomer] = useState();

  const showEditOldCustomerFields = async (customer) => {
    setDisplayCustomerSearch(false);
    setSelectedEditOldCustomer(customer);
    if (!customer) {
      console.error("Customer data not available");
      return;
    }

    const fieldValues = {
      editName: customer.name || "",
      editMobile: customer.mobileNo || "",
      editEmail: customer.email || "",
      editPincode: customer.pincode || "",
      name: customer.name || "",
      mobile: customer.mobileNo || "",
      birthday: customer.birthday ? moment(customer.birthday) : null,
      anniversaryDate: customer.anniversaryDate ? moment(customer.anniversaryDate) : null,
      city: customer.customerAddress?.line2 || "",
      street: customer.customerAddress?.line1 || "",
      gender: customer.gender || "",
      lastName: customer.lastName || "",
      taxID: customer.taxId || "",
      pincode: customer.pincode || "",
      country: customer.customerAddress?.country || tillData.tillAccess.csBunit.customerAddress?.csCountry?.name || "",
      state: customer.customerAddress?.region || tillData.tillAccess.csBunit.customerAddress?.csRegion?.name || "",
      type: "editCustomerForm",
    };

    form.setFieldsValue(fieldValues);
    setKeyboardInputFields(fieldValues);

    try {
      let loyaltyData = await db.loyalityData.toArray();
      loyaltyData.forEach((item) => {
        if (item.isDefault === "Y") {
          form.setFieldsValue({
            program: item.loyaltylevelId || "", // Handle missing loyalty level
          });
        }
      });
    } catch (error) {
      console.error("Error fetching loyalty data:", error);
    }

    setDisplayEditOldCustomer(true);
  };

  const editOldCustomer = async (data) => {
    const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE";
    const activeCart = isExchange ? JSON.parse(localStorage.getItem("exchangeCartObj") || "{}") : cart;
    const resolvedPanDrawerMode = panDrawerMode === "THRESHOLD" && isPanCustomer && panCustomerInfo?.realStatus === "VALID & OPERATIVE" ? "VALIDATION" : panDrawerMode;
    const oldCustomer = isExchange ? activeCart?.customer : selectedEditOldCustomer;
    await updateCustomer(
      data,
      activeCart,
      setCart,
      form,
      closeCustomerSearch,
      oldCustomer,
      setSelectedEditOldCustomer,
      setDisplayEditOldCustomer,
      tillData,
      activeCart?.customer,
      UAECustomerForm,
      setDisplayAddNewCustomer,
      setFormDataCache,
      setIsSubmittingCustomer,
      setLastSearchedValue,
      setSelectedB2BCustomer,
      selectedB2BCustomer,
      isCallCenterFlow,
      setCallCenterVisible,
      setIsCallCenterFlow,
      history,
      tillLayout,
      isPanCustomer,
      setIsPanCustomer,
      isB2BEnabled,
      setPanCustomerInfo,
      panCustomerInfo,
      pendingRefundCustomer,
      setPendingRefundCustomer,
      isRefundCustomerEdit,
      setIsRefundCustomerEdit,
      isRefundWalletOpen,
      setIsRefundWalletOpen,
      isNriBilling,
      setIsNriBilling,
      isCreditSale,
      setIsCreditSale,
      resolvedPanDrawerMode,
      documents,
      setGstInfo,
      gstInfo,
      setExchangeCartTcs,
      selectedInvoiceAddress,
      selectedDeliveryAddress,
      setSelectedInvoiceAddress,
      setSelectedDeliveryAddress,
      switchToggle,
      setSwitchToggle
    );
  };
  // EDIT CUSTOMER BLOCK END

  //// CENTER BUTTON BLOCK START /////

  const [isQtyUpdate, setIsQtyUpdate] = useState(false);
  const [showPaymentMethods, setShowPaymentMethods] = useState(false);
  const [selectedProductInCart, setSelectedProductInCart] = useState({});
  const [selectedProductQty, setSelectProductQty] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [isInputFocused, setIsInputFocused] = useState(false);

  const selectProductInCart = (record, e) => {
    if (record.productId === selectedProductInCart.productId && e !== "1") {
      // setSelectedRowKeys([]);
      // setSelectedProductInCart({});
    } else {
      record.weight = parseFloat(parseFloat(record.weight)?.toFixed(record?.isQtyDesimal));
      setSelectedRowKeys([record.key]);
      setSelectedProductInCart(record);
    }
  };

  const enterTotalQty = async (type) => {
    const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE";

    const activeCart = isExchange ? JSON.parse(localStorage.getItem("exchangeCartObj") || "{}") : cart;
    // stopCallingGetWeight();
    if (activeCart.payments.length > 0) {
      Modal.confirm({
        title: "Payment is in progress. You cannot modify cart items once payment has started. Please complete or cancel this payment to proceed",
        icon: null,
        okText: "Ok",
        cancelButtonProps: { style: { display: "none" } }, // hides the Cancel button
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        onOk() {
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
            }, 300);
          }
        },
      });
    } else {
      setDisplayManualQtyWeightInput(false);
      if (CWHardwareController) {
        CWPoleDisplay(selectedProductInCart, "Quantity update");
      } else {
        PoleDisplay(selectedProductInCart, "Quantity update");
      }
      if (activeCart.items.length > 0 && selectedProductInCart.weight > 0 && !selectedProductInCart.isReturn) {
        let totalQtyFlag = true;
        setSelectedProductInCart({});
        let product = {};
        const addedToCart = activeCart.items;

        // Use Promise.all to wait for all async operations to complete
        // await Promise.all(
        //   addedToCart.map(async (item) => {
        //     if (item.value === selectedProductInCart.value && item.lineId === selectedProductInCart.lineId) {
        //       product = item;
        //     }
        //   })
        // );

        if (selectedProductInCart.groupedItems) {
          const parentItem = addedToCart.find((item) => item.children?.some((child) => child.childrenId === selectedProductInCart.childrenId));
          if (parentItem) {
            await Promise.all(
              parentItem.children.map(async (childItem) => {
                if (childItem.childrenId === selectedProductInCart.childrenId && childItem.lineId === selectedProductInCart.lineId) {
                  product = childItem;
                }
              })
            );
          }
        } else {
          // Case: Handle normal items
          await Promise.all(
            addedToCart.map(async (item) => {
              if (item.value === selectedProductInCart.value && item.lineId === selectedProductInCart.lineId) {
                product = item;
              }
            })
          );
        }

        delete product.expiryId;
        setIsInputFocused(false);
        if (type === "weight") {
          addProduct(selectedProductInCart, selectedProductInCart.weight, totalQtyFlag, 0, false, false);
        } else {
          addProduct(product, selectedProductInCart.weight, totalQtyFlag, 0, false, false);
        }

        const amountInput = document.getElementById("sm-amount-input");
        if (amountInput) {
          amountInput?.focus();
          amountInput?.blur();
        }
        setTimeout(() => {
          if (searchInputRef?.current) {
            searchInputRef?.current?.focus();
          }
        }, 100);
      }
    }
  };

  const enterRealPrice = async (type) => {
    // stopCallingGetWeight();
    setDisplayManualQtyWeightInput(false);
    if (CWHardwareController) {
      CWPoleDisplay(selectedProductInCart, "Quantity update");
    } else {
      PoleDisplay(selectedProductInCart, "Quantity update");
    }
    if (cart.items.length > 0 && selectedProductInCart.weight > 0 && !selectedProductInCart.isReturn) {
      let totalQtyFlag = true;
      setSelectedProductInCart({});
      let product = {};
      const addedToCart = cart.items;

      // Use Promise.all to wait for all async operations to complete
      await Promise.all(
        addedToCart.map(async (item, index) => {
          if (item.value === selectedProductInCart.value && item.lineId === selectedProductInCart.lineId) {
            // product = item;
            product = { ...item, realPrice: Number(realPrice) };
            addedToCart[index] = { ...item, realPrice: Number(realPrice), salePrice: Number(realPrice), originalPrice: Number(realPrice), sunitprice: Number(realPrice) };
            setSelectedProductInCart(addedToCart[index]);
            // setSelectedProductInCart(product);
          }
        })
      );
      const updatedCart = {
        ...cart,
        items: addedToCart,
      };
      if (!isExchange) {
        setCart(updatedCart);
        localStorage.setItem("cartObj", JSON.stringify(updatedCart));
      }
      delete product.expiryId;
      setIsInputFocused(false);
      if (type === "weight") {
        addProduct(selectedProductInCart, selectedProductInCart.weight, totalQtyFlag, 0, false, false);
      } else {
        addProduct(product, selectedProductInCart.weight, totalQtyFlag, 0, false, false);
      }

      const amountInput = document.getElementById("sm-amount-input");
      if (amountInput) {
        amountInput?.focus();
        amountInput?.blur();
      }
    }
  };
  const onChangeTotalQuantity = async (e) => {
    if (!selectedProductInCart.isReturn && Object.keys(selectedProductInCart).length > 0) {
      delete selectedProductInCart.expiryId;
      setSelectedProductInCart({ ...selectedProductInCart, weight: selectedProductInCart.isDecimalQty === true ? e : e.replaceAll(".", "") });
    }
  };

  const handleTotalQty = async (value) => {
    // if (isInputFocused === false) {
    //   if (productSearchInput === "" && value === "x") {
    //     setProductSearchInput("");
    //   } else if (value === "x") {
    //     setProductSearchInput(`${productSearchI nput.toString().substring(0, productSearchInput.toString().length - 1)}`);
    //   } else {
    //     setProductSearchInput(`${productSearchInput ? productSearchInput : ""}${value}`);
    //   }
    // } else {
    if (selectedProductInCart?.restrictPosQtyEdit === "Y") {
      return;
    }
    if (Object.keys(selectedProductInCart).length > 0 && !selectedProductInCart.isReturn) {
      if (selectedProductQty === "" && value === "x") {
        setSelectedProductInCart({ ...selectedProductInCart, weight: 0 });
      } else if (value === "x") {
        setSelectedProductInCart({
          ...selectedProductInCart,
          weight: `${selectedProductInCart.weight.toString().substring(0, selectedProductInCart.weight.toString().length - 1)}`,
        });
      } else if (value === "clear") {
        setSelectedProductInCart({ ...selectedProductInCart, weight: 0 });
      } else {
        if (qtyNumberFlag === 0) {
          setQtyNumberFlag(1);
          setSelectedProductInCart({ ...selectedProductInCart, weight: value });
        } else {
          setSelectedProductInCart({
            ...selectedProductInCart,
            weight: selectedProductInCart.isDecimalQty === true ? `${selectedProductInCart.weight}${value}` : `${selectedProductInCart.weight}${value}`.replaceAll(".", ""),
          });
        }
      }
    }
    const amountInput = document.getElementById("sm-amount-input");
    if (amountInput) {
      amountInput?.focus();
    }
    // }
  };

  const compressImage = (file, maxWidth = 1920, quality = 0.75) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = (e) => {
        image.src = e.target.result;
      };

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        let width = image.width;
        let height = image.height;

        // Maintain aspect ratio
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(image, 0, 0, width, height);

        // Convert canvas to blob
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Image compression failed"));
              return;
            }

            // Create new compressed file
            const compressedFile = new File([blob], file.name, {
              type: file.type,
              lastModified: Date.now(),
            });

            resolve(compressedFile);
          },
          file.type,
          quality
        );
      };

      image.onerror = (err) => {
        reject(err);
      };

      reader.onerror = (err) => {
        reject(err);
      };
    });
  };

  const handleRealPrice = (value) => {
    let updatedPrice = realPrice;

    if (value === "x") {
      updatedPrice = realPrice.slice(0, -1);
    } else if (value === "clear") {
      updatedPrice = "";
    } else if (value === ".") {
      if (!realPrice.includes(".")) {
        updatedPrice += ".";
      }
    } else {
      if (firstInputValue) {
        updatedPrice = value;
        setFirstInputValue(false);
      } else {
        updatedPrice += value;
      }
    }

    setRealPrice(updatedPrice);
  };

  const selectProduct = (record) => {
    setSelectedKeys([record.key]);
    // setSelectedProduct(record);
  };

  const selectSalseProduct = (record) => {
    setSelectedKeys([record.sOrderID]);
    // setSelectedProduct(record);
  };

  const deleteProduct = async (addToCart) => {
    try {
      clearSelectedProductInCart();
      const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE";
      const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
      const activeCart = isExchange && exchangeCartObj?.items?.length > 0 ? exchangeCartObj : cart;
      if (activeCart.isRetrived === "Y" && activeCart.items.length === 1) {
        message.warning(`${messages.errors.cart.cannot_delete_parked_item}`);
        return;
      } else if (
        activeCart.isRetrived === "Y" &&
        activeCart.items.length > 1 &&
        addToCart?.type !== "S" &&
        addToCart?.productSegment !== "" &&
        addToCart?.productSegment !== "AD"
      ) {
        message.warning(`${messages.errors.cart.cannot_delete_parked_item}`);
        return;
      } else if (activeCart.payments.length > 0) {
        message.warning(`${messages.errors.cart.delete_payment_first}`);
        return;
      } else if (addToCart.isReturn) return;
      const deleteProductInCart = true;
      await addProduct(addToCart, -addToCart.weight, false, 0, deleteProductInCart, false);
      if (giftCardData?.length > 0) {
        let authToken = authHeaders?.access_token || "";
        const { referenceId } = activeCart;
        const giftCardDetails = giftCardData.map(
          (ele) => `{
          cardNo: ${ele.number ? `"${ele.number}"` : null},
          type: "RD",
          referenceNo: "${referenceId}",
          amount: ${ele.amount * -1},
          cardPin: ${ele.pin ? `"${ele.pin}"` : null}
          tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
          b2c_Customer_Id: ${activeCart.customer.cwrCustomerId ? `"${activeCart.customer.cwrCustomerId}"` : null}
        }`
        );
        const query = `
          mutation {
            upsertGiftCardTransaction(giftCardTransactions: [${giftCardDetails.join(",")}]) {
              status
              message
            }
          }`;

        await upsertGiftCardTransaction(query);

        // const paidAmount = giftCardData.reduce((sum, ele) => sum + ele.amount, 0);
        // const updatedPayments = cart.payments.filter((payment) => payment.name.toLowerCase() !== "gift card");

        // cart.payments = updatedPayments;
        // cart.giftCardData = [];
        // cart.total -= paidAmount;

        if (!isExchange) {
          setCart((prevCart) => {
            const paidAmount = giftCardData.reduce((sum, ele) => sum + ele.amount, 0);
            const updatedPayments = prevCart.payments.filter((payment) => payment.name.toLowerCase() !== "gift card");

            return {
              ...prevCart,
              payments: updatedPayments,
              giftCardData: [],
              total: prevCart.total - paidAmount,
            };
          });
        }
        setGiftCardData([]);
        // setCart(cart);
      }

      const posConfig = JSON.parse(localStorage.getItem("posConfig")) || {};
      if (posConfig?.DLN === "Y") {
        posLogActivity(addToCart, "DLN");
      }
    } catch (error) {
      message.error(error.message || `${messages.errors.cart.error_deleting_product}`);
    }
  };

  const decreaseProductQty = (addToCart) => {
    if (cart.payments.length > 0) {
      Modal.confirm({
        title: "Payment is in progress. You cannot modify cart items once payment has started. Please complete or cancel this payment to proceed",
        icon: null,
        okText: "Ok",
        cancelButtonProps: { style: { display: "none" } }, // hides the Cancel button
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        onOk() {
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
            }, 300);
          }
        },
      });
    } else {
      if (!addToCart.isReturn) {
        // ⭐ MANUAL WEIGHT HANDLER ⭐
        if (addToCart.isManualQty) {
          dispatchWeight(addToCart, setInputFocused, selectedProductInCart, setSelectedProductInCart, (updatedProduct) => {
            if (updatedProduct) {
              updatedProduct.lineId = addToCart.lineId;
              addProduct(updatedProduct, updatedProduct?.weight || 1, true, 0, false, true);
              // const updatedItems = cart.items.map((i) => {
              //   if (i.lineId === addToCart.lineId) {
              //     const newWeight = Number(updatedProduct.weight);
              //     const unitPrice = Number(i.sunitprice) || Number(i.salePrice) || 0;
              //     // const newNetTotal = newWeight * unitPrice;
              //     const unitTax = taxIncludeFlag === "Y" ? unitPrice - unitPrice / (1 + i.taxRate / 100) : (unitPrice * i.taxRate) / 100;
              //     const newNetTotal =
              //       taxIncludeFlag === "Y" ? parseFloat(newWeight * unitPrice).toFixed(pricePrecision) : parseFloat(newWeight * (unitPrice + unitTax)).toFixed(pricePrecision);

              //     return {
              //       ...i,
              //       weight: newWeight,
              //       nettotal: newNetTotal,
              //     };
              //   }
              //   return i;
              // });

              // const updatedCart = {
              //   ...cart,
              //   items: updatedItems,
              //   total: updatedItems.reduce((sum, item) => sum + (item.nettotal || 0), 0),
              // };
              // if (!isExchange) {
              //   setCart(updatedCart);
              //   localStorage.setItem("cartObj", JSON.stringify(updatedCart));
              // }
            }
          });
          return; // IMPORTANT: prevent normal -1 flow
        }

        // 🟢 ORIGINAL LOGIC — UNTOUCHED
        if (!addToCart.isManualQty) {
          if (addToCart.weight - 1 !== 0) {
            delete addToCart.expiryId;
          }
          const deleteQty = addToCart.weight - 1;
          if (cart.isRetrived === "Y" && cart.items.length === 1 && deleteQty <= 0) {
            message.warning(`${messages.errors.cart.cannot_delete_parked_item}`);
            return;
          }
          addProduct(addToCart, -1, false, 0, false, true);
          if (JSON.parse(localStorage.getItem("posConfig"))?.RQT === "Y") {
            posLogActivity(addToCart, "RQT");
          }
          const amountInput = document.getElementById("sm-amount-input");
          if (amountInput) {
            amountInput?.focus();
            amountInput?.blur();
          }
        }
      }
    }
  };

  // const increaseProductQty = (addToCart) => {
  //   if (!addToCart.isReturn) {
  //     if (!addToCart.isManualQty) {
  //       delete addToCart.expiryId;
  //       addProduct(addToCart, 1);
  //       const amountInput = document.getElementById("sm-amount-input");
  //       if (amountInput) {
  //         amountInput?.focus();
  //         amountInput?.blur();
  //       }
  //     }
  //   }
  // };

  const increaseProductQty = async (addToCart) => {
    if (cart.payments.length > 0) {
      Modal.confirm({
        title: "Payment is in progress. You cannot modify cart items once payment has started. Please complete or cancel this payment to proceed",
        icon: null,
        okText: "Ok",
        cancelButtonProps: { style: { display: "none" } }, // hides the Cancel button
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        onOk() {
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
            }, 300);
          }
        },
      });
    } else {
      if (!addToCart.isReturn) {
        // ⭐ MANUAL WEIGHT HANDLER ⭐
        console.log(addToCart, "----------------------------->addToCart");
        if (addToCart.isManualQty) {
          dispatchWeight(addToCart, setInputFocused, selectedProductInCart, setSelectedProductInCart, (updatedProduct) => {
            console.log(updatedProduct, "----------------------------->updatedProduct");
            if (updatedProduct) {
              updatedProduct.lineId = addToCart.lineId;
              addProduct(updatedProduct, updatedProduct?.weight || 1, true, 0, false, true);
            }
          });
          return; // IMPORTANT: prevent +1 normal flow
        } else if (addToCart?.productAddons?.length > 0) {
          setSelectedProduct(addToCart);
          const requiredListFilter = _.filter([...addToCart.productAddons], (item) => item.mAddonGroup.minqty === 1);

          const optionsListFilter = _.filter([...addToCart.productAddons], (item) => item.mAddonGroup.minqty === 0);

          setAddOnsList({
            requiredList: requiredListFilter || [],
            optionsList: optionsListFilter || [],
          });

          setAddonSourceItem(addToCart);
          setShowAddonsCustomizePopUp(true);
          return;
        }

        // 🟢 ORIGINAL LOGIC — UNTOUCHED
        if (!addToCart.isManualQty) {
          delete addToCart.expiryId;
          addProduct(addToCart, 1, false, 0, false, true);
          const amountInput = document.getElementById("sm-amount-input");
          if (amountInput) {
            amountInput?.focus();
            amountInput?.blur();
          }
        }
      }
    }
  };

  const deleteReceipt = (param, exchangeFlag) => {
    let cartObj = {
      items: [],
      couponInput: [],
      advancePayment: 0,
      total: 0,
      tax: 0,
      discount: 0,
      paid: 0,
      change: 0,
      totalQty: 0,
      roundOff: 0,
      payments: [],
      redemptionPoints: 0,
      accumulationPoints: 0,
      creditAmount: 0,
      docType: "Invoice",
      sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
      referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
      giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
      couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
      customer: selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : defaultCustomer,
      salesRepId: null,
      cardPaymentData: {},
      documentno:
        cart?.parked === "Y"
          ? `${tillData.tillAccess.cwrTill.prefix}${documentSequence + 1}`
          : param === "layAwayParked" || param
            ? `${tillData.tillAccess.cwrTill.prefix}${documentSequence + 1}`
            : `${tillData.tillAccess.cwrTill.prefix}${documentSequence + 2}`,
      userName: userData.user,
      tillName: tillValue?.name,
      subTotal: 0,
      itemsSummery: {},
      amountInWords: "",
      groupedItemsByTaxRate: {},
      serviceCharge: 0,
      tip: 0,
      deiveryCharge: 0,
      packingCharge: 0,
      others: 0,
    };
    // localStorage.setItem("exchangeCartObj", JSON.stringify(cartObj));
    if (!exchangeFlag) {
      setCart(cartObj);
      localStorage.setItem("cartObj", JSON.stringify(cartObj));
    }

    setSelectedRowKeys([]);
    setSelectedProductInCart({});
    setAmount("");
    if (selectedReturnType !== "STORE_CREDIT") {
      setSelectedPaymentMethod("");
    }
  };

  const deleteCart = (status = false, type, isExchangeFlag) => {
    if (status === true) {
      if (JSON.parse(localStorage.getItem("posConfig"))?.DOR === "Y") {
        upsertPOSLog(cart, "DOR");
      }
    }
    deleteReceipt(type, isExchangeFlag);
    /* if (parkedList.length > 0) {
        selectParkedBill(parkedList[0]);
      } */
  };

  // ORDER HISTORY BLOCK START
  const [displayOrderHistory, setDisplayOrderHistory] = useState(false);
  const [orderHistoryDetails, setOrderHistoryDetails] = useState([]);
  const [ordersCopy, setOrdersCopy] = useState([]);
  const [selectDate, setSelectDate] = useState("");
  const [salesHistoryType, setSalesHistoryType] = useState([]);
  const [startRowData, setStartRowData] = useState({ startRow: "0", endRow: "10" });

  const [orderHistorySearchType, setOrderHistorySearchType] = useState("orderDocumentNo");
  const changeOrderHistorySearchType = (value, e) => {
    setOrderHistorySearchType(value);
    setSelectDate(e);
  };

  const showOrderHistory = () => {
    db.orders
      .orderBy("orderTime")
      .limit(20)
      .reverse()
      .toArray()
      .then((data) => {
        setDisplayOrderHistory(true);
      });
  };

  const [selectedOrderHistoryLine, setSelectedOrderHistoryLine] = useState("");
  const showOrderHistoryLine = (orderID) => {
    if (selectedOrderHistoryLine === orderID) {
      setSelectedOrderHistoryLine("");
    } else {
      setSelectedOrderHistoryLine(orderID);
    }
  };

  // useEffect(() => {
  //   localStorage.setItem("dataLength", orderHistoryDetails.length);
  // }, [orderHistoryDetails]);

  const getSalesHistoryData = async (order_id) => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    setLoading(true);
    try {
      const data = {
        query: `query {salesHistoryDetails(
                    orderId: "${order_id}"
                  ) {
                    sOrderID
                    created
                    createdby
                    updated
                    updatedby
                    deliveryDate
                    documentno
                    salesRepID
                    dateordered
                    cwrProductQty
                    orderTime
                    taxamt
                    grosstotal
                    discAmount
                    layAway
                    creditSale
                    isReturn
                    paid
                    csUser {
                      user
                    }
                    csBUnit {
                      csBunitId
                      name
                    }
                    csbUnitLocation {
                      fulladdress
                    }
                    cwrB2cCustomer {
                      cwrCustomerId
                      sPriceListId
                      code
                      name
                      mobileNo
                      pincode
                      email
                      retlLoyaltyBalance
                      iscredit
                      loyaltyLevelId
                      creditBalance
                      loyaltyLevel {
                       cwrLoyaltyLevelId
                       name
                      }
                      cwrWallet {
                        wallet_Id
                        balance_Amt
                      }
                      sCustomer {
                        sCustomerID
                        customerCategory {
                          sCustomerCateforyId
                          value
                          name
                          description
                        }
                      }
                    }
                    saleType {
                      cwrSaletypeId
                      name
                      value
                    }
                    cwrTill {
                      cwrTillID
                      till
                    }
                    tablename
                    fboRder {
                      guests
                    }
                    saLesRep {
                      waitername
                    }
                    finReceiptPlan {
                      finReceiptPlanDetails {
                        amount
                        transactionId
                        cardType
                        cardNo
                        transactionTime
                        authorizationCode
                        cwrPaymentmethod {
                          cWRPaymentMethodID
                          finFinancialAccountId
                          finPaymentmethodId
                          integratedPayment
                          isloyalty
                          paymentProvider
                        }
                      }
                    }
                    line {
                      sOrderlineID
                      sOrderId
                      line
                      description
                      qty
                      deliveryDate
                      netlist
                      netunit
                      created
                      linetax
                      unittax
                      unitprice
                      linenet
                      linegross
                      grosslist
                      grossstd
                      returnline
                      returnQty
                      discount
                      mBatchId
                      batchNo
                      product {
                        mProductId
                        name
                        value
                        upc
                        hsncode
                        imageurl
                        isManualQty
                        shortDescription
                        returnable
                        returnDays
                        productSegment
                      }
                      uom {
                        csUomId
                        name
                      }
                      tax {
                        csTaxID
                        name
                        rate
                      }
                      pricingRule {
                        mPricingrulesId
                        name
                      }
                      addons {
                        qty
                        price
                        name
                        addonProductId
                        value
                      }
                    }
                    metaData { key value }
                  }
                }`,
      };
      const response = await salesHistoryService(data);
      // Processing the fetched data
      let totalQty = 0;
      const salesData = response?.data?.data?.salesHistoryDetails;
      if (salesData[0]?.metaData?.length > 0) {
        setMetaData(salesData[0].metaData);
        metaDataRef.current = salesData[0].metaData;
      }

      const arrayData = await Promise.all(
        response?.data?.data?.salesHistoryDetails?.map(async (item) => {
          const paymentMethods = [];
          let change = 0;

          const itemSummery = {
            decimalItems: { totalQty: 0, totalAmount: 0 },
            nonDecimalItems: { totalQty: 0, totalAmount: 0 },
            itemsQty: 0,
            items: 0,
          };

          // Group items by tax rate
          const groupedItems = (item.line || []).reduce((acc, item) => {
            const key = item.tax?.rate ?? item.taxRate ?? "0";
            acc[key] = acc[key] || [];
            acc[key].push(item);
            return acc;
          }, {});

          // Calculate tax totals with SGST and CGST
          const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
            const totalTaxAmount = items.reduce((sum, item) => {
              const taxValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.linetax : item.taxAmount) || 0;
              return sum + parseFloat(taxValue);
            }, 0);

            const totalNetTotal = items.reduce((sum, item) => {
              const netValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.linegross : item.nettotal) || 0;
              return parseFloat(parseFloat(sum).toFixed(precision)) + parseFloat(parseFloat(netValue).toFixed(precision));
            }, 0);

            // Calculate SGST and CGST (assuming they're either explicitly provided or half of total tax)
            const totalSgstAmount = items.reduce((sum, item) => {
              const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.linetax || item.taxAmount || 0) / 2;
              return sum + parseFloat(sgstValue || 0);
            }, 0);

            const totalCgstAmount = items.reduce((sum, item) => {
              const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.linetax || item.taxAmount || 0) / 2;
              return sum + parseFloat(cgstValue || 0);
            }, 0);

            return {
              taxRate,
              totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount)?.toFixed(precision)),
              totalLinetax: parseFloat(parseFloat(totalTaxAmount)?.toFixed(precision)),
              totalLinegross: parseFloat(parseFloat(totalNetTotal)?.toFixed(precision)),
              totalSgst: parseFloat(parseFloat(totalSgstAmount)?.toFixed(precision)),
              totalCgst: parseFloat(parseFloat(totalCgstAmount)?.toFixed(precision)),
            };
          });

          let totalLineStd = 0;
          const lineItems = await Promise.all(
            item.line.map(async (pro) => {
              const productObj = await db.products
                .where("mProductId")
                .equals(pro.product.mProductId)
                .and((product) => product.productSegment !== "BG")
                .first();
              if (!productObj && pro?.product?.mProductId) {
                try {
                  const normalizedValue = pro.product.mProductId?.toString().trim();

                  console.log("Syncing missing product using productId as value:", normalizedValue);

                  const syncId = localStorage.getItem("syncId") || uuidv4().replace(/-/g, "").toUpperCase();

                  await syncSingleProductByValue(tillData, syncId, tillData?.tillAccess?.cwrTill?.cwrTillID, normalizedValue);

                  // 🔁 Re-fetch after sync
                  productObj = await db.products
                    .where("mProductId")
                    .equals(pro.product.mProductId)
                    .and((product) => product.productSegment !== "BG")
                    .first();
                } catch (err) {
                  console.error("Sales history product sync (by productId) failed:", err);
                }
              }
              const matchedGiftCardData = await db.giftCardData
                .toArray()
                .then((giftCardData) => giftCardData.find((giftcard) => giftcard.mProductId === item.mProductId || pro.product.mProductId));

              // Update summary
              // const isDecimal = pro.uomData?.[0]?.decimal === "Y" || pro?.isDecimal;
              // const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";
              // itemSummery.itemsQty += pro.qty;
              // itemSummery.items += 1;
              // itemSummery[summaryKey].totalQty += pro.qty;
              // itemSummery[summaryKey].totalAmount += pro.linegross;

              if (Array.isArray(pro.children) && pro.children.length > 0) {
                pro.children.forEach((child) => {
                  const isDecimal = pro.uomData?.[0]?.decimal === "Y" || pro?.isDecimal;
                  const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

                  itemSummery.itemsQty += child.qty;
                  itemSummery.items += 1;
                  itemSummery[summaryKey].totalQty += child.qty;
                  itemSummery[summaryKey].totalAmount += child.linegross;
                });
              } else {
                const isDecimal = pro.uomData?.[0]?.decimal === "Y" || pro.isDecimal;
                const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

                itemSummery.itemsQty += pro.qty;
                itemSummery.items += 1;
                itemSummery[summaryKey].totalQty += pro.qty;
                itemSummery[summaryKey].totalAmount += pro.linegross;
              }

              const productDefined = {
                batchno: pro?.batchNo?.split("-:")[0] || pro?.batchNo || productObj?.batchno || null,
                description: productObj?.description || "",
                discount: pro?.discount ?? 0,
                discountName: pro?.pricingRule?.name || "",
                imageurl: productObj?.imageurl || "",
                isDecimal: productObj?.isDecimal || false,
                isManualQty: productObj?.isManualQty || false,
                restrictPosQtyEdit: productObj?.restrictPosQtyEdit || "N",
                showAlternateUomInPos: productObj?.showAlternateUomInPos || "N",
                posPriceEdit: productObj?.posPriceEdit || "N",
                alternateUom: productObj?.alternateUom || null,
                companion: productObj?.companion || "N",
                isPromoApplicable: productObj?.isPromoApplicable || false,
                deliveryDate: pro?.deliveryDate ? moment(pro?.deliveryDate).format("DD-MM-YYYY HH:mm:ss") : null,
                isReturn: false,
                mBatchId: pro?.mBatchId || null,
                giftCardType: matchedGiftCardData ? matchedGiftCardData?.type : null,
                mPricingruleId: null,
                name: productObj?.name || "",
                name2: productObj?.name2 || "",
                nettotal: pro.linegross || 0,
                primaryOrderLine: null,
                productId: productObj?.mProductId || null,
                realPrice: pro.unitprice || 0,
                listPrice: productObj?.slistprice || 0,
                sunitprice: pro?.unitprice || 0,
                returnQty: null,
                originalPrice: pro?.unitprice || 0,
                productSegment: pro?.product?.productSegment || "",
                salePrice: pro?.unitprice || 0,
                stock: productObj?.onhandQty || 0,
                tax: productObj?.cTaxId || null,
                taxCategory: productObj?.taxCategory || "",
                taxName: productObj?.taxName || "",
                taxFlag: productObj?.taxFlag || "N",
                taxAmount: pro.linetax || 0,
                taxRate: productObj?.taxRate || 0,
                interTaxId: productObj?.interTaxId || "",
                interTaxRate: productObj?.interTaxRate || 0,
                interTaxName: productObj?.interTaxName || "",
                uom: productObj?.csUomId || null,
                uom_name: productObj?.uomName || "",
                addNewLine: productObj?.addNewLine || "N",
                customAttributes: productObj?.customAttributes || [],
                preparationTime: productObj?.preparationTime || "",
                printerId: productObj?.printerId || "",
                showAddons: productObj?.showAddons || false,
                foodType: productObj?.foodType || "",
                itemType: productObj?.itemType || "",
                type: productObj?.type || "",
                newCustomAttributes: [],
                priceList: productObj?.priceList || [],
                addons: pro.addons || [],
                selectedAddons: [],
                isDecimalQty: productObj?.uomData?.[0]?.decimal === "Y",
                isQtyDesimal: productObj?.uomData?.[0]?.stdprecision ?? 2,
                upc: pro.product?.upc || null,
                value: productObj?.value || null,
                weight: pro.qty || 0,
                order: "N",
                productionCenter: productObj?.productionCenter || "",
                productionCenterId: productObj?.productionCenterId || "",
                shortDescription: productObj?.shortDescription || "",
                hsncode: productObj?.hsncode || null,
                csBunitId: productObj?.csBunitId || null,
                mProductCategoryId: productObj?.mProductCategoryId || null,
                productManufacturerId: productObj?.productManufacturerId || null,
                productBrandId: productObj?.productBrandId || null,
                productBrandName: productObj?.productBrandName || null,
                productCategoryName: productObj?.productCategoryName || "",
                productAddons: productObj?.productAddons || [],
                batchedProduct: productObj?.batchedProduct || false,
                batchedForSale: productObj?.batchedForSale || false,
                batchedForStock: productObj?.batchedForStock || false,
                multiPrice: productObj?.multiPrice || [],
                shelfLife: productObj?.shelfLife || 0,
                stdTax: productObj?.sunitprice * (1 + productObj?.taxRate / 100),
                lineId: uuidv4().replace(/-/g, "").toUpperCase(),
                layAway: item.layAway || "N",
                // linestd: pro.grossstd * pro.qty,
                // linestd: pro.linegross,
                linestd:
                  taxIncludeFlag === "Y"
                    ? productObj?.sunitprice
                      ? productObj?.sunitprice * pro.qty
                      : pro.linegross
                    : productObj?.sunitprice
                      ? productObj?.sunitprice * (1 + productObj?.taxRate / 100) * pro.qty
                      : pro.linegross,
              };
              // const linestd = (pro.grossstd || 0) * (pro.qty || 0);
              // const linestd = pro.linegross;
              const linestd =
                taxIncludeFlag === "Y"
                  ? productObj?.sunitprice
                    ? productObj?.sunitprice * pro.qty
                    : pro.linegross
                  : productObj?.sunitprice
                    ? productObj?.sunitprice * (1 + productObj?.taxRate / 100) * pro.qty
                    : pro.linegross;
              totalLineStd += linestd;

              return { ...pro, ...productDefined };
            })
          );

          let paidAmount = 0;
          item?.finReceiptPlan?.[0]?.finReceiptPlanDetails?.forEach((ele) => {
            const paymentMethod = tillDataPaymentMethods.find((pi) => pi.finPaymentmethodId === ele.cwrPaymentmethod.finPaymentmethodId);
            if (paymentMethod && ele.amount > 0) {
              // paymentMethods.push({ ...paymentMethod, amount: parseFloat(ele.amount?.toFixed(2)), advancePayment: parseFloat(ele.amount?.toFixed(2)) });
              paymentMethods.push({
                ...paymentMethod,
                amount: parseFloat(parseFloat(ele.amount)?.toFixed(precision)),
                advancePayment: parseFloat(parseFloat(ele.amount)?.toFixed(precision)),
                transactionId: ele.transactionId || "",
                cardType: ele.cardType || "",
                cardNo: ele.cardNo || "",
                transactionTime: ele.transactionTime ? moment(ele.transactionTime).format("DD-MM-YYYY HH:mm:ss") : "",
                authorizationCode: ele.authorizationCode || "",
              });
              paidAmount += ele.amount;
            } else if (ele.amount < 0) {
              change = ele.amount;
            }
          });
          salesData?.forEach((item) => {
            const paymentDetailsMeta = item.metaData?.find((meta) => meta.key === "Payment Details");
            const paymentDetails = paymentDetailsMeta ? JSON.parse(paymentDetailsMeta.value) : [];
            const changeObj = paymentDetails.find((detail) => detail.change !== undefined && detail.change !== null);
            change = changeObj ? changeObj.change : 0;
          });
          const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData") || "{}");
          const selectedPriceListId = item?.cwrB2cCustomer?.sPriceListId ?? saleTypeData?.customer?.sPriceListId;
          return {
            change,
            items: lineItems || [],
            cardPaymentData: {},
            originalPrice: item.grosstotal || 0,
            customer: { ...item.cwrB2cCustomer, sPriceListId: selectedPriceListId } || "",
            documentno: item.documentno,
            salesRepID: item.salesRepID,
            total: parseFloat(parseFloat(item.grosstotal || 0)?.toFixed(precision)),
            discount: item.discAmount || 0,
            tax: item.taxamt || 0,
            deliveryDate: item?.deliveryDate ? moment(item?.deliveryDate).format("DD-MM-YYYY HH:mm:ss") : null,
            orderTime: item.orderTime ? moment(item.orderTime).format("DD-MM-YYYY HH:mm:ss") : null,
            orderDate: item.dateordered,
            totalQty: item.cwrProductQty,
            payments: [],
            paymentData: paymentMethods || [],
            roundOff: 0,
            sOrderID: item.sOrderID,
            key: item.documentno,
            salesHistory: "Y",
            status: "Success",
            isSynced: 0,
            creditAmount: 0,
            createdBy: "",
            layAway: item?.layAway || "N",
            creditSale: item?.creditSale || "N",
            isReturn: item?.isReturn || "N",
            paid: paidAmount || 0,
            advancePayment: paidAmount || 0,
            redemptionPoints: 0,
            accumulationPoints: 0,
            saleType: item.saleType || {},
            referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
            userName: userData.user,
            tillName: tillValue?.name,
            // subTotal: parseFloat(parseFloat(item?.grosstotal - item.discAmount - item?.taxamt || 0)?.toFixed(precision)),
            subTotal: parseFloat(parseFloat(item?.grosstotal - item?.taxamt || 0)?.toFixed(precision)),
            itemsSummery: itemSummery,
            amountInWords: numberToWords(item?.grosstotal || 0),
            groupedItemsByTaxRate: groupedItemsByTaxRate,
            totalStd: totalLineStd,
          };
        })
      );
      if (arrayData.length > 0) {
        // Create a new array by updating or adding records
        const updatedOrderDetails = orderHistoryDetails.map((order) => {
          // Check if the current order matches any entry in arrayData
          const matchingData = arrayData.find((newData) => newData.sOrderID === order.sOrderID);
          return matchingData ? { ...order, ...matchingData } : order; // Update if match found
        });

        // Update state with the new array
        setOrderHistoryDetails(updatedOrderDetails);
        setOrdersCopy(updatedOrderDetails);
      }

      setLoading(false);
      return arrayData;
    } catch (error) {
      console.error("Error fetching order history:", error);
      // Handle error appropriately, for example, set a state to show an error message
    } finally {
      setLoading(false);
    }
    setOrderHistoryInput("");
  };

  const searchOrderHistory = async (date, dateValue, row, flag, dateFlag, deliveryDateValue = []) => {
    let setAuthTokens;
    let startDate;
    let endDate;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    const sortOptions = {
      documentno: "desc",
      dateordered: "desc",
      customer: null,
      totalAmount: null,
    };
    const filteredSortOptions = Object.fromEntries(Object.entries(sortOptions).filter(([key, value]) => value !== null));
    if (dateValue?.length > 0) {
      localStorage.setItem("orderType", JSON.stringify([date, dateValue]));
      startDate = moment(dateValue[0]).format("YYYY-MM-DD");
      endDate = moment(dateValue[1]).format("YYYY-MM-DD");
    }

    let deliveryStartDate = startDate;
    let deliveryEndDate = endDate;

    if (deliveryDateValue?.length > 0) {
      deliveryStartDate = moment(deliveryDateValue[0]).format("YYYY-MM-DD");
      deliveryEndDate = moment(deliveryDateValue[1]).format("YYYY-MM-DD");
    }

    const productSearchInput = document.getElementById("sm-salesHistory-customer");
    if (productSearchInput) {
      productSearchInput.focus();
    }
    const isPreOrderPage = window.location.pathname.includes("/preorder");
    let dateFiltered;
    if (isPreOrderPage) {
      dateFiltered = `"{\\"DateRange\\":[\\"${startDate}\\",\\"${endDate}\\"],\\"DeliveryDateRange\\":[\\"${deliveryStartDate}\\",\\"${deliveryEndDate}\\"]}"`;
    } else {
      dateFiltered = `"{\\"DateRange\\":[\\"${startDate}\\",\\"${endDate}\\"]}"`;
    }
    // const dateFiltered = `"{\\"DateRange\\":[\\"${startDate}\\",\\"${endDate}\\"]}"`;
    const sortData = JSON.stringify(filteredSortOptions).replace(/"/g, '\\"');
    const isCallCenterPage = window.location.pathname.includes("/call-center");
    if (date === "orderDateSearchKey") {
      setLoading(true);
      try {
        const startRow = row;
        const endRow = parseInt(startRow, 10) + 50;
        const specificStores = posConfig?.showStoreSpecificRecords === "Y" ? true : false;
        const data = {
          query: `query {salesHistory(
                    q: ${
                      posConfig?.enableCallCentre === "Y" && isCallCenterPage ? `"${cart.customer.code}"` : searchHistoryInput?.trim() ? `"${searchHistoryInput.trim()}"` : null
                    },
                    filter_by: ${dateFiltered},
                    startRow: "${startRow}",
                    endRow: "${endRow}",
                    sort_by: "${sortData}",
                    tillId: ${specificStores ? `"${tillValue?.cwr_till_id}"` : null}
                  ) {
                  sOrderID
                  documentno
                  dateordered
                  totalQty
                  orderTime
                  grosstotal
                  layAway
                  isReturn
                  docstatus
                  creditSale
                  estimateDocumentNo
                  saleType {
                    cwrSaletypeId
                    name
                    value
                  }
                  deliveryDate
                  cwrB2cCustomer {
                    cwrCustomerId
                    code
                    name
                    mobileNo
                    pincode
                    email
                    retlLoyaltyBalance
                    loyaltyLevelId
                    creditBalance
                    creditApproachPercentage
                    loyaltyLevel {
                      name
                    }
                    cwrWallet {
                      wallet_Id
                      balance_Amt
                    }
                    sCustomer {
                      sCustomerID
                      customerCategory {
                        sCustomerCategoryId
                        value
                        name
                        description
                      }
                    }
                  }
                  cwrTill {
                    till
                  }
                }        
                }
                `,
        };
        const orderHistoryData = await orderHistoryService(data);

        if (orderHistoryData?.data?.data?.salesHistory.length === 0) {
          message.error(`${messages.errors.cart.no_more_records}`);
          setFiltersFlag(true);
          setLoading(false);
        } else {
          setFilterdDate(dateFiltered);
          const isPreOrderPage = window.location.pathname.includes("/preorder");
          const arrayData = await Promise.all(
            orderHistoryData?.data?.data?.salesHistory
              ?.filter((item) => {
                if (!isPreOrderPage && posConfig?.enablePreOrder === "Y" && item.layAway === "Y") {
                  return false;
                }
                return true;
              })
              ?.map(async (item) => {
                const obj = {
                  change: 0,
                  items: [],
                  cardPaymentData: {},
                  originalPrice: item.grosstotal || 0,
                  customer: item.cwrB2cCustomer || "",
                  documentno: item.documentno,
                  total: parseFloat(parseFloat(item.grosstotal || 0)?.toFixed(precision)),
                  discount: item.discAmount || 0,
                  tax: item.taxamt || 0,
                  orderTime: item.orderTime,
                  orderDate: item.dateordered,
                  totalQty: item.totalQty || 0,
                  payments: [],
                  paymentData: [],
                  roundOff: 0,
                  sOrderID: item.sOrderID,
                  key: item.documentno,
                  salesHistory: "Y",
                  status: "Success",
                  isSynced: 0,
                  creditAmount: 0,
                  createdBy: "",
                  layAway: item.layAway || "N",
                  creditSale: item.creditSale || "N",
                  isReturn: item.isReturn || "N",
                  docstatus: item.docstatus,
                  deliveryDate: item.deliveryDate,
                  saleType: item.saleType || {},
                  estimateDocumentNo: item.estimateDocumentNo || "",
                  paid: 0,
                  advancePayment: 0,
                  redemptionPoints: 0,
                  accumulationPoints: 0,
                  // saleType: item.saleType || {},)
                  referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
                  userName: userData.user,
                  tillName: tillValue?.name,
                  subTotal: 0,
                  itemsSummery: {},
                  amountInWords: "",
                  groupedItemsByTaxRate: {},
                };

                return obj;
              })
          );

          setOrderHistoryDetails((prevData) => {
            const existingOrderIds = new Set(prevData.map((order) => order.sOrderID));
            const uniqueNewOrders = arrayData.filter((order) => !existingOrderIds.has(order.sOrderID));
            return [...prevData, ...uniqueNewOrders];
          });
          setOrdersCopy((prevData) => {
            const existingOrderIds = new Set(prevData.map((order) => order.sOrderID));
            const uniqueNewOrders = arrayData.filter((order) => !existingOrderIds.has(order.sOrderID));
            return [...prevData, ...uniqueNewOrders];
          });
          setFiltersFlag(dateFlag ? false : true);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching order history data:", error);
        setLoading(false);
      }
    } else {
      setLoading(true);
      setOrderHistoryDetails([]);
      prevHistoryRef.current = orderHistoryDetails;
      localStorage.setItem("dataLength", "100");
      const specificStores = posConfig?.showStoreSpecificRecords === "Y" ? true : false;
      try {
        const data = {
          query: `query { salesHistory(
              q: "${dateValue.trim()}",
              filter_by: ${flag ? filteredDate : null},
              startRow: "0",
              endRow: "100",
              sort_by: "${sortData}",
              tillId: ${specificStores ? `"${tillValue?.cwr_till_id}"` : null}
            ) {
                  sOrderID
                  documentno
                  dateordered
                  totalQty
                  orderTime
                  grosstotal
                  layAway
                  isReturn
                  docstatus
                  creditSale
                  estimateDocumentNo
                  saleType {
                    cwrSaletypeId
                    name
                    value
                  }
                  deliveryDate
                  cwrB2cCustomer {
                    cwrCustomerId
                    code
                    name
                    mobileNo
                    pincode
                    email
                    retlLoyaltyBalance
                    loyaltyLevelId
                    creditBalance
                    creditApproachPercentage
                    loyaltyLevel {
                      name
                    }
                    cwrWallet {
                      wallet_Id
                      balance_Amt
                    }
                    sCustomer {
                      sCustomerID
                      customerCategory {
                        sCustomerCategoryId
                        value
                        name
                        description
                      }
                    }
                  }
                  cwrTill {
                    till
                  }
                }
                }`,
        };
        const response = await orderHistoryService(data);

        // Processing the fetched data
        const arrayData = await Promise.all(
          response?.data?.data?.salesHistory?.map(async (item) => {
            return {
              change: 0,
              items: [],
              cardPaymentData: {},
              originalPrice: item.grosstotal || 0,
              customer: item.cwrB2cCustomer || "",
              documentno: item.documentno,
              total: parseFloat(parseFloat(item.grosstotal || 0)?.toFixed(precision)),
              discount: item.discAmount || 0,
              tax: item.taxamt || 0,
              orderTime: item.orderTime,
              orderDate: item.dateordered,
              totalQty: item.cwrProductQty || item.totalQty,
              payments: [],
              paymentData: [],
              roundOff: 0,
              sOrderID: item.sOrderID,
              key: item.documentno,
              salesHistory: "Y",
              status: "Success",
              isSynced: 0,
              creditAmount: 0,
              createdBy: "",
              layAway: item?.layAway || "N",
              creditSale: item.creditSale || "N",
              isReturn: item?.isReturn || "N",
              docstatus: item.docstatus,
              deliveryDate: item.deliveryDate,
              estimateDocumentNo: item.estimateDocumentNo || "",
              saleType: item.saleType || {},
              paid: 0,
              advancePayment: 0,
              redemptionPoints: 0,
              accumulationPoints: 0,
              referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
              userName: userData.user,
              tillName: tillValue?.name,
              subTotal: 0,
              itemsSummery: {},
              amountInWords: "",
              groupedItemsByTaxRate: {},
            };
          })
        );
        setOrdersCopy(arrayData);
        setOrderHistoryDetails(arrayData);
        setFiltersFlag(!dateFlag);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching order history:", error);
        // Handle error appropriately, for example, set a state to show an error message
      } finally {
        setLoading(false);
      }
    }

    setOrderHistoryInput("");
  };

  const getDisplayDate = () => {
    if (dateRange && dateRange.length === 2) {
      const [start, end] = dateRange;
      return `${start.format("DD-MM-YYYY")} to ${end.format("DD-MM-YYYY")}`;
    }
    return "Choose date range";
  };

  const content = (
    <RangePicker
      open={isPopoverVisible}
      allowEmpty
      id="sm-salesHistory-date"
      onPressEnter={searchOrderHistory}
      allowClear={true}
      format={"YYYY-MM-DD"}
      suffixIcon={null}
      separator={null}
      value={dateRange}
      onChange={(e) => {
        if (e?.length > 0) {
          setFilterdDate(null);
          setPopoverVisible(false);
          setDateRange(e);
          setOrderHistoryDetails([]);
          localStorage.setItem("dataLength", 0);
          searchOrderHistory("orderDateSearchKey", e, 0, searchHistoryInput !== "" ? true : false, false);
        } else if (e === null && searchHistoryInput === "") {
          setFilterdDate(null);
          setDateRange(e);
          setOrderHistoryDetails([]);
          db.orders
            .orderBy("orderTime")
            .limit(20)
            .reverse()
            .toArray()
            .then((data) => {
              // Your logic to handle data here
            });
        } else if (e === null && searchHistoryInput !== "") {
          setDateRange(e);
          setFilterdDate(null);
          setOrderHistoryDetails([]);
          searchOrderHistory("customer", searchHistoryInput, 0, false);
        }
      }}
      className="salesHistory-datePicker-sm"
    />
  );
  // parked block

  const storedParkedList = JSON.parse(localStorage.getItem("parkedList"));
  const initialParkedList = storedParkedList ? storedParkedList : [];
  const [displayParkedBillModal, setDisplayParkedBillModal] = useState(false);
  const [parkedList, setParkedList] = useState(initialParkedList);
  const [filterdParkedList, setFilterdParkedList] = useState(initialParkedList);

  const discardParkedBill = async (record) => {
    upsertPOSLog(record.parkedCart, "DPO");

    // Remove from localStorage / main list
    const localParkedList = JSON.parse(localStorage.getItem("parkedList")) || [];
    const updatedList = localParkedList.filter((item) => item.key !== record.key);
    localStorage.setItem("parkedList", JSON.stringify(updatedList));
    setParkedList([...updatedList]);

    // Update filtered list based on current search input
    if (!parkedBillSearchInput) {
      setFilterdParkedList(mapParkedList(updatedList));
    } else {
      const lowercaseKey = parkedBillSearchInput.toLowerCase();
      const filteredBills = updatedList.filter((item) => {
        const lowercaseCustomer = item?.parkedCart?.customer?.name?.toLowerCase() || "";
        const lowercaseParkedDocNo = item.parkedDocNo?.toLowerCase() || "";
        return lowercaseCustomer.includes(lowercaseKey) || lowercaseParkedDocNo.includes(lowercaseKey);
      });
      setFilterdParkedList(mapParkedList(filteredBills));
    }

    // Save discarded cart to DB (your existing logic)
    const tillSession = JSON.parse(localStorage.getItem("tillSession"));
    const tillSessionId = tillSession?.tillSessionId;
    let cartToDb = record.parkedCart;
    cartToDb.orderTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    cartToDb.createdBy = tillData.tillAccess?.csUserId || "";
    cartToDb.orderType = orderType?.cwrSaletype?.cwrSaletypeId || "";
    cartToDb.orderDate = moment(new Date()).format("DD-MM-YYYY");
    cartToDb.tillSessionId = tillSessionId;
    cartToDb.key = uuidv4().replace(/-/g, "").toUpperCase();
    cartToDb.isSynced = 0;
    cartToDb.syncAttempts = 0;
    cartToDb.customerSearchKey = cart?.customer?.code || "";
    cartToDb.total = 0;
    cartToDb.totalQty = 0;
    cartToDb.tax = 0;
    cartToDb.isReturn = false;
    cartToDb.items.forEach((item) => {
      item.salePrice = 0;
      item.sunitprice = 0;
      item.netStd = 0;
      item.nettotal = 0;
      item.unitTax = 0;
      item.taxAmount = 0;
      item.weight = 0;
      item.unitPrice = 0;
      item.netList = 0;
      item.discount = 0;
      item.isReturn = false;
      item.linetax = 0;
      item.linenet = 0;
      item.linegross = 0;
      item.linestd = 0;
      item.netunit = 0;
      item.listPrice = 0;
      item.grossunit = 0;
      item.grossstd = 0;
      item.grosslist = 0;
      item.realPrice = 0;
    });
    if (record.parkedCart.type === "Layaway") {
      setDocumnetSequence(documentSequence);
    } else {
      await db.orders.put(cartToDb);
    }
  };

  const retrieveParkedData = async (record) => {
    const parkedCart = record?.parkedCart || {};
    const saleTypeId = parkedCart?.saleType?.cwrSaletypeId;

    try {
      const saleTypes = await db.posSaletypes.toArray();
      const saleTypeData = saleTypes.find((item) => item.cwrSaletype?.cwrSaletypeId === saleTypeId);

      if (saleTypeData?.cwrSaletype?.name) {
        setSelectedSaleType(saleTypeData.cwrSaletype.name);
      }

      if (cart.items.length > 0) {
        openDisplayParkedBillModal("retrieve", record);
      } else {
        selectParkedBill(record, "management");
      }
    } catch (err) {
      console.error("Error retrieving sale type from DB:", err);
      message.error(`${messages.info.retrieve_saletype_failed}`);
    }
  };

  const openDisplayParkedBillModal = (param, record) => {
    if (localStorage.getItem("selectedReturnType") === "EXCHANGE") {
      message.warning("Hold is not allowed during Return & Exchange.");
      return;
    }
    if (cart.items.length > 0) {
      Modal.confirm({
        title: "Save Cart Items ?",
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            You can retrieve the bill later by selecting the 'Retrieve' option in Parked Bills.
            <br />
            Do you want to continue parking the bill?
          </div>
        ),
        okText: "Yes",
        cancelText: "No",
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        async onOk() {
          if (posConfig?.saveParkedBills === "Y") {
            // cartItems is stored as string → parse it
            const cartItems = JSON.parse(localStorage.getItem("cartObj"));
            const csBunitId = tillData?.tillAccess?.csBunit?.csBunitId;
            const cwrPosCartId = cartItems?.cwr_pos_cart_id ? cartItems.cwr_pos_cart_id : uuidv4().replace(/-/g, "").toUpperCase();
            const cwrTillId = tillData?.tillAccess?.cwrTill?.cwrTillID;
            const status = "DR";

            const cartPayload = {
              csBunitId,
              cwrPosCartId,
              cwrTillId,
              status,
              cartItems,
            };

            const response = await upsertCart(cartPayload);
            if (response?.status === 200) {
              if (response?.data?.data?.upsertCart?.status === "200") {
                message.success(response?.data?.data?.upsertCart?.message);
                deleteReceipt();
              } else if (response?.data?.data?.upsertCart?.status === "201") {
                message.error(response?.data?.data?.upsertCart?.message);
              } else {
                message.error("Something is wrong in upsertCart service");
              }
            } else {
              message.warning("Something is wrong in upsertCart service");
            }
          } else {
            setSelectedDocumentType("Invoice");
            let PaymentMethods = getFilteredPaymentMethods() || [];
            let payments =
              PaymentMethods.length > 5
                ? _.sortBy(PaymentMethods, "sequenceNo").slice(
                    0,
                    tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
                  )
                : PaymentMethods;

            setShowPayments(payments);
            parkBill(param, record);
            const productSearchInput = document.getElementById("sm-product-search");
            setTimeout(() => {
              // productSearchInput.focus();
              setOpen(false);
            }, 600);
            if (searchInputRef?.current) {
              searchInputRef?.current?.focus();
            }
            setProductSearchInput("");
          }
        },
        onCancel() {
          const productSearchInput = document.getElementById("sm-product-search");
          productSearchInput?.focus();
          if (searchInputRef?.current) {
            searchInputRef.current.focus();
          }
          setOpen(false);
          setProductSearchInput("");
          setDisplayParkedBillModal(true);
        },
      });
    } else {
      setProductSearchInput("");
      setDisplayParkedBillModal(true);
    }
  };

  const parkedListRef = useRef(initialParkedList);
  useEffect(() => {
    parkedListRef.current = parkedList;
  }, [parkedList]);

  const discardGiftCards = async (cart) => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    if (giftCardData.length > 0) {
      let details = [];
      cart?.giftCardData?.map((ele) => {
        details.push(`{
            cardNo: ${ele.number ? `"${ele.number}"` : null}
            referenceNo: "${ele.refId}"
                }`);
      });
      discardGiftCard(null, null, details);
      let upsertDetails = [];
      giftCardData.map((ele) => {
        upsertDetails.push(`{
            cardNo: ${ele.number ? `"${ele.number}"` : null}
            type: "RD"
            referenceNo: "${cart.referenceId}"
            amount: ${ele.amount * -1}
            cardPin: ${ele?.pin ? `"${ele?.pin}"` : null}
            tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
            b2c_Customer_Id: ${cart.customer.cwrCustomerId ? `"${cart.customer.cwrCustomerId}"` : null}
                }`);
      });
      const data = {
        query: `
            mutation {
              upsertGiftCardTransaction(giftCardTransactions: [${upsertDetails}]) {
                status
                message
              }
            }`,
      };
      await upsertGiftCardTransaction(data);
    }
  };

  const processWithParkedBillCancellation = (record) => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    discardGiftCards(record.parkedCart);
    if (record?.parkedCart?.couponInput?.length > 0) {
      const serverUrl = process.env.REACT_APP_serverUrl;

      const couponsData = [...record.parkedCart.couponInput];
      // Function to discard a coupon
      const discardCoupon = async (coupon) => {
        const discardCouponQuery = {
          query: `query {
              discardCoupon(couponcode: "${coupon.couponCode}", referenceId: "${coupon.referenceId}") {
                status
                message
              }
            }`,
        };
        try {
          const response = await discardCouponService(coupon.couponCode, coupon.referenceId);
        } catch (error) {
          console.error(`Error discarding coupon ${coupon.couponCode}:`, error);
        }
      };
      couponsData.forEach((coupon) => {
        discardCoupon(coupon);
      });
    }
    let index = record.parkedCart.payments.findIndex((payment) => payment.name.toLowerCase() === "loyalty" && !record.parkedCart.isReturn);
    if (index >= 0) {
      handleLoyaltyPayment(record.parkedCart.payments[index], record.parkedCart);
    }
    setGiftCardData([]);
    discardParkedBill(record);
    setParkedBillSearchInput("");

    // Refresh the parked bills list
    const allParkedList = JSON.parse(localStorage.getItem("parkedList")) || [];
    setFilterdParkedList(mapParkedList(allParkedList));
    const productSearchInput = document.getElementById("sm-product-search");
    if (productSearchInput) {
      setTimeout(() => {
        productSearchInput.focus();
      }, 300);
    }
  };

  const handleOk = async (record) => {
    const updatedItems = record?.parkedCart?.items?.map((item) => ({
      ...item,
      realWeight: item.weight,
    }));

    const updatedRecord = {
      ...record,
      parkedCart: {
        ...record.parkedCart,
        items: updatedItems,
      },
    };
    const { workflowRules, approvers } = await getWorkflowData();
    const cancelParkedBillRule = workflowRules.find((res) => res.eventName === "Cancel Parked Bill");
    if (cancelParkedBillRule) {
      dispatchEvent(cancelParkedBillRule.eventName, cancelParkedBillRule.ruleName, cancelParkedBillRule.ruleCondition, approvers, null, async (eventData) => {
        if (eventData?.approvalGranted) {
          await processWithParkedBillCancellation(updatedRecord);
        } else {
          Modal.error({
            title: "Approval Required",
            content: "The cancellation request was not approved.",
          });
        }
      });
    } else {
      await processWithParkedBillCancellation(updatedRecord);
    }
  };

  const handleCancel = () => {
    // Handle the cancel action here
    Modal.destroyAll();
    const productSearchInput = document.getElementById("sm-product-search");
    if (productSearchInput) {
      setTimeout(() => {
        productSearchInput.focus();
      }, 300);
    }
  };

  const discardMessage = (modalTitle, modalContent, record) => {
    Modal.confirm({
      title: modalTitle,
      content: modalContent,
      onOk: () => handleOk(record),
      okButtonProps: { style: { display: "inline-block" } },
      autoFocusButton: null,
      onCancel: handleCancel,
    });
  };

  const parkBill = (value, record) => {
    if (cart.parked !== "Y" && cart.layAway !== "Y") {
      const newDocumentSequence = documentSequence + 1;
      localStorage.setItem("documentSequence", newDocumentSequence);
      setDocumnetSequence(newDocumentSequence);
      deleteReceipt();
      if (value === "retrieve") {
        selectParkedBill(record, "management");
      }
    } else if (cart.layAway === "Y") {
      const newDocumentSequence = documentSequence + 1;
      localStorage.setItem("documentSequence", newDocumentSequence);
      setDocumnetSequence(newDocumentSequence);
      deleteReceipt();
    } else {
      if (value === "retrieve") {
        selectParkedBill(record, "management");
      } else {
        if (cart.isRetrived !== "Y") {
          const newDocumentSequence = documentSequence + 1;
          localStorage.setItem("documentSequence", newDocumentSequence);
          setDocumnetSequence(newDocumentSequence);
        }
        deleteReceipt();
      }
    }
    const presentParkedList = value === "parkKey" ? parkedListRef.current : JSON.parse(localStorage.getItem("parkedList")) || [];
    cart.parked = "Y";
    const presentCart = cart;
    const presentTimeStamp = timeStamp();
    const parkedBill = {
      parkedCart: presentCart,
      parkedTime: presentTimeStamp,
      parkedDocNo: cart.documentno,
      parkedOrderID: cart.items[0].sOrderReturnId,
      parkedBillId: uuidv4().replace(/-/g, "").toUpperCase(),
      qty: presentCart.totalQty,
    };
    presentParkedList.push(parkedBill);
    localStorage.setItem("parkedList", JSON.stringify(presentParkedList));
    setParkedList([...presentParkedList]);
    hasShownCustomerModalRef.current = false;

    {
      message.success(`${t("bill_parking_successful")}`);
    }
  };

  const selectParkedBill = async (item, fieldName) => {
    const listItemIndex = parkedList.findIndex((bill) => bill.parkedBillId === item.parkedBillId);
    const selectedParkedBill = { ...parkedList[listItemIndex].parkedCart, isRetrived: "Y" };

    let stockCheckResult = true;
    let isFinalValidation = false;
    let isCompleteSale = false;
    if (navigator.onLine && tillData?.tillAccess?.csBunit?.allowNegativeStock !== "Y") {
      stockCheckResult = await stock({
        cart: selectedParkedBill,
        setCart,
        tillData,
        setProductStock,
        isFinalValidation,
        setTempCart,
        isCompleteSale: true,
        setShowCompleteSaleStock,
        setCompleteSaleStockData,
        customMixHandler: false,
        setProductBOMStock,
        setProductBOMStockData,
      });
      if (!stockCheckResult) {
        setSelectedProductInCart({});
        return;
      } else {
        setShowPaymentMethods(true);
        setOrderHistoryDetails([]);
        setIsparkedBill(false);
      }
    } else {
      setShowPaymentMethods(true);
      setOrderHistoryDetails([]);
      setIsparkedBill(false);
    }
    // Remove the selected bill from the parked list
    const updatedParkedList = JSON.parse(localStorage.getItem("parkedList")) || [];
    updatedParkedList.splice(listItemIndex, 1);
    setParkedList(updatedParkedList);
    localStorage.setItem("parkedList", JSON.stringify(updatedParkedList));

    // Handle layaway logic
    if (selectedParkedBill?.layAway === "Y") {
      setSelectedDocumentType("Advance");

      const PaymentMethods = getFilteredPaymentMethods() || [];
      const maxPayments =
        PaymentMethods.length > 5
          ? _.sortBy(PaymentMethods, "sequenceNo").slice(
              0,
              tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
            )
          : PaymentMethods;

      setShowPayments(maxPayments);
    }
    if (!isExchange) {
      setCart(selectedParkedBill);
      localStorage.setItem("cartObj", JSON.stringify(selectedParkedBill));
    }
    setDisplayParkedBillModal(false);
    if (fieldName === "management") {
      setManagementScreenShow(false);
    }
  };

  const selectLayAwayOrder = async (item, fieldName) => {
    const itemWithNumberTotal = {
      ...item,
      total: parseFloat(item.total),
    };
    const customMixEntry = metaDataRef.current.find((entry) => entry.key === "Custom Mix");
    let updatedCart;
    if (!customMixEntry) {
      updatedCart = {
        ...itemWithNumberTotal,
      };
    } else {
      let customMixData = [];
      try {
        customMixData = JSON.parse(customMixEntry.value);
      } catch (error) {
        console.error("Invalid JSON in Custom Mix value", error);
        return [];
      }
      const matchedIds = new Set();
      const enrichedMixes = customMixData.map((mix) => {
        const matchedChildren = mix.children
          .map((child) => {
            const matchedItem = item.items.find((line) => line.sOrderlineID === child.sOrderlineID);
            if (matchedItem) {
              matchedIds.add(child.sOrderlineID);
            }
            return {
              ...matchedItem,
              taxAmount: matchedItem?.unittax ?? 0,
              groupedItems: true,
              actualWeight: matchedItem?.weight / mix.weight,
              baseQty: matchedItem?.weight / mix.weight,
            };
          })
          .filter(Boolean);

        return {
          ...mix,
          children: matchedChildren,
          nettotal: mix.nettotal,
          sunitprice: mix.nettotal,
          originalPrice: mix.nettotal,
          salePrice: mix.nettotal - mix.taxAmount,
          realPrice: mix.nettotal - mix.taxAmount,
          addNewLine: "N",
          batchedForSale: "N",
          batchedForStock: "N",
          batchedProduct: "N",
          batchno: null,
          bunitName: "",
          csBunitId: null,
          customAttributes: [],
          preparationTime: "",
          printerId: "",
          cwrMenuTimeslot: [],
          productAliasName: null,
          description: "",
          discount: mix.discount,
          discountName: "",
          foodType: "",
          itemType: "",
          grosslist: 0,
          grossstd: 0,
          grossunit: 0,
          hsncode: "",
          imageUrl: "",
          imageurl: "",
          isDecimal: false,
          isDecimalQty: false,
          isManualQty: false,
          restrictPosQtyEdit: "N",
          isPromoApplicable: false,
          isQtyDesimal: 2,
          isReturn: false,
          key: 0,
          lineId: uuidv4().replace(/-/g, "").toUpperCase(),
          linegross: 0,
          linenet: 0,
          linetax: 0,
          listPrice: 0,
          listprice: 0,
          mBatchId: null,
          mPricingruleId: null,
          multiPrice: "N",
          name2: "",
          netList: 0,
          netStd: 0,
          netunit: 0,
          newCustomAttributes: [],
          order: "N",
          originalPrice: 0,
          priceList: [],
          primaryOrderLine: null,
          productAddons: [],
          productCategoryName: "",
          productId: uuidv4().replace(/-/g, "").toUpperCase(),
          productManufacturerId: null,
          productionCenter: "",
          productionCenterId: "",
          returnQty: null,
          salesRepId: null,
          salesRepName: "",
          selectedAddons: [],
          shelfLife: "",
          shortDescription: "",
          showAddons: "N",
          taxCategory: "",
          taxFlag: "N",
          taxName: "",
          // taxRate: 18,
          type: "I",
          unitPrice: 0,
          unitTax: 0,
          upc: "",
          upcPricingRule: null,
          value: "",
        };
      });
      const unmatchedItems = item.items.filter((line) => !matchedIds.has(line.sOrderlineID));
      const allItems = [...enrichedMixes, ...unmatchedItems];
      updatedCart = {
        ...itemWithNumberTotal,
        items: allItems,
      };
    }
    setShowPaymentMethods(true);
    const filteredItemsForStockCheck = updatedCart.items.filter((item) => item.productSegment !== "CB" && item.type === "I");
    const stockCart = {
      ...updatedCart,
      items: filteredItemsForStockCheck,
    };
    let stockCheckResult = true;
    let isFinalValidation = false;
    if (navigator.onLine && updatedCart?.preOrder === "Y" && tillData?.tillAccess?.csBunit?.allowNegativeStock !== "Y") {
      stockCheckResult = await stock({
        cart: stockCart,
        setCart,
        tillData,
        setProductStock,
        isFinalValidation,
        setTempCart,
        isCompleteSale: true,
        setShowCompleteSaleStock,
        setCompleteSaleStockData,
        customMixHandler: false,
        setProductBOMStock,
        setProductBOMStockData,
      });
      if (!stockCheckResult) {
        setSelectedProductInCart({});
        return;
      } else {
        localStorage.setItem("cartObj", JSON.stringify(updatedCart));
        setCart(updatedCart);
      }
    }
    localStorage.setItem("cartObj", JSON.stringify(updatedCart));
    setCart(updatedCart);
    if (tillaccess?.layout === "2") {
      setKeyValue("2");
      const saleData = await db.posSaletypes.toArray();

      const selectedSaleTypeRecord = saleData.find((item) => item.cwrSaletype.cwrSaletypeId === updatedCart.saleType?.cwrSaletypeId);
      if (selectedSaleTypeRecord) {
        handleSelectedSaleTypeForProducts(selectedSaleTypeRecord);
      }
      <MenuLayout {...componentProps} />;
    }
  };

  const [parkedBillSearchInput, setParkedBillSearchInput] = useState("");
  const [salesHistoryCustomerSearchInput, setSalesHistoryCustomerSearchInput] = useState("");
  const [salesHistoryDocumentNoSearchInput, setSalesHistoryDocumentNoSearchInput] = useState("");

  const handleParkedBillSearchInput = (e) => {
    setParkedBillSearchInput(e.target.value);
    searchParkedBill(e.target.value);
  };

  const mapParkedList = (list) => {
    return list.map((item) => ({
      ...item,
      customer: item?.parkedCart?.customer?.name || "",
      status: "Parked",
      key: item.key,
      qty: item?.parkedCart?.totalQty || 0,
    }));
  };

  const searchParkedBill = (key) => {
    if (!key) {
      const allParkedList = JSON.parse(localStorage.getItem("parkedList")) || [];
      setFilterdParkedList(mapParkedList(allParkedList));
      return;
    }

    const lowercaseKey = key.toLowerCase();
    const allParkedList = JSON.parse(localStorage.getItem("parkedList")) || [];

    const filteredBills = allParkedList.filter((list) => {
      const lowercaseCustomer = list?.parkedCart?.customer?.name?.toLowerCase() || "";
      const lowercaseParkedDocNo = list.parkedDocNo?.toLowerCase() || "";
      return lowercaseCustomer.includes(lowercaseKey) || lowercaseParkedDocNo.includes(lowercaseKey);
    });
    setFilterdParkedList(mapParkedList(filteredBills));
  };

  const closeParkedBillModal = () => {
    setDisplayParkedBillModal(false);
    setParkedBillSearchInput("");
    setFilterdParkedList([...parkedList]);
  };

  // PARKED BILL BLOCK END

  // prodcut add ons start

  const [displayAddOnSelection, setDisplayAddOnSelection] = useState(false);
  const [addOnsList, setAddOnsList] = useState({
    requiredList: [],
    optionsList: [],
  });
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [isUpdatingAddon, setIsUpdatingAddon] = useState(false);

  const addDefinedProductWithAddons = (productObjs, upc, batchno, mBatchId, price, addonWeightFlag) => {
    const productObj = { ...productObjs };
    if (productObj.overRideTax === "Y" && price <= productObj.overRideCondition) {
      const originalPrice = price - (price - price * (100 / (100 + productObj.taxRate)));
      const taxedPrice = originalPrice + (originalPrice * productObj.contraRate) / 100;
      price = taxedPrice;
      productObj.cTaxId = productObj.contraTaxId;
      productObj.taxRate = productObj.contraRate;
    }
    productObj.salePrice = productObj?.sunitprice || 0;
    productObj.realPrice = price;
    productObj.order = "N";
    ((productObj.isQtyDesimal = productObj?.uomData[0]?.length > 0 ? productObj.uomData[0].stdprecision : 2), (productObj.productId = productObj?.mProductId || null));
    productObj.mBatchId = mBatchId || null;
    productObj.productId = productObjs.productId;
    productObj.selectedAddons = productObj.selectedAddons.map((addon) => ({
      ...addon,
      // weight: addon?.weight  ? addon?.weight + 1 : 1,
      weight: addonWeightFlag ? (addon.weight ?? 1) : (addon.weight ?? 0) + 1,
    }));
    addProductToCart(
      productObj,
      productObj.weight || productObj?.qty,
      false,
      cart,
      setCart,
      setSelectedProductInCart,
      deleteCart,
      processTotalManualDiscount,
      setLoader,
      salesRepresentDefaultLine,
      tillData,
      cartRef,
      productsCopy,
      salesRepresent,
      orderType,
      processBillDiscounts,
      undefined,
      setSelectedRowKeys,
      selectedRowKeysRef,
      setOrderTimeDetails,
      setDisplayAddOnSelection,
      displayAddOnSelection,
      handleAddOnModal,
      manualDiscountTypes,
      CheckoutFlatDiscount,
      CheckoutPercentageDiscount,
      CheckoutTotalManualDiscount,
      setProductStock,
      selectedProductInCart,
      setTableCards,
      dispatchItemSelection,
      searchInputRef,
      false,
      setShowCompleteSaleStock,
      setCompleteSaleStockData,
      TotalBillDiscount,
      tillLayout,
      false,
      setManualDiscountInput,
      setSelectedManualDiscountTypeValue,
      removeAllDiscounts,
      setSelectedPaymentMethod,
      selectedReturnType,
      false,
      setProductBOMStock,
      setProductBOMStockData
    );
    setSelectedAddons([]);
  };

  // const handleAddOnModal = (record, qty) => {
  //   setDisplayAddOnSelection(true);
  //   record.qty = qty;
  //   setSelectedProduct(record);
  //   setAddOnsList({
  //     requiredList: record.productAddons,
  //     optionsList: record.productAddons,
  //   });
  // };

  const handleAddOnModal = (record, event) => {
    //event.stopPropagation();
    setSelectedProduct(record);
    setDisplayAddOnSelection(true);
    //setSelectedProduct(record);
    const requiredListFilter = _.filter([...record.productAddons], (item) => Number(item.mAddonGroup?.minqty || 0) >= 0);

    const optionsListFilter = _.filter([...record.productAddons], (item) => Number(item.mAddonGroup?.minqty || 0) === 0);
    // const requiredListFilter = _.filter(product.productAddons || [], (item) => item.mAddonGroup.minqty === 1);

    // const optionsListFilter = _.filter(product.productAddons || [], (item) => item.mAddonGroup.minqty === 0);
    setAddOnsList({
      requiredList: requiredListFilter || [],
      optionsList: optionsListFilter || [],
    });
  };

  const handleAddOnValue = (e, fieldName) => {
    let newSelectedAddons = [...selectedAddons];
    const indexValue =
      fieldName === "addOnRadio"
        ? _.findIndex(newSelectedAddons, (item) => item.mAddonGroup.mAddonGroupId === e.target.value.mAddonGroup.mAddonGroupId)
        : _.findIndex(newSelectedAddons, (item) => item === e.target.value);
    if (indexValue !== -1) {
      if (e.target.checked) {
        newSelectedAddons[indexValue] = e.target.value;
      } else {
        newSelectedAddons.splice(indexValue, 1);
      }
    } else {
      newSelectedAddons = [...selectedAddons, e.target.value];
    }
    const selectedAddonsWithWeight = {
      ...newSelectedAddons,
      weight: 1,
    };
    setSelectedAddons(newSelectedAddons);
  };

  const handleQty = (fieldName) => {
    let newSelectedProduct = {
      ...selectedProduct,
      weight: selectedProduct?.weight || 1,
    };
    if (fieldName === "plus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) + 1;
    }
    if (fieldName === "minus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) - 1;
      if (newSelectedProduct.weight <= 1) {
        newSelectedProduct.weight = 1;
      }
    }
    setSelectedProduct({
      ...newSelectedProduct,
    });
  };

  const handleCopyKOT = () => {
    const firedItems = cart.items.filter((item) => Number(item.firedQty) > 0 && item.order === "Y");

    if (firedItems.length === 0) {
      message.info("No valid fired items (with order = 'Y') to copy KOT.");
      return;
    }

    const clones = firedItems.map((item) => {
      const qty = Number(item.firedQty);

      // Deep clone (to avoid reference linking)
      const clone = structuredClone ? structuredClone(item) : JSON.parse(JSON.stringify(item));

      // Assign a new lineId (very important)
      clone.lineId = uuidv4().replace(/-/g, "").toUpperCase();

      // New item → should not be fired
      clone.order = "N";
      clone.firedQty = 0;
      clone.sendQty = 0;

      // Set quantity equal to firedQty
      clone.weight = qty;

      return clone;
    });

    const mergedCart = {
      ...cart,
      items: [
        ...cart.items, // keep original items
        ...clones, // add copies (one per fired item)
      ],
    };
    if (!isExchange) {
      setCart(mergedCart);
      localStorage.setItem("cartObj", JSON.stringify(mergedCart));
    }
    message.success("Copied KOT items added!");
  };

  const openCopyKOTModal = async () => {
    const firedItems = cart.items.filter((item) => Number(item.firedQty) > 0 && item.order === "Y");

    if (firedItems.length === 0) {
      message.info("No fired items to copy.");
      return;
    }

    // Load category list from DB
    const categories = await db.productCategories.toArray();

    // Map categoryId -> categoryName
    const categoryMap = {};
    categories.forEach((cat) => {
      categoryMap[cat.mProductCategoryId] = cat.name;
    });

    // Group fired items by category, unique by productId
    const grouped = firedItems.reduce((acc, item) => {
      const categoryName = categoryMap[item.mProductCategoryId] || "Others";

      if (!acc[categoryName]) acc[categoryName] = [];

      // Prevent same product appearing multiple times
      if (!acc[categoryName].some((x) => x.productId === item.productId)) {
        acc[categoryName].push(item);
      }

      return acc;
    }, {});

    setGroupedFiredItems(grouped);
    setSelectedCopyItems({});
    setCopyKOTVisible(true);
  };

  const handleSelectedSaleTypeForProducts = (obj) => async () => {
    try {
      setSelectedSaleTypeData(obj);
      const paymentDetails = getFilteredPaymentMethods(obj?.cwrSaletype?.cwrSaletypeId || null);
      setShowPayments(paymentDetails);
      localStorage.setItem("saleTypeData", JSON.stringify(obj));
      setSelectedSaleType(obj?.cwrSaletype?.name);
      setIsSaleTypeFlag(false);
      changeCustomerId(obj);

      let updatedCart = JSON.parse(localStorage.getItem("cartObj"));
      updatedCart.customer = obj?.customer?.b2cCustomerId ? obj?.customer : tillData.tillAccess.csBunit.b2cCustomer;
      let processedProducts;
      let updatedProducts = await db.products
        .filter((product) => product.isactive === true)
        .filter((product) => product.productSegment !== "BG")
        .toArray();
      const filteredProducts = updatedProducts.filter((product) => product.priceList?.some((priceList) => priceList?.sPricelistId === updatedCart.customer?.sPriceListId));
      processedProducts = filteredProducts.map((product) => {
        // const matchedPrice = product.priceList.find((priceList) => priceList.sPricelistId === updatedCart.customer?.sPriceListId);
        // return {
        //   ...product,
        //   price: matchedPrice.pricestd,
        //   salePrice: matchedPrice.pricestd,
        //   realPrice: matchedPrice.pricestd,
        //   sunitprice: matchedPrice.pricestd,
        // };
        const selectedPrice = getApplicablePrice({
          priceList: product.priceList,
          selectedUomId: product.uomData[0]?.csUomId,
          sPriceListId: updatedCart.customer.sPriceListId,
          alternateUom: product?.alternateUom || [],
          primaryUomId: product?.uom || null,
        });

        if (!selectedPrice) return product;

        return {
          ...product,
          price: selectedPrice.pricestd,
          salePrice: selectedPrice.pricestd,
          realPrice: selectedPrice.pricestd,
          sunitprice: selectedPrice.pricestd,
        };
      });
      if (!updatedCart?.customer?.sPriceListId) {
        processedProducts = updatedProducts;
      }

      setSaleTypeProducts(processedProducts);

      const finalCartObj = { ...updatedCart };
      localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
      setCart(finalCartObj);

      if (obj?.cwrSaletype?.fulfilmentType === "DI" || obj?.cwrSaletype?.fulfilmentType === "TA") {
        return;
      } else {
        setShowProducts(true);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };

  const handleSelectedRevenueCategory = (obj) => () => {
    localStorage.setItem("selectedRevenueCategory", JSON.stringify(obj));
    setSelectedRevenueCategoryName(obj.name);
    setIsRevenueCategoryFlag(false);
  };

  const handleAdd = async () => {
    await addDefinedProductWithAddons(
      {
        ...selectedProduct,
        sProductID: uuidv4().replace(/-/g, "").toUpperCase(),
        selectedAddons: selectedAddons || [],
      },
      selectedProduct.upc,
      null,
      null,
      selectedProduct.sunitprice,
      false
    );
    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
    setFilterDrawer(false);
  };

  const handleAddOnModalClose = () => {
    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
  };

  // product add ons end

  //// CENTER BUTTON BLOCK END ////

  //// CART OPERATIONS START ////

  // DEFAULT CART START
  const [cart, setCart] = useState({
    items: [],
    couponInput: [],
    advancePayment: 0,
    total: 0,
    tax: 0,
    discount: 0,
    paid: 0,
    change: 0,
    totalQty: 0,
    roundOff: 0,
    payments: [],
    redemptionPoints: 0,
    accumulationPoints: 0,
    creditAmount: 0,
    docType: "Invoice",
    sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
    referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
    giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    customer: defaultCustomer,
    salesRepId: null,
    cardPaymentData: {},
    documentno: `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
    userName: userData.user,
    tillName: tillValue?.name,
    subTotal: 0,
    itemsSummery: {},
    amountInWords: "",
    groupedItemsByTaxRate: {},
    serviceCharge: 0,
    tip: 0,
    deiveryCharge: 0,
    packingCharge: 0,
    others: 0,
    refundAmount: 0,
  });

  useEffect(() => {
    const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE";
    const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
    const tempCartObj = JSON.parse(localStorage.getItem("cartObj")) || {};
    const activeCart = isExchange && exchangeCartObj ? exchangeCartObj : tempCartObj;
    if (activeCart?.items?.length > 0) {
      const preciseTotal = parseFloat(activeCart?.total?.toFixed(precision));
      let updatedCart = {
        ...activeCart,
        total: preciseTotal,
        amountInWords: numberToWords(preciseTotal),
        totalStd:
          activeCart?.items?.reduce((sum, item) => {
            if (item?.isCanceled === "Y") return sum;

            // 🔥 If grouped item → calculate from children
            if (Array.isArray(item.children) && item.children.length > 0) {
              const childrenStd = item.children.reduce((childSum, child) => childSum + (child?.linestd || 0), 0);
              return sum + childrenStd;
            }

            // Normal item
            return sum + (item?.linestd || 0);
          }, 0) || 0,
      };
      if (isExchange) {
        localStorage.setItem("exchangeCartObj", JSON.stringify(updatedCart));
      } else {
        localStorage.setItem("cartObj", JSON.stringify(updatedCart));
      }
    }
  }, [cart, localStorage.getItem("exchangeCartObj")]);

  useEffect(() => {
    let saleType = JSON.parse(localStorage.getItem("saleTypeData"));
    let cartObj = JSON.parse(localStorage.getItem("cartObj")) ? JSON.parse(localStorage.getItem("cartObj")) : cart;
    if (saleType && cartObj?.items?.length > 0) {
      let updatedCart = {
        ...cartObj,
        saleType: saleType?.cwrSaletype,
      };
      if (!isExchange) {
        localStorage.setItem("cartObj", JSON.stringify(updatedCart));
      }
    }
  }, [selectedSaleType, cart]);

  useEffect(() => {
    if (cart?.items?.length > 0) {
      if (window.location.pathname.includes("/pos")) {
        if (cart?.isPreOrderPage === true && cart?.preOrder !== "Y" && tillaccess?.layout !== "2") {
          Modal.confirm({
            title: "Clear The Cart Items ?",
            icon: <ExclamationCircleOutlined />,
            content: <div>Pre-Order cart will be cleared if you continue. Do you want to proceed?</div>,
            okText: "Yes",
            cancelText: "No",
            autoFocusButton: null,
            okButtonProps: { style: { display: "inline-block" } },
            onOk() {
              let updatedCart = {
                ...cart,
                isPreOrderPage: false,
                items: [],
                total: 0,
                subTotal: 0,
                tax: 0,
                discount: 0,
                paid: 0,
                change: 0,
                roundOff: 0,
                advancePayment: 0,
                couponInput: [],
                payments: [],
                giftCardRefId: null,
                couponRefId: null,
                itemsSummery: {},
                groupedItemsByTaxRate: {},
              };
              if (!isExchange) {
                localStorage.setItem("cartObj", JSON.stringify(updatedCart));
                setCart(updatedCart);
              }
            },
            onCancel() {
              history.push("/preorder");
            },
          });
        }
      } else if (window.location.pathname.includes("/preorder")) {
        let updatedCart = {
          ...cart,
          isPreOrderPage: true,
        };
        localStorage.setItem("cartObj", JSON.stringify(updatedCart));
      }
    }
  }, [cart]);

  // DEFAULT CART END

  // BARCODE READER BLOCK START
  const [displayBatchSelection, setDisplayBatchSelection] = useState(false);
  const [batchSetAvailable, setBatchSetAvailable] = useState([]);

  const onBarcodeInput = async (data, flag) => {
    keyboard?.current?.setInput("");
    let chackBarcodeFlag = false;
    if (data?.trim() !== "" && data !== null) {
      await barcodeScaner(
        data,
        tillData,
        tillLayout,
        addDefinedProduct,
        setBatchSetAvailable,
        setDisplayBatchSelection,
        setLayoutType,
        setIsProductsVisible,
        setProductsData,
        chackBarcodeFlag,
        setSelectedProductInCart,
        setProductSearchInput,
        productSearchInputRef,
        cart,
        authHeaders,
        setOptions,
        fetchOnlineBatches,
        setCart,
        setProductStock,
        setTempCart,
        setShowCompleteSaleStock,
        setCompleteSaleStockData,
        setShowPaymentMethods,
        history
      );
    }
  };

  const [isStockModal, setIsStockModal] = useState(false);
  const [tempCart, setTempCart] = useState({});
  const verifyStock = async (docType) => {
    const selectedReturnType = localStorage.getItem("selectedReturnType");
    const exchangeCartData = JSON.parse(localStorage.getItem("exchangeCartObj"));
    const storedCart = JSON.parse(localStorage.getItem("cartObj")) || cart;

    const activeCart = selectedReturnType === "EXCHANGE" && exchangeCartData ? exchangeCartData : storedCart;
    // const activeCart = selectedReturnType === "EXCHANGE" && exchangeCartData ? exchangeCartData : cart;
    const defaultCustomer = activeCart?.customer?.cwrCustomerId === tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId;
    // const isAnonymousCustomer = cart?.customer?.b2cRegisteredstoreId === null;
    const isAnonymousCustomer = defaultCustomer && (posConfig?.showCustomerSearchValue === "Before Payment" || posConfig?.customerRequired === "Y");
    const checkConditionalRules = async () => {
      if (isNriBilling || activeCart?.customer?.nriBilling === true) {
        return false;
      }
      const panRule = retailCustomerRules?.find((rule) => rule.action === "Request PAN");

      if (!panRule || Number(activeCart.total) <= Number(panRule.value) || activeCart?.customer?.b2cRegisteredstoreId === null) {
        return false;
      }

      const finalPAN = activeCart?.customer?.metaData?.find((m) => m.key?.toLowerCase().startsWith("pan card"))?.value || activeCart?.customer?.panCard;
      if (!finalPAN || finalPAN.trim() === "") {
        setPanDrawerMode("THRESHOLD");
        return true;
      }

      setSelectedEditOldCustomer(activeCart?.customer);

      // if (!isPanCustomer) {
      //   setPanDrawerMode("VALIDATION");
      //   return true;
      // }
      if (!isPanCustomer) {
        setPanDrawerMode("VALIDATION");
        return true;
      }
      return false;
    };

    const performStockCheck = async () => {
      if (posConfig?.enableStockCheck === "N" || !posConfig?.enableStockCheck) {
        handleCartTotalClick(docType);
        return true;
      }

      const isFinalValidation = true;
      const stockCheckResult = await stock({
        cart,
        setCart,
        tillData,
        setProductStock,
        isFinalValidation,
        setTempCart,
        isCompleteSale: true,
        setShowCompleteSaleStock,
        setCompleteSaleStockData,
        customMixHandler: false,
        setProductBOMStock,
        setProductBOMStockData,
      });

      setSelectedProductInCart({});

      if (stockCheckResult) {
        handleCartTotalClick();
        return true;
      } else {
        setIsStockModal(true);
        return false;
      }
    };
    if (!navigator.onLine) {
      return await performStockCheck();
    }
    const isPanRuleViolated = await checkConditionalRules();
    const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj"));
    const cartObj = JSON.parse(localStorage.getItem("cartObj"));

    if (selectedReturnType === "EXCHANGE" && (!exchangeCartObj || exchangeCartObj?.items?.length === 0) && cartObj?.items?.length > 0) {
      message.warning("Please add items in exchange cart before proceeding.");
      return false;
    }
    if (exchangeCartObj && exchangeCartObj?.items?.length > 0) {
      const exchangeTotal = exchangeCartObj?.total;

      const returnTotal = Math.abs(cart?.total || 0);

      if (exchangeTotal < returnTotal) {
        message.warning("Exchange value must be equal to or greater than Return value.");
        return false;
      }
    }
    if (posConfig?.requireSalesRepresentative === "Y" && !isPanRuleViolated) {
      const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj"));
      if (isExchange) {
        if (exchangeCartObj?.salesRepId === null) {
          setOpenSalesRep({ flag: true, level: "order" });
          return false;
        }
      } else {
        if (activeCart?.salesRepId === null) {
          setOpenSalesRep({ flag: true, level: "order" });
          return false;
        }
      }
    }

    if (isAnonymousCustomer && !hasShownCustomerModalRef.current && activeCart.total > 0) {
      hasShownCustomerModalRef.current = true;
      setCustomerSearchTrigger("verifyStock");
      setDisplayCustomerSearch(true);
      return false;
    } else if (isPanRuleViolated) {
      const mappedCustomer = convertMetaDataToKeyValue(activeCart?.customer);
      const formValues = {};
      // Utility: convert "Anniversary Date" -> "anniversarydate"
      const normalize = (str) => str?.toLowerCase().replace(/\s+/g, "");

      // Build a dynamic lookup map from mappedCustomer
      const dynamicMapping = {};
      Object.keys(mappedCustomer || {}).forEach((key) => {
        dynamicMapping[normalize(key)] = key;
      });
      retailCustomerFields.forEach((field) => {
        const fieldKey = normalize(field.name); // e.g., "anniversarydate"
        const mappedKey = dynamicMapping[fieldKey];

        // let value;
        // if (mappedKey?.includes(".")) {
        //   value = mappedKey.split(".").reduce((obj, k) => obj?.[k], mappedCustomer);
        // } else {
        //   value = mappedCustomer[mappedKey];
        // }
        let value;

        if (field.groupId) {
          const groupKey = field.groupId;
          const groupData = mappedCustomer[groupKey] || {};

          value = groupData[toCamelCase(field.name)] ?? groupData[normalize(field.name)];
        } else {
          value = mappedCustomer[mappedKey];
        }

        if (field.groupId) {
          if (!formValues[field.groupId]) {
            formValues[field.groupId] = {};
          }
          // formValues[field.groupId][field.name] = value;
          formValues[String(field.groupId).toLowerCase()][toCamelCase(field.name)] = value;
        } else {
          // formValues[field.name] = value;
          formValues[toCamelCase(field.name)] = value;
        }
      });
      customerForm.setFieldsValue(formValues);
      const meta = activeCart?.customer?.metaData || [];
      const panMeta = meta.find((m) => m.key === "PAN_CARD_URL");
      const docMeta = meta.find((m) => m.key === "CUSTOMER_DOCUMENT_URLS");

      const docsToSet = [];

      if (panMeta?.value) {
        docsToSet.push({ docID: "", docName: "PAN Card", docUrl: panMeta.value, fileName: panMeta.value.split("/").pop() });
      }

      if (docMeta?.value) {
        try {
          JSON.parse(docMeta.value).forEach((url, i) => {
            docsToSet.push({ docID: `existing_${i}`, docName: "Customer Document", docUrl: url, fileName: url.split("/").pop() });
          });
        } catch {}
      }

      setDocuments(docsToSet); // ✅ done

      setIsPanUpdateMode(true);
      setDisplayAddNewCustomer(true);
      return false;
    } else {
      const statesData = JSON.parse(localStorage.getItem("statesData")) || [];
      if (retailCustomerFields && retailCustomerFields.length > 0) {
        // const getStateId = (stateValue) => {
        //   if (!stateValue) return "";
        //   const isId = statesData.some((state) => state.RecordID === stateValue);
        //   if (isId) return stateValue;
        //   return statesData.find((state) => state.Name?.toLowerCase().trim() === stateValue.toLowerCase().trim())?.RecordID || "";
        // };
        const storeStateId = tillData?.tillAccess?.csBunit?.csRegionId;
        const customerConfig = localStorage.getItem("customerConfigs") ? JSON.parse(localStorage.getItem("customerConfigs")) : [];
        const customerConfigData = customerConfig ? JSON.parse(customerConfig[0]?.configuration) : {};
        const retailCustomerGroups = customerConfigData?.fieldGroups || [];
        //     const customerStateRaw = activeCart?.customer?.metaData?.find((item) => item.key?.toLowerCase() === "state")?.value;
        // const customerStateId = getStateId(customerStateRaw);
        const storedB2B = localStorage.getItem("isB2bEnabled") === "true";
        let customerStateId = "";
        if (storedB2B && retailCustomerGroups.length > 0) {
          const groupId = retailCustomerGroups?.find((g) => g.name === "Delivery Address")?.id;
          const addressObj = activeCart?.customer?.metaData?.find((item) => item.key === groupId)?.value
            ? JSON.parse(activeCart?.customer?.metaData?.find((item) => item.key === groupId)?.value)
            : null;
          customerStateId = addressObj?.state || "";
        } else if (retailCustomerGroups.length > 0) {
          const groupId = retailCustomerGroups?.find((g) => g.name === "Address")?.id;
          const addressObj = activeCart?.customer?.metaData?.find((item) => item.key === groupId)?.value
            ? JSON.parse(activeCart?.customer?.metaData?.find((item) => item.key === groupId)?.value)
            : null;
          customerStateId = addressObj?.state || "";
        }
        const statesData = JSON.parse(localStorage.getItem("statesData")) || [];
        if (customerStateId) {
          const isId = statesData.some((s) => s.RecordID === customerStateId);
          if (!isId) {
            const match = statesData.find((s) => s.Name?.toLowerCase() === customerStateId?.toLowerCase());
            customerStateId = match?.RecordID || "";
          }
        }
        // const customerStateRaw = activeCart?.customer?.metaData?.find((item) => item.key?.toLowerCase() === "state")?.value;
        // const customerStateId = getStateId(customerStateRaw);
        const isDifferentRegion = customerStateId && storeStateId !== customerStateId;
        if (!storedB2B && isDifferentRegion && !supplyRegionProceed) {
          return new Promise((resolve) => {
            Modal.confirm({
              title: "Place of Supply Mismatch",
              content: "Customer region and store region are different. Do you want to proceed or change place of supply?",
              okText: "Proceed",
              cancelText: "Change",
              okButtonProps: {
                style: { display: "inline-block" },
              },
              onOk: async () => {
                const result = await performStockCheck();
                setSupplyRegionProceed(true);
                resolve(result);
              },
              onCancel: () => {
                const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
                setSelectedEditOldCustomer(cartDetails?.customer);
                const mappedCustomer = convertMetaDataToKeyValue(activeCart?.customer);
                const formValues = {};
                // Utility: convert "Anniversary Date" -> "anniversarydate"
                const normalize = (str) => str?.toLowerCase().replace(/\s+/g, "");

                // Build a dynamic lookup map from mappedCustomer
                const dynamicMapping = {};
                Object.keys(mappedCustomer || {}).forEach((key) => {
                  dynamicMapping[normalize(key)] = key;
                });
                retailCustomerFields.forEach((field) => {
                  const fieldKey = normalize(field.name); // e.g., "anniversarydate"
                  const mappedKey = dynamicMapping[fieldKey];

                  let value;

                  if (field.groupId) {
                    const groupKey = field.groupId;
                    const groupData = mappedCustomer[groupKey] || {};

                    value = groupData[toCamelCase(field.name)] ?? groupData[normalize(field.name)];
                  } else {
                    value = mappedCustomer[mappedKey];
                  }

                  if (field.groupId) {
                    if (!formValues[field.groupId]) {
                      formValues[field.groupId] = {};
                    }
                    // formValues[field.groupId][field.name] = value;
                    formValues[String(field.groupId).toLowerCase()][toCamelCase(field.name)] = value;
                  } else {
                    // formValues[field.name] = value;
                    formValues[toCamelCase(field.name)] = value;
                  }
                });
                customerForm.setFieldsValue(formValues);
                setDisplayEditOldCustomer(true);
                resolve(false);
              },
            });
          });
        }
      }
      return await performStockCheck();
    }
  };

  const handleCartTotalClick = async (documentType) => {
    try {
      let index = cart.items.findIndex((item) => item.productSegment === "AD");
      if ((posConfig ? posConfig["requireDeliveryDate-Advance"] === "Y" : false) && (documentType === "Advance" || selectedDocumentType === "Advance")) {
        if (!cart.deliveryDate && cart.deliveryDate !== "") {
          message.warn(`${messages.errors.cart.deliverydate_required}`);
          return;
        }
      }
      if (index !== -1 && selectedDocumentType !== "Advance") {
        setShowPaymentMethods(false);
        message.warn(`${messages.errors.cart.advance_option_required}`);
        return;
      }
      // setAmount(parseFloat(parseFloat(amount || cart.total - (cart.paid ?? 0))?.toFixed(precision)));

      let cartObj = JSON.parse(localStorage.getItem("cartObj")) ? JSON.parse(localStorage.getItem("cartObj")) : cart;
      // setAmount(parseFloat(parseFloat(cartObj.total - (cartObj.paid ?? 0) || amount)?.toFixed(precision)));
      setAmount(
        parseFloat(
          (
            parseFloat(localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj")).total : cart.total) +
            parseFloat(localStorage.getItem("exchangeCartObj") ? JSON.parse(localStorage.getItem("exchangeCartObj")).total : 0) -
            Math.abs(cartObj.paid ?? 0) -
            parseFloat(localStorage.getItem("exchangeCartObj") ? JSON.parse(localStorage.getItem("exchangeCartObj")).paid : 0)
          ).toFixed(precision)
        )
      );
      const workflowRules = (await db.POSWorkFlowRules.toArray()) || [];
      const approvers = (await db.approvers.toArray()) || [];

      let localCart = JSON.parse(localStorage.getItem("cartObj")) || cart;

      if (!localCart.items) {
        localCart.items = [];
      }

      let PaymentMethods = getFilteredPaymentMethods() || [];
      const advanceItem = cart.items.find((item) => item.type === "S" && item.weight > 0 && item.productSegment === "AD");
      if (
        cart.layAway === "Y" &&
        cart?.docType === "Advance" &&
        !advanceItem &&
        posConfig?.allowLayawaywithoutPayment !== "Y" &&
        !cart.items.some((item) => item.type === "S" && item?.productSegment === "AD" && item.weight > 0)
      ) {
        PaymentMethods = [
          ...PaymentMethods,
          ...(posConfig?.enablePreOrder !== "Y"
            ? [
                {
                  cWRPaymentMethodID: "",
                  sequenceNo: 9999,
                  finPaymentmethodId: "",
                  finFinancialAccountId: "",
                  finDayCloseAccountId: null,
                  name: "Complete Order",
                  integratedPayment: false,
                  isloyalty: false,
                  paymentProvider: null,
                  iscredit: false,
                  isGiftCard: false,
                  isDefault: "N",
                  csCurrencyId: "",
                  isoCode: "AED",
                  isactive: true,
                  salesType: [],
                },
              ]
            : []),
        ];
      }
      const isPreOrderPage = window.location.pathname.includes("/preorder");
      if (isPreOrderPage) {
        const isRefundScenario = amount < 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash";
        const maxPaymentsToShow = isRefundScenario ? 3 : 3;
        let payments =
          PaymentMethods.length > maxPaymentsToShow
            ? _.sortBy(PaymentMethods, "sequenceNo").slice(
                0,
                tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === maxPaymentsToShow
                  ? maxPaymentsToShow
                  : cart.layAway === "Y"
                    ? maxPaymentsToShow
                    : maxPaymentsToShow
              )
            : PaymentMethods;
        setShowPayments(payments);
        setStartIndex(cart.layAway === "Y" && payments.length >= maxPaymentsToShow ? maxPaymentsToShow : payments.length);
      } else {
        let payments =
          PaymentMethods.length > 5
            ? _.sortBy(PaymentMethods, "sequenceNo").slice(
                0,
                tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
              )
            : PaymentMethods;

        setShowPayments(payments);
        setStartIndex(cart.layAway === "Y" && payments.length >= 5 ? 5 : payments.length);
      }

      if (workflowRules.length > 0 && localCart.isReturn === true && localCart.items.length > 0 && !showPaymentMethods) {
        workflowRules.forEach((res) => {
          if (res.eventName === "Sales Return Process") {
            dispatchEvent(res.eventName, res.ruleName, res.ruleCondition, approvers, null, (eventData) => {
              if (eventData?.approvalGranted) {
                setSelectedProductInCart({});
                openPaymentModalByCustomer(cart);
                setShowPaymentMethods(true);
                if (CWHardwareController) {
                  CWPoleDisplay(cart, "Total to pay");
                } else {
                  PoleDisplay(cart, "Total to pay");
                }
              }
            });
          }
        });
      } else if (localCart.items.length > 0) {
        setSelectedProductInCart({});
        openPaymentModalByCustomer(localCart);
        setShowPaymentMethods(true);
        if (CWHardwareController) {
          CWPoleDisplay(cart, "Total to pay");
        } else {
          PoleDisplay(cart, "Total to pay");
        }
      }
      let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails")) || { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
      };

      localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
    } catch (error) {
      console.error("Error handling cart total:", error);
    }
  };

  // const filterPaymentsBySaleType = (paymentMethods, id) => {
  //   const saleTypeId = id || selectedSaleTypeData?.cwrSaletype?.cwrSaletypeId;
  //   if (!saleTypeId) return paymentMethods; // If saleTypeId is null or falsy, return all payment methods

  //   return paymentMethods.filter(({ salesType }) => Array.isArray(salesType) && salesType.some(({ cwrSaletypeId }) => cwrSaletypeId === saleTypeId));
  // };

  const filterPaymentsBySaleType = (paymentMethods, id) => {
    const saleTypeId = id || selectedSaleTypeData?.cwrSaletype?.cwrSaletypeId;
    if (!saleTypeId) return paymentMethods; // If saleTypeId is null or falsy, return all payment methods
    const tillId = tillData.tillAccess?.cwrTill?.cwrTillID;
    return paymentMethods.filter(
      ({ salesType, cwrTillId }) => (!cwrTillId || cwrTillId === tillId) && Array.isArray(salesType) && salesType.some(({ cwrSaletypeId }) => cwrSaletypeId === saleTypeId)
    );
  };
  const getFilteredPaymentMethods = (id) => {
    if (!Array.isArray(tillDataPaymentMethods)) return [];
    const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE";
    const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
    const activeCart = isExchange && exchangeCartObj ? exchangeCartObj : cart;
    const filteredBySaleType = filterPaymentsBySaleType(tillDataPaymentMethods, id);
    const filteredMethods = _.sortBy(
      filteredBySaleType.filter((pm) => {
        const isLoyaltyDisabled = posConfig?.loyaltyApplicable === "N" && pm.name === "Loyalty";
        const isNoLoyaltyLevel = !activeCart?.customer?.loyaltyLevel?.cwrLoyaltyLevelId && pm.name === "Loyalty";
        const isNoCredit = !activeCart?.customer?.iscredit && pm.name === "Credit" && localStorage.getItem("isCreditSale") !== "true";
        const isCafeTips = pm.name.toLowerCase() === "cafe tips";
        const loyaltyFlag = tillData?.tillAccess?.csBunit?.enableLoyalty !== "Y" && pm.name === "Loyalty";
        const isNoWallet = !activeCart?.customer?.cwrWallet?.wallet_Id && pm.isWallet === "Y";
        const isInvalidReturnMethod = activeCart?.isReturn === true && pm.isReturns !== "Y";
        return !(isLoyaltyDisabled || isNoLoyaltyLevel || isNoCredit || isCafeTips || loyaltyFlag || isNoWallet || isInvalidReturnMethod);
        // return pm;
      }),
      "sequenceNo"
    );
    return filteredMethods;
  };

  const filteredPaymentMethods = getFilteredPaymentMethods();

  const initialShowPayments = filteredPaymentMethods.length > 5 ? filteredPaymentMethods.slice(0, 5) : filteredPaymentMethods;
  localStorage.setItem("initialShowPayments", JSON.stringify(initialShowPayments));
  const [isShowingAll, setIsShowingAll] = useState(false);
  const [showPayments, setShowPayments] = useState(initialShowPayments);
  const [startIndex, setStartIndex] = useState(0);
  const [comboBoxPopup, setComboBoxPopup] = useState(false);

  const addDefinedProduct = async (productObjs, upc, batchno, mBatchId, price, checkWeight, modifiedQty, batchedItem, modifiedPrice, scanFlag, data) => {
    const cartKey = isExchange ? "exchangeCartObj" : "cartObj";
    const cartObj = JSON.parse(localStorage.getItem(cartKey));
    if (productObjs?.productSegment === "AD") {
      const isAlreadyInCart = cartObj?.items?.some((item) => item?.value === productObjs?.value);
      if (isAlreadyInCart) {
        message.warning("This advance item is already present in the cart and cannot be added again.");
        return;
      }
    }

    setFilterDrawer(false);
    setIsProductsVisible(false);
    setQtyNumberFlag(0);
    const productObj = { ...productObjs };
    if (productObj.overRideTax === "Y" && price <= productObj.overRideCondition) {
      // prettier-ignore
      const originalPrice = price - (price - (price * (100 / (100 + productObj.taxRate))));
      const taxedPrice = originalPrice + (originalPrice * productObj.contraRate) / 100;
      price = taxedPrice;
      productObj.cTaxId = productObj.contraTaxId;
      productObj.taxRate = productObj.contraRate;
    }
    // let matchedPriceIndex = [];
    // if (!scanFlag) {
    //   if (productObj?.priceList?.length > 0) {
    //     let cartData = JSON.parse(localStorage.getItem("cartObj"));
    //     matchedPriceIndex = productObj?.priceList?.filter((i) => i.sPricelistId === cartData.customer.sPriceListId);
    //     price = matchedPriceIndex[0]?.pricestd || price;
    //     productObj.originalPrice = productObj.sunitprice;
    //     productObj.sunitprice = matchedPriceIndex[0]?.pricestd || productObj.sunitprice;
    //   }
    // }
    if (!scanFlag && productObj?.priceList?.length > 0) {
      const selectedPrice = getApplicablePrice({
        priceList: productObj.priceList,
        selectedUomId: productObj.uomData[0]?.csUomId,
        sPriceListId: cartObj?.customer?.sPriceListId,
        alternateUom: productObj?.alternateUom || [],
        primaryUomId: productObj?.uom || null,
      });

      if (selectedPrice) {
        productObj.originalPrice = productObj.sunitprice;
        productObj.sunitprice = selectedPrice.pricestd;
        price = selectedPrice.pricestd;
      }
    }

    let productDefined = {
      batchno: batchno || null,
      description: productObj?.description || "",
      discount: 0,
      discountName: "",
      imageurl: productObj?.imageurl || "",
      isDecimal: productObj?.isDecimal || false,
      isManualQty: productObj?.isManualQty || false,
      restrictPosQtyEdit: productObj?.restrictPosQtyEdit || "N",
      showAlternateUomInPos: productObj?.showAlternateUomInPos || "N",
      posPriceEdit: productObj?.posPriceEdit || "N",
      alternateUom: productObj?.alternateUom || null,
      companion: productObj?.companion || "N",
      isPromoApplicable: productObj?.isPromoApplicable || false,
      isReturn: false,
      mBatchId: mBatchId || null,
      mPricingruleId: null,
      name: productObj?.name || "",
      name2: productObj?.name2 || "",
      nettotal: 0,
      primaryOrderLine: null,
      productId: productObj?.mProductId || null,
      realPrice: price || 0,
      listPrice: productObj?.slistprice || 0,
      sunitprice: productObj?.sunitprice || 0,
      returnQty: null,
      salePrice: price || 0,
      stock: productObj?.onhandQty || 0,
      tax: productObj?.cTaxId || null,
      taxCategory: productObj?.taxCategory || "",
      taxName: productObj?.taxName || "",
      taxFlag: productObj?.taxFlag || "N",
      taxAmount: 0,
      taxRate: productObj?.taxRate || 0,
      interTaxId: productObj?.interTaxId || "",
      interTaxRate: productObj?.interTaxRate || 0,
      interTaxName: productObj?.interTaxName || "",
      uom: productObj?.csUomId || null,
      uom_name: productObj?.uom_name || productObj?.unit || productObj?.uomName || "",
      uomData: productObj?.uomData || [],
      addNewLine: productObj?.addNewLine || "N",
      customAttributes: productObj?.customAttributes || [],
      preparationTime: productObj?.preparationTime || "",
      printerId: productObj?.printerId || "",
      cwrPcatalogueId: productObj?.cwrPcatalogueId || null,
      cwrMenuTimeslot: productObj?.cwrMenuTimeslot || [],
      productAliasName: productObj?.productAliasName || null,
      bunitName: productObj?.bunitName || "",
      imageUrl: productObj?.imageUrl || "",
      showAddons: productObj?.showAddons || false,
      foodType: productObj?.foodType || "",
      itemType: productObj?.itemType || "",
      type: productObj?.type || "",
      newCustomAttributes: [],
      priceList: productObj?.priceList || [],
      originalPrice: productObj?.originalPrice || productObj?.sunitprice,
      productSegment: productObj?.productSegment || "",
      selectedAddons: [],
      isDecimalQty: productObj?.uomData?.[0]?.decimal === "Y" ? true : false,
      isQtyDesimal: productObj?.uomData?.[0]?.stdprecision || 2,
      upc: upc || "",
      value: productObj?.value || "",
      weight: 0,
      order: "N",
      productionCenter: productObj?.productionCenter || "",
      productionCenterId: productObj?.productionCenterId || "",
      shortDescription: productObj?.shortDescription || "",
      hsncode: productObj?.hsncode || null,
      csBunitId: productObj?.csBunitId || null,
      mProductCategoryId: productObj?.mProductCategoryId || null,
      productManufacturerId: productObj?.productManufacturerId || null,
      productBrandId: productObj?.productBrandId || null,
      productBrandName: productObj?.productBrandName || null,
      productCategoryName: productObj?.productCategoryName || "",
      productAddons: productObj?.productAddons || [],
      batchedProduct: productObj?.batchedProduct || false,
      batchedForSale: productObj?.batchedForSale || false,
      batchedForStock: productObj?.batchedForStock || false,
      multiPrice: productObj?.multiPrice || false,
      shelfLife: productObj?.shelfLife || "",
      stdTax: productObj?.sunitprice * (1 + productObj?.taxRate / 100),
      posPriceEdit: productObj?.posPriceEdit || "N",
      upcPricingRule: productObj?.upcPricingRule || null,
    };

    // let cartItems = JSON.parse(localStorage.getItem("cartObj"))?.items;
    let cartItems = cartObj?.items;
    let filterItem = cartItems?.filter((item) => item.productId === productDefined.productId);
    if (filterItem?.length === 1 && filterItem?.selectedAddons?.length <= 0) {
      productDefined.lineId = filterItem[0].lineId;
    }
    let updatedWeight;
    const isUomProduct = productDefined?.alternateUom?.length > 0 && productDefined?.showAlternateUomInPos === "Y";

    // Handle UOM product — open UOM popup and wait for user selection
    if (isUomProduct) {
      setOptions([]);
      const updatedProductFromUom = await new Promise((resolve) => {
        dispatchWeight(productDefined, setInputFocused, selectedProductInCart, setSelectedProductInCart, (updatedProduct) => {
          if (updatedProduct) {
            resolve(updatedProduct);
          } else {
            resolve(null); // user cancelled
          }
        });
      });

      if (!updatedProductFromUom) {
        // User cancelled the UOM popup
        setActiveInput("search");
        if (searchInputRef?.current) searchInputRef.current.focus();
        return;
      }

      updatedWeight = updatedProductFromUom.weight;
      modifiedQty = updatedProductFromUom.weight;
      productDefined = updatedProductFromUom;
    } else if (productDefined.isManualQty && posConfig?.showWeightPopup === "Y" && (modifiedQty === 1 || modifiedQty === 0 || !modifiedQty) && data?.length !== 13) {
      setOptions([]);
      setActiveInput("weightPopup");
      const updateProductWithWeight = new Promise((resolve) => {
        dispatchWeight(productDefined, setInputFocused, selectedProductInCart, setSelectedProductInCart, (updatedProduct) => {
          if (updatedProduct) {
            updatedWeight = updatedProduct.weight;
            modifiedQty = updatedProduct.weight;
            productDefined = updatedProduct;
            resolve(updatedProduct);
          }
        });
      });

      const updatedProductDefined = await updateProductWithWeight;
      setCurrentWeightSelectedProduct(updatedProductDefined);
    }
    setActiveInput("search");
    if (searchInputRef?.current) {
      searchInputRef.current.focus();
    }
    if (checkWeight === true || updatedWeight) {
      let index = cartObj.items.findIndex((item) => item.value === productDefined.value);
      if (batchedItem === true && !updatedWeight) {
        modifiedQty = cartObj.items > 0 ? cart.items[index].weight + 1 : 1;
      }
      const productSearchInput = document.getElementById("sm-product-search");
      if (productSearchInput) {
        productSearchInput.blur();
      }
      await addProduct(productDefined, modifiedQty, false, modifiedPrice, false, false);
      setProductSearchInput("");
      localStorage.removeItem("productName");
      setOptions([]);
      if (productSearchInputRef?.current) {
        productSearchInputRef?.current?.clearInput();
      }
    } else {
      await addProduct(productDefined, 1, false, 0, false, false);
      setProductSearchInput("");
      localStorage.removeItem("productName");
      setOptions([]);
      if (productSearchInputRef?.current) {
        productSearchInputRef?.current?.clearInput();
      }
    }
  };

  const selectProductToCart = (batch, qty = 1) => {
    batch.productAddons = batch.productAddons || [];
    batch.customAttributes = batch.customAttributes || [];
    batch.selectedAddons = batch.selectedAddons || [];

    addProduct(batch, qty, false, 0, false, false);
    setDisplayBatchSelection(false);
  };

  // BARCODE READER BLOCK END

  // PRODUCT WEIGHT MODAL START
  const [displayManualQtyWeightInput, setDisplayManualQtyWeightInput] = useState(false);
  const [productWeightModalInput, setProductWeightModalInput] = useState("");
  const [currentWeightSelectedProduct, setCurrentWeightSelectedProduct] = useState({});
  const [stockList, setStockList] = useState([]);

  const onProductModalChangeWeight = (event) => {
    setProductWeightModalInput(event.target.value);
  };

  const handleWeightManual = (value) => {
    if (productWeightModalInput === "" && value === "x") {
      setProductWeightModalInput("");
    } else if (value === "x") {
      setProductWeightModalInput(`${productWeightModalInput.toString().substring(0, productWeightModalInput.toString().length - 1)}`);
    } else {
      setProductWeightModalInput(`${productWeightModalInput}${value}`);
    }
  };

  const addManualBatchProduct = () => {
    if (!manualBatchNo) {
      message.warning("Please enter Batch Number");
      return;
    }
    const obj = { ...manualBatchProduct };
    const productDefined = {
      batchno: manualBatchNo || null,
      description: obj.description || "",
      discount: 0,
      discountName: "",
      imageurl: obj.imageurl || "",
      isDecimal: obj.isDecimal || false,
      isManualQty: obj.isManualQty || false,
      restrictPosQtyEdit: obj.restrictPosQtyEdit || "N",
      showAlternateUomInPos: obj?.showAlternateUomInPos || "N",
      posPriceEdit: obj?.posPriceEdit || "N",
      alternateUom: obj?.alternateUom || null,
      companion: obj?.companion || "N",
      isPromoApplicable: obj.isPromoApplicable || false,
      isReturn: false,
      mBatchId: null,
      mPricingruleId: null,
      name: obj.name || "",
      name2: obj.name2 || "",
      nettotal: 0,
      primaryOrderLine: null,
      productId: obj.mProductId || "",
      realPrice: obj.sunitprice || 0,
      listPrice: obj.slistprice || 0,
      sunitprice: obj.sunitprice || 0,
      returnQty: null,
      salePrice: obj.sunitprice || 0,
      originalPrice: obj.sunitprice || 0,
      productSegment: obj?.productSegment || "",
      mrpPrice: obj.sunitprice || 0,
      stock: obj.onhandQty || 0,
      tax: obj.cTaxId || null,
      taxCategory: obj.taxCategory || "",
      taxName: obj?.taxName || "N",
      productSegment: obj.productSegment || "",
      taxFlag: obj?.taxFlag || "N",
      customAttributes: obj.customAttributes || [],
      preparationTime: obj?.preparationTime || "",
      printerId: obj?.printerId || "",
      productionCenterId: obj?.productionCenterId || "",
      cwrPcatalogueId: obj.cwrPcatalogueId || null,
      cwrMenuTimeslot: obj.cwrMenuTimeslot || [],
      productAliasName: obj.productAliasName || null,
      bunitName: obj?.bunitName || "",
      imageUrl: obj?.imageUrl || "",
      showAddons: obj?.showAddons || false,
      foodType: obj?.foodType || "",
      itemType: obj?.itemType || "",
      type: obj.type || "",
      newCustomAttributes: [],
      priceList: obj?.priceList || [],
      selectedAddons: [],
      taxAmount: 0,
      taxRate: obj.taxRate || 0,
      interTaxId: obj?.interTaxId || "",
      interTaxRate: obj?.interTaxRate || 0,
      interTaxName: obj?.interTaxName || "",
      uom: obj.csUomId || null,
      uom_name: obj.uomName || "",
      uomData: obj.uomData || [],
      addNewLine: obj?.addNewLine || "N",
      isDecimalQty: obj.uomData?.[0]?.decimal === "Y" || false,
      isQtyDesimal: obj.uomData?.[0]?.stdprecision || 2,
      upc: null,
      value: obj.value || null,
      weight: 0,
      order: "N",
      shortDescription: obj.shortDescription || "",
      hsncode: obj.hsncode || null,
      csBunitId: obj.csBunitId || null,
      mProductCategoryId: obj.mProductCategoryId || null,
      productManufacturerId: obj.productManufacturerId || null,
      productBrandId: obj.productBrandId || null,
      productBrandName: obj?.productBrandName || null,
      batchedProduct: obj.batchedProduct || "",
      batchedForSale: obj.batchedForSale || "",
      batchedForStock: obj.batchedForStock || "",
      multiPrice: obj.multiPrice || false,
      shelfLife: obj.shelfLife || "",
      stdTax: obj?.sunitprice * (1 + obj?.taxRate / 100),
      posPriceEdit: obj?.posPriceEdit || "N",
    };
    addProduct(productDefined, 1, false, 0, false, false);
    setFilterDrawer(false);
    setShowManualBatchPopup(false);
    setManualBatchProduct(null);
    setManualBatchNo("");
  };

  const pickProduct = (obj) => {
    console.log("Picked product:", obj);
    setIsProductsVisible(false);
    const receiptlessReturn2Enabled = posConfig?.enableReceiptlessReturn2 === "Y";
    const activeCart = isExchange ? JSON.parse(localStorage.getItem("exchangeCartObj")) : cart;
    const isReceiptlessReturn = receiptlessReturn2Enabled && activeCart?.isReturn === true && activeCart?.isBlindReceipt === true;

    if (isReceiptlessReturn && obj.batchedProduct === "Y" && obj.batchedForSale === "Y") {
      setManualBatchProduct(obj);
      setManualBatchNo("");
      setShowManualBatchPopup(true);
    } else if (obj.batchedProduct === "Y" && obj.batchedForSale === "Y" && Array.isArray(obj.mBatch) && obj.mBatch.length > 0) {
      // if (obj.mBatch.length === 1) {
      //   setFilterDrawer(false);
      //   addDefinedProduct(obj, obj.mBatch[0].upc, obj.mBatch[0].batchno, obj.mBatch[0].mBatchId, obj.mBatch[0].price);
      // } else {
      const productSet = [];
      const localObj = obj;
      for (let i = 0; i < obj.mBatch.length; i += 1) {
        const batchItem = { ...localObj.mBatch[i] };
        const obj = { ...localObj };
        if (obj.overRideTax === "Y" && batchItem.price <= obj.overRideCondition) {
          // prettier-ignore
          const originalPrice = batchItem.price - (batchItem.price - (batchItem.price * (100 / (100 + obj.taxRate))));
          const taxedPrice = originalPrice + (originalPrice * obj.contraRate) / 100;
          batchItem.price = taxedPrice;
          obj.cTaxId = obj.contraTaxId;
          obj.taxRate = obj.contraRate;
        }
        const productDefined = {
          batchno: batchItem.batchno,
          description: obj.description || "",
          discount: 0,
          discountName: "",
          imageurl: obj.imageurl || "",
          isDecimal: obj.isDecimal || false,
          isManualQty: obj.isManualQty || false,
          restrictPosQtyEdit: obj.restrictPosQtyEdit || "N",
          showAlternateUomInPos: obj?.showAlternateUomInPos || "N",
          posPriceEdit: obj?.posPriceEdit || "N",
          alternateUom: obj?.alternateUom || null,
          companion: obj?.companion || "N",
          isPromoApplicable: obj.isPromoApplicable || false,
          isReturn: false,
          mBatchId: batchItem?.mBatchId || null,
          mPricingruleId: null,
          name: obj.name || "",
          name2: obj.name2 || "",
          nettotal: 0,
          primaryOrderLine: null,
          productId: obj.mProductId || "",
          realPrice: batchItem.price || 0,
          listPrice: obj.slistprice || 0,
          sunitprice: obj.sunitprice || 0,
          returnQty: null,
          salePrice: batchItem.price || 0,
          originalPrice: obj.sunitprice || 0,
          productSegment: obj?.productSegment || "",
          mrpPrice: batchItem.listPrice || 0,
          stock: obj.onhandQty || 0,
          tax: obj.cTaxId || null,
          taxCategory: obj.taxCategory || "",
          taxName: obj?.taxName || "N",
          productSegment: obj.productSegment || "",
          taxFlag: obj?.taxFlag || "N",
          customAttributes: obj.customAttributes || [],
          preparationTime: obj?.preparationTime || "",
          printerId: obj?.printerId || "",
          productionCenterId: obj?.productionCenterId || "",
          cwrPcatalogueId: obj.cwrPcatalogueId || null,
          cwrMenuTimeslot: obj.cwrMenuTimeslot || [],
          productAliasName: obj.productAliasName || null,
          bunitName: obj?.bunitName || "",
          imageUrl: obj?.imageUrl || "",
          showAddons: obj?.showAddons || false,
          foodType: obj?.foodType || "",
          itemType: obj?.itemType || "",
          type: obj.type || "",
          newCustomAttributes: [],
          priceList: obj?.priceList || [],
          selectedAddons: [],
          taxAmount: 0,
          taxRate: obj.taxRate || 0,
          interTaxId: obj?.interTaxId || "",
          interTaxRate: obj?.interTaxRate || 0,
          interTaxName: obj?.interTaxName || "",
          uom: obj.csUomId || null,
          uom_name: obj.uomName || "",
          uomData: obj.uomData || [],
          addNewLine: obj?.addNewLine || "N",
          isDecimalQty: obj.uomData?.[0]?.decimal === "Y" || false,
          isQtyDesimal: obj.uomData?.[0]?.stdprecision || 2,
          upc: batchItem.upc || null,
          value: obj.value || null,
          weight: 0,
          order: "N",
          shortDescription: obj.shortDescription || "",
          hsncode: obj.hsncode || null,
          csBunitId: obj.csBunitId || null,
          mProductCategoryId: obj.mProductCategoryId || null,
          productManufacturerId: obj.productManufacturerId || null,
          productBrandId: obj.productBrandId || null,
          productBrandName: obj?.productBrandName || null,
          batchedProduct: obj.batchedProduct || "",
          batchedForSale: obj.batchedForSale || "",
          batchedForStock: obj.batchedForStock || "",
          multiPrice: obj.multiPrice || false,
          shelfLife: obj.shelfLife || "",
          stdTax: obj?.sunitprice * (1 + obj?.taxRate / 100),
          posPriceEdit: obj?.posPriceEdit || "N",
        };
        const selectedPrice = getApplicablePrice({
          priceList: obj?.priceList,
          selectedUomId: obj?.uomData[0]?.csUomId,
          sPriceListId: cart.customer.sPriceListId,
          alternateUom: obj?.alternateUom || [],
          primaryUomId: obj?.uom || null,
        });
        productDefined.salePrice = selectedPrice?.pricestd;
        productDefined.realPrice = selectedPrice?.pricestd;
        productSet.push(productDefined);
      }
      setFilterDrawer(false);
      setBatchSetAvailable([...productSet]);
      fetchOnlineBatches(productSet);
      // }
    } else {
      addDefinedProduct(obj, obj.upc, null, null, obj.sunitprice);
    }
  };

  const checkIsManualWeight = (prod) => {
    if (prod.isManualQty && posConfig?.showWeightPopup === "Y") {
      setDisplayManualQtyWeightInput(true);
      setCurrentWeightSelectedProduct(prod);
    } else {
      addProduct(prod, 1, false, 0, false, false);
    }
  };

  const modulo = (a, b) => {
    return a - b * Math.floor(a / b);
  };

  const isValidAmount = (amount) => {
    if (amount === null || amount === undefined) return false;
    const value = amount.toString().trim();
    if (value === "") return false;
    const number = Number(value);
    return !isNaN(number) && number > 0;
  };

  const handlePayment = async ({
    selectedPaymentMethod,
    cart,
    amount,
    posConfig,
    tillData,
    isOnline,
    isExchange,
    showConfirm,
    requestPayment,
    processOrder,
    setShowCardPaymnteModal,
    setPaymentType,
    setCardPaymnetError,
    messages,
    t,
    isCardPaymentFlag = false,
    enableGiftCardCheck = false,
    enablePoleDisplay = false,
    enableSetNumb = false,
    setNumb,
    CWHardwareController,
    CWPoleDisplay,
    PoleDisplay,
  }) => {
    const paymentName = selectedPaymentMethod?.name?.toLowerCase();
    const parsedAmount = parseFloat(amount || 0);
    const cartPaid = parseFloat(cart?.paid || 0);
    const cartTotal = parseFloat(cart?.total || 0);

    if (isCardPaymentFlag) return;

    const cashSaleValidation = retailCustomerRules?.find((rule) => rule.condition === "Cash Sale Validation");

    if (paymentName === "cash" && cashSaleValidation?.value) {
      const limitAmount = parseFloat(cashSaleValidation.value);

      const existingCashPaid = cart?.payments?.filter((p) => p?.name?.toLowerCase() === "cash")?.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0) || 0;

      const totalCashAfterPayment = existingCashPaid + parsedAmount;

      if (totalCashAfterPayment > limitAmount) {
        const formattedLimit = limitAmount.toLocaleString("en-IN", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });

        Modal.warning({
          title: "Cash Payment Restricted",
          content: `Total cash payment cannot exceed ₹${formattedLimit}.
Please use another payment method or split using card/UPI.`,
          okText: "OK",
          cancelButtonProps: { style: { display: "none" } },
        });

        return;
      }
    }

    if (paymentName === "cash" && cartPaid + parsedAmount >= cartTotal && posConfig?.showPaymentSummary === "Y") {
      const confirmed = await showConfirm();
      if (!confirmed) return;
    }

    // if (paymentName === "card" && posConfig?.show_card_payment_popup === "Y") {
    //   if (selectedPaymentMethod?.integratedPayment) {
    //     setPaymentType("edc");
    //     setShowCardPaymnteModal(true);
    //     return;
    //   } else {
    //     console.log("Card payment attempted without integrated payment setup.");
    //     setPaymentType("manual");
    //     setCardPaymnetError(true);
    //     setShowCardPaymnteModal(true);
    //     return;
    //   }
    // }
    if (selectedPaymentMethod?.name?.toLowerCase() === "card" && selectedPaymentMethod?.integratedPayment && posConfig?.show_card_payment_popup === "Y") {
      if (isValidAmount(amount)) {
        setShowCardPaymnteModal(true);
      } else {
        message.warning("Kindly enter the amount before proceeding");
      }
    } else if (selectedPaymentMethod?.name?.toLowerCase() === "card" && !selectedPaymentMethod?.integratedPayment && posConfig?.show_card_payment_popup === "Y") {
      if (isValidAmount(amount)) {
        setPaymentType("manual");
        setCardPaymnetError(true);
        setShowCardPaymnteModal(true);
        return;
      } else {
        message.warning("Kindly enter the amount before proceeding");
      }
    }

    const denominations = tillData?.tillAccess?.csBunit?.currencies?.[0]?.denominations?.sort((a, b) => a.value - b.value) || [];

    const smallest = denominations?.[0]?.value || 1;
    const result = modulo(parsedAmount, smallest);

    const isGiftCardOrLoyalty = paymentName !== "loyalty" && paymentName !== "voucher" && paymentName !== "gift card";

    if (enableGiftCardCheck && !isGiftCardOrLoyalty) {
      return;
    }

    const isExchangeMode = localStorage.getItem("selectedReturnType") === "EXCHANGE";

    const exchangeCartData = isExchangeMode ? JSON.parse(localStorage.getItem("exchangeCartObj") || "{}") : null;

    // const netForPayment = isExchangeMode ? Math.abs((exchangeCartData?.total || 0) + cartTotal) : Math.abs(cartTotal);

    // const paidForPayment = isExchangeMode ? exchangeCartData?.paid || 0 : cartPaid;

    let netForPayment = 0;
    let paidForPayment = 0;

    if (isExchangeMode) {
      const exchangeTotal = Math.abs(exchangeCartData?.total || 0);
      const returnTotal = Math.abs(cartTotal || 0);
      const alreadyPaid = Math.abs(cartPaid || 0);
      const exchangeAlreadyPaid = Math.abs(exchangeCartData?.paid || 0);

      netForPayment = exchangeTotal - returnTotal;
      paidForPayment = alreadyPaid + exchangeAlreadyPaid;
    } else {
      netForPayment = Math.abs(cartTotal || 0);
      paidForPayment = Math.abs(cartPaid || 0);
    }

    if (netForPayment > Math.abs(paidForPayment)) {
      if (paymentName === "cash" && result !== 0) {
        message.warning(messages?.warnings?.payment?.payment_multiple_check ? `${messages.warnings.payment.payment_multiple_check} ${smallest}` : t?.("cash_payment_error"));
        return;
      }

      if (posConfig?.disableOfflineBilling === "Y" && !isOnline) {
        message.warning(`${messages?.warnings?.payment?.payment_network_check}`);
        return;
      }

      if (enableSetNumb && setNumb) {
        setNumb(0);
      }

      requestPayment(selectedPaymentMethod, parsedAmount);
      setIsBankTransferOpen(false);
      financialForm.resetFields();
      setFinancialDocument(null);
      if (enablePoleDisplay && Math.abs(cartTotal) > parsedAmount) {
        if (CWHardwareController) {
          CWPoleDisplay(cart, "Show due payment", parsedAmount);
        } else if (PoleDisplay) {
          PoleDisplay(cart, "Show due payment", parsedAmount);
        }
      }
    } else if (netForPayment === 0 && isExchange) {
      requestPayment(selectedPaymentMethod, parsedAmount);
    } else if (cart?.docType !== "Advance") {
      processOrder();
    }
  };

  const addManualWeightToProduct = () => {
    let inputValidator = new RegExp(/^[0-9]*$/);
    if (currentWeightSelectedProduct.isDecimal) inputValidator = new RegExp(/^[0-9]\d*(\.\d+)?$/);
    if (inputValidator.test(productWeightModalInput) && parseFloat(productWeightModalInput) > 0) {
      setDisplayManualQtyWeightInput(false);
      addProduct(currentWeightSelectedProduct, productWeightModalInput, false, 0, false, false);
      setTimeout(() => {
        setProductWeightModalInput("");
        setCurrentWeightSelectedProduct({});
      }, 500);
    } else {
      console.warn("Invalid weight input: ", productWeightModalInput);
      message.warning(`${messages.warnings.cart.invalid_input_value}`);
    }
  };

  // PRODUCT WEIGHT MODAL END

  // PRODUCT FILTER START
  const [isProductsFilter, setIsProductsFilter] = useState(() => (posConfig?.defaultSearchScreen === "Category Search" ? true : false));
  const [allProductCategories, setAllProductCategories] = useState([]);
  const [selectedProductBrand, setSelectedProductBrand] = useState([]);
  const [selectedProductCategory, setSelectedProductCategory] = useState("allProducts");
  const [selectCategotyList, setSelectCategotyList] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const prevProductsListRef = useRef(null);
  const prevHistoryRef = useRef(orderHistoryDetails);
  const [productsCopy, setProductsCopy] = useState([]);
  const hasShownCustomerModalRef = useRef(false);

  const callGetWeightAPI = async (productDefined) => {
    try {
      const response = await Axios({
        url: `${tillData?.tillAccess?.cwrTill?.hardwareController?.imageUrl}getWeight`,
        method: "POST",
      });
      const productToUpdate = productDefined && Object.keys(productDefined)?.length > 0 ? productDefined : selectedProductInCart;
      if (response?.data?.Weight) {
        const weight = parseFloat(response.data.Weight.replace("kg", "").trim());
        if (!isNaN(weight)) {
          productToUpdate.weight = weight;
          setSelectedProductInCart(productToUpdate);
        }
      }
    } catch (error) {
      console.error("Error in callGetWeightAPI:", error);
    }
  };

  useEffect(() => {
    db.AllProductCategories.toArray().then((res) => {
      setAllProductCategories(res);
    });
    if (!localStorage.getItem("cartObj") && !isExchange) {
      localStorage.setItem("cartObj", JSON.stringify(cart));
    }
  }, []);

  useEffect(() => {
    getCategoryProducts(selectedProductCategory);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const selectProductCategory = (category) => {
    if (selectedProductCategory !== category) {
      setSelectedProductCategory(category);
    }
  };

  const filterProducts = (brands, categories) => {
    let filteredItems = productsCopy;

    if (brands?.length > 0 || categories?.length > 0) {
      filteredItems = productsCopy.filter(
        (item) => (brands?.length === 0 || brands?.includes(item.brandId)) && (categories?.length === 0 || categories?.includes(item.mProductCategoryId))
      );
    }

    // Update the productsList with filtered items
  };

  // const restaurantProductCategory = async (categorie) => {
  //   await db.products
  //     .where("mProductCategoryId")
  //     .equals(categorie)
  //     .toArray()
  //     .then(async (response) => {
  //       setProductsData(response);
  //     });
  // };

  // Debounced handler for brand checkbox changes
  const debouncedBrandChange = debounce((brandId) => {
    const isSelected = selectedProductBrand?.includes(brandId);
    let updatedSelectedBrands = [];

    if (isSelected) {
      // Brand is already selected, remove it from the selectedProductBrand array
      updatedSelectedBrands = selectedProductBrand?.filter((id) => id !== brandId);
    } else {
      // Brand is not selected, add it to the selectedProductBrand array
      let tempBrand = selectedProductBrand || [];
      updatedSelectedBrands = [...tempBrand, brandId];
    }

    setSelectedProductBrand(updatedSelectedBrands || []); // Ensure it's always an array

    // Filter products based on selected brands and categories
    filterProducts(updatedSelectedBrands || [], selectCategotyList);
  }, 300);

  const handleBrandCheckboxChange = (brandId) => {
    debouncedBrandChange(brandId);
  };

  // Debounced handler for category checkbox changes
  const debouncedCategoryChange = debounce((checkedValues) => {
    setSelectCategotyList(checkedValues);
    // Filter products based on selected brands and categories
    filterProducts(selectedProductBrand, checkedValues);
  }, 300); // Adjust debounce delay as needed
  const handleCategoryCheckboxChange = (checkedValues) => {
    debouncedCategoryChange(checkedValues);
  };

  const handleSelectProduct = () => {
    prevProductsListRef.current = [];
    const lowerCaseSearchInput = productSearchInput.toLowerCase();
    const filteredProducts = productsCopy.filter(
      (product) =>
        product?.name?.toLowerCase().includes(lowerCaseSearchInput) ||
        product?.batchIndex === lowerCaseSearchInput ||
        product?.upcIndex === lowerCaseSearchInput ||
        product?.value === lowerCaseSearchInput ||
        product?.upc === lowerCaseSearchInput
    );
    if (filteredProducts.length === 0) {
      {
        message.info(`${t("product_search_category_error")}`);
      }
    } else {
    }
  };

  useEffect(() => {
    if (selectedProductCategory !== "all") {
      getCategoryProducts();
    }
  }, [selectedProductCategory]);

  const getMoreProducts = () => {
    if (productSearchInput === "") {
      getCategoryProducts(selectedProductCategory);
    }
  };

  const getCategoryProducts = () => {
    // if (selectedProductCategory === "allProducts") {
    //   db.products.toArray().then((productsFetched) => {
    //     const additionalProductsFetched = productsList.concat(productsFetched);
    //     additionalProductsFetched.map((ele) => {
    //       cart.items.map((item) => {
    //         if (ele.mProductId === item.productId) {
    //           ele.selected = "Y";
    //         }
    //       });
    //     });
    //     setProductsList([...additionalProductsFetched.slice(0, 50)]);
    //     setProductsCopy([...additionalProductsFetched]);
    //   });
    // } else {
    //   db.products
    //     .where("mProductCategoryId")
    //     .equalsIgnoreCase(selectedProductCategory)
    //     .offset(productsList.length)
    //     .limit(50)
    //     .toArray()
    //     .then((productsFetched) => {
    //       const additionalProductsFetched = productsList.concat(productsFetched);
    //       setProductsList([...additionalProductsFetched]);
    //     });
    // }
  };
  // PRODUCT FILTER END

  // PRODUCT SEARCH START
  const [isSearchProducts, setIsSearchProducts] = useState(() =>
    posConfig?.defaultSearchScreen === "Product Search" || posConfig?.defaultSearchScreen === "Category Search" || posConfig?.defaultSearchScreen === undefined ? true : false
  );
  const [isProductsVisible, setIsProductsVisible] = useState(false);
  const [productSearchInput, setProductSearchInput] = useState("");
  const [numb, setNumb] = useState(0);
  const [qtyNumberFlag, setQtyNumberFlag] = useState(0);

  const getSearchedProducts = () => {
    db.products
      .filter((product) => product.isactive === true)
      .filter((product) => product.productSegment !== "BG")
      .filter(
        (product) =>
          (typeof product.name === "string" && product.name.toLowerCase().includes(productSearchInput.toLowerCase())) ||
          (typeof product.value === "string" && product.value.toLowerCase() === productSearchInput.toLowerCase())
      )
      .limit(100)
      .toArray()
      .then(async (productsFetched) => {
        if (productsFetched.length > 1) {
          setProductsData(productsFetched);
          setIsProductsVisible(true);
        } else if (productsFetched.length === 1) {
          const obj = productsFetched[0];

          if (obj.batchedProduct === "Y" && obj.batchedForSale === "Y" && Array.isArray(obj.mBatch) && obj.mBatch.length > 0) {
            if (Array.isArray(obj.mBatch) && obj.mBatch.length > 0) {
              const batchProductIndex = obj.mBatch.findIndex((bp) => bp.batchno.toLowerCase() === productSearchInput.toLowerCase());

              if (batchProductIndex >= 0 && obj.multiPrice === "N") {
                const batchItem = obj.mBatch[batchProductIndex];
                addDefinedProduct(obj, batchItem.upc || "", batchItem.batchno || "", batchItem.mBatchId || "", batchItem.price || 0);
                setNumb(0);
                paymentModalInputRef.current?.focus();
              } else if (obj.mBatch.length === 1) {
                const batchItem = obj.mBatch[0];
                addDefinedProduct(obj, batchItem.upc || "", batchItem.batchno || "", batchItem.mBatchId || "", batchItem.price || 0);
                paymentModalInputRef?.current?.focus();
                setNumb(0);
              } else {
                const productSet = [];
                const localObj = obj;

                for (let i = 0; i < obj.mBatch.length; i += 1) {
                  const batchItem = { ...localObj.mBatch[i] };
                  const newObj = { ...localObj };

                  if (newObj.overRideTax === "Y" && batchItem.price <= newObj.overRideCondition) {
                    const originalPrice = batchItem.price - (batchItem.price - batchItem.price * (100 / (100 + newObj.taxRate)));
                    const taxedPrice = originalPrice + (originalPrice * newObj.contraRate) / 100;
                    batchItem.price = taxedPrice;
                    newObj.cTaxId = newObj.contraTaxId;
                    newObj.taxRate = newObj.contraRate;
                  }

                  const productDefined = {
                    batchno: batchItem.batchno || null,
                    description: newObj.description || "",
                    discount: 0,
                    discountName: "",
                    imageurl: newObj.imageurl || "",
                    isDecimal: newObj.isDecimal || false,
                    isManualQty: newObj.isManualQty || false,
                    restrictPosQtyEdit: newObj.restrictPosQtyEdit || "N",
                    showAlternateUomInPos: newObj?.showAlternateUomInPos || "N",
                    posPriceEdit: newObj?.posPriceEdit || "N",
                    alternateUom: newObj?.alternateUom || null,
                    companion: newObj?.companion || "N",
                    isPromoApplicable: newObj.isPromoApplicable || false,
                    isReturn: false,
                    mBatchId: batchItem.mBatchId || null,
                    mPricingruleId: null,
                    name: newObj.name || "",
                    name2: newObj.name2 || "",
                    nettotal: 0,
                    primaryOrderLine: null,
                    productId: newObj.mProductId || null,
                    realPrice: newObj.sunitprice || 0,
                    listPrice: newObj.slistprice || 0,
                    sunitprice: newObj.sunitprice || 0,
                    returnQty: null,
                    salePrice: newObj.sunitprice || 0,
                    originalPrice: newObj.sunitprice || 0,
                    productSegment: newObj?.productSegment || "",
                    mrpPrice: batchItem.listPrice || 0,
                    stock: newObj.onhandQty || 0,
                    taxCategory: newObj.taxCategory || "",
                    taxName: newObj?.taxName || "",
                    taxFlag: newObj?.taxFlag || "N",
                    tax: newObj.cTaxId || null,
                    taxAmount: 0,
                    taxRate: newObj.taxRate || 0,
                    interTaxId: newObj?.interTaxId || "",
                    interTaxRate: newObj?.interTaxRate || 0,
                    interTaxName: newObj?.interTaxName || "",
                    uom: newObj.csUomId || null,
                    customAttributes: newObj.customAttributes || {},
                    preparationTime: newObj?.preparationTime || "",
                    printerId: newObj?.printerId || "",
                    productionCenterId: newObj?.productionCenterId || "",
                    cwrPcatalogueId: newObj.cwrPcatalogueId || null,
                    cwrMenuTimeslot: newObj.cwrMenuTimeslot || {},
                    productAliasName: newObj.productAliasName || null,
                    bunitName: newObj?.bunitName || "",
                    imageUrl: newObj?.imageUrl || "",
                    showAddons: newObj?.showAddons || false,
                    foodType: newObj?.foodType || "",
                    itemType: newObj?.itemType || "",
                    type: newObj.type || "",
                    addNewLine: newObj?.addNewLine || "N",
                    newCustomAttributes: [],
                    priceList: newObj?.priceList || [],
                    selectedAddons: [],
                    uom_name: newObj.uomName || "",
                    isDecimalQty: newObj?.uomData?.[0]?.decimal === "Y" || false,
                    isQtyDesimal: newObj?.uomData?.[0]?.stdprecision || 2,
                    upc: batchItem.upc || null,
                    value: newObj.value || null,
                    weight: 0,
                    shortDescription: newObj.shortDescription || "",
                    hsncode: newObj.hsncode || null,
                    csBunitId: newObj.csBunitId || null,
                    mProductCategoryId: newObj.mProductCategoryId || null,
                    productManufacturerId: newObj.productManufacturerId || null,
                    productBrandId: newObj.productBrandId || null,
                    productBrandName: newObj?.productBrandName || null,
                    batchedProduct: newObj.batchedProduct || "N",
                    batchedForSale: newObj.batchedForSale || "N",
                    batchedForStock: newObj.batchedForStock || "N",
                    multiPrice: newObj.multiPrice || "N",
                    shelfLife: newObj.shelfLife || "",
                    stdTax: newObj?.sunitprice * (1 + newObj?.taxRate / 100),
                    posPriceEdit: newObj?.posPriceEdit || "N",
                  };
                  const selectedPrice = getApplicablePrice({
                    priceList: newObj?.priceList,
                    selectedUomId: newObj?.uomData[0]?.csUomId,
                    sPriceListId: cart.customer.sPriceListId,
                    alternateUom: newObj?.alternateUom || [],
                    primaryUomId: newObj?.uom || null,
                  });
                  productDefined.salePrice = selectedPrice.pricestd;
                  productDefined.realPrice = selectedPrice.pricestd;
                  productSet.push(productDefined);
                }
                setBatchSetAvailable([...productSet]);
                fetchOnlineBatches(productSet);
              }
            }
          } else {
            addDefinedProduct(obj, obj.upc || "", null, null, obj.sunitprice || 0);
            paymentModalInputRef?.current?.focus();
            setProductSearchInput("");
            localStorage.removeItem("productName");
            setOptions([]);
            if (productSearchInputRef?.current) {
              productSearchInputRef?.current?.clearInput();
            }
            setNumb(0);
          }
        }
        //  else {
        //   message.warning(`${t("product_search_error")}`);
        // }
        else {
          try {
            const normalizedValue = productSearchInput?.toString().trim().toLowerCase();

            if (normalizedValue) {
              console.log("Syncing from getSearchedProducts:", normalizedValue);

              const syncId = localStorage.getItem("syncId") || uuidv4().replace(/-/g, "").toUpperCase();

              await syncSingleProductByValue(tillData, syncId, tillData?.tillAccess?.cwrTill?.cwrTillID, normalizedValue);

              // 🔁 Re-fetch after sync
              const productsFetchedAfterSync = await db.products
                .filter((product) => product.isactive === true)
                .filter((product) => product.productSegment !== "BG")
                .filter(
                  (product) =>
                    (typeof product.name === "string" && product.name.toLowerCase().includes(normalizedValue)) ||
                    (typeof product.value === "string" && product.value.toLowerCase() === normalizedValue)
                )
                .limit(100)
                .toArray();

              if (productsFetchedAfterSync.length > 1) {
                setProductsData(productsFetchedAfterSync);
                setIsProductsVisible(true);
                return;
              } else if (productsFetchedAfterSync.length === 1) {
                const obj = productsFetchedAfterSync[0];

                if (obj.batchedProduct === "Y" && obj.batchedForSale === "Y" && Array.isArray(obj.mBatch) && obj.mBatch.length > 0) {
                  if (Array.isArray(obj.mBatch) && obj.mBatch.length > 0) {
                    const batchProductIndex = obj.mBatch.findIndex((bp) => bp.batchno.toLowerCase() === normalizedValue);

                    if (batchProductIndex >= 0 && obj.multiPrice === "N") {
                      const batchItem = obj.mBatch[batchProductIndex];
                      addDefinedProduct(obj, batchItem.upc || "", batchItem.batchno || "", batchItem.mBatchId || "", batchItem.price || 0);
                      setNumb(0);
                      paymentModalInputRef.current?.focus();
                    } else if (obj.mBatch.length === 1) {
                      const batchItem = obj.mBatch[0];
                      addDefinedProduct(obj, batchItem.upc || "", batchItem.batchno || "", batchItem.mBatchId || "", batchItem.price || 0);
                      paymentModalInputRef?.current?.focus();
                      setNumb(0);
                    } else {
                      const productSet = [];
                      const localObj = obj;

                      for (let i = 0; i < obj.mBatch.length; i += 1) {
                        const batchItem = { ...localObj.mBatch[i] };
                        const newObj = { ...localObj };

                        if (newObj.overRideTax === "Y" && batchItem.price <= newObj.overRideCondition) {
                          const originalPrice = batchItem.price - (batchItem.price - batchItem.price * (100 / (100 + newObj.taxRate)));
                          const taxedPrice = originalPrice + (originalPrice * newObj.contraRate) / 100;
                          batchItem.price = taxedPrice;
                          newObj.cTaxId = newObj.contraTaxId;
                          newObj.taxRate = newObj.contraRate;
                        }

                        const productDefined = {
                          batchno: batchItem.batchno || null,
                          description: newObj.description || "",
                          discount: 0,
                          discountName: "",
                          imageurl: newObj.imageurl || "",
                          isDecimal: newObj.isDecimal || false,
                          isManualQty: newObj.isManualQty || false,
                          restrictPosQtyEdit: newObj.restrictPosQtyEdit || "N",
                          showAlternateUomInPos: newObj?.showAlternateUomInPos || "N",
                          posPriceEdit: newObj?.posPriceEdit || "N",
                          alternateUom: newObj?.alternateUom || null,
                          companion: newObj?.companion || "N",
                          isPromoApplicable: newObj.isPromoApplicable || false,
                          isReturn: false,
                          mBatchId: batchItem.mBatchId || null,
                          mPricingruleId: null,
                          name: newObj.name || "",
                          name2: newObj.name2 || "",
                          nettotal: 0,
                          primaryOrderLine: null,
                          productId: newObj.mProductId || null,
                          realPrice: newObj.sunitprice || 0,
                          listPrice: newObj.slistprice || 0,
                          sunitprice: newObj.sunitprice || 0,
                          returnQty: null,
                          salePrice: newObj.sunitprice || 0,
                          originalPrice: newObj.sunitprice || 0,
                          productSegment: newObj?.productSegment || "",
                          mrpPrice: batchItem.listPrice || 0,
                          stock: newObj.onhandQty || 0,
                          taxCategory: newObj.taxCategory || "",
                          taxName: newObj?.taxName || "",
                          taxFlag: newObj?.taxFlag || "N",
                          tax: newObj.cTaxId || null,
                          taxAmount: 0,
                          taxRate: newObj.taxRate || 0,
                          interTaxId: newObj?.interTaxId || "",
                          interTaxRate: newObj?.interTaxRate || 0,
                          interTaxName: newObj?.interTaxName || "",
                          uom: newObj.csUomId || null,
                          customAttributes: newObj.customAttributes || {},
                          preparationTime: newObj?.preparationTime || "",
                          printerId: newObj?.printerId || "",
                          productionCenterId: newObj?.productionCenterId || "",
                          cwrPcatalogueId: newObj.cwrPcatalogueId || null,
                          cwrMenuTimeslot: newObj.cwrMenuTimeslot || {},
                          productAliasName: newObj.productAliasName || null,
                          bunitName: newObj?.bunitName || "",
                          imageUrl: newObj?.imageUrl || "",
                          showAddons: newObj?.showAddons || false,
                          foodType: newObj?.foodType || "",
                          itemType: newObj?.itemType || "",
                          type: newObj.type || "",
                          addNewLine: newObj?.addNewLine || "N",
                          newCustomAttributes: [],
                          priceList: newObj?.priceList || [],
                          selectedAddons: [],
                          uom_name: newObj.uomName || "",
                          isDecimalQty: newObj?.uomData?.[0]?.decimal === "Y" || false,
                          isQtyDesimal: newObj?.uomData?.[0]?.stdprecision || 2,
                          upc: batchItem.upc || null,
                          value: newObj.value || null,
                          weight: 0,
                          shortDescription: newObj.shortDescription || "",
                          hsncode: newObj.hsncode || null,
                          csBunitId: newObj.csBunitId || null,
                          mProductCategoryId: newObj.mProductCategoryId || null,
                          productManufacturerId: newObj.productManufacturerId || null,
                          productBrandId: newObj.productBrandId || null,
                          productBrandName: newObj?.productBrandName || null,
                          batchedProduct: newObj.batchedProduct || "N",
                          batchedForSale: newObj.batchedForSale || "N",
                          batchedForStock: newObj.batchedForStock || "N",
                          multiPrice: newObj.multiPrice || "N",
                          shelfLife: newObj.shelfLife || "",
                          stdTax: newObj?.sunitprice * (1 + newObj?.taxRate / 100),
                          posPriceEdit: newObj?.posPriceEdit || "N",
                        };

                        const selectedPrice = getApplicablePrice({
                          priceList: newObj?.priceList,
                          selectedUomId: newObj?.uomData?.[0]?.csUomId,
                          sPriceListId: cart.customer.sPriceListId,
                          alternateUom: newObj?.alternateUom || [],
                          primaryUomId: newObj?.uom || null,
                        });

                        productDefined.salePrice = selectedPrice.pricestd;
                        productDefined.realPrice = selectedPrice.pricestd;

                        productSet.push(productDefined);
                      }

                      setBatchSetAvailable([...productSet]);
                      fetchOnlineBatches(productSet);
                    }
                  }
                } else {
                  addDefinedProduct(obj, obj.upc || "", null, null, obj.sunitprice || 0);
                  paymentModalInputRef?.current?.focus();
                  setProductSearchInput("");
                  localStorage.removeItem("productName");
                  setOptions([]);
                  if (productSearchInputRef?.current) {
                    productSearchInputRef?.current?.clearInput();
                  }
                  setNumb(0);
                }

                return;
              }
            }
          } catch (err) {
            console.error("Sync failed in getSearchedProducts:", err);
          }

          message.warning(`${t("product_search_error")}`);
        }
      });
  };

  const kioskFilteredProducts = (filter) => {
    db.products
      .filter((product) => product.isactive === true)
      .filter((product) => product.productSegment !== "BG")
      .limit(100)
      .toArray()
      .then((productsFetched) => {
        if (productsFetched.length > 1) {
          let filteredData = [];
          productsFetched.forEach((item) => {
            const itemName = item.name[0].toUpperCase();

            if (filter.includes("-")) {
              const filters = filter.split("-");
              const start = filters[0];
              const end = filters[filters.length - 1];

              if (itemName >= start && itemName <= end) {
                filteredData.push(item);
              }
            } else if (itemName === filter) {
              filteredData.push(item);
            }
          });

          setIsProductsVisible(true);

          if (filter === "All") {
            // setProductsList([...productsFetched]);
          } else {
            // setProductsList([...filteredData]);
          }
        }
      });
  };

  const getSearchedItem = () => {
    db.products
      .where("name")
      .startsWithIgnoreCase(productSearchInput)
      .or("batchIndex")
      .equalsIgnoreCase(productSearchInput)
      .or("upcIndex")
      .equalsIgnoreCase(productSearchInput)
      .or("value")
      .equalsIgnoreCase(productSearchInput)
      .and((product) => product.isactive === true) // ✅ use AND, not filter
      .and((product) => product.productSegment !== "BG")
      .limit(100)
      .toArray()
      .then((product) => {
        if (product.length > 0) {
          const obj = product[0] || {};
          const mBatch = obj.mBatch || [];
          const uomData = obj.uomData || [{}];
          const defaultPrice = obj.sunitprice || 0;

          if (obj.batchedProduct === "Y" && obj.batchedForSale === "Y" && Array.isArray(obj.mBatch) && obj.mBatch.length > 0) {
            const batchProductIndex = mBatch.findIndex((bp) => bp.batchno?.toLowerCase() === (productSearchInput || "").toLowerCase());
            if (batchProductIndex >= 0 && obj.multiPrice === "N") {
              addDefinedProduct(
                obj,
                mBatch[batchProductIndex]?.upc || "",
                mBatch[batchProductIndex]?.batchno || "",
                mBatch[batchProductIndex]?.mBatchId || "",
                mBatch[batchProductIndex]?.price || 0
              );
            } else if (mBatch.length === 1) {
              addDefinedProduct(obj, mBatch[0]?.upc || "", mBatch[0]?.batchno || "", mBatch[0]?.mBatchId || "", mBatch[0]?.price || 0);
            } else {
              const productSet = [];
              for (let i = 0; i < mBatch.length; i++) {
                const batchItem = { ...mBatch[i] };
                const productDefined = {
                  batchno: batchItem.batchno || null,
                  description: obj.description || "",
                  discount: 0,
                  discountName: "",
                  imageurl: obj.imageurl || "",
                  isDecimal: obj.isDecimal || false,
                  isManualQty: obj.isManualQty || false,
                  restrictPosQtyEdit: obj.restrictPosQtyEdit || "N",
                  showAlternateUomInPos: obj?.showAlternateUomInPos || "N",
                  posPriceEdit: obj?.posPriceEdit || "N",
                  alternateUom: obj?.alternateUom || null,
                  companion: obj?.companion || "N",
                  isPromoApplicable: obj.isPromoApplicable || false,
                  isReturn: false,
                  mBatchId: batchItem.mBatchId || null,
                  mPricingruleId: null,
                  name: obj.name || "",
                  name2: obj.name2 || "",
                  nettotal: 0,
                  primaryOrderLine: null,
                  productId: obj.mProductId || null,
                  realPrice: obj.sunitprice || 0,
                  listPrice: obj.slistprice || 0,
                  sunitprice: obj.sunitprice || 0,
                  originalPrice: obj.sunitprice || 0,
                  productSegment: obj?.productSegment || "",
                  returnQty: null,
                  salePrice: obj.sunitprice || 0,
                  mrpPrice: batchItem.listPrice || 0,
                  stock: obj.onhandQty || 0,
                  taxCategory: obj.taxCategory || "",
                  taxName: obj?.taxName || "",
                  taxFlag: obj?.taxFlag || "N",
                  tax: obj.cTaxId || null,
                  taxAmount: 0,
                  taxRate: obj.taxRate || 0,
                  interTaxId: obj?.interTaxId || "",
                  interTaxRate: obj?.interTaxRate || 0,
                  interTaxName: obj?.interTaxName || "",
                  uom: obj.csUomId || null,
                  customAttributes: obj.customAttributes || {},
                  preparationTime: obj?.preparationTime || "",
                  printerId: obj?.printerId || "",
                  productionCenterId: obj?.productionCenterId || "",
                  cwrPcatalogueId: obj.cwrPcatalogueId || null,
                  cwrMenuTimeslot: obj.cwrMenuTimeslot || {},
                  productAliasName: obj.productAliasName || null,
                  bunitName: obj?.bunitName || "",
                  imageUrl: obj?.imageUrl || "",
                  showAddons: obj?.showAddons || false,
                  foodType: obj?.foodType || "",
                  itemType: obj?.itemType || "",
                  type: obj.type || "",
                  addNewLine: obj.addNewLine || "N",
                  newCustomAttributes: [],
                  priceList: obj?.priceList || [],
                  selectedAddons: [],
                  uom_name: obj.uomName || "",
                  isDecimalQty: uomData[0]?.decimal === "Y" || false,
                  isQtyDesimal: uomData[0]?.stdprecision || 2,
                  upc: batchItem.upc || null,
                  value: obj.value || null,
                  weight: 0,
                  shortDescription: obj.shortDescription || "",
                  hsncode: obj.hsncode || null,
                  csBunitId: obj.csBunitId || null,
                  mProductCategoryId: obj.mProductCategoryId || null,
                  productManufacturerId: obj.productManufacturerId || null,
                  productBrandId: obj.productBrandId || null,
                  productBrandName: obj?.productBrandName || null,
                  batchedProduct: obj.batchedProduct || "",
                  batchedForSale: obj.batchedForSale || "",
                  batchedForStock: obj.batchedForStock || "",
                  multiPrice: obj.multiPrice || "",
                  shelfLife: obj.shelfLife || "",
                  stdTax: obj?.sunitprice * (1 + obj?.taxRate / 100),
                  posPriceEdit: obj?.posPriceEdit || "N",
                };
                const selectedPrice = getApplicablePrice({
                  priceList: obj?.priceList,
                  selectedUomId: obj?.uomData[0]?.csUomId,
                  sPriceListId: cart.customer.sPriceListId,
                  alternateUom: obj?.alternateUom || [],
                  primaryUomId: obj?.uom || null,
                });
                productDefined.salePrice = selectedPrice.pricestd;
                productDefined.realPrice = selectedPrice.pricestd;
                productSet.push(productDefined);
              }
              setBatchSetAvailable([...productSet]);
              fetchOnlineBatches(productSet);
            }
          } else {
            addDefinedProduct(obj, obj.upc || "", null, null, defaultPrice);
          }
        } else {
          message.warning(`${t("product_search_error")}`);
        }
      });
  };

  const clearProductSearchResults = () => {
    setProductSearchInput("");
    setOptions([]);
    if (keyboard.current) {
      keyboard.current.setInput("");
    }
    localStorage.removeItem("productName");
  };

  const productListCardRef = useRef(null);

  const closeProductPanel = () => {
    const productSearchInput = document.getElementById("sm-product-search");
    productSearchInput.focus();
    setIsSearchProducts(false);
    setIsProductsVisible(false);
    setIsProductsFilter(false);
    setProductSearchInput("");
    clearProductSearchResults();
    setProductsData([]);
    localStorage.removeItem("productName");
  };
  // PRODUCT SEARCH END

  const cartRef = useRef();
  useEffect(() => {
    let cartObj = JSON.parse(localStorage.getItem("cartObj")) ? JSON.parse(localStorage.getItem("cartObj")) : cart;
    cartRef.current = { ...cart };
    if (cart.items.length === 0) {
      cart.couponInput = [];
      cart.discount = 0;
      cart.payments = [];
      cart.paid = 0;
      cart.giftCardRefId = null;
      cart.totalBillDicount = null;
      setOverPayedAmount(0);
      setSelectedProductInCart({});
      // setCustomMixItems([]);
      setGroupQty(1);
      setShowPaymentMethods(false);
      setCart(cart);
    }
    let PaymentMethods = getFilteredPaymentMethods() || [];
    const isPreOrderPage = window.location.pathname.includes("/preorder");
    const advanceItem = cart.items.find((item) => item.type === "S" && item.weight > 0 && item.productSegment === "AD");
    if (
      cart.layAway === "Y" &&
      cart?.docType === "Advance" &&
      !advanceItem &&
      posConfig?.allowLayawaywithoutPayment !== "Y" &&
      cart.items.some((item) => item.type !== "S" && item?.productSegment !== "AD")
    ) {
      PaymentMethods = [
        ...PaymentMethods,
        ...(posConfig?.enablePreOrder !== "Y"
          ? [
              {
                cWRPaymentMethodID: "",
                sequenceNo: 9999,
                finPaymentmethodId: "",
                finFinancialAccountId: "",
                finDayCloseAccountId: null,
                name: "Complete Order",
                integratedPayment: false,
                isloyalty: false,
                paymentProvider: null,
                iscredit: false,
                isGiftCard: false,
                isDefault: "N",
                csCurrencyId: "",
                isoCode: "AED",
                isactive: true,
                salesType: [],
              },
            ]
          : []),
      ];
      let payments =
        PaymentMethods.length > 5
          ? _.sortBy(PaymentMethods, "sequenceNo").slice(
              0,
              tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
            )
          : PaymentMethods;
      setShowPayments(payments);
      setStartIndex(cart.layAway === "Y" && payments.length >= 5 ? 5 : payments.length);
    } else if (isPreOrderPage) {
      const isRefundScenario = amount < 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash";
      const maxPaymentsToShow = isRefundScenario ? 3 : 4;
      let payments =
        PaymentMethods.length > maxPaymentsToShow
          ? _.sortBy(PaymentMethods, "sequenceNo").slice(
              0,
              tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === maxPaymentsToShow
                ? maxPaymentsToShow
                : cart.layAway === "Y"
                  ? maxPaymentsToShow
                  : maxPaymentsToShow
            )
          : PaymentMethods;
      setShowPayments(payments);
      setStartIndex(cart.layAway === "Y" && payments.length >= maxPaymentsToShow ? maxPaymentsToShow : payments.length);
    } else {
      let payments =
        PaymentMethods.length > 5
          ? _.sortBy(PaymentMethods, "sequenceNo").slice(
              0,
              tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
            )
          : PaymentMethods;
      setShowPayments(payments);
      setStartIndex(cart.layAway === "Y" && payments.length >= 5 ? 5 : payments.length);
    }

    // adjustDiscount(cartObj);
  }, [cart, selectedSaleType]);

  useEffect(() => {
    const cartOBJ = JSON.parse(localStorage.getItem("cartObj"));
    if (localStorage.getItem("selectedReturnType") === "STORE_CREDIT") {
      const walletPayment = tillData.tillAccess.csBunit.paymentMethodList.find((pm) => pm.isWallet === "Y");
      if (walletPayment) {
        setSelectedPaymentMethod(walletPayment);
      }
    }
  }, [cart, isRefundWalletOpen]);

  const adjustDiscount = (cartObj) => {
    if (cartObj.items.length > 0 && cartObj.total > 0) {
      let cartTotal = cartObj.items.reduce((sum, item) => sum + item.nettotal + item.discount, 0);

      let newCartTotal = parseFloat(parseFloat(cartObj.total)?.toFixed(precision)) + parseFloat(parseFloat(cartObj.discount)?.toFixed(precision));

      if (parseFloat(parseFloat(newCartTotal)?.toFixed(precision)) !== parseFloat(parseFloat(cartTotal)?.toFixed(precision))) {
        let adjustAmount = newCartTotal - cartTotal;

        let lastDiscountedItemIndex = [...cartObj.items].reverse().findIndex((item) => item.discount > 0);
        if (lastDiscountedItemIndex !== -1) {
          let indexToUpdate = cartObj.items.length - 1 - lastDiscountedItemIndex;

          let updatedItems = [...cartObj.items];
          updatedItems[indexToUpdate].discount = parseFloat(parseFloat(updatedItems[indexToUpdate].discount - adjustAmount)?.toFixed(precision));
          updatedItems[indexToUpdate].nettotal = parseFloat(parseFloat(updatedItems[indexToUpdate].nettotal + adjustAmount)?.toFixed(precision));

          let updatedCart = {
            ...cartObj,
            items: updatedItems,
            discount: cartObj.discount - adjustAmount,
          };
          setCart(updatedCart);
          localStorage.setItem("cartObj", JSON.stringify(updatedCart));
        }
      }
    }
  };

  // dynamic pop up modal start
  const [dynamicForm, setDynamicForm] = useState(false);
  const [dynamicModalForm] = Form.useForm();

  const submitCustomAttributs = (prod) => {
    const productObj = { ...prod };

    addProductToCart(
      productObj,
      productObj.qty,
      false,
      cart,
      setCart,
      setSelectedProductInCart,
      deleteCart,
      processTotalManualDiscount,
      setLoader,
      salesRepresentDefaultLine,
      tillData,
      cartRef,
      productsCopy,
      salesRepresent,
      orderType,
      processBillDiscounts,
      undefined,
      setSelectedRowKeys,
      setOrderTimeDetails,
      setDisplayAddOnSelection,
      displayAddOnSelection,
      handleAddOnModal,
      manualDiscountTypes,
      CheckoutFlatDiscount,
      CheckoutPercentageDiscount,
      CheckoutTotalManualDiscount,
      setProductStock,
      selectedProductInCart,
      setTableCards,
      dispatchItemSelection,
      searchInputRef,
      false,
      setShowCompleteSaleStock,
      setCompleteSaleStockData,
      TotalBillDiscount,
      tillLayout,
      false,
      setManualDiscountInput,
      setSelectedManualDiscountTypeValue,
      removeAllDiscounts,
      setSelectedPaymentMethod,
      selectedReturnType,
      false,
      setProductBOMStock,
      setProductBOMStockData
    );
    setSelectedAddons([]);
  };

  const addProduct = async (addToCart, qty, totalQtyFlag, modifiedPrice, deleteProductInCart, quantityChange) => {
    setStockList([]);
    const returnThisReceipt = localStorage.getItem("returnThisReceipt");
    const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE" && !returnThisReceipt;
    const cartKey = isExchange ? "exchangeCartObj" : "cartObj";
    const cart = JSON.parse(localStorage.getItem(cartKey)) || { ...cartRef.current };
    if (receiptlessReturn2Enabled && cart?.isReturn === true && cart?.isBlindReceipt === true) {
      qty = -Math.abs(qty);

      addToCart.isReturn = true;
      addToCart.returnQty = Math.abs(qty);
    }
    if (cart.layAway === "Y" && posConfig?.allowLayawaywithoutPayment === "Y") {
      message.info("This order cannot be edited!");
    } else {
      if (cart?.preOrder === "Y") {
        Modal.confirm({
          title: <div style={{ fontWeight: "500", fontSize: "1.2em", color: "#0F0718" }}>Cart Editing Restricted</div>,
          content: (
            <div style={{ fontSize: "14px", color: "#0F0718", marginTop: "8px" }}>
              <p style={{ marginBottom: 0, color: "#0F0718", fontSize: "1em" }}>
                This is a pre-order with advance payment. Cart items cannot be modified at this stage. Please proceed to complete the transaction.
              </p>
            </div>
          ),
          icon: null,
          icon: <WarningOutlined />,
          okText: "Ok",
          okButtonProps: { style: { display: "inline-block" } },
          cancelButtonProps: { style: { display: "none" } },
          // autoFocusButton: null,
          okButtonProps: { style: { display: "inline-block" } },
          modalRender: (node) => <div className="custom-confirm-modal-wrapper">{node}</div>,

          onOk() {
            const productSearchInput = document.getElementById("sm-product-search");
            if (productSearchInput) {
              setTimeout(() => {
                productSearchInput.focus();
              }, 300);
            }
          },
        });

        return;
      }
      if (cart?.couponInput?.length > 0) {
        Modal.confirm({
          title: <div style={{ fontWeight: "500", fontSize: "1.2em", color: "#0F0718" }}>Cart Editing Restricted</div>,
          content: (
            <div style={{ fontSize: "14px", color: "#0F0718", marginTop: "8px" }}>
              <p style={{ marginBottom: 0 }}>Coupon applied to this order. Do you want to remove the coupon and continue editing the cart?</p>
            </div>
          ),
          icon: <WarningOutlined />,
          okText: "Yes",
          cancelText: "No",
          autoFocusButton: null,
          okButtonProps: { style: { display: "inline-block" } },
          onOk: async () => {
            if (cart?.couponInput?.length > 0) {
              for (const coupon of cart.couponInput) {
                await removeCoupon(coupon);
              }
            }
          },

          onCancel() {
            const productSearchInput = document.getElementById("sm-product-search");
            if (productSearchInput) {
              setTimeout(() => {
                productSearchInput.focus();
              }, 300);
            }
          },
        });

        return;
      }
      if (Object.keys(addToCart).length === 0) {
        return;
      }

      if (!("isBlindReceipt" in cart) || (cart.isBlindReceipt && addToCart.isGiftCard)) {
        // Do nothing
      } else {
        setShowPaymentMethods(false);
      }

      setProductSearchInput("");
      localStorage.removeItem("productName");
      let freeFlag = true;
      if (addToCart.isFree) {
        const matchingPricingRules = await db.pricingRules.where("mPricingrulesId").equalsIgnoreCase(addToCart.mPricingruleId).toArray();
        const matchingProductIndex = matchingPricingRules[0]?.mPricingXProducts.find((op) => op.mProductId === addToCart.productId);
        freeFlag = matchingProductIndex && addToCart.weight + qty <= matchingProductIndex.quantity;
      }

      const findItemIndex = (condition) =>
        cart?.items?.findIndex(
          (p) =>
            p.productId === addToCart.productId &&
            p.upc === addToCart.upc &&
            p.mBatchId === addToCart.mBatchId &&
            p.isReturn === false &&
            p.lineId === addToCart.lineId &&
            condition(p)
        );

      const addonIndex = findItemIndex((p) => p?.selectedAddons?.length > 0);
      const attributeIndex = findItemIndex((p) => p?.newCustomAttributes?.length > 0);

      let addOnFlag = false;

      if (addToCart?.productAddons?.length > 0 && addToCart.weight + qty !== 0 && qty > 0 && addToCart.showAddons === "Y") {
        if (addonIndex !== -1) {
          addOnFlag = true;
        } else {
          console.log("show addon modal");
          setDisplayAddOnSelection(true);
          handleAddOnModal(addToCart, qty);
        }
      }

      if (addToCart?.customAttributes?.length > 0 && addToCart.weight + qty !== 0 && qty > 0) {
        if (attributeIndex !== -1) {
          addOnFlag = true;
        } else {
          setDynamicForm(true);
          addToCart.qty = qty;
          setSelectedProductInCart(addToCart);
        }
      }

      if (
        freeFlag &&
        (addToCart?.productAddons?.length <= 0 || addToCart.weight + qty === 0 || qty < 0 || addOnFlag || addToCart.showAddons !== "Y") &&
        (addToCart?.customAttributes?.length <= 0 || addToCart.weight + qty === 0 || qty < 0 || addOnFlag)
      ) {
        console.log("addToCart -------->", addToCart);
        await addProductToCart(
          addToCart,
          qty,
          totalQtyFlag,
          cart,
          setCart,
          setSelectedProductInCart,
          deleteCart,
          processTotalManualDiscount,
          setLoader,
          salesRepresentDefaultLine,
          tillData,
          cartRef,
          productsCopy,
          salesRepresent,
          orderType,
          processBillDiscounts,
          modifiedPrice,
          setSelectedRowKeys,
          setOrderTimeDetails,
          setDisplayAddOnSelection,
          displayAddOnSelection,
          handleAddOnModal,
          manualDiscountTypes,
          CheckoutFlatDiscount,
          CheckoutPercentageDiscount,
          CheckoutTotalManualDiscount,
          setProductStock,
          selectedProductInCart,
          setTableCards,
          dispatchItemSelection,
          searchInputRef,
          deleteProductInCart,
          setShowCompleteSaleStock,
          setCompleteSaleStockData,
          TotalBillDiscount,
          tillLayout,
          quantityChange,
          setManualDiscountInput,
          setSelectedManualDiscountTypeValue,
          removeAllDiscounts,
          setSelectedPaymentMethod,
          selectedReturnType,
          false,
          setProductBOMStock,
          setProductBOMStockData
        );
      }
    }
  };

  const modifyProductList = async () => {
    const result = await new Promise((resolve) => {
      const itemsToDispatch = selectedProductInCart;
      dispatchItemSelection(itemsToDispatch, cart, setCart, setProductStock, (eventData) => {
        if (eventData?.selectedItems?.length > 0) {
          resolve({
            selectedItems: eventData.selectedItems,
          });
        }
      });
    });
    selectedProductInCart.childItems = result?.selectedItems || [];

    setSelectedProductInCart({
      ...selectedProductInCart,
      childItems: result?.selectedItems,
    });

    const cartObj = JSON.parse(localStorage.getItem("cartObj")) || { items: [] };
    const updatedCartItems = cartObj.items.map((cartItem) => {
      if (cartItem.productId === selectedProductInCart.productId || cartItem.value === selectedProductInCart.value) {
        return {
          ...cartItem,
          childItems: result?.selectedItems,
        };
      }
      return cartItem;
    });

    localStorage.setItem(
      "cartObj",
      JSON.stringify({
        ...cartObj,
        items: updatedCartItems,
      })
    );
    setCart({
      ...cartObj,
      items: updatedCartItems,
    });
  };

  const [documentSequence, setDocumnetSequence] = useState(tillDocumentSequence);
  //   const [orderDelay, setOrderDelay] = useState(moment().format("DD-MM-YYYY HH:mm:ss"));
  const [orderDelay, setOrderDelay] = useState(moment().format("YYYY-MM-DD HH:mm:ss"));
  const [activeOrderProcess, setActiveOrderProcess] = useState(false);
  const orderState = useRef(0);

  // const processOrder = async (param) => {
  //   orderState.current += 1;
  //   if (orderState.current === 1 && cart.items.length !== 0 && posConfig?.disableOfflineBilling !== "Y") {
  //     processOrderApproved(param);
  //   } else if (orderState.current === 1 && cart.items.length !== 0 && posConfig?.disableOfflineBilling === "Y") {
  //     await syncOrders();
  //   } else {
  //     setPaymentModal(false);
  //   }
  // };

  const processOrder = async (param) => {
    orderState.current += 1;
    if (orderState.current === 1 && cart.items.length !== 0 && posConfig?.disableOfflineBilling !== "Y") {
      // Check if multi print templates is enabled and has templates
      if (enableMultiPrintTemplates && printTemplates.length > 0) {
        setPendingOrderParam(param);
        setPendingDocumentNo(null);
        setPendingIsSynced(null);
        setIsPendingDirectApproved(false);
        setIsPendingSyncOrder(false);
        setSelectedPrintTemplate(printTemplates[0]?.cwr_printtemplate_id || null); // Select first template by default
        setShowPrintTemplateModal(true);
      } else {
        processOrderApproved(param);
      }
    } else if (orderState.current === 1 && cart.items.length !== 0 && posConfig?.disableOfflineBilling === "Y") {
      // Check if multi print templates is enabled and has templates - show modal BEFORE syncing
      if (enableMultiPrintTemplates && printTemplates.length > 0) {
        setPendingOrderParam(param);
        setPendingDocumentNo(null);
        setPendingIsSynced(null);
        setIsPendingDirectApproved(false);
        setIsPendingSyncOrder(true); // Flag to indicate we need to sync after template selection
        setSelectedPrintTemplate(printTemplates[0]?.cwr_printtemplate_id || null); // Select first template by default
        setShowPrintTemplateModal(true);
      } else {
        await syncOrders();
      }
    } else {
      setPaymentModal(false);
    }
  };

  // Handle print template modal confirmation
  const handlePrintTemplateConfirm = async () => {
    setShowPrintTemplateModal(false);
    localStorage.setItem("selectedPrintTemplateId", selectedPrintTemplate);

    if (isPendingSyncOrder) {
      // When disableOfflineBilling === "Y", we need to sync orders after template selection
      await syncOrders();
    } else if (isPendingDirectApproved) {
      await processOrderApproved(pendingOrderParam, pendingDocumentNo, pendingIsSynced);
    } else {
      processOrderApproved(pendingOrderParam);
    }

    // Reset pending state
    setPendingOrderParam(null);
    setPendingDocumentNo(null);
    setPendingIsSynced(null);
    setIsPendingDirectApproved(false);
    setIsPendingSyncOrder(false);
  };

  // Handle print template modal cancel
  const handlePrintTemplateCancel = () => {
    setShowPrintTemplateModal(false);
    orderState.current = 0; // Reset order state so user can try again
    setPendingOrderParam(null);
    setPendingDocumentNo(null);
    setPendingIsSynced(null);
    setIsPendingDirectApproved(false);
    setIsPendingSyncOrder(false);
  };

  const processOrderApproved = async (param, documentNo, isSynced) => {
    setSelectedPaymentMethod({}); // Reset payment method
    if (activeOrderProcess) return; // Early return if already processing

    // Batch initial state updates
    setOverPayedAmount(0);
    setAmount(0);
    setActiveOrderProcess(true);
    const tableData = JSON.parse(localStorage.getItem("tableName")) || {};
    const isSplitParentFlow = tableData?.isSplitParent === "Y" && tableData?.displayName?.includes("-");

    // Create a deep copy of cart to avoid modifying state directly
    const cartToDb = JSON.parse(localStorage.getItem("cartObj")) || {};
    //const newDocumentSequence = cart?.statusType === "OCU" && posConfig?.enableGuestRegistration === "Y" ? documentSequence : documentSequence + 1;
    const newDocumentSequence =
      cart?.statusType === "OCU" && (posConfig?.enableGuestRegistration === "Y" || posConfig?.enableGuestRegistration === "N") ? documentSequence : documentSequence + 1;
    const tillSession = JSON.parse(localStorage.getItem("tillSession")) || {};
    const tillSessionId = tillSession.tillSessionId || null;

    // Process payment and layaway logic
    if (param !== "layaway") {
      cartToDb.layAway = cart.layAway === "Y" ? "Y" : "N";
      // const change = cartToDb.paid - Math.abs(cartToDb.total);
      const change = cartToDb.change;
      const isPreOrderPage = window.location.pathname.includes("/preorder");

      if (cart.items.some((it) => it.isReturn) && cartToDb.total === 0) {
        cartToDb.change = 0;
        const paymentType =
          selectedPaymentMethod.name?.toLowerCase() === "cash" || selectedPaymentMethod.name?.toLowerCase() === "card" ? selectedPaymentMethod.name.toLowerCase() : "cash";
        const pMindex = tillDataPaymentMethods.findIndex((pi) => pi.name.toLowerCase() === paymentType);
        cartToDb.payments.push({
          ...tillDataPaymentMethods[pMindex],
          amount: Number(cart.total) || 0,
        }); // Minimal copy
      } else if (amount < 0 && cart.layAway === "Y" && cart?.type === "Layaway" && isPreOrderPage) {
        cartToDb.payments.push({ ...selectedPaymentMethod, amount });
      } else {
        cartToDb.change = parseFloat(parseFloat(change)?.toFixed(precision));
      }

      if (cart.isReturn === true || cart.isReturn === "Y") {
        for (let i = 0; i < cartToDb.payments.length; i++) {
          cartToDb.payments[i].amount *= -1; // Update in place
        }
      }
    } else {
      cartToDb.layAway = "Y";
      if (selectedPaymentMethod?.name) {
        const pMindex = cartToDb.payments.findIndex((pi) => pi.name.toLowerCase() === selectedPaymentMethod.name.toLowerCase());
        if (pMindex !== -1) {
          cartToDb.payments[pMindex].amount += amount; // Update in place
        } else {
          cartToDb.payments.push({ ...selectedPaymentMethod, amount }); // Minimal copy
        }
      }
    }

    // Loyalty points calculation
    // if (cartToDb.customer?.loyaltyLevel?.cwrLoyaltyLevelId) {
    //   const loyaltyLevelId = cartToDb.customer.loyaltyLevel.cwrLoyaltyLevelId;
    //   const loyaltyData = await db.loyalityData.where("loyaltylevelId").equals(loyaltyLevelId).first();
    //   if (loyaltyData) {
    //     const eventCalenders = loyaltyData.loyaltyEventCalenders || [];
    //     const hasValidEventCalenders = eventCalenders.length > 0 ? dateValidator(eventCalenders[0].startDate, eventCalenders[0].endDate) : true;

    //     for (const item of loyaltyData.LoyaltyAccumulation || []) {
    //       const productValidation = item.mProductId ? cart.items.some((pc) => pc.mProductId === item.mProductId) : true;
    //       const categoryValidation = item.mProductCategoryId ? cart.items.some((pc) => pc.mProductCategoryId === item.mProductCategoryId) : true;
    //       const checkEventsCalender =
    //         item.loyaltyEvent === "Y" && eventCalenders.length > 0
    //           ? eventCalenders.some((i) => dateValidator(i.startDate, i.endDate))
    //           : item.loyaltyEvent === "Y" && eventCalenders.length === 0;

    //       if (
    //         (item.loyaltyEvent === "Y" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation && hasValidEventCalenders && checkEventsCalender) ||
    //         (item.loyaltyEvent === "N" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation)
    //       ) {
    //         cartToDb.accumulationPoints =
    //           tillData?.tillAccess?.csBunit?.enableLoyalty === "Y"
    //             ? cartToDb?.discount > 0
    //               ? loyaltyData?.noLoyaltyOnDiscount === "Y"
    //                 ? 0
    //                 : parseFloat(parseFloat(item.pointsPerUnit * (cart.total - cart.tax))?.toFixed(3))
    //               : cartToDb?.redemptionPoints > 0
    //               ? loyaltyData?.noLoyaltyOnRedemption === "Y"
    //                 ? 0
    //                 : parseFloat(parseFloat(item.pointsPerUnit * (cart.total - cart.tax))?.toFixed(3))
    //               : parseFloat(parseFloat(item.pointsPerUnit * (cart.total - cart.tax))?.toFixed(3))
    //             : 0;
    //         break;
    //       }
    //     }
    //   }
    // }
    if (cartToDb.customer?.loyaltyLevel?.cwrLoyaltyLevelId) {
      const loyaltyLevelId = cartToDb.customer.loyaltyLevel.cwrLoyaltyLevelId;
      const loyaltyData = await db.loyalityData.where("loyaltylevelId").equals(loyaltyLevelId).first();
      if (loyaltyData) {
        const eventCalenders = loyaltyData.loyaltyEventCalenders || [];
        // ✅ Check if ANY event calendar is active
        const isEventActive = eventCalenders.length > 0 && eventCalenders.some((ec) => dateValidator(ec.startDate, ec.endDate));

        // ✅ Find applicable accumulation rule
        const applicableRule = (loyaltyData.LoyaltyAccumulation || []).find((item) => {
          const productValidation = item.mProductId ? cart.items.some((pc) => pc.mProductId === item.mProductId) : true;
          const categoryValidation = item.mProductCategoryId ? cart.items.some((pc) => pc.mProductCategoryId === item.mProductCategoryId) : true;
          if (isEventActive) {
            if (item.loyaltyEvent === "Y") {
              return item.loyaltyEvent === "Y" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation;
            } else {
              return item.loyaltyEvent === "N" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation;
            }
          }

          return item.loyaltyEvent === "N" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation;
        });

        // ✅ Calculate points
        if (applicableRule) {
          const baseAmount = cart.total - cart.tax;

          if (tillData?.tillAccess?.csBunit?.enableLoyalty !== "Y") {
            cartToDb.accumulationPoints = 0;
          } else if (cartToDb.discount > 0 && loyaltyData.noLoyaltyOnDiscount === "Y") {
            cartToDb.accumulationPoints = 0;
          } else if (cartToDb.redemptionPoints > 0 && loyaltyData.noLoyaltyOnRedemption === "Y") {
            cartToDb.accumulationPoints = 0;
          } else {
            cartToDb.accumulationPoints = Number((applicableRule.pointsPerUnit * baseAmount).toFixed(3));
          }
        }
      }
    }

    // Update order details
    const now = moment(new Date());
    const orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails")) || {
      orderStartTime: "",
      orderEndTime: "",
      paymentStartTime: "",
    };
    orderTimeDetails.orderEndTime = now.format("DD-MM-YYYY HH:mm:ss");
    Object.assign(cartToDb, {
      orderTime: now.format("DD-MM-YYYY HH:mm:ss"),
      createdBy: tillData.tillAccess.csUserId,
      documentno: documentNo
        ? documentNo
        : cart.isRetrived === "Y" || cart.type === "Layaway" || cart.isSplit === "Y" || cart?.statusType === "OCU" || cart?.isCreditSale === "Y"
          ? cart.documentno
          : `${tillData.tillAccess.cwrTill.prefix}${newDocumentSequence}`,
      // documentno: cart.documentno,
      orderType: orderType?.cwrSaletype?.cwrSaletypeId,
      orderDate: now.format("DD-MM-YYYY"),
      tillSessionId,
      key: uuidv4().replace(/-/g, "").toUpperCase(),
      isSynced: isSynced ? isSynced : 0,
      syncAttempts: 0,
      giftCardData: [...giftCardData], // Shallow copy to avoid retaining reference
      roundOff: parseFloat(parseFloat(cart.isReturn ? cartToDb.roundOff * -1 : cartToDb.roundOff)?.toFixed(precision)),
      discount: parseFloat(parseFloat(cartToDb.discount)?.toFixed(precision) || 0),
      customerSearchKey: cartToDb.customer?.code,
      orderTimeDetails,
      totalQty: parseFloat(parseFloat(cartToDb.totalQty)?.toFixed(precision) || 0),
      dineIn: localStorage.getItem("dineIn") || "Y",
      typeOrder: localStorage.getItem("homeDelivery") || "N",
      statusType: JSON.parse(localStorage.getItem("cartObj"))?.statusType || "N",
      orderCompleted: cartToDb.statusType === "layAway" ? false : true,
      overPayedAmount: overPayedAmount || 0,
    });

    if (cartToDb.customer) {
      cartToDb.customer.retlLoyaltyBalance = (cartToDb.customer.retlLoyaltyBalance || 0) + (cartToDb.accumulationPoints || 0);
    }

    // Optimize item updates
    for (let i = 0; i < cartToDb.items.length; i++) {
      const item = cartToDb.items[i];
      item.discount = item.discount ? parseFloat(parseFloat(item.discount)?.toFixed(precision)) : 0;
      item.key = i;
      item.nettotal = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      console.log("Processing item:", item);
      console.log("Tax include flag:", taxIncludeFlag);
      if (!item.isGiftCard) {
        const taxRate = Number(item.taxRate) || 0;
        const listPrice = Number(item.listPrice) || 0;
        const sunitprice = Number(item.sunitprice) || 0;
        const weight = Number(item.weight) || 1;

        const lineTax = listPrice * (1 + taxRate / 100);
        const stdTax = sunitprice * (1 + taxRate / 100);

        const unitPrice =
          isFinite(item.nettotal / weight) && weight !== 0 ? (taxIncludeFlag === "Y" ? item.nettotal / weight / (1 + taxRate / 100) : Number(item.salePrice) || 0) : 0;
        // let lineTax = item.listPrice * (1 + item.taxRate / 100);
        // const stdTax = item.sunitprice * (1 + item.taxRate / 100);
        // let unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;
        const gross_list = taxIncludeFlag === "Y" ? item.listPrice : lineTax;
        const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
        const netList =
          taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision)) : item.listPrice;
        const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : stdTax;
        // const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : item.sunitprice + parseFloat(lineTax?.toFixed(precision));

        Object.assign(item, {
          listPrice: taxIncludeFlag === "Y" ? item.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision)),
          linetax: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(item.taxAmount)?.toFixed(precision)) : 0,
          linenet: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision)) : 0,
          linestd: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(grossStd * item.weight)?.toFixed(precision)) : 0,
          linegross: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(item.nettotal)?.toFixed(precision)) : 0,
          netunit: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
          listprice: Math.abs(item.nettotal) > 0 ? item.listPrice : 0,
          grossunit: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0,
          grossstd: Math.abs(item.nettotal) > 0 ? roundTo(grossStd, precision) : 0,
          grosslist: Math.abs(item.nettotal) > 0 ? roundTo(gross_list, precision) : 0,
          grosslist: Math.abs(item.nettotal) > 0 ? gross_list : 0,
          netList: Math.abs(item.nettotal) > 0 ? netList : 0,
          unitPrice: Math.abs(item.nettotal) > 0 ? unitPrice : 0,
          taxAmount: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(item.taxAmount)?.toFixed(precision)) : 0,
        });
      }
    }

    // Tax details calculation
    // const taxDetails = [];
    // const taxMap = {};
    // for (const item of cart.items) {
    //   if (!item.isGiftCard) {
    //     const taxRate = item.taxRate;
    //     const taxAmount = parseFloat(item.taxAmount?.toFixed(precision));
    //     const nettotal = parseFloat((item.nettotal - item.taxAmount)?.toFixed(precision));
    //     if (taxMap[taxRate]) {
    //       taxMap[taxRate].taxAmount += taxAmount;
    //       taxMap[taxRate].nettotal += nettotal;
    //     } else {
    //       taxMap[taxRate] = { taxAmount, nettotal, tax: item.tax, taxRate, taxCategory: item.taxCategory, taxName: item.taxName };
    //     }
    //   }
    // }

    const taxDetails = [];
    const taxMap = {};

    for (const item of cart.items) {
      if (!item.isGiftCard) {
        if (item.taxRate >= 0 && item.tax) {
          const taxRate = item.taxRate;
          const taxAmount = parseFloat(parseFloat(item.taxAmount)?.toFixed(precision));
          const nettotal = parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision));
          if (taxMap[taxRate]) {
            taxMap[taxRate].taxAmount += taxAmount;
            taxMap[taxRate].nettotal += nettotal;
          } else {
            taxMap[taxRate] = {
              taxAmount,
              nettotal,
              tax: item.tax,
              taxRate,
              taxCategory: item.taxCategory,
              taxName: item.taxName,
            };
          }
        }

        // Handle custom mix item (no taxRate on parent)
        if (!item.taxRate && item.children?.length > 0) {
          for (const child of item.children) {
            if (child.taxRate && child.tax) {
              const taxRate = child.taxRate;
              const taxAmount = parseFloat(parseFloat(child.taxAmount)?.toFixed(precision));
              const nettotal = parseFloat(parseFloat(child.nettotal - child.taxAmount)?.toFixed(precision));
              if (taxMap[taxRate]) {
                taxMap[taxRate].taxAmount += taxAmount;
                taxMap[taxRate].nettotal += nettotal;
              } else {
                taxMap[taxRate] = {
                  taxAmount,
                  nettotal,
                  tax: child.tax,
                  taxRate,
                  taxCategory: child.taxCategory,
                  taxName: child.taxName,
                };
              }
            }
          }
        }
      }
    }

    cartToDb.combinedTaxRates = Object.keys(taxMap).map((taxRate) => {
      const entry = taxMap[taxRate];
      taxDetails.push({
        csTaxID: entry.tax,
        taxableAmt: entry.taxAmount,
        taxAmt: entry.nettotal,
        taxRate,
        taxCategory: entry.taxCategory,
        taxName: entry.taxName,
      });
      return { csTaxID: entry.tax, taxableAmt: entry.nettotal, taxAmt: entry.taxAmount };
    });
    cartToDb.taxDetails = taxDetails;

    // Clear temporary references
    localStorage.removeItem("orderTimeDetails");
    setGiftCardData([]);
    setShowPayments(initialShowPayments);
    setSelectedDate(null);

    // Database operations
    await db.orders
      .where("tillSessionId")
      .equals(tillSessionId)
      .toArray(async (orders) => {
        const newOrder = {
          salesTax: [],
          returnTax: [],
          items: [],
          netTotal: 0,
          grossTotal: 0,
          totalTax: 0,
          netReturnTotal: 0,
          grossReturnTotal: 0,
          totaReturnlTax: 0,
          returnsTransactions: 0,
          salesTransactions: 0,
        };
        let orderExists = false;

        if (orders.length > 0) {
          for (let i = 0; i < orders.length; i++) {
            if (orders[i].sOrderID === cartToDb.sOrderID) {
              orders[i] = { ...cartToDb }; // Create a new copy to avoid retaining reference
              orderExists = true;
              break;
            }
          }
          if (!orderExists) orders.push({ ...cartToDb });

          for (const order of orders) {
            await processOrderData(order, newOrder, orders);
          }
        } else {
          await processOrderData({ ...cartToDb }, newOrder, orders);
        }

        await db.ordersData
          .where("tillSessionId")
          .equals(tillSessionId)
          .modify((order) => {
            Object.assign(order, { tillSessionId, tillStatus: "open", ...newOrder });
          });
      });

    async function processOrderData(orderDetails, newOrder, allOrders) {
      const groupedItems = newOrder.items;
      const targetTaxArray = orderDetails.isReturn ? newOrder.returnTax : newOrder.salesTax;

      for (const item of orderDetails.items) {
        const index = groupedItems.findIndex((ele) => ele.value === item.value);
        if (index >= 0) {
          groupedItems[index].taxAmount = +parseFloat(parseFloat(groupedItems[index].taxAmount + item.taxAmount)?.toFixed(precision));
          groupedItems[index].nettotal = +parseFloat(parseFloat(groupedItems[index].nettotal + item.nettotal)?.toFixed(precision));
          groupedItems[index].weight = parseFloat((parseFloat(groupedItems[index].weight) + parseFloat(item.weight))?.toFixed(item?.isQtyDesimal || 2));
        } else {
          groupedItems.push({
            taxAmount: +parseFloat(parseFloat(item.taxAmount)?.toFixed(precision)),
            nettotal: +parseFloat(parseFloat(item.nettotal)?.toFixed(precision)),
            weight: parseFloat(parseFloat(item.weight)?.toFixed(item?.isQtyDesimal || 2)),
            value: item.value,
            name: item.name,
          });
        }
      }

      for (const newTax of orderDetails.taxDetails || []) {
        const existingTax = targetTaxArray.find((tax) => tax.taxRate === newTax.taxRate);
        if (existingTax) {
          existingTax.taxAmt = +parseFloat(parseFloat(existingTax.taxAmt + newTax.taxAmt)?.toFixed(precision));
          existingTax.taxableAmt = +parseFloat(parseFloat(existingTax.taxableAmt + newTax.taxableAmt)?.toFixed(precision));
        } else {
          targetTaxArray.push({
            csTaxID: newTax.csTaxID,
            taxableAmt: parseFloat(parseFloat(newTax.taxableAmt)?.toFixed(precision)),
            taxAmt: parseFloat(parseFloat(newTax.taxAmt)?.toFixed(precision)),
            taxRate: newTax.taxRate,
            taxCategory: newTax.taxCategory,
            taxName: newTax.taxName,
          });
        }
      }

      const isReturn = orderDetails.isReturn === true || orderDetails.isReturn === "Y";
      const orderIndex = allOrders.findIndex((o) => o.sOrderID === orderDetails.sOrderID);
      if (isReturn) {
        newOrder.returnTax = targetTaxArray;
        newOrder.netReturnTotal = +parseFloat(parseFloat((newOrder.netReturnTotal || 0) + (orderDetails.total - orderDetails.tax))?.toFixed(precision));
        newOrder.grossReturnTotal = +parseFloat(parseFloat((newOrder.grossReturnTotal || 0) + orderDetails.total)?.toFixed(precision));
        newOrder.totaReturnlTax = +parseFloat(parseFloat((newOrder.totaReturnlTax || 0) + orderDetails.tax)?.toFixed(precision));
        newOrder.returnsTransactions += 1;
        upsertPOSLog(orderDetails, "SLR");
      } else {
        newOrder.salesTax = targetTaxArray;
        newOrder.netTotal = +parseFloat(parseFloat((newOrder.netTotal || 0) + (orderDetails.total - orderDetails.tax))?.toFixed(precision));
        newOrder.grossTotal = +parseFloat(parseFloat((newOrder.grossTotal || 0) + orderDetails.total)?.toFixed(precision));
        newOrder.totalTax = +parseFloat(parseFloat((newOrder.totalTax || 0) + orderDetails.tax)?.toFixed(precision));
        newOrder.salesTransactions += 1;
      }

      if (orderIndex !== -1) {
        const advancePayment = parseFloat(orderDetails.advancePayment || 0);
        newOrder.netTotal = +parseFloat(parseFloat(newOrder.netTotal - advancePayment)?.toFixed(precision));
        newOrder.grossTotal = +parseFloat(parseFloat(newOrder.grossTotal - advancePayment)?.toFixed(precision));
      }
    }

    // Payments data update
    await db.paymentsData
      .where("tillSessionId")
      .equals(tillSessionId)
      .modify((event) => {
        const filteredPayments = event.payments.filter((payment) => payment?.cwrTillId === tillId);
        for (const payment of filteredPayments) {
          let currPaymentAmount = 0;
          let currPaymentReturn = 0;
          for (const orderPayment of cart.payments || []) {
            if (payment.name.toLowerCase() === orderPayment.name.toLowerCase()) {
              if (cart.total > 0) {
                currPaymentAmount += parseFloat(orderPayment.amount);
                payment.transactionCount = (payment.transactionCount || 0) + 1;
              } else if (cart.total < 0) {
                currPaymentReturn += parseFloat(Math.abs(orderPayment.amount));
                payment.transactionCount = (payment.transactionCount || 0) + 1;
              }
            }
          }
          payment.expectedAmount = (payment.expectedAmount || 0) + currPaymentAmount;
          payment.amount = (payment.amount || 0) + currPaymentAmount;
          payment.paymentReturn = (payment.paymentReturn || 0) + currPaymentReturn;
          payment.difference = (payment.difference || 0) + payment.expectedAmount;
          payment.change = (payment.change || 0) + cart.change;
        }
        event.payments = filteredPayments;
      });

    setSelectedDocumentType("Invoice");
    setPaymentProcessFlag(false);
    // Final order processing
    try {
      if (cart.type !== "Layaway" && cart?.isCreditSale !== "Y") {
        await db.orders.add(cartToDb);
      } else {
        await db.orders.put(cartToDb);
      }

      setPaymentModal(false);

      const resetMergedTablesAfterPayment = async (tableRecord, cart, tillData) => {
        const parentId = tableRecord.cwrFbTableId;
        const childIds = (tableRecord.merge || []).map((m) => m.fbMTableId);
        const allIds = [parentId, ...childIds];

        const fbOrders = await db.fbOrderData.where("cwrFbTableId").equals(parentId).toArray();
        for (const fbOrder of fbOrders) {
          if (fbOrder.fbOrderStatus === "IP") {
            Object.assign(fbOrder, {
              salesHistory: "Y",
              fbOrderSync: "N",
              tableSync: "N",
              statusType: "OPN",
              fbOrderStatus: "CO",
              color: "#a7c957",
              sOrderID: cart.sOrderID,
            });
            await db.fbOrderData.put(fbOrder);
          }
        }

        // 2️⃣ Reset all merged tables to OPN locally
        await db.tableData
          .where("cwrFbTableId")
          .anyOf(allIds)
          .modify((t) => {
            t.statusType = "OPN";
            t.noOfPersons = 0;
            t.guestName = "";
            t.waiter = null;
            t.referredBy = "";
            t.guestType = "";
            t.time = null;
            t.color = "#a7c957";
            t.tableSync = "N";
            t.items = [];
            t.lines = [];
            t.totalAmount = 0;
            t.ordered = "N";
          });

        // 3️⃣ Send parent with merge to server
        const parentPayload = {
          fbtableStatusId: tableRecord.fbtableStatusId,
          cwrFbTableId: tableRecord.cwrFbTableId,
          cwrFbsectionId: tableRecord.cwrFbsectionId,
          statusType: "OPN",
          noOfPersons: 0,
          guestName: "",
          guestType: "",
          referredBy: "",
          waiter: tableRecord.waiter || null,
          merge: tableRecord.merge, // keep original
        };
        await SyncData(parentPayload, "upsertTableStatus");

        // 5️⃣ Convert merge group into independent tables in DB
        await db.tableData
          .where("cwrFbTableId")
          .anyOf(allIds)
          .modify((t) => {
            t.merge = [];
            t.isMergedParent = "N";
            t.isMergedChild = "N";
            t.parentTableId = null;
            t.mergedTableIds = [];
            t.displayName = t.name;
          });

        await SyncData(tableRecord, "upsertFbOrder");
      };

      const takeAway = localStorage?.getItem("dineIn");
      const isCallCenter = isCallCenterFlow && tillLayout === 2;
      if (takeAway === "Y" && !isCallCenter) {
        let tableData = JSON.parse(localStorage.getItem("tableName")) || {};
        // const tableRecord = await db.tableData.where("cwrFbTableId").equals(tableData.cwrFbTableId).first();
        const tableRecord = await db.tableData.where("cwrFbTableId").equals(tableData?.cwrFbTableId).first();
        if (tableRecord) {
          const isMerged = Array.isArray(tableRecord.merge) && tableRecord.merge.length > 0;
          if (isMerged) {
            // 🔹 merged table → use helper (closes order + un-merges all tables)
            if (isMerged) {
              await resetMergedTablesAfterPayment(tableRecord, cart, tillData);
            }
          } else {
            if (tableRecord.isSplitParent === "Y") {
              const splitName = tableData.splitTable || tableData.tableName;
              const updatedSplitTables = tableRecord.splitTables.map((st) =>
                st.splitTable === splitName
                  ? {
                      ...st,
                      status: "OPN",
                      ordered: "N",
                      cart: {
                        items: [],
                        couponInput: [],
                        advancePayment: 0,
                        total: 0,
                        tax: 0,
                        discount: 0,
                        paid: 0,
                        change: 0,
                        totalQty: 0,
                        roundOff: 0,
                        payments: [],
                        redemptionPoints: 0,
                        accumulationPoints: 0,
                        creditAmount: 0,
                        docType: "Invoice",
                        sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
                        referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
                        giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                        couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                        customer: selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData.customer : defaultCustomer,
                        salesRepId: null,
                        cardPaymentData: {},
                        documentno: `${tillData.tillAccess.cwrTill.prefix}${documentSequence + 1}`,
                        userName: userData.user,
                        tillName: tillValue?.name,
                        subTotal: 0,
                        itemsSummery: {},
                        amountInWords: "",
                        groupedItemsByTaxRate: {},
                        serviceCharge: 0,
                        tip: 0,
                        deiveryCharge: 0,
                        packingCharge: 0,
                        others: 0,
                      },
                    }
                  : st
              );
              const allSplitsDone = updatedSplitTables.every((st) => st.status === "OPN" || st.status === "CO");

              // ✅ Now write to DB with full reset if all done
              await db.tableData.update(tableRecord.cwrFbTableId, {
                splitTables: updatedSplitTables,
                ...(allSplitsDone
                  ? {
                      statusType: "OPN",
                      displayName: tableRecord.name,
                      color: "#a7c957",
                      ordered: "N",
                      items: [],
                      lines: [],
                      totalAmount: 0,
                      noOfPersons: 0,
                      guestName: "",
                      waiter: null,
                      referredBy: "",
                      guestType: "",
                      time: null,
                    }
                  : {}),
              });
              // 2️⃣ Close fbOrder for THIS split only
              const fbOrders = await db.fbOrderData.filter((o) => o.splitTable === splitName).toArray();

              for (const fbOrder of fbOrders) {
                if (fbOrder.fbOrderStatus === "IP") {
                  Object.assign(fbOrder, {
                    fbOrderStatus: "CO",
                    salesHistory: "Y",
                    tableSync: "N",
                    sOrderID: cart.sOrderID,
                  });
                  await db.fbOrderData.put(fbOrder);
                  await SyncData(fbOrder, "upsertFbOrder");
                }
              }

              // 3️⃣ Sync parent table WITH updated splitTables
              await SyncData(
                {
                  fbtableStatusId: tableRecord.fbtableStatusId,
                  cwrFbTableId: tableRecord.cwrFbTableId,
                  splitTables: updatedSplitTables,
                  statusType: tableRecord.statusType,
                  waiter: tableRecord.waiter,
                },
                "upsertTableStatus"
              );

              // 4️⃣ Clear ONLY this split cart
              //   const emptyCart = {
              //   items: [],
              //   total: 0,
              //   tax: 0,
              //   paid: 0,
              //   payments: [],
              //   totalQty: 0,
              //   discount: 0,
              //   roundOff: 0,
              //   change: 0,
              // };

              // localStorage.setItem("cartObj", JSON.stringify(emptyCart));

              setCart({
                ...cart,
                items: [],
                total: 0,
                tax: 0,
                paid: 0,
                payments: [],
              });
              const updatedTableData = await db.tableData.toArray();
              setTableCards(updatedTableData);
              const ocuTables = updatedTableData.filter((t) => t.statusType === "OCU" || t.statusType === "ONG");
              setOcupiedTablesData(ocuTables);
              const resTables = updatedTableData.filter((t) => t.statusType === "RES");
              setReservedTablesData(resTables);
              setTableList(updatedTableData);
              // 5️⃣ STOP ALL FURTHER FLOW
              setPaymentModal(false);
              orderState.current = 0;
              setActiveOrderProcess(false);
              return;
            }
            Object.assign(tableRecord, {
              salesHistory: "Y",
              fbOrderSync: "N",
              tableSync: "N",
              statusType: "OPN",
              fbOrderStatus: "CO",
              color: "#a7c957",
              ordered: "N",
              items: [],
              lines: [],
              totalAmount: 0,
              noOfPersons: 0,
              guestName: "",
              waiter: null,
              referredBy: "",
              guestType: "",
              time: null,
            });

            const fbOrders = await db.fbOrderData.where("cwrFbTableId").equals(tableData.cwrFbTableId).toArray();
            console.log("fbOrders to update", fbOrders);
            for (const fbOrder of fbOrders) {
              if (fbOrder.fbOrderStatus === "IP") {
                Object.assign(fbOrder, {
                  salesHistory: "Y",
                  fbOrderSync: "N",
                  tableSync: "N",
                  statusType: "OPN",
                  fbOrderStatus: "CO",
                  color: "#a7c957",
                  sOrderID: cart.sOrderID,
                  items: [],
                  lines: [],
                  cart: {},
                  totalAmount: 0,
                });
                await db.fbOrderData.put(fbOrder, fbOrder.fbOrderId);
              }
            }
            const tableStatusResult = await SyncData(tableRecord, "upsertTableStatus");
            console.log("tableRecord", tableRecord);

            const currentOrder = fbOrders.find((o) => o.sOrderID === cart.sOrderID);
            if (currentOrder) {
              await SyncData(currentOrder, "upsertFbOrder");
            }

            // ✅ Now show order complete screen AFTER both APIs succeed
            if (tableStatusResult?.success) {
              console.log("Table status updated successfully on server");
              setShowOrderCompleteFlag(true);
            }
          }
        }
      }
      if (takeAway !== "Y") {
        setShowOrderCompleteFlag(true);
      }
      // Reset state and local storage
      localStorage.setItem("cartObj", "[]");
      if (cart.isRetrived !== "Y" && cart.type !== "Layaway" && splitCarts.length === 0) {
        localStorage.setItem("documentSequence", String(newDocumentSequence));
        setDocumnetSequence(newDocumentSequence);
        deleteCart();
      } else {
        const newCart = {
          items: [],
          couponInput: [],
          advancePayment: 0,
          total: 0,
          tax: 0,
          discount: 0,
          paid: 0,
          change: 0,
          totalQty: 0,
          roundOff: 0,
          payments: [],
          redemptionPoints: 0,
          accumulationPoints: 0,
          creditAmount: 0,
          docType: "Invoice",
          sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
          referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
          giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
          couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
          customer: selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData.customer : defaultCustomer,
          salesRepId: null,
          cardPaymentData: {},
          documentno: `${tillData.tillAccess.cwrTill.prefix}${documentSequence + 1}`,
          userName: userData.user,
          tillName: tillValue?.name,
          subTotal: 0,
          itemsSummery: {},
          amountInWords: "",
          groupedItemsByTaxRate: {},
          serviceCharge: 0,
          tip: 0,
          deiveryCharge: 0,
          packingCharge: 0,
          others: 0,
        };
        setCart(newCart);
        localStorage.setItem("cartObj", JSON.stringify(newCart));
      }

      setNotesValue("");
      setOrderDelay(now.format("DD-MM-YYYY HH:mm:ss"));
      if (posConfig?.disableOfflineBilling !== "Y") {
        message.success(`Order ${cartToDb.documentno} Created Successfully`);
        localStorage.removeItem("selectedReturnType");
        localStorage.removeItem("exchangeCartObj");
      }
      hasShownCustomerModalRef.current = false;
      setIsInputFocused(false);
      orderState.current = 0;
      setActiveOrderProcess(false);
      localStorage.removeItem("totalDiscountsCartRef");

      if (cartToDb.giftVoucherType) {
        const { csBunitId, cwrTillId } = tillData.tillAccess;
        const customerId = cartToDb.customer?.cwrCustomerId;
        if (!csBunitId || !cwrTillId || !customerId) {
          console.error("Missing required data for gift voucher generation");
          cartToDb.voucherCode = null;
        } else {
          const query = `
            mutation {
              generateGiftVoucher(
                giftVoucher: {
                  cSBunitID: "${csBunitId}"
                  tillId: "${cwrTillId}"
                  b2cCustomerId: "${customerId}"
                  giftVoucherType: "${cartToDb.giftVoucherType}"
                  voucherAmount: ${cartToDb.giftVoucherAmount || 0}
                }
              ) {
                status
                message
                voucherCode
              }
            }
          `;
          try {
            const response = await generateGiftVoucher(query);
            const gGV = response?.data?.data?.generateGiftVoucher;
            cartToDb.voucherCode = gGV?.status === "200" ? gGV.voucherCode : null;
          } catch (error) {
            console.error("Error in generating gift voucher:", error);
            cartToDb.voucherCode = null;
          }
        }
      }
      if (tillaccess?.layout === "2") cartToDb.orderSelection = orderTypeSelection;
      if (localStorage.getItem("isPreparedBill") !== "true") {
        PrintController(cartToDb, cart);
        setInvoicePrinted("SUCCESS");
      }

      const defaultSaleType = await getDefaultSaleType();
      if (defaultSaleType) {
        setSelectedSaleType(defaultSaleType.cwrSaletype.name);
        setSelectedSaleTypeData(defaultSaleType);
        localStorage.setItem("saleTypeData", JSON.stringify(defaultSaleType));

        const cartDetails = JSON.parse(localStorage.getItem("cartObj")) || {};
        cartDetails.customer = defaultSaleType.customer?.b2cCustomerId ? defaultSaleType.customer : tillData.tillAccess.csBunit.b2cCustomer;
        setCart(cartDetails);
        localStorage.setItem("cartObj", JSON.stringify(cartDetails));
      }
      const defaultRevenueCategory = await getDefaultRevenueCategory();
      if (defaultRevenueCategory) {
        setSelectedRevenueCategoryName(defaultRevenueCategory?.name);
        localStorage.setItem("selectedRevenueCategory", JSON.stringify(defaultRevenueCategory));
      }
      if (searchInputRef?.current) {
        searchInputRef.current.focus();
      }

      if (tillLayout === 2) {
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          history.push("/pos");
        }, 500);
      }

      if (posConfig?.redirectToInvoiceAfterPreorder === "Y") {
        history.push("/pos");
      }
    } catch (error) {
      console.error("Failed to process order:", error);
      setActiveOrderProcess(false); // Ensure flag is reset on error
    }
  };
  //// CART OPERATIONS END ////

  // OFFERS AND DISCOUNTS BLOCK START
  const [offerProductsList, setOfferProductList] = useState();
  const [displayOfferProductSelectiton, setDisplayOfferProductSelection] = useState(false);

  const selectOfferProduct = (product) => {
    const pro = product;
    addProduct(pro, 1, false, 0, false, false);
    setDisplayOfferProductSelection(false);
    if (tillLayout === 2) {
      setPaymentModal(true);
    }
  };
  // OFFERS AND DISCOUNTS BLOCK START

  //// PAYMENTS BLOCK START ////
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentProcessFlag, setPaymentProcessFlag] = useState(false);
  const [amount, setAmount] = useState("");
  const [overPayedAmount, setOverPayedAmount] = useState(0);
  const [denaminationsKeyboard, setDenaminationsKeyboard] = useState(false);

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({});

  const [loader, setLoader] = useState(false);

  const onChangeAmount = (event) => {
    let type = "3";
    // let value = event.target.value?.replace(/[^\d.]/g, "");
    let value = event.target.value;
    value = value.replace(/[^0-9.]/g, "");
    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }
    paymentProcess(type, value, setAmount, amount, cart, tillData, selectedPaymentMethod, setOverPayedAmount, setNumb, numb);
  };

  const handleAmount = (value) => {
    let type = "1";
    paymentProcess(type, value, setAmount, amount, cart, tillData, selectedPaymentMethod, setOverPayedAmount, setNumb, numb);
  };

  const showConfirm = () => {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        title: (
          <>
            <ExclamationCircleOutlined style={{ color: "#FAAD17" }} /> Confirm Payment Details
          </>
        ),
        icon: null,
        content: (
          <div
            style={{
              background: "#fff",
              height: "auto",
              width: "100%",
              border: "1px solid #fff",
              borderRadius: "7px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* Bill Amount Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Bill Amount</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {parseFloat(Math.abs(cart.total)).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Amount Tendered Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Tendered</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {parseFloat(amount).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Amount Received Row */}
            <Row
              style={{
                fontSize: "1em", // Adjust font size for readability
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Received</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {Math.abs(cart.total - cart.paid).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Change Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Change Due</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {cart.paid + parseFloat(amount) - Math.abs(cart.total) > 0
                    ? (cart.paid + parseFloat(amount) - Math.abs(Math.abs(cart.total) + Math.abs(overPayedAmount))).toFixed(pricePrecision)
                    : cart?.change <= 0
                      ? "0.00"
                      : cart?.change}
                </p>
              </Col>
            </Row>
          </div>
        ),
        onOk() {
          resolve(true);
        },
        onCancel() {
          resolve(false);
        },
        cancelButtonProps: {
          style: {
            borderRadius: "5px", // Border radius for the Cancel button
          },
        },
        okButtonProps: {
          style: {
            borderRadius: "5px", // Border radius for the OK button
          },
        },
      });
    });
  };

  const handleCashPayment = (value) => {
    let type = "2";
    paymentProcess(type, value, setAmount, amount, cart, tillData, selectedPaymentMethod, setOverPayedAmount, setNumb, numb);
  };

  const [paymentModalByCustomerState, setPaymentModalByCustomerState] = useState(false);

  const openPaymentModal = async () => {
    if (tillLayout === 2) {
      setPaymentModal(true);
    }
    setPaymentProcessFlag(true);
    openPaymentModalByCustomer();
  };

  const openPaymentModalByCustomer = (cartObj) => {
    paymentModalInputRef?.current?.select();
    paymentModalInputRef?.current?.focus();
    // const cartData = cartObj ? { ...cartObj } : { ...cart };
    const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj")) || {};
    const cartObjData = JSON.parse(localStorage.getItem("cartObj")) || cart;
    const cartData = isExchange ? exchangeCartObj : cartObjData;
    if (cartObj && (cart.iscoupon === true || cart.totalBillDicount)) {
      cartData.iscoupon = cart.iscoupon;
      cartData.totalBillDicount = cart.totalBillDicount;
      cartData.items = cart.items;
    }
    localStorage.setItem("totalDiscountsCartRef", JSON.stringify(cartData));
    setPaymentModalByCustomerState(false);
    if (cartData?.items?.length > 0) {
      db.pricingRules.toArray().then((pr) => {
        const pricingRuleCount = pr.length;
        if (pricingRuleCount > 0) {
          pr.sort((a, b) => {
            if (a.priority === null && b.priority === null) {
              return 0;
            } else if (a.priority === null) {
              return 1;
            } else if (b.priority === null) {
              return -1;
            }
            return parseInt(a.priority, 10) - parseInt(b.priority, 10);
          });
          const cartHasCoupon = cartData.iscoupon === true || cartData.couponInput?.length > 0 || cartData.items?.some((item) => item.iscoupon === true);

          for (let i = 0; i < pricingRuleCount; i++) {
            const pricingRule = pr[i];
            if (dateValidator(pricingRule.startDate, pricingRule.endDate) && pricingRule.iscoupon === "N" && (pricingRule.type === "TD" || pricingRule.type === "TDF")) {
              if (cartHasCoupon) {
                continue;
              }
              if (pricingRule.timeSpecific === "Y") {
                const weekDay = currentDay();
                const pStartTime = pricingRule.starttime.substring(11);
                const pEndTIme = pricingRule.endtime !== null ? pricingRule.endtime.substring(11) : moment(new Date()).format("DD-MM-YYYY HH:mm:ss").substring(11);
                const starttime = timeStamp().substring(0, 10) + " " + pStartTime;
                const endtime = timeStamp().substring(0, 10) + " " + pEndTIme;
                if (timeValidator(starttime, endtime) && pricingRule[weekDay] === "Y") {
                  processBillDiscounts(pricingRule, cartData, false);
                }
              } else {
                processBillDiscounts(pricingRule, cartData, false);
              }
            }
          }
        }
      });
    }
  };

  const processBillDiscounts = (pricingRule, cartObj, iscoupon, couponInput, uniqReferenceId, mPricingCouponId, mPricingRulesId) => {
    if (pricingRule.type === "TD" && (pricingRule.manualDiscount === "N" || pricingRule.manualDiscount === null)) {
      let updatedCart = TotalBillDiscount(pricingRule, setCart, cart, orderType, cartObj, iscoupon, couponInput, uniqReferenceId, mPricingCouponId, mPricingRulesId);
      if (updatedCart?.couponError) {
        message.warning(updatedCart.couponError);
        return cartObj; // return old cart (no changes)
      }
      return updatedCart;
    }

    if (pricingRule.type === "TDF" && (pricingRule.manualDiscount === "N" || pricingRule.manualDiscount === null)) {
      let updatedCart = TotalBillFreeProductDiscount(
        pricingRule,
        setCart,
        cart,
        orderType,
        cartObj,
        addProduct,
        setOfferProductList,
        setDisplayOfferProductSelection,
        iscoupon,
        couponInput,
        uniqReferenceId,
        mPricingCouponId,
        mPricingRulesId
      );
      return updatedCart;
    }
  };

  const closePaymentModal = () => {
    setPaymentModal(false);
    setSelectedPaymentMethod("");
  };

  const [loyaltyPaymentOtp, setLoyaltyPaymentOtp] = useState();
  const [loyaltyInputValue, setLoyaltyInputValue] = useState("");
  const [loyalityOtpModalVisible, setLoyalityOtpModalVisible] = useState(false);
  const [loyalityOtpData, setLoyalityOtpData] = useState();
  const [paymentModalLoyalityMessages, setPaymentModalLoyalityMessages] = useState({ inputMessage: "Enter Amount", buttonText: "Add Payment" });

  const processOtpInput = () => {
    const { otp, paymentMethod, value, redeemPoints } = loyalityOtpData;
    setLoyalityOtpModalVisible(false);
    if (otp === loyaltyPaymentOtp) {
      message.success(`${messages.errors.loyalty.loyalty_points_redeemed}`);
      paymentMethod.redemptionPoints = parseInt(redeemPoints);
      processPayment(paymentMethod, value);
    } else {
      message.warning(`${messages.info.invalid_otp}`);
    }
    setLoyalityOtpData();
    setLoyaltyPaymentOtp();
  };

  const handleLoyalityInput = (value) => {
    if (value === "clear") {
      setLoyaltyInputValue("");
    } else if (value === "x") {
      setLoyaltyInputValue(`${loyaltyInputValue.toString().substring(0, loyaltyInputValue.toString().length - 1)}`);
    } else {
      setLoyaltyInputValue(`${loyaltyInputValue}${value}`);
    }
  };

  const checkLoyality = async () => {
    requestPayment(selectedPaymentMethod, parseFloat(loyaltyInputValue));
    setLoyalityOtpModalVisible(false);
    setLoyaltyInputValue(0);
    // setCart(cartObj);
    // localStorage.setItem("cartObj", JSON.stringify(cartObj));
  };

  useEffect(() => {
    const fetchData = async () => {
      if (selectedPaymentMethod?.name?.toLowerCase() === "cash") {
        setDenaminationsKeyboard(true);
      }
      if (selectedPaymentMethod.isloyalty) {
        setPaymentModalLoyalityMessages({
          inputMessage: "Enter Points to Redeem",
          buttonText: "Redeem",
        });
        try {
          let loyaltyData = await db.loyalityData.toArray();
          let cartObj = JSON.parse(localStorage.getItem("cartObj")) || {};
          const matchedLoyalty = loyaltyData.find((loyalty) => loyalty.name === cart.customer.loyaltyLevel.name);
          let value = 0;
          if (posConfig?.enableLoyalty === "Y") {
            loyaltyData?.forEach((loyality) => {
              if (loyality.loyaltylevelId === cartObj?.customer?.loyaltyLevel?.cwrLoyaltyLevelId) {
                loyality.loyaltyRedemption.forEach((redeemItem) => {
                  value = parseFloat(parseFloat(cartObj.total - cartObj.paid / redeemItem.redemptionValue)?.toFixed(precision));
                });
              }
            });
          } else {
            value = parseFloat(parseFloat(cartObj.total - cartObj.paid)?.toFixed(precision));
          }
          if (Math.abs(matchedLoyalty.loyaltyRedemption[0].minPurchase <= cart.total)) {
            setLoyalityOtpModalVisible(true);
            console.log("Loyalty Input Value Set To:", value);
            setLoyaltyInputValue(value ? value : 0);
            upsertPOSLog(cart, "LOR");
          } else {
            message.error(`${messages.errors.loyalty.minimum_purchase_not_met}`);
          }
        } catch (error) {
          console.error("Error fetching loyalty data:", error);
        }
      } else if (selectedPaymentMethod.isGiftCard) {
        setGiftCardFlag(true);
        setTimeout(() => {
          if (redeemNumberRef.current) {
            redeemNumberRef.current.focus();
          }
        }, 250);
        setPaymentModalLoyalityMessages({
          inputMessage: "Enter Coupon Code",
          buttonText: "Redeem",
        });
      } else {
        setPaymentModalLoyalityMessages({
          inputMessage: "Enter Amount",
          buttonText: "Add Payment",
        });
      }
    };

    fetchData();
  }, [selectedPaymentMethod]);

  const requestPayment = async (paymentMethod, value, grant, wallet, cardPaymentDetails, updatedCart) => {
    addAmount(
      paymentMethod,
      value,
      grant,
      updatedCart || cart,
      setCart,
      setLoader,
      setPaymentModal,
      setAmount,
      setLoyalityOtpData,
      setLoyalityOtpModalVisible,
      setSelectedPaymentMethod,
      setPaytmQrCodeModalOpens,
      setQrCodeResponse,
      overPayedAmount,
      setShowCardPaymnteModal,
      setCardPaymnetError,
      setCardPaymnetStatus,
      setCardPaymnetStatusPLB,
      setLoading,
      setIsCardPaymentLoading,
      setLayoutType,
      setKioskUI,
      dispatchQRCodeEvent,
      closeQRCodeModal,
      wallet,
      cardPaymentDetails,
      setIntegratedPaymentStatus,
      exchangeCart,
      setExchangeCart,
      processOrder,
      showCustomerWallet,
      handleWalletPostPayment,
      isNewGiftCardFlag,
      showGiftCardTopup,
      handleGiftCardTopupPostPayment
    );
  };

  const processPayment = (paymentMethod, value) => {
    completePayment(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod);
  };
  //// PAYMENTS BLOCK END ////

  const eBillConfig = useRef({});
  useEffect(() => {
    const fetchPOSConfig = async () => {
      try {
        if (!authHeaders?.access_token || !tillValue?.cwr_till_id) {
          console.error("Missing required parameters: access token or till ID");
          return;
        }
        const response = await posConfigService(tillValue?.cwr_till_id);

        const posConfigData = response?.data?.data?.getPOSConfig;

        if (posConfigData?.length > 0) {
          const ebConfig = JSON.parse(posConfigData[0]?.configJson || "{}");
          eBillConfig.current = ebConfig;
        } else {
          console.warn("No POS configuration found for the provided till ID");
        }
      } catch (error) {
        console.error("Error fetching POS configuration:", error);
      }
    };
    fetchPOSConfig();
  }, []);

  const sendWebHookData = async (pendingOrders) => {
    try {
      // const orders = await db.orders.where("isSynced").equals(0).toArray();
      const orders = [...pendingOrders];
      for (const order of orders) {
        let shortId = "";
        const { eBillWebHookURL } = eBillConfig.current;
        try {
          const { data } = await Axios.get(`${eBillWebHookURL}/ebill/uniqueid`);
          shortId = data;
        } catch (error) {
          console.error(error);
          throw new Error("Failed to Fetch ID");
        }

        const orderItems = [];
        const taxKeyValue = [];
        const taxType = [];

        order.items.forEach((orderItem, i) => {
          let taxRate = orderItem.taxRate;
          if (taxType.indexOf(taxRate) !== -1) {
            let taxVal = orderItem.taxAmount / 2;
            for (let j = 0; j < taxKeyValue.length; j += 1) {
              const keys = Object.keys(taxKeyValue[j]);
              if (keys[0].toString() === taxRate.toString()) {
                taxKeyValue[j][taxRate] = taxKeyValue[j][taxRate] + taxVal;
              }
            }
          } else {
            taxType.push(taxRate);
            let taxVal = orderItem.taxAmount / 2;
            taxKeyValue.push({ [taxRate]: taxVal });
          }

          orderItems.push({
            line_no: i + 1,
            sku: orderItem.value,
            name: orderItem.name,
            description: null,
            hsn_code: null,
            selling_price: orderItem.salePrice,
            quantity: orderItem.weight,
            amount: orderItem.nettotal,
            list_price: orderItem.realPrice,
            uom: orderItem.uom_name,
            attributes: {
              mc: "",
              symc: "",
            },
            taxes: [
              {
                tax_name: "GST",
                percentage: orderItem.taxRate,
                amount: orderItem.taxAmount,
                taxableAmount: orderItem.nettotal,
              },
            ],
            brand: null,
            categoryId: orderItem.mProductCategoryId,
            categoryName: null,
          });
        });

        const payments = [];
        order.payments.forEach((payment, i) => {
          payments.push({
            payment_method: payment.name,
            amount: payment.amount,
          });
        });

        const orderData = {
          clientId: tillData.tillAccess.csClientId,
          storeId: tillData.tillAccess.csBunit.csBunitId,
          eBillCommType: eBillConfig.current.eBillCommType,
          created: order.orderTime,
          updated: order.orderTime,
          short_id: shortId,
          customer: {
            customer_id: order.customer.cwrCustomerId,
            first_name: order.customer.name,
            last_name: "",
            mobile: order.customer.mobileNo,
          },
          order_type: order.orderType,
          order_id: order.sOrderID,
          bill_no: order.documentno,
          bill_status: "PAID",
          order_date: order.orderTime,
          items: orderItems,
          item_count: order.items.length,
          total_qty: order.totalQty,
          net_total: order.total,
          gross_total: order.total,
          payment: payments,
          taxes: [
            {
              tax_name: "GST",
              amount: order.tax,
              taxableAmount: order.total,
            },
          ],
          additonalTaxinfo: taxKeyValue,
          feedback: false,
          feedbackStars: 0,
        };

        try {
          if (orderData.customer.mobile !== "9999999999") {
            await Axios.post(`${eBillWebHookURL}/ebill/webhook`, orderData);
          }
        } catch (error) {
          console.error(error);
          throw new Error("Failed to POST Webhook");
        }
      }
    } catch (e) {
      console.error("Webhook Error", e);
    }
  };

  const getDefaultSaleType = async () => {
    const saleData = await db.posSaletypes.toArray();
    return saleData.find((sale) => sale?.cwrSaletype?.isdefault === "Y");
  };

  const getDefaultRevenueCategory = async () => {
    const revenueData = await db.getRevenueCategories.toArray();
    return revenueData.find((revenue) => revenue?.isDefault === "Y");
  };

  const fetchIRNDetails = async (orderId) => {
    try {
      if (!orderId) {
        console.log("No sOrderID found");
        return;
      }

      setIrnGenerating("LOADING");

      let retryCount = 0;

      const interval = setInterval(async () => {
        retryCount++;

        const detailsQuery = {
          query: `
          query {
            getEInvoiceDetails(
              orderId: "${orderId}"
            )
          }
        `,
        };

        const response = await getEInvoiceDetails(detailsQuery);

        const parsedResponse = JSON.parse(response?.data?.data?.getEInvoiceDetails || "{}");
        // SUCCESS

        if (parsedResponse?.eInvoiceNo) {
          clearInterval(interval);
          setIrnGenerating("SUCCESS");
          setIrnStatus("SUCCESS");
          setIrnNumber(parsedResponse.eInvoiceNo);
          setIrnDownloadReady("LOADING");
          const urlQuery = {
            query: `
            query {
              getEInvoiceURLs(
                orderId: "${orderId}"
              )
            }
          `,
          };

          const urlResponse = await getEInvoiceURLs(urlQuery);
          const parsedUrls =
            typeof urlResponse?.data?.data?.getEInvoiceURLs === "string" ? JSON.parse(urlResponse?.data?.data?.getEInvoiceURLs) : urlResponse?.data?.data?.getEInvoiceURLs || {};

          const urls = parsedUrls?.urls || [];

          if (urls?.length > 0) {
            setIrnPdfUrl(urls[0]);
            setIrnDownloadReady("SUCCESS");
          }
        } else if (parsedResponse?.eInvoiceStatus === "IF") {
          clearInterval(interval);
          setIrnGenerating("FAILED");
          setIrnFailureMessage("Invoice failed, please contact administration");
          return;
        } else if (parsedResponse?.message) {
          clearInterval(interval);
          setIrnGenerating("FAILED");
          setIrnFailureMessage(parsedResponse?.message);
          return;
        }

        // STILL PROCESSING
        else if (parsedResponse?.message === "EInvoice Not Found for Order") {
          setIrnGenerating("LOADING");
        }

        // FAILED AFTER RETRIES

        if (retryCount >= 6) {
          clearInterval(interval);

          setIrnGenerating("FAILED");
        }
      }, 5000);
    } catch (error) {
      console.log("IRN FETCH ERROR", error);

      setIrnGenerating("FAILED");
    }
  };

  // ORDER SYNC BLOCK START
  const syncOrders = async (syncTrigger) => {
    const activeCart = syncTrigger === "exchange" ? JSON.parse(localStorage.getItem("exchangeCartObj")) : cart;
    const nWStatus = navigator.onLine ? "online" : "offline";
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    const posConfig = JSON.parse(localStorage.getItem("posConfig"));
    let saleTypeId = null;
    if (localStorage.getItem("saleTypeData") !== null) {
      const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData"));
      saleTypeId = saleTypeData?.cwrSaletype?.cwrSaletypeId;
    }
    if (nWStatus === "online") {
      db.logInformation.toArray().then(async (fetched) => {
        if (fetched.length > 0) {
          const posLogArray = [];
          const trxId = uuidv4().replace(/-/g, "").toUpperCase();
          let shouldCallAxios = false;

          for (const item of fetched) {
            const value = { ...item };
            await db.logInformation.where("id").equals(value.id).delete();

            posLogArray.push(`{
              type: ${JSON.stringify(value.type)},
              action: "LOG",
              description: ${JSON.stringify(value.description)},
              date: ${JSON.stringify(value.date)},
              time: ${JSON.stringify(value.time)},    
              orderNo: ${JSON.stringify(value.orderNo)},
              remarks: ${JSON.stringify(value.remarks)},
              transactionId: "${trxId}",
              status: "SCS",
              duration: ${value.duration ?? 0}
            }`);

            if (posConfig?.[value.type] === "Y") {
              shouldCallAxios = true;
            }
          }

          if (shouldCallAxios) {
            try {
              if (!tillData?.tillAccess?.cwrTill?.cwrTillID || !tillData?.tillAccess?.csUserId || !tillData?.tillAccess?.csBunit?.csBunitId) {
                console.error("Required till data is missing");
                return;
              }
              const response = await upsertPOSLogService(
                tillData.tillAccess.cwrTill.cwrTillID,
                tillData.tillAccess.csUserId,
                tillData.tillAccess.csBunit.csBunitId,
                posLogArray.join(", ")
              );

              if (response.status === 200) {
                console.log("POS logs successfully upserted:", response.data);
              } else {
                console.error("Error upserting POS logs:", response.status, response.data);
              }
            } catch (error) {
              console.error("Axios request failed:", error);
            }
          }
        }
      });
      const retailCustomerGroups = customerConfigData?.fieldGroups || [];
      const invoicingGroup = retailCustomerGroups.find((group) => group.name?.toLowerCase() === "delivery address");
      const invoicingMeta = cart?.customer?.metaData?.find((item) => item.key === invoicingGroup?.id);
      let invoicingState = "";
      if (invoicingMeta?.value) {
        try {
          const parsed = JSON.parse(invoicingMeta.value);
          invoicingState = parsed?.state || "";
        } catch (e) {
          console.log("Error parsing invoicing meta", e);
        }
      }
      // const stateId =
      //   localStorage.getItem("isB2bEnabled") === "true" ? getStateId(invoicingState) : cart?.customer?.metaData?.find((item) => item.key?.toLowerCase() === "state")?.value;
      const storedB2B = localStorage.getItem("isB2bEnabled") === "true";
      let stateId = "";
      if (storedB2B && retailCustomerGroups.length > 0) {
        const groupId = retailCustomerGroups?.find((g) => g.name === "Delivery Address")?.id;
        const addressObj = activeCart?.customer?.metaData?.find((item) => item.key === groupId)?.value
          ? JSON.parse(activeCart?.customer?.metaData?.find((item) => item.key === groupId)?.value)
          : null;
        stateId = addressObj?.state || "";
      } else if (retailCustomerGroups.length > 0) {
        const groupId = retailCustomerGroups?.find((g) => g.name === "Address")?.id;
        const addressObj = activeCart?.customer?.metaData?.find((item) => item.key === groupId)?.value
          ? JSON.parse(activeCart?.customer?.metaData?.find((item) => item.key === groupId)?.value)
          : null;
        stateId = addressObj?.state || "";
      }
      const statesData = JSON.parse(localStorage.getItem("statesData")) || [];
      if (stateId) {
        const isId = statesData.some((s) => s.RecordID === stateId);
        if (!isId) {
          const match = statesData.find((s) => s.Name?.toLowerCase() === stateId?.toLowerCase());
          stateId = match?.RecordID || "";
        }
      }
      const isSameState = !stateId || tillData?.tillAccess?.csBunit?.csRegionId === stateId;
      const csCurrencyId = tillData?.tillAccess?.csBunit?.currencies[0]?.csCurrencyId || "";
      let orders = [];
      const taxDetails = [];
      const taxMap = {};
      for (const item of activeCart.items) {
        if (!item.isGiftCard) {
          if (item.taxRate >= 0 && item.tax) {
            const taxRate = item.taxRate;
            const taxAmount = parseFloat(parseFloat(item.taxAmount)?.toFixed(precision));
            const nettotal = parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision));
            if (taxMap[taxRate]) {
              taxMap[taxRate].taxAmount += taxAmount;
              taxMap[taxRate].nettotal += nettotal;
            } else {
              taxMap[taxRate] = {
                taxAmount,
                nettotal,
                tax: isSameState
                  ? item.tax || item.cTaxId // intra-state
                  : item.interTaxId,
                taxRate,
                taxCategory: item.taxCategory,
                taxName: item.taxName,
              };
            }
          }

          if (!item.taxRate && item.children?.length > 0 && item.companion !== "Y") {
            for (const child of item.children) {
              if (child.taxRate && child.tax) {
                const taxRate = child.taxRate;
                const taxAmount = parseFloat(parseFloat(child.taxAmount)?.toFixed(precision));
                const nettotal = parseFloat(parseFloat(child.nettotal - child.taxAmount)?.toFixed(precision));
                if (taxMap[taxRate]) {
                  taxMap[taxRate].taxAmount += taxAmount;
                  taxMap[taxRate].nettotal += nettotal;
                } else {
                  taxMap[taxRate] = {
                    taxAmount,
                    nettotal,
                    tax: child.tax,
                    taxRate,
                    taxCategory: child.taxCategory,
                    taxName: child.taxName,
                  };
                }
              }
            }
          }
        }
      }

      const combinedTaxRates = Object.keys(taxMap).map((taxRate) => {
        const entry = taxMap[taxRate];
        taxDetails.push({
          csTaxID: entry.tax,
          taxableAmt: entry.nettotal,
          taxAmt: entry.taxAmount,
          taxRate,
          taxCategory: entry.taxCategory,
          taxName: entry.taxName,
        });
        return { csTaxID: entry.tax, taxableAmt: entry.nettotal, taxAmt: entry.taxAmount };
      });

      if (posConfig?.disableOfflineBilling === "Y") {
        const now = moment(new Date());
        const orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails")) || {
          orderStartTime: "",
          orderEndTime: "",
          paymentStartTime: "",
        };
        orderTimeDetails.orderEndTime = now.format("DD-MM-YYYY HH:mm:ss");
        const tillSessionId = tillSession?.tillSessionId || null;

        let activeCartAccumulationPoints = 0;
        if (activeCart.customer?.loyaltyLevel?.cwrLoyaltyLevelId) {
          const loyaltyLevelId = activeCart.customer.loyaltyLevel.cwrLoyaltyLevelId;
          const loyaltyData = await db.loyalityData.where("loyaltylevelId").equals(loyaltyLevelId).first();
          if (loyaltyData) {
            const eventCalenders = loyaltyData.loyaltyEventCalenders || [];
            const isEventActive = eventCalenders.length > 0 && eventCalenders.some((ec) => dateValidator(ec.startDate, ec.endDate));

            const applicableRule = (loyaltyData.LoyaltyAccumulation || []).find((item) => {
              const productValidation = item.mProductId ? activeCart.items.some((pc) => pc.mProductId === item.mProductId) : true;
              const categoryValidation = item.mProductCategoryId ? activeCart.items.some((pc) => pc.mProductCategoryId === item.mProductCategoryId) : true;
              if (isEventActive) {
                if (item.loyaltyEvent === "Y") {
                  return item.loyaltyEvent === "Y" && item.minPurchase <= Math.abs(activeCart.total) && productValidation && categoryValidation;
                } else {
                  return item.loyaltyEvent === "N" && item.minPurchase <= Math.abs(activeCart.total) && productValidation && categoryValidation;
                }
              }
              return item.loyaltyEvent === "N" && item.minPurchase <= Math.abs(activeCart.total) && productValidation && categoryValidation;
            });

            if (applicableRule) {
              const baseAmount = activeCart.total - activeCart.tax;
              if (tillData?.tillAccess?.csBunit?.enableLoyalty !== "Y") {
                activeCartAccumulationPoints = 0;
              } else if (activeCart?.discount > 0 && loyaltyData?.noLoyaltyOnDiscount === "Y") {
                activeCartAccumulationPoints = 0;
              } else if (activeCart?.redemptionPoints > 0 && loyaltyData?.noLoyaltyOnRedemption === "Y") {
                activeCartAccumulationPoints = 0;
              } else {
                activeCartAccumulationPoints = Number((applicableRule.pointsPerUnit * baseAmount).toFixed(3));
              }
            }
          }
        }

        // First check DB for pending orders (e.g. cancelled orders from clearCart)
        const pendingDbOrders = await db.orders.where("isSynced").equals(0).or("isSynced").equals(2).toArray();
        if (pendingDbOrders.length > 0) {
          // Pending DB orders exist (cancelled orders) -- sync those
          orders = pendingDbOrders;
        } else if (activeCart.items.length > 0 && activeCart.total !== undefined) {
          // No pending DB orders, cart has items -- build from live cart (regular payment)
          const tempCart =
            syncTrigger === "exchange" ? JSON.parse(localStorage.getItem("exchangeCartObj")) : localStorage.getItem("cartObj") ? JSON.parse(localStorage.getItem("cartObj")) : cart;
          orders = [
            {
              ...activeCart,
              payments: tempCart.payments,
              combinedTaxRates,
              taxDetails,
              accumulationPoints: activeCartAccumulationPoints,
              createdBy: tillData.tillAccess.csUserId,
              customerSearchKey: activeCart?.customer?.code || "",
              isSynced: 0,
              orderCompleted: activeCart.statusType === "layAway" ? false : true,
              orderDate: now.format("DD-MM-YYYY"),
              orderTime: now.format("DD-MM-YYYY HH:mm:ss"),
              orderTimeDetails,
              orderType: orderType?.cwrSaletype?.cwrSaletypeId,
              overPayedAmount: overPayedAmount || 0,
              syncAttempts: 0,
              tillSessionId,
              typeOrder: localStorage.getItem("homeDelivery") || "N",
            },
          ];
        } else {
          orders = [];
        }
      } else {
        orders = await db.orders.where("isSynced").equals(0).or("isSynced").equals(2).toArray();
      }

      const pendingOrdersCount = orders.length;
      if (pendingOrdersCount > 0) {
        if (eBillConfig.current.eBill === "Y") {
          sendWebHookData(orders);
        }
        for (let i = 0; i < pendingOrdersCount; i += 1) {
          const regularOrders = orders.filter((order) => {
            const layAwayStatus = order?.layAway || "N";
            const paidAmount = order.layAway === "Y" && posConfig?.advanceLayaway === "Y" && order.advancePayment <= 0 ? 0 + order?.paid : order?.paid || 0;
            const advancePayment = order?.advancePayment || 0;
            const totalAmount = order?.total || 0;
            const totalQty = order?.totalQty || 0;
            const isParked = order?.parked === "Y";
            const isCreditSaleInCart = order?.creditSale === "Y";
            const isRegularOrderWithPaid =
              !isCreditSaleInCart &&
              (posConfig?.advanceLayaway === "Y"
                ? layAwayStatus === "Y"
                  ? layAwayStatus === "Y" && paidAmount + advancePayment <= totalAmount && advancePayment <= 0 && order?.docType !== "Advance"
                  : layAwayStatus === "N" && paidAmount !== 0
                : layAwayStatus === "N" && paidAmount !== 0);

            const isRegularOrderWithoutPaid = !isCreditSaleInCart && (layAwayStatus === "N" || layAwayStatus === "Y") && paidAmount === 0;
            const isCancelledOrder = totalAmount === 0 && totalQty === 0;
            const isParkedOrder = isParked && paidAmount === 0;
            return isRegularOrderWithPaid || isRegularOrderWithoutPaid || isCancelledOrder || isParkedOrder;
          });
          const username = localStorage.getItem("username");
          const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
          const matchedRep = salesReps.find((rep) => rep.name === username);
          if (regularOrders.length > 0 && regularOrders[i]?.items?.length > 0) {
            const orderLines = [];
            const childItemMetaMap = new Map();
            for (let j = 0; j < regularOrders[i]?.items.length; j += 1) {
              if (regularOrders[i].items[j]?.isCanceled === "Y") continue;
              let unitTax = regularOrders[i].items[j].taxAmount / regularOrders[i].items[j].weight;
              unitTax = unitTax * (regularOrders[i].items[j].isReturn ? -1 : 1);

              let linesMeta = [];
              if (regularOrders[i].items[j].newCustomAttributes?.length > 0) {
                Object.entries(regularOrders[i].items[j].newCustomAttributes[0]).forEach(([key, value]) => {
                  linesMeta.push({
                    key: key,
                    value: value,
                  });
                });
              }

              if (regularOrders[i]?.items[j]?.approval?.length > 0) {
                const approval = regularOrders[i].items[j].approval[0];
                const keysToRemove = ["type", "min", "max", "roleId", "mPricingrulesId", "pin"];

                keysToRemove.forEach((key) => delete approval[key]);

                linesMeta.push({
                  key: "Approval",
                  value: JSON.stringify([approval]),
                });
              }

              const productAddons = [];

              if (regularOrders[i].items[j]?.childItems?.length > 0) {
                regularOrders[i].items[j]?.childItems.forEach((childItem) => {
                  const sp = parseFloat(parseFloat(childItem?.sunitprice || 0)?.toFixed(precision));
                  const quantity = childItem.weight * regularOrders[i].items[j].weight;
                  const grossUnit = sp;
                  const lineGross = parseFloat(parseFloat(sp * quantity)?.toFixed(precision));
                  const tax = taxIncludeFlag === "Y" ? lineGross - lineGross / (1 + childItem.taxRate / 100) : (lineGross * childItem.taxRate) / 100;
                  const unitTax = parseFloat(parseFloat(tax / quantity)?.toFixed(precision));
                  const lineTotal = parseFloat(parseFloat(lineGross + tax)?.toFixed(precision));

                  productAddons.push({
                    name: childItem.name,
                    price: sp,
                    addonProductId: childItem.mProductId,
                    qty: quantity,
                    lineGross: lineGross,
                    lineTax: tax,
                    lineTotal: lineTotal,
                    unitTax: unitTax,
                    grossUnit: grossUnit,
                    value: childItem.value,
                  });
                });
              } else if (regularOrders[i].items[j]?.selectedAddons?.length > 0) {
                regularOrders[i].items[j]?.selectedAddons.forEach((addon) => {
                  // const sp = parseFloat(parseFloat(childItem?.sunitprice || 0)?.toFixed(precision));
                  // const quantity = childItem.weight * regularOrders[i].items[j].weight;
                  // const grossUnit = sp;
                  // const lineGross = parseFloat(parseFloat(sp * quantity)?.toFixed(precision));
                  // const tax = taxIncludeFlag === "Y" ? lineGross - lineGross / (1 + childItem.taxRate / 100) : (lineGross * childItem.taxRate) / 100;
                  // const unitTax = parseFloat(parseFloat(tax / quantity)?.toFixed(precision));
                  // const lineTotal = parseFloat(parseFloat(lineGross + tax)?.toFixed(precision));

                  productAddons.push({
                    name: addon.name,
                    price: addon.price,
                    addonProductId: addon?.mAddonProduct?.mProductId || null,
                    qty: addon.weight,
                    lineGross: 0,
                    lineTax: 0,
                    lineTotal: 0,
                    unitTax: 0,
                    grossUnit: 0,
                  });
                });
              }
              const item = regularOrders[i].items[j];
              if (item?.realWeight)
                linesMeta.push({
                  key: item.name,
                  value: item?.realWeight.toString(),
                });
              const lineTaxableAmt = item.linenet !== null && item.linenet !== undefined && item.linenet !== 0 ? item.linenet : 0;
              if (Array.isArray(item.children) && item.children.length > 0 && item.companion !== "Y") {
                const childIDs = [];
                for (let k = 0; k < item.children.length; k++) {
                  const currentItem = item.children[k];
                  const childTaxableAmt = currentItem.linenet !== null && currentItem.linenet !== undefined && currentItem.linenet !== 0 ? currentItem.linenet : 0;
                  let unitTax = currentItem.taxAmount / currentItem.weight;
                  const sOrderlineID = uuidv4().replace(/-/g, "").toUpperCase();
                  const parsedDate = moment(
                    regularOrders[i].orderTime,
                    [
                      "YYYY-MM-DD HH:mm:ss", // case 1
                      "DD-MM-YYYY HH:mm:ss", // case 2
                    ],
                    true
                  );
                  orderLines.push({
                    csBunitId: currentItem.csBunitId || null,
                    wastage: currentItem.wastage === "Y" ? "Y" : null,
                    // sOrderlineID: uuidv4().replace(/-/g, "").toUpperCase(),
                    sOrderlineID: sOrderlineID,
                    childrenId: currentItem.childrenId || null,
                    sOrderlineReturnId: currentItem.sOrderlineReturnId || null,
                    created: moment(regularOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    createdby: regularOrders[i].createdBy,
                    updated: moment(regularOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    updatedby: regularOrders[i].createdBy,
                    deliveryDate: regularOrders[i]?.deliveryDate
                      ? moment(regularOrders[i]?.deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                      : moment(parsedDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    sOrderId: regularOrders[i].sOrderID,
                    line: (j + 1) * 10 + k,
                    description: currentItem.notes || "",
                    mProductId: currentItem.productId || currentItem.mProductId,
                    csUomId: currentItem.uom || currentItem.uomData?.[0]?.csUomId,
                    csTaxId: !stateId || tillData?.tillAccess?.csBunit?.csRegionId === stateId ? currentItem.tax || currentItem.cTaxId : currentItem.interTaxId,
                    qty: currentItem.weight,
                    unitprice: parseFloat(currentItem.realPrice) * (currentItem.isReturn ? -1 : 1),
                    discount: currentItem.discount,
                    returnline: currentItem.isReturn || false,
                    returnQty: currentItem.isReturn ? Math.abs(currentItem.weight) : 0,
                    mBatchId: currentItem.mBatchId || null,
                    batchNo: currentItem.batchno || null,
                    mPricingruleId: currentItem.mPricingruleId || null,
                    batchedForSale: currentItem.batchedForSale,
                    batchedForStock: currentItem.batchedForStock,
                    batchedProduct: currentItem.batchedProduct,
                    salesRepId: currentItem.salesRepId || regularOrders[i]?.salesRepId || matchedRep?.salesRepresentId || null,
                    multiPrice: currentItem.multiPrice,
                    discountTypeId: null,
                    discountAmount: null,
                    metaData: linesMeta,
                    unittax: unitTax > 0 ? parseFloat(parseFloat(unitTax)?.toFixed(precision)) : 0,
                    netstd: Math.abs(currentItem.netStd) ? parseFloat(currentItem.netStd) : 0,
                    listprice: currentItem.listPrice || 0,
                    linetax:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(currentItem.nettotal) > 0
                          ? parseFloat(parseFloat(currentItem.taxAmount)?.toFixed(precision))
                          : 0
                        : parseFloat(currentItem.linetax || 0),
                    linenet:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(currentItem.nettotal) > 0
                          ? parseFloat(parseFloat(currentItem.nettotal - currentItem.taxAmount)?.toFixed(precision))
                          : 0
                        : currentItem.linenet || 0,
                    linegross: posConfig?.disableOfflineBilling === "Y" ? (Math.abs(currentItem.nettotal) > 0 ? currentItem.nettotal : 0) : currentItem.linegross || 0,
                    linestd:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(currentItem.nettotal) > 0
                          ? parseFloat(
                              parseFloat(taxIncludeFlag === "Y" ? currentItem.sunitprice : currentItem.sunitprice * (1 + currentItem.taxRate / 100) * currentItem.weight)?.toFixed(
                                precision
                              )
                            )
                          : 0
                        : currentItem.linestd || 0,
                    netunit:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(currentItem.nettotal) > 0
                          ? parseFloat(
                              parseFloat(
                                isFinite(currentItem.nettotal / currentItem.weight)
                                  ? taxIncludeFlag === "Y"
                                    ? currentItem.nettotal / currentItem.weight / (1 + currentItem.taxRate / 100)
                                    : currentItem.salePrice
                                  : 0
                              )?.toFixed(precision)
                            )
                          : 0
                        : currentItem.netunit || 0,
                    grossunit:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(currentItem.nettotal) > 0
                          ? parseFloat(
                              parseFloat(
                                isFinite(currentItem.nettotal / currentItem.weight)
                                  ? taxIncludeFlag === "Y"
                                    ? currentItem.nettotal / currentItem.weight / (1 + currentItem.taxRate / 100)
                                    : currentItem.salePrice
                                  : 0
                              )?.toFixed(precision)
                            ) * (currentItem.isReturn ? -1 : 1)
                          : 0
                        : currentItem.grossunit || 0,
                    grossstd:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(currentItem.nettotal) > 0
                          ? roundTo(taxIncludeFlag === "Y" ? currentItem.sunitprice : currentItem.sunitprice * (1 + currentItem.taxRate / 100), precision)
                          : 0
                        : roundTo(currentItem.grossstd, precision) || 0,
                    grosslist:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(currentItem.nettotal) > 0
                          ? roundTo(taxIncludeFlag === "Y" ? currentItem.listPrice : currentItem.listPrice * (1 + currentItem.taxRate / 100), precision)
                          : 0
                        : roundTo(currentItem.grosslist, precision) || 0,
                    netlist:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(currentItem.nettotal) > 0
                          ? taxIncludeFlag === "Y"
                            ? currentItem.listPrice - parseFloat(parseFloat(currentItem.listPrice - currentItem.listPrice / (1 + currentItem.taxRate / 100))?.toFixed(precision))
                            : currentItem.listPrice
                          : 0
                        : parseFloat(currentItem.netList),
                    tax: [
                      {
                        csTaxID: !stateId || tillData?.tillAccess?.csBunit?.csRegionId === stateId ? currentItem.tax || currentItem.cTaxId : currentItem.interTaxId,
                        taxableAmt: parseFloat(parseFloat(childTaxableAmt).toFixed(precision) || 0),
                        taxAmt: parseFloat(parseFloat(currentItem.taxAmount || 0)?.toFixed(precision)),
                      },
                    ],
                    addons: productAddons,
                  });
                  childIDs.push({ sOrderlineID });
                }
                childItemMetaMap.set(item.name + "_" + j, {
                  name: item.name,
                  weight: item.weight,
                  discount: item.discount,
                  taxAmount: item.taxAmount,
                  realPrice: item.realPrice,
                  nettotal: item.nettotal,
                  children: childIDs,
                });
              } else {
                orderLines.push({
                  csBunitId: regularOrders[i].items[j].csBunitId || null,
                  wastage: regularOrders[i].items[j].wastage === "Y" ? "Y" : null,
                  sOrderlineID: uuidv4().replace(/-/g, "").toUpperCase(),
                  sOrderlineReturnId: regularOrders[i].items[j].sOrderlineReturnId || null,
                  created: moment(regularOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                  createdby: regularOrders[i].createdBy,
                  updated: moment(regularOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                  updatedby: regularOrders[i].createdBy,
                  deliveryDate: regularOrders[i]?.deliveryDate
                    ? moment(regularOrders[i]?.deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                    : moment(regularOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                  sOrderId: regularOrders[i].sOrderID,
                  line: (j + 1) * 10,
                  description: regularOrders[i].items[j].notes || "",
                  mProductId: regularOrders[i].items[j].productId || regularOrders[i].items[j].mProductId,
                  csUomId: regularOrders[i].items[j].uom || regularOrders[i].items[j]?.uomData?.[0]?.csUomId,
                  // csTaxId: regularOrders[i].items[j].tax || regularOrders[i].items[j].cTaxId,
                  csTaxId:
                    !stateId || tillData?.tillAccess?.csBunit?.csRegionId === stateId
                      ? regularOrders[i].items[j].tax || regularOrders[i].items[j].cTaxId
                      : regularOrders[i].items[j].interTaxId,
                  qty: regularOrders[i].items[j].weight,
                  unitprice: parseFloat(regularOrders[i].items[j].realPrice) * (regularOrders[i].items[j].isReturn ? -1 : 1),
                  discount: regularOrders[i].items[j].discount,
                  returnline: regularOrders[i].items[j].isReturn || false,
                  returnQty: regularOrders[i].items[j].isReturn ? Math.abs(regularOrders[i].items[j].weight) : 0,
                  mBatchId: regularOrders[i].items[j].mBatchId || null,
                  batchNo: regularOrders[i].items[j].batchno || null,
                  mPricingruleId: regularOrders[i].items[j].mPricingruleId || null,
                  batchedForSale: regularOrders[i].items[j].batchedForSale,
                  batchedForStock: regularOrders[i].items[j].batchedForStock,
                  batchedProduct: regularOrders[i].items[j].batchedProduct,
                  salesRepId: regularOrders[i].items[j]?.salesRepId || regularOrders[i]?.salesRepId || matchedRep?.salesRepresentId || null,
                  multiPrice: regularOrders[i].items[j].multiPrice,
                  discountTypeId: null,
                  discountAmount: null,
                  metaData: linesMeta,
                  unittax: unitTax > 0 ? parseFloat(parseFloat(unitTax)?.toFixed(precision)) : 0,
                  netstd: Math.abs(regularOrders[i].items[j].netStd) ? parseFloat(regularOrders[i].items[j].netStd) : 0,
                  listprice: regularOrders[i].items[j].listPrice || 0,
                  linetax:
                    posConfig?.disableOfflineBilling === "Y"
                      ? Math.abs(regularOrders[i].items[j].nettotal) > 0
                        ? parseFloat(parseFloat(regularOrders[i].items[j].taxAmount)?.toFixed(precision))
                        : 0
                      : parseFloat(regularOrders[i].items[j].linetax || 0),
                  linenet:
                    posConfig?.disableOfflineBilling === "Y"
                      ? Math.abs(regularOrders[i].items[j].nettotal) > 0
                        ? parseFloat(parseFloat(regularOrders[i].items[j].nettotal - regularOrders[i].items[j].taxAmount)?.toFixed(precision))
                        : 0
                      : regularOrders[i].items[j].linenet || 0,
                  linegross:
                    posConfig?.disableOfflineBilling === "Y"
                      ? Math.abs(regularOrders[i].items[j].nettotal) > 0
                        ? regularOrders[i].items[j].nettotal
                        : 0
                      : regularOrders[i].items[j].linegross || 0,
                  linestd:
                    posConfig?.disableOfflineBilling === "Y"
                      ? Math.abs(regularOrders[i].items[j].nettotal) > 0
                        ? parseFloat(
                            parseFloat(
                              taxIncludeFlag === "Y"
                                ? regularOrders[i].items[j].sunitprice
                                : regularOrders[i].items[j].sunitprice * (1 + regularOrders[i].items[j].taxRate / 100) * regularOrders[i].items[j].weight
                            )?.toFixed(precision)
                          )
                        : 0
                      : regularOrders[i].items[j].linestd || 0,
                  netunit:
                    posConfig?.disableOfflineBilling === "Y"
                      ? Math.abs(regularOrders[i].items[j].nettotal) > 0
                        ? parseFloat(
                            parseFloat(
                              isFinite(regularOrders[i].items[j].nettotal / regularOrders[i].items[j].weight)
                                ? taxIncludeFlag === "Y"
                                  ? regularOrders[i].items[j].nettotal / regularOrders[i].items[j].weight / (1 + regularOrders[i].items[j].taxRate / 100)
                                  : regularOrders[i].items[j].salePrice
                                : 0
                            )?.toFixed(precision)
                          )
                        : 0
                      : regularOrders[i].items[j].netunit || 0,
                  grossunit:
                    posConfig?.disableOfflineBilling === "Y"
                      ? Math.abs(regularOrders[i].items[j].nettotal) > 0
                        ? parseFloat(
                            parseFloat(
                              isFinite(regularOrders[i].items[j].nettotal / regularOrders[i].items[j].weight)
                                ? taxIncludeFlag === "Y"
                                  ? regularOrders[i].items[j].nettotal / regularOrders[i].items[j].weight / (1 + regularOrders[i].items[j].taxRate / 100)
                                  : regularOrders[i].items[j].salePrice
                                : 0
                            )?.toFixed(precision)
                          ) * (regularOrders[i].items[j].isReturn ? -1 : 1)
                        : 0
                      : regularOrders[i].items[j].grossunit || 0,
                  grossstd:
                    posConfig?.disableOfflineBilling === "Y"
                      ? Math.abs(regularOrders[i].items[j].nettotal) > 0
                        ? roundTo(
                            taxIncludeFlag === "Y" ? regularOrders[i].items[j].sunitprice : regularOrders[i].items[j].sunitprice * (1 + regularOrders[i].items[j].taxRate / 100),
                            precision
                          )
                        : 0
                      : roundTo(regularOrders[i].items[j].grossstd, precision) || 0,
                  grosslist:
                    posConfig?.disableOfflineBilling === "Y"
                      ? Math.abs(regularOrders[i].items[j].nettotal) > 0
                        ? roundTo(
                            taxIncludeFlag === "Y" ? regularOrders[i].items[j].listPrice : regularOrders[i].items[j].listPrice * (1 + regularOrders[i].items[j].taxRate / 100),
                            precision
                          )
                        : 0
                      : roundTo(regularOrders[i].items[j].grosslist, precision) || 0,
                  netlist:
                    posConfig?.disableOfflineBilling === "Y"
                      ? Math.abs(regularOrders[i].items[j].nettotal) > 0
                        ? taxIncludeFlag === "Y"
                          ? regularOrders[i].items[j].listPrice -
                            parseFloat(
                              parseFloat(regularOrders[i].items[j].listPrice - regularOrders[i].items[j].listPrice / (1 + regularOrders[i].items[j].taxRate / 100))?.toFixed(
                                precision
                              )
                            )
                          : regularOrders[i].items[j].listPrice
                        : 0
                      : parseFloat(regularOrders[i].items[j].netList),
                  tax: [
                    {
                      csTaxID:
                        !stateId || tillData?.tillAccess?.csBunit?.csRegionId === stateId
                          ? regularOrders[i].items[j].tax || regularOrders[i].items[j].cTaxId
                          : regularOrders[i].items[j].interTaxId,
                      taxableAmt: parseFloat(parseFloat(lineTaxableAmt).toFixed(precision) || 0),
                      taxAmt: parseFloat(parseFloat(regularOrders[i].items[j].taxAmount)?.toFixed(precision)),
                    },
                  ],
                  addons: productAddons,
                });
              }
            }
            let metaData = [];
            const paymentsList = [];

            const paymentMetaData = [];
            let amtMax = -100000000000000000000;
            let maxFinPaymentMethod;
            const isReturnOrder = regularOrders[i]?.isReturn === true || regularOrders[i]?.isReturn === "Y" || regularOrders[i]?.total < 0;

            for (const payment of regularOrders[i]?.payments?.flat() || []) {
              let amount = parseFloat(payment.amount || 0);

              // 🔥 apply only for return
              if (isReturnOrder) {
                amount = -Math.abs(amount);
              }

              // ---------- META ----------
              paymentMetaData.push({
                [payment.name]: parseFloat(amount.toFixed(precision)), // ← FIXED
              });

              // ---------- MAX PAYMENT METHOD ----------
              if (amtMax < Math.abs(amount)) {
                // ← use abs for compare
                amtMax = Math.abs(amount);
                maxFinPaymentMethod = payment.finPaymentmethodId;
              }

              // ---------- CARD ----------
              if (payment.name.toLowerCase() === "card") {
                if (payment.integratedPayment === true) {
                  paymentsList.push({
                    finPaymentmethodID: payment.finPaymentmethodId,
                    amount: parseFloat(amount.toFixed(precision)), // ← FIXED
                    transactionResponse: regularOrders[i].cardPaymentData?.response?.length > 0 ? regularOrders[i].cardPaymentData?.response[0]?.resultMessage : "",
                    transactionId: null,
                    cardType: "",
                    cardNo: "",
                    transactionTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                    authorizationCode: null,
                    metaData: [
                      {
                        key: "payload",
                        value: regularOrders[i].cardPaymentData?.payload?.length > 0 ? JSON.stringify(regularOrders[i].cardPaymentData?.payload[0]) : "",
                      },
                      {
                        key: "response",
                        value: regularOrders[i].cardPaymentData?.response?.length > 0 ? JSON.stringify(regularOrders[i].cardPaymentData?.response[0]) : "",
                      },
                    ],
                  });
                } else {
                  paymentsList.push({
                    finPaymentmethodID: payment.finPaymentmethodId,
                    amount: parseFloat(amount.toFixed(precision)), // ← FIXED
                    transactionResponse: null,
                    transactionId: regularOrders[i]?.cardPaymentData?.manual?.transactionId || null,
                    cardType: regularOrders[i].cardPaymentData?.manual?.cardType || null,
                    cardNo: regularOrders[i].cardPaymentData?.manual?.cardNumber || null,
                    transactionTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                    authorizationCode: payment.authorization || null,
                    metaData: [],
                  });
                }
              } else if (payment?.isBankTransfer === "Y") {
                paymentsList.push({
                  finPaymentmethodID: payment.finPaymentmethodId,
                  amount: payment.amount,
                  fin_account_id: payment?.financialAccount || null,
                  date: payment?.transactionDate ? moment(payment.transactionDate).format("YYYY-MM-DD") : null,
                  Image_url: payment?.financialFile || null,
                  transactionId: payment?.transactionId || null,
                });
              } else {
                // ---------- CASH / WALLET ----------
                paymentsList.push({
                  finPaymentmethodID: payment.finPaymentmethodId,
                  amount: parseFloat(amount.toFixed(precision)), // ← FIXED
                });
              }
            }

            if (paymentMetaData.length > 0) {
              const details = [
                ...paymentMetaData,
                { "Bill Amount": regularOrders[i]?.total },
                { change: regularOrders[i]?.change },
                { "Round Off": regularOrders[i]?.roundOff },
                { "Over Payment": regularOrders[i]?.overPayedAmount },
              ];

              if (regularOrders[i]?.tenderedAmount > 0) {
                details.push({ "Cash Received": parseFloat(parseFloat(regularOrders[i]?.tenderedAmount)?.toFixed(precision)) });
              }

              metaData.push({
                key: "Payment Details",
                value: JSON.stringify(details),
              });
            }

            let tableData = JSON.parse(localStorage.getItem("tableName"));
            if (localStorage.getItem("dineIn") === "Y") {
              const keysToCheck = ["guestName", "guestType", "cwrFbTableId", "cwrFbsectionId", "noOfPersons", "referredBy", "orderId"];
              // localStorage.removeItem("tableName");
              for (const key of keysToCheck) {
                if (tableData?.hasOwnProperty(key)) {
                  metaData.push({
                    key: key,
                    // value: tableData[key],
                    value: key === "noOfPersons" ? String(tableData[key]) : tableData[key],
                  });
                }
              }
            }

            if (regularOrders[i]?.orderTimeDetails) {
              Object.keys(regularOrders[i].orderTimeDetails).forEach((obj) => {
                metaData.push({
                  key: obj,
                  value: regularOrders[i].orderTimeDetails[obj],
                });
              });
            }
            let tcsCharges = [];

            const tcsValue = Number(regularOrders[i]?.tcs) > 0 ? Number(regularOrders[i]?.tcs).toFixed(2) : Number(activeCart?.tcs) > 0 ? Number(activeCart?.tcs).toFixed(2) : null;
            const tcsId = saleTypeData?.additionalCharges?.find((c) => c.chargeType === "TCS")?.additionalChargesId;
            if (tcsValue) {
              tcsCharges.push({
                amount: tcsValue,
                additionalChargesId: tcsId || null,
              });
            }
            const tcsDetails = regularOrders[i].items.map((item) => ({
              productId: item.productId || item.mProductId || null,
              amount: Number(item.itemTcs) > 0 ? Number(item.itemTcs).toFixed(2) : "0.00",
              additionalChargesId: tcsId || null,
            }));

            if (tcsDetails.length > 0) {
              metaData.push({
                key: "tcsDetails",
                value: JSON.stringify(tcsDetails),
              });
            }
            let giftCards = [];
            regularOrders[i]?.giftCardData?.map((res) => {
              giftCards.push({
                redeemRefNo: res.redemptionId || null,
                cardNo: res.number || null,
                referenceNo: res.refId || null,
              });
            });

            if (Array.isArray(regularOrders[i]?.items)) {
              if (childItemMetaMap.size > 0) {
                const customMixMeta = [];

                childItemMetaMap.forEach((metaObj) => {
                  customMixMeta.push(metaObj);
                });

                metaData.push({
                  key: "Custom Mix",
                  value: JSON.stringify(customMixMeta),
                });
              }
            }

            const couponData = JSON.parse(localStorage.getItem("couponAdditionalInfo"));

            if (couponData) {
              metaData.push({
                key: "Coupon Data",
                value: JSON.stringify(couponData),
              });
            }

            const discountData = JSON.parse(localStorage.getItem("discountAdditionalInfo"));

            if (discountData) {
              metaData.push({
                key: "Discount Data",
                value: JSON.stringify(discountData),
              });
            }
            const salesReturnData = JSON.parse(localStorage.getItem("salesReturnData"));

            if (salesReturnData) {
              metaData.push({
                key: "Sales Return Data",
                value: JSON.stringify(salesReturnData),
              });
            }

            // Cancel Parked Bill
            const billParkingData = JSON.parse(localStorage.getItem("billParkingData"));

            if (billParkingData?.remarks?.trim()) {
              metaData.push({
                key: "Bill parking",
                value: JSON.stringify({
                  remarks: billParkingData.remarks.trim(),
                }),
              });
            }
            if (documents?.length > 0) {
              const panDoc = documents.find((doc) => doc.docName === "PAN Card");
              const passportDoc = documents.find((doc) => doc.docName === "Passport");
              if (panDoc?.docUrl) {
                metaData.push({
                  key: "Pan Card",
                  value: panDoc.docUrl,
                });
              }
              if (passportDoc?.docUrl) {
                metaData.push({
                  key: "Passport",
                  value: passportDoc.docUrl,
                });
              }
            }

            let storeOpsTillID;
            const tillEvent = await db?.tillEvents?.where("tillSessionId")?.equals(tillSession?.tillSessionId)?.first();

            if (tillEvent) {
              storeOpsTillID = tillEvent?.storeDailyOpsTillid;
            }
            const isLoyaltyEnabled =
              (posConfig?.enableLoyalty || "N") === "N" || ((posConfig?.enableLoyalty || "N") === "Y" && (posConfig?.disablePOSLoyaltyCalculation || "N") === "N");
            if (!regularOrders[i] || !regularOrders[i].items) continue;
            const parsedDate = moment(
              regularOrders[i].orderTime,
              [
                "YYYY-MM-DD HH:mm:ss", // case 1
                "DD-MM-YYYY HH:mm:ss", // case 2
              ],
              true
            );
            const returnCustomerIdFromMemory =
              activeCart.isReturn === true || activeCart.isReturn === "Y" ? JSON.parse(localStorage.getItem("refundReturnCustomerId") || "null") : null;
            let sCustomerId = null;
            const customerAddressIds = JSON.parse(localStorage.getItem("customerAddressIds") || "{}");
            if (retailCustomerFields && retailCustomerFields.length > 0) {
              const sId = regularOrders[i]?.customer?.sCustomer?.sCustomerID;
              const newB2bId = regularOrders[i]?.customer?.newB2bCustomerId;
              if (localStorage.getItem("isB2bEnabled") === "true") {
                if (customerAddressIds?.customerId) {
                  sCustomerId = customerAddressIds.customerId;
                } else if (sId) {
                  sCustomerId = sId;
                } else if (newB2bId) {
                  sCustomerId = newB2bId;
                } else {
                  sCustomerId = null;
                }
              } else {
                sCustomerId = null;
              }
            } else {
              const sId = regularOrders[i]?.customer?.sCustomer?.sCustomerID;
              if (sId) {
                sCustomerId = sId;
              } else {
                sCustomerId = tillData.tillAccess.csBunit.b2cCustomer.sCustomer.sCustomerID;
              }
            }
            const exchangeCartData = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
            if (posConfig) posConfig.disablePOSLoyaltyCalculation = posConfig?.disablePOSLoyaltyCalculation || "N";
            const nextBusinessDate = localStorage.getItem("nextBusinessDate")
              ? localStorage.getItem("nextBusinessDate")
              : moment(parsedDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
            // Build companions array from items where companion === "Y"
            const companions = [];
            for (const item of regularOrders[i].items) {
              if (item.companion === "Y" && Array.isArray(item.children) && item.children.length > 0) {
                for (const child of item.children) {
                  companions.push({
                    productId: item.productId, // parent item's productId
                    companionProductId: child.companion_product_id || child.productId, // from children
                    qty: item.weight ?? 1, // qty from child or parent
                  });
                }
              }
            }
            const orderJson = {
              sOrderID: regularOrders[i].sOrderID,
              returnCustomerId: returnCustomerIdFromMemory?.cwrCustomerId || null,
              cSClientID: tillData.tillAccess.csClientId,
              cSBunitID: tillData.tillAccess.csBunit.csBunitId,
              created: moment(parsedDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
              createdby: regularOrders[i].createdBy,
              updated: moment(parsedDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
              updatedby: regularOrders[i].createdBy,
              csDoctypeId: tillData.tillAccess.csBunit.cwrCsDoctypeId,
              sCustomerId: sCustomerId,
              sCustomerBillingId:
                retailCustomerFields && retailCustomerFields.length > 0 ? customerAddressIds?.billingId || null : tillData.tillAccess.csBunit.customerAddress?.sCustomerAddressID,
              sCustomerShippingId:
                retailCustomerFields && retailCustomerFields.length > 0 ? customerAddressIds?.shippingId || null : tillData.tillAccess.csBunit.customerAddress?.sCustomerAddressID,
              sPricelistId: tillData.tillAccess.csBunit.cwrSpricelistId,
              documentno: regularOrders[i].documentno,
              dateordered: nextBusinessDate,
              datepromised: regularOrders[i].deliveryDate
                ? moment(regularOrders[i].deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                : moment(parsedDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
              csPaymenttermID: null,
              finPaymentmethodId: regularOrders[i].layAway === "N" && maxFinPaymentMethod ? maxFinPaymentMethod : null,
              csCurrencyId: csCurrencyId,
              mWarehouseId: tillData.tillAccess.csBunit.mWarehouse.mWarehouseID,
              cwrLongitude: "",
              cwrLatitude: "",
              csUserId: tillData.tillAccess.csUserId,
              cwrB2cCustomerId: regularOrders[i].customer?.cwrCustomerId ? regularOrders[i].customer?.cwrCustomerId : regularOrders[i].customer?.b2cCustomerId,
              orderreference: "",
              cwrPayref: "",
              cwrPayremarks: "",
              description: regularOrders[i].description || "",
              storeDailyOpsTillid: storeOpsTillID,
              cwrTillId: tillData.tillAccess.cwrTill.cwrTillID,
              redemption: isLoyaltyEnabled ? regularOrders[i].redemptionPoints : 0,
              accumulation: isLoyaltyEnabled ? regularOrders[i].accumulationPoints : 0,
              redeemRefId: regularOrders[i].referenceId,
              roundoff: parseFloat(parseFloat(regularOrders[i].roundOff)?.toFixed(precision)) || 0,
              cwrProductQty: regularOrders[i].totalQty,
              cwrProductCount: regularOrders[i].totalQty,
              ofdStatus: "Delivered",
              ofdIspaid: "Y",
              posLoyaltyCalculation: posConfig?.disablePOSLoyaltyCalculation,
              mPricingruleId: regularOrders[i].mPricingruleId ?? null,
              cwrSaletypeId: regularOrders[i]?.saleType?.cwrSaletypeId || saleTypeId,
              salesRepId: regularOrders[i]?.salesRepId || matchedRep?.salesRepresentId || null,
              discAmount: parseFloat(parseFloat(regularOrders[i].discount)?.toFixed(precision)),
              creditReferenceNo: regularOrders[i]?.referenceId ?? null,
              creditAmount: `${regularOrders[i].isReturn && regularOrders[i].customer?.iscredit ? -regularOrders[i].creditAmount : regularOrders[i].creditAmount}`,
              creditSale: localStorage.getItem("isCreditSale") === "true" && posConfig?.generateInvoiceForCreditSale !== "Y" ? "Y" : "N",
              metaData: metaData,
              giftCard: giftCards,
              pricingCoupon: [
                {
                  mPricingCouponId: regularOrders[i]?.couponInput?.[0]?.mPricingCouponId || null,
                  redemptionCount: regularOrders[i].couponRedemptionCount ? parseInt(regularOrders[i].couponRedemptionCount) : null,
                  referenceId: regularOrders[i]?.couponInput?.[0]?.referenceId || null,
                  couponCode: regularOrders[i]?.couponInput?.[0]?.couponCode || null,
                },
              ],
              companions: companions,
              orderTotal: regularOrders[i].total,
              nettotal:
                parseFloat(parseFloat(regularOrders[i].total - regularOrders[i].tax)?.toFixed(precision)) - parseFloat(parseFloat(regularOrders[i].tcs || 0)?.toFixed(precision)),
              taxamt: parseFloat(parseFloat(regularOrders[i].tax)?.toFixed(precision)),
              isReturn: regularOrders[i].items.some((f) => f.isReturn) ? "Y" : "N",
              sOrderReturnId: regularOrders[i].items?.[0]?.sOrderReturnId || exchangeCartData?.returnsOrderId || null,
              layAway: regularOrders[i].layAway || null,
              payments:
                (localStorage.getItem("selectedReturnType") === "STORE_CREDIT" || localStorage.getItem("selectedReturnType") === "EXCHANGE") && regularOrders[i].isReturn
                  ? []
                  : paymentsList,
              tax: regularOrders[i].combinedTaxRates ? regularOrders[i].combinedTaxRates : [],
              line: orderLines,
              charges: tcsCharges,
              estimateId: regularOrders[i]?.estimateId || null,
              b2bOrder: localStorage.getItem("isB2bEnabled") === "true" ? "Y" : "N",
              revenueCategoryId: JSON.parse(localStorage.getItem("selectedRevenueCategory"))?.revenueCategoryId || null,
              tableId: regularOrders[i]?.tableId || null,
            };

            const stringifiedData = JSON.stringify(orderJson);
            const newStringifiedFields = stringifiedData.replace(/\\"/g, '\\"');
            const newStringRequest = JSON.stringify(newStringifiedFields);
            const orderObj = JSON.parse(JSON.parse(newStringRequest));

            const paramsInput = {
              query: `
                    mutation {
                      posOrderProcessor1(
                        tillId: "${tillData.tillAccess.cwrTill.cwrTillID}",
                        orderId: "${regularOrders[i].sOrderID}",
                        documentNo: ${posConfig?.disableOfflineBilling !== "Y" ? `"${regularOrders[i].documentno}"` : null},
                        orderJson: ${newStringRequest}
                      ) {
                        documentno
                        status
                        message
                      }
                    }
                  `,
            };
            if (posConfig?.disableOfflineBilling === "Y") {
              setLoading(true);
            }
            try {
              const response = await posOrderProcessor1(paramsInput);
              const result = response.data.data.posOrderProcessor1;
              const { status, documentno } = result;
              const orderId = cart?.sOrderID;
              setPendingIRNOrderId(orderId);
              if (status === "200") {
                if (posConfig?.disableOfflineBilling !== "Y") {
                  console.info(`Order ${regularOrders[i].documentno} synced to Server`);
                  db.orders.where("sOrderID").equals(regularOrders[i].sOrderID).modify({ isSynced: 1 });
                } else if (posConfig?.disableOfflineBilling === "Y" && posConfig?.saveParkedBills !== "Y") {
                  console.info(`Order ${documentno} synced to Server`);
                  message.success(`Order ${documentno} Created Successfully`);
                  setInvoiceProcessing("SUCCESS");
                  const dbOrderExists = await db.orders.where("sOrderID").equals(regularOrders[i].sOrderID).first();
                  if (dbOrderExists) {
                    await db.orders.where("sOrderID").equals(regularOrders[i].sOrderID).modify({ isSynced: 1, documentno: documentno });
                  } else {
                    await processOrderApproved(regularOrders[i].sOrderID, documentno, 1);
                    if (localStorage.getItem("selectedReturnType") === "EXCHANGE") {
                      const exchangeCart = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
                      // ✅ Clear selectedReturnType IMMEDIATELY to prevent re-triggering
                      localStorage.removeItem("selectedReturnType");

                      if (exchangeCart?.items?.length > 0) {
                        const newCart = {
                          ...exchangeCart,
                          isReturn: false,
                        };

                        setCart(newCart);
                        localStorage.setItem("cartObj", JSON.stringify(newCart));
                        await syncOrders("exchange");
                      }
                    }
                  }
                } else if (posConfig?.saveParkedBills === "Y") {
                  // Check if this order already exists in DB (e.g. cancelled order saved by clearCart)
                  const dbOrderExists = await db.orders.where("sOrderID").equals(regularOrders[i].sOrderID).first();
                  if (dbOrderExists) {
                    // Order already in DB (cancelled order) -- just update isSynced
                    await db.orders.where("sOrderID").equals(regularOrders[i].sOrderID).modify({ isSynced: 1, documentno: documentno });
                  } else if (activeCart?.isRetrived === "Y") {
                    const csBunitId = tillData?.tillAccess?.csBunit?.csBunitId;
                    const cwrPosCartId = JSON.parse(localStorage.getItem("cartObj"))?.cwr_pos_cart_id || null;
                    const cwrTillId = tillData?.tillAccess?.cwrTill?.cwrTillID;
                    const status = "CO";

                    const cartItems = JSON.parse(localStorage.getItem("cartObj"));

                    const cartPayload = {
                      csBunitId,
                      cwrPosCartId,
                      cwrTillId,
                      status,
                      cartItems,
                    };

                    const response = await upsertCart(cartPayload);
                    if (response?.status === 200) {
                      await processOrderApproved(regularOrders[i].sOrderID, documentno, 1);
                    } else {
                      message.warning("Something is wrong in upsertCart service");
                    }
                  } else {
                    await processOrderApproved(regularOrders[i].sOrderID, documentno, 1);
                    if (localStorage.getItem("selectedReturnType") === "EXCHANGE") {
                      const exchangeCart = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
                      // ✅ Clear selectedReturnType IMMEDIATELY to prevent re-triggering
                      localStorage.removeItem("selectedReturnType");

                      if (exchangeCart?.items?.length > 0) {
                        const newCart = {
                          ...exchangeCart,
                          isReturn: false,
                        };

                        setCart(newCart);
                        localStorage.setItem("cartObj", JSON.stringify(newCart));
                        await syncOrders("exchange");
                      }
                    }
                  }
                }
                if (posConfig?.disableOfflineBilling === "Y" && localStorage.getItem("isB2bEnabled") === "true") {
                  // setTimeout(async () => {
                  setShowIRNModal(true);
                  await fetchIRNDetails(orderId);
                  // }, 300);
                  setInvoiceProcessing("SUCCESS");
                  setIrnGenerating("LOADING");
                }
                const isB2bEnabled = localStorage.getItem("isB2bEnabled") === "true";
                if (posConfig?.disableOfflineBilling === "Y" && tillLayout === 4 && !isB2bEnabled) {
                  Modal.info({
                    icon: null,
                    okText: "Ok",
                    okButtonProps: {
                      style: {
                        display: "inline-block",
                        backgroundColor: "#4285F4",
                        borderColor: "#4285F4",
                        color: "#fff",
                        borderRadius: "4px",
                        padding: "8px 24px",
                        height: "auto",
                        fontWeight: "500",
                      },
                    },
                    content: (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "20px 0",
                        }}
                      >
                        {/* Invoice Icon with Checkmark */}
                        <div style={{ position: "relative", marginBottom: "16px" }}>
                          <div
                            style={{
                              width: "80px",
                              height: "90px",
                              backgroundColor: "#FFF9C4",
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              position: "relative",
                            }}
                          >
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                              <div style={{ width: "40px", height: "4px", backgroundColor: "#4CAF50", borderRadius: "2px" }}></div>
                              <div style={{ width: "30px", height: "4px", backgroundColor: "#E0E0E0", borderRadius: "2px" }}></div>
                              <div style={{ width: "35px", height: "4px", backgroundColor: "#E0E0E0", borderRadius: "2px" }}></div>
                              <div style={{ width: "25px", height: "4px", backgroundColor: "#E0E0E0", borderRadius: "2px" }}></div>
                            </div>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              bottom: "-5px",
                              right: "-5px",
                              width: "28px",
                              height: "28px",
                              backgroundColor: "#4CAF50",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <span style={{ color: "#fff", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                          </div>
                        </div>

                        {/* Invoice Number */}
                        <p style={{ margin: "8px 0", fontSize: "14px", fontWeight: "400", color: "#666" }}>{documentno}</p>

                        {/* Success Title */}
                        <p style={{ margin: "8px 0", fontSize: "20px", fontWeight: "600", color: "#0F0718" }}>Invoice Completed Successfully</p>

                        {/* Success Message */}
                        <p style={{ margin: "8px 0 24px 0", fontSize: "14px", fontWeight: "400", color: "#999", textAlign: "center" }}>
                          Your bill has been printed successfully.
                          <br />
                          Redirecting to new bill...
                        </p>

                        {/* Total Amount Box */}
                        <div
                          style={{
                            backgroundColor: "#F5F5F5",
                            borderRadius: "8px",
                            padding: "16px 32px",
                            textAlign: "center",
                            minWidth: "180px",
                          }}
                        >
                          <p style={{ margin: "0 0 4px 0", fontSize: "12px", fontWeight: "400", color: "#999" }}>Total Amount</p>
                          <p style={{ margin: "0", fontSize: "22px", fontWeight: "600", color: "#0F0718" }}>
                            {tillData?.tillAccess?.csBunit?.currencies[0]?.currSymbol}{" "}
                            {parseFloat(regularOrders[i]?.total?.toString()).toFixed(tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2)}
                          </p>
                        </div>
                      </div>
                    ),
                    centered: true,
                    style: {
                      top: 0,
                    },
                    bodyStyle: {
                      overflow: "hidden",
                    },
                    closable: false,
                  });
                }
                setCustomMixItems([]);
                setIsPanCustomer(false);
                localStorage.removeItem("couponAdditionalInfo");
                localStorage.removeItem("discountAppliedData");
                localStorage.removeItem("discountAdditionalInfo");
                customerForm.resetFields();
                localStorage.removeItem("tableName");
                localStorage.removeItem("salesReturnData");
                localStorage.removeItem("billParkingData");
                localStorage.removeItem("isB2bEnabled");
                localStorage.removeItem("isPanCustomer");
                localStorage.removeItem("isNriBilling");
                localStorage.removeItem("isCreditSale");
                localStorage.removeItem("refundReturnCustomerId");
                localStorage.removeItem("returnType");
                localStorage.removeItem("returnThisReceipt");
                localStorage.removeItem("isPreparedBill");
                localStorage.removeItem("customerAddressIds");
                localStorage.removeItem("refundCustomerEdit");
                setExchangeCartTcs(false);
                if (localStorage.getItem("selectedReturnType") === "STORE_CREDIT") {
                  localStorage.removeItem("selectedReturnType");
                }
                // localStorage.removeItem("selectedReturnType");
                // localStorage.removeItem("exchangeCartObj");
                setSelectedCoupon(null);
                setDisplayCustomerSearch(false);
                setIsRefundWalletOpen(false);
                setDocuments([]);
                setSupplyRegionProceed(false);
                setPanDrawerMode(null);
                let rfidData = [];
                if (posConfig?.generateLabelforReturnItems === "Y" && regularOrders[i]?.isReturn === true) {
                  // Print each item's QR codes individually
                  for (const item of regularOrders[i]?.items) {
                    // Create QR data with partNumber and batchGroup
                    const sanitize = (val) => String(val || "N/A").replace(/[,{}]/g, "");

                    const qrData = `productcode:${sanitize(item?.value)},batchno:${sanitize(item?.batchno)}`;

                    // Calculate total stickers for this item
                    const totalStickers = Math.abs(item.weight || 1) * 1;
                    // Print each sticker for this item
                    for (let i = 0; i < totalStickers; i++) {
                      const printData = {
                        elements: [
                          {
                            type: "qrcode",
                            content: qrData,
                            x: 8,
                            y: 15,
                            moduleSize: 4,
                          },
                          {
                            type: "text",
                            content: item.productBrandName || "N/A",
                            x: 260,
                            y: 20,
                            style: ["bold"],
                            addNewline: false,
                          },
                          {
                            type: "text",
                            content: item.value || "N/A",
                            x: 260,
                            y: 50,
                            style: ["bold"],
                            addNewline: false,
                          },
                          {
                            type: "text",
                            content: item.batchno || 0,
                            x: 260,
                            y: 80,
                            style: ["bold"],
                            addNewline: false,
                          },
                          {
                            type: "text",
                            content: item.realPrice || 0,
                            x: 260,
                            y: 105,
                            style: ["bold"],
                            addNewline: false,
                          },
                        ],
                        settings: {
                          copies: 1,
                          labelWidth: 80,
                          labelHeight: 40,
                        },
                      };

                      try {
                        const res = await fetch(`${printerURL}labelprinter`, {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify(printData),
                        });

                        if (!res.ok) {
                          throw new Error(`HTTP ${res.status}`);
                        }

                        console.log(`Sticker ${i + 1}/${totalStickers} → SUCCESS`);
                      } catch (err) {
                        console.error(`Sticker ${i + 1}/${totalStickers} → FAILED`, err);
                      }

                      // Always wait, success or fail
                      await new Promise((resolve) => setTimeout(resolve, 200));
                    }
                  }
                }
                await db.rfidData.toArray((products) => {
                  products.map((ele) => {
                    if (ele.tag_status === "SO") {
                      rfidData.push(` {
                                tagValue: "${ele.tag_value}"
                                taggingDate: null
                                batchNumber: null
                                batchId: null
                                warehouseId: null
                                tagStatus: "SO"
                                lastScannedDate: "${moment(new Date()).format("DD-MM-YYYY HH:mm:ss")}"
                                scannedBy: null
                                expirydate: null
                                customAttribute: null
                                tagType: null
                                productCode: "${ele.product_code}"
                                }`);
                    }
                  });
                });
                await RFIDTag(rfidData);
              } else {
                console.error("Failed Order Sync ====> ", response);
                const syncFailedCount = parseInt(regularOrders[i].syncAttempts) + 1;
                if (parseInt(regularOrders[i].syncAttempts) < 100) {
                  db.regularOrders.where("sOrderID").equals(regularOrders[i].sOrderID).modify({ syncAttempts: syncFailedCount });
                } else {
                  db.regularOrders.where("sOrderID").equals(regularOrders[i].sOrderID).modify({ isSynced: 2 });
                }
              }
            } catch (error) {
              console.log(error, "err------------>");
            } finally {
              setLoading(false);
            }
          } else {
            const layAwayOrders = orders.filter((order) => {
              const isCreditSale = order?.creditSale === "Y";
              // return order.layAway === "Y" && order.paid !== 0;
              return (order.layAway === "Y" && order.paid !== 0) || (isCreditSale && order.paid !== 0);
            });
            if (layAwayOrders.length > 0 && layAwayOrders[i]?.items?.length > 0) {
              const orderLines = [];
              const childItemMetaMap = new Map();
              for (let j = 0; j < layAwayOrders[i].items.length; j += 1) {
                if (layAwayOrders[i].items[j]?.isCanceled === "Y") continue;
                let unitPrice;
                if (layAwayOrders[i].items[j].weight > 0) {
                  unitPrice = layAwayOrders[i].items[j].realPrice;
                  unitPrice = parseFloat(parseFloat(unitPrice)?.toFixed(precision));
                } else {
                  unitPrice = 0;
                }
                let orderLineMeta = [];
                if (layAwayOrders[i]?.items[j]?.approval?.length > 0) {
                  orderLineMeta.push();
                }
                const item = layAwayOrders[i].items[j];

                if (Array.isArray(item.children) && item.children.length > 0 && item.companion !== "Y") {
                  const childIDs = [];
                  for (let k = 0; k < item.children.length; k++) {
                    let unitPrice;
                    const currentItem = item.children[k];
                    let unitTax = currentItem.taxAmount / currentItem.weight;
                    // const sOrderlineID = uuidv4().replace(/-/g, "").toUpperCase();
                    const sOrderlineID = currentItem.sOrderlineID ? currentItem.sOrderlineID : uuidv4().replace(/-/g, "").toUpperCase();
                    const lineTaxableAmt = currentItem?.linenet !== null && currentItem?.linenet !== undefined ? currentItem.linenet : 0;
                    orderLines.push({
                      sOrderlineID: sOrderlineID,
                      sOrderlineReturnId: currentItem.sOrderlineReturnId || null,
                      created: moment(layAwayOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                      createdby: layAwayOrders[i].createdBy,
                      updated: moment(layAwayOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                      updatedby: layAwayOrders[i].createdBy,
                      // deliveryDate: layAwayOrders[i]?.deliveryDate
                      //   ? moment(layAwayOrders[i]?.deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                      //   : momentylayAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                      deliveryDate: activeCart?.deliveryDate
                        ? moment(activeCart.deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                        : layAwayOrders[i]?.deliveryDate
                          ? moment(layAwayOrders[i].deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                          : moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                      sOrderId: layAwayOrders[i].sOrderID,
                      line: (j + 1) * 10 + k,
                      description: "",
                      mProductId: currentItem.productId ? currentItem.productId : currentItem.mProductId,
                      csUomId: currentItem.productId ? currentItem.uom : currentItem.uom?.csUomId || null,
                      csTaxId: currentItem.productId ? currentItem.tax : currentItem.tax?.csTaxID || null,
                      qty: currentItem.weight,
                      unitprice: currentItem.weight > 0 ? parseFloat(parseFloat(currentItem.realPrice)?.toFixed(precision)) : 0,
                      discount: currentItem.discount,
                      returnline: currentItem.isReturn ?? currentItem.returnline,
                      returnQty: currentItem.isReturn === true ? Math.abs(currentItem.weight) : 0,
                      mBatchId: currentItem.mBatchId || null,
                      batchNo: currentItem.batchno || null,
                      mPricingruleId: currentItem.mPricingruleId ?? null,
                      batchedForSale: currentItem.batchedForSale || null,
                      batchedForStock: currentItem.batchedForStock || null,
                      batchedProduct: currentItem.batchedProduct || null,
                      salesRepId: currentItem.salesRepId || layAwayOrders[i]?.salesRepId || null,
                      multiPrice: currentItem.multiPrice || null,
                      discountTypeId: null,
                      discountAmount: null,
                      unittax: currentItem.weight > 0 && currentItem.taxRate > 0 ? currentItem?.unitTax || currentItem?.unittax || 0 : 0,
                      metaData: orderLineMeta,
                      listprice: currentItem.weight > 0 ? currentItem?.listPrice : 0,
                      linetax:
                        posConfig?.disableOfflineBilling === "Y"
                          ? Math.abs(currentItem.nettotal) > 0
                            ? parseFloat(parseFloat(currentItem.taxAmount)?.toFixed(precision))
                            : 0
                          : parseFloat(currentItem.linetax || 0),
                      linenet:
                        posConfig?.disableOfflineBilling === "Y"
                          ? Math.abs(currentItem.nettotal) > 0
                            ? parseFloat(parseFloat(currentItem.nettotal - currentItem.taxAmount)?.toFixed(precision))
                            : 0
                          : currentItem.linenet || 0,
                      linegross: posConfig?.disableOfflineBilling === "Y" ? (Math.abs(currentItem.nettotal) > 0 ? currentItem.nettotal : 0) : currentItem.linegross || 0,
                      linestd:
                        posConfig?.disableOfflineBilling === "Y"
                          ? Math.abs(currentItem.nettotal) > 0
                            ? parseFloat(
                                parseFloat(
                                  taxIncludeFlag === "Y" ? currentItem.sunitprice : currentItem.sunitprice * (1 + currentItem.taxRate / 100) * currentItem.weight
                                )?.toFixed(precision)
                              )
                            : 0
                          : currentItem.linestd || 0,
                      netunit:
                        posConfig?.disableOfflineBilling === "Y"
                          ? Math.abs(currentItem.nettotal) > 0
                            ? parseFloat(
                                parseFloat(
                                  isFinite(currentItem.nettotal / currentItem.weight)
                                    ? taxIncludeFlag === "Y"
                                      ? currentItem.nettotal / currentItem.weight / (1 + currentItem.taxRate / 100)
                                      : currentItem.salePrice
                                    : 0
                                )?.toFixed(precision)
                              )
                            : 0
                          : currentItem.netunit || 0,
                      grossunit:
                        posConfig?.disableOfflineBilling === "Y"
                          ? Math.abs(currentItem.nettotal) > 0
                            ? parseFloat(
                                parseFloat(
                                  isFinite(currentItem.nettotal / currentItem.weight)
                                    ? taxIncludeFlag === "Y"
                                      ? currentItem.nettotal / currentItem.weight / (1 + currentItem.taxRate / 100)
                                      : currentItem.salePrice
                                    : 0
                                )?.toFixed(precision)
                              ) * (currentItem.isReturn ? -1 : 1)
                            : 0
                          : currentItem.grossunit || 0,
                      grossstd:
                        posConfig?.disableOfflineBilling === "Y"
                          ? Math.abs(currentItem.nettotal) > 0
                            ? roundTo(taxIncludeFlag === "Y" ? currentItem.sunitprice : currentItem.sunitprice * (1 + currentItem.taxRate / 100), precision)
                            : 0
                          : roundTo(currentItem.grossstd, precision) || 0,
                      grosslist:
                        posConfig?.disableOfflineBilling === "Y"
                          ? Math.abs(currentItem.nettotal) > 0
                            ? roundTo(taxIncludeFlag === "Y" ? currentItem.listPrice : currentItem.listPrice * (1 + currentItem.taxRate / 100), precision)
                            : 0
                          : roundTo(currentItem.grosslist, precision) || 0,
                      netlist:
                        posConfig?.disableOfflineBilling === "Y"
                          ? Math.abs(currentItem.nettotal) > 0
                            ? taxIncludeFlag === "Y"
                              ? currentItem.listPrice - parseFloat(parseFloat(currentItem.listPrice - currentItem.listPrice / (1 + currentItem.taxRate / 100))?.toFixed(precision))
                              : currentItem.listPrice
                            : 0
                          : parseFloat(currentItem.netList),
                      tax: [
                        {
                          csTaxID: layAwayOrders[i].taxDetails[0]?.csTaxID || "",
                          taxableAmt: parseFloat(parseFloat(lineTaxableAmt).toFixed(precision)),
                          taxAmt: parseFloat(parseFloat(currentItem.taxAmount)?.toFixed(precision) || 0),
                        },
                      ],
                    });
                    childIDs.push({ sOrderlineID });
                  }
                  childItemMetaMap.set(item.name + "_" + j, {
                    name: item.name,
                    weight: item.weight,
                    discount: item.discount,
                    taxAmount: item.taxAmount,
                    realPrice: item.realPrice,
                    nettotal: item.nettotal,
                    children: childIDs,
                  });
                } else {
                  orderLines.push({
                    sOrderlineID: layAwayOrders[i].items[j].sOrderlineID ? layAwayOrders[i].items[j].sOrderlineID : uuidv4().replace(/-/g, "").toUpperCase(),
                    sOrderlineReturnId: layAwayOrders[i].items[j].sOrderlineReturnId || null,
                    created: moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    createdby: layAwayOrders[i].createdBy,
                    updated: moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    updatedby: layAwayOrders[i].createdBy,
                    // deliveryDate: layAwayOrders[i]?.deliveryDate
                    //   ? moment(layAwayOrders[i]?.deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                    //   : moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    deliveryDate: activeCart?.deliveryDate
                      ? moment(activeCart.deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                      : layAwayOrders[i]?.deliveryDate
                        ? moment(layAwayOrders[i].deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                        : moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    sOrderId: layAwayOrders[i].sOrderID,
                    line: (j + 1) * 10,
                    description: "",
                    mProductId: layAwayOrders[i].items[j].productId ? layAwayOrders[i].items[j].productId : layAwayOrders[i].items[j].product.mProductId,
                    csUomId: layAwayOrders[i].items[j].productId ? layAwayOrders[i].items[j].uom : layAwayOrders[i].items[j].uom?.csUomId || null,
                    csTaxId: layAwayOrders[i].items[j].productId ? layAwayOrders[i].items[j].tax : layAwayOrders[i].items[j].tax?.csTaxID || null,
                    qty: layAwayOrders[i].items[j].weight,
                    unitprice: unitPrice || 0,
                    discount: layAwayOrders[i].items[j].discount,
                    returnline: layAwayOrders[i].items[j].isReturn ?? layAwayOrders[i].items[j].returnline,
                    returnQty: layAwayOrders[i].items[j].isReturn === true ? Math.abs(layAwayOrders[i].items[j].weight) : 0,
                    mBatchId: layAwayOrders[i].items[j].mBatchId || null,
                    batchNo: layAwayOrders[i].items[j].batchno || null,
                    mPricingruleId: layAwayOrders[i].items[j].mPricingruleId ?? null,
                    batchedForSale: layAwayOrders[i].items[j].batchedForSale || null,
                    batchedForStock: layAwayOrders[i].items[j].batchedForStock || null,
                    batchedProduct: layAwayOrders[i].items[j].batchedProduct || null,
                    salesRepId: layAwayOrders[i].items[j]?.salesRepId || layAwayOrders[i]?.salesRepId || null,
                    multiPrice: layAwayOrders[i].items[j].multiPrice || null,
                    discountTypeId: null,
                    discountAmount: null,
                    unittax:
                      layAwayOrders[i].items[j].weight > 0 && layAwayOrders[i].items[j].taxRate > 0
                        ? layAwayOrders[i].items[j]?.unitTax || layAwayOrders[i].items[j]?.unittax || 0
                        : 0,
                    metaData: orderLineMeta,
                    listprice: layAwayOrders[i].items[j].weight > 0 ? layAwayOrders[i].items[j].listPrice : 0,
                    linetax:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(layAwayOrders[i].items[j].nettotal) > 0
                          ? parseFloat(parseFloat(layAwayOrders[i].items[j].taxAmount)?.toFixed(precision))
                          : 0
                        : parseFloat(layAwayOrders[i].items[j].linetax || 0),
                    linenet:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(layAwayOrders[i].items[j].nettotal) > 0
                          ? parseFloat(parseFloat(layAwayOrders[i].items[j].nettotal - layAwayOrders[i].items[j].taxAmount)?.toFixed(precision))
                          : 0
                        : layAwayOrders[i].items[j].linenet || 0,
                    linegross:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(layAwayOrders[i].items[j].nettotal) > 0
                          ? layAwayOrders[i].items[j].nettotal
                          : 0
                        : layAwayOrders[i].items[j].linegross || 0,
                    linestd:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(layAwayOrders[i].items[j].nettotal) > 0
                          ? parseFloat(
                              parseFloat(
                                taxIncludeFlag === "Y"
                                  ? layAwayOrders[i].items[j].sunitprice
                                  : layAwayOrders[i].items[j].sunitprice * (1 + layAwayOrders[i].items[j].taxRate / 100) * layAwayOrders[i].items[j].weight
                              )?.toFixed(precision)
                            )
                          : 0
                        : layAwayOrders[i].items[j].linestd || 0,
                    netunit:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(layAwayOrders[i].items[j].nettotal) > 0
                          ? parseFloat(
                              parseFloat(
                                isFinite(layAwayOrders[i].items[j].nettotal / layAwayOrders[i].items[j].weight)
                                  ? taxIncludeFlag === "Y"
                                    ? layAwayOrders[i].items[j].nettotal / layAwayOrders[i].items[j].weight / (1 + layAwayOrders[i].items[j].taxRate / 100)
                                    : layAwayOrders[i].items[j].salePrice
                                  : 0
                              )?.toFixed(precision)
                            )
                          : 0
                        : layAwayOrders[i].items[j].netunit || 0,
                    grossunit:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(layAwayOrders[i].items[j].nettotal) > 0
                          ? parseFloat(
                              parseFloat(
                                isFinite(layAwayOrders[i].items[j].nettotal / layAwayOrders[i].items[j].weight)
                                  ? taxIncludeFlag === "Y"
                                    ? layAwayOrders[i].items[j].nettotal / layAwayOrders[i].items[j].weight / (1 + layAwayOrders[i].items[j].taxRate / 100)
                                    : layAwayOrders[i].items[j].salePrice
                                  : 0
                              )?.toFixed(precision)
                            ) * (layAwayOrders[i].items[j].isReturn ? -1 : 1)
                          : 0
                        : layAwayOrders[i].items[j].grossunit || 0,
                    grossstd:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(layAwayOrders[i].items[j].nettotal) > 0
                          ? roundTo(
                              taxIncludeFlag === "Y" ? layAwayOrders[i].items[j].sunitprice : layAwayOrders[i].items[j].sunitprice * (1 + layAwayOrders[i].items[j].taxRate / 100),
                              precision
                            )
                          : 0
                        : roundTo(layAwayOrders[i].items[j].grossstd, precision) || 0,
                    grosslist:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(layAwayOrders[i].items[j].nettotal) > 0
                          ? roundTo(
                              taxIncludeFlag === "Y" ? layAwayOrders[i].items[j].listPrice : layAwayOrders[i].items[j].listPrice * (1 + layAwayOrders[i].items[j].taxRate / 100),
                              precision
                            )
                          : 0
                        : roundTo(layAwayOrders[i].items[j].grosslist, precision) || 0,
                    netlist:
                      posConfig?.disableOfflineBilling === "Y"
                        ? Math.abs(layAwayOrders[i].items[j].nettotal) > 0
                          ? taxIncludeFlag === "Y"
                            ? layAwayOrders[i].items[j].listPrice -
                              parseFloat(
                                parseFloat(layAwayOrders[i].items[j].listPrice - layAwayOrders[i].items[j].listPrice / (1 + layAwayOrders[i].items[j].taxRate / 100))?.toFixed(
                                  precision
                                )
                              )
                            : layAwayOrders[i].items[j].listPrice
                          : 0
                        : parseFloat(layAwayOrders[i].items[j].netList),
                    tax: [
                      {
                        csTaxID: layAwayOrders[i].taxDetails[0]?.csTaxID || "",
                        taxableAmt: parseFloat(parseFloat(layAwayOrders[i].items[j].linenet)?.toFixed(precision) || 0),
                        taxAmt: parseFloat(parseFloat(layAwayOrders[i].items[j].taxAmount)?.toFixed(precision) || 0),
                      },
                    ],
                  });
                }
              }
              const paymentsList = [];
              let amtMax = -100000000000000000000;
              let maxFinPaymentMethod = null;
              for (let k = 0; k < layAwayOrders[i].payments.length; k += 1) {
                if (amtMax < parseFloat(layAwayOrders[i].payments[k].amount)) {
                  amtMax = parseFloat(layAwayOrders[i].payments[k].amount);
                  maxFinPaymentMethod = layAwayOrders[i].payments[k].finPaymentmethodId;
                }
                paymentsList.push({
                  finPaymentmethodID: layAwayOrders[i].payments[k].finPaymentmethodId,
                  amount: parseFloat(parseFloat(layAwayOrders[i].payments[k].amount).toFixed(2)),
                });
              }
              let tableData = JSON.parse(localStorage.getItem("tableName"));
              let metaData = [];
              if (localStorage.getItem("dineIn") === "Y") {
                const keysToCheck = ["guestName", "guestType", "cwrFbTableId", "cwrFbsectionId", "noOfPersons", "referredBy", "orderId"];
                // localStorage.removeItem("tableName");
                for (const key of keysToCheck) {
                  if (tableData.hasOwnProperty(key)) {
                    metaData.push({
                      key: key,
                      value: tableData[key],
                    });
                  }
                }
              }
              if (Array.isArray(layAwayOrders[i].items)) {
                if (childItemMetaMap.size > 0) {
                  const customMixMeta = [];

                  childItemMetaMap.forEach((metaObj) => {
                    customMixMeta.push(metaObj);
                  });

                  metaData.push({
                    key: "Custom Mix",
                    value: JSON.stringify(customMixMeta),
                  });
                }
              }
              let accumulationPoints;
              // if (cart.customer?.loyaltyLevel?.cwrLoyaltyLevelId) {
              //   const loyaltyLevelId = cart.customer.loyaltyLevel.cwrLoyaltyLevelId;
              //   const loyaltyData = await db.loyalityData.where("loyaltylevelId").equals(loyaltyLevelId).first();
              //   if (loyaltyData) {
              //     const eventCalenders = loyaltyData.loyaltyEventCalenders || [];
              //     const hasValidEventCalenders = eventCalenders.length > 0 ? dateValidator(eventCalenders[0].startDate, eventCalenders[0].endDate) : true;

              //     for (const item of loyaltyData.LoyaltyAccumulation || []) {
              //       const productValidation = item.mProductId ? cart.items.some((pc) => pc.mProductId === item.mProductId) : true;
              //       const categoryValidation = item.mProductCategoryId ? cart.items.some((pc) => pc.mProductCategoryId === item.mProductCategoryId) : true;
              //       const checkEventsCalender =
              //         item.loyaltyEvent === "Y" && eventCalenders.length > 0
              //           ? eventCalenders.some((i) => dateValidator(i.startDate, i.endDate))
              //           : item.loyaltyEvent === "Y" && eventCalenders.length === 0;

              //       if (
              //         (item.loyaltyEvent === "Y" &&
              //           item.minPurchase <= Math.abs(cart.total) &&
              //           productValidation &&
              //           categoryValidation &&
              //           hasValidEventCalenders &&
              //           checkEventsCalender) ||
              //         (item.loyaltyEvent === "N" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation)
              //       ) {
              //         accumulationPoints =
              //           tillData?.tillAccess?.csBunit?.enableLoyalty === "Y"
              //             ? cart?.discount > 0
              //               ? loyaltyData?.noLoyaltyOnDiscount === "Y"
              //                 ? 0
              //                 : parseFloat(parseFloat(item.pointsPerUnit * (cart.total - cart.tax))?.toFixed(3))
              //               : cart?.redemptionPoints > 0
              //               ? loyaltyData?.noLoyaltyOnRedemption === "Y"
              //                 ? 0
              //                 : parseFloat(parseFloat(item.pointsPerUnit * (cart.total - cart.tax))?.toFixed(3))
              //               : parseFloat(parseFloat(item.pointsPerUnit * (cart.total - cart.tax))?.toFixed(3))
              //             : 0;
              //         break;
              //       }
              //     }
              //   }
              // }
              if (activeCart.customer?.loyaltyLevel?.cwrLoyaltyLevelId) {
                const loyaltyLevelId = activeCart.customer.loyaltyLevel.cwrLoyaltyLevelId;
                const loyaltyData = await db.loyalityData.where("loyaltylevelId").equals(loyaltyLevelId).first();
                if (loyaltyData) {
                  const eventCalenders = loyaltyData.loyaltyEventCalenders || [];
                  // ✅ Check if any event calendar is active
                  const isEventActive = eventCalenders.length > 0 && eventCalenders.some((ec) => dateValidator(ec.startDate, ec.endDate));

                  // ✅ Select applicable accumulation rule
                  const applicableRule = (loyaltyData.LoyaltyAccumulation || []).find((item) => {
                    const productValidation = item.mProductId ? activeCart.items.some((pc) => pc.mProductId === item.mProductId) : true;
                    const categoryValidation = item.mProductCategoryId ? activeCart.items.some((pc) => pc.mProductCategoryId === item.mProductCategoryId) : true;
                    if (isEventActive) {
                      if (item.loyaltyEvent === "Y") {
                        return item.loyaltyEvent === "Y" && item.minPurchase <= Math.abs(activeCart.total) && productValidation && categoryValidation;
                      } else {
                        return item.loyaltyEvent === "N" && item.minPurchase <= Math.abs(activeCart.total) && productValidation && categoryValidation;
                      }
                    }

                    return item.loyaltyEvent === "N" && item.minPurchase <= Math.abs(activeCart.total) && productValidation && categoryValidation;
                  });

                  // ✅ Calculate accumulation points
                  if (applicableRule) {
                    const baseAmount = activeCart.total - activeCart.tax;

                    if (tillData?.tillAccess?.csBunit?.enableLoyalty !== "Y") {
                      accumulationPoints = 0;
                    } else if (activeCart?.discount > 0 && loyaltyData?.noLoyaltyOnDiscount === "Y") {
                      accumulationPoints = 0;
                    } else if (activeCart?.redemptionPoints > 0 && loyaltyData?.noLoyaltyOnRedemption === "Y") {
                      accumulationPoints = 0;
                    } else {
                      accumulationPoints = Number((applicableRule.pointsPerUnit * baseAmount).toFixed(3));
                    }
                  }
                }
              }
              // Build companions array from items where companion === "Y"
              const companions = [];
              for (const item of layAwayOrders[i].items) {
                if (item.companion === "Y" && Array.isArray(item.children) && item.children.length > 0) {
                  for (const child of item.children) {
                    companions.push({
                      productId: item.productId, // parent item's productId
                      companionProductId: child.companion_product_id || child.productId, // from children
                      qty: item.weight ?? 1, // qty from child or parent
                    });
                  }
                }
              }
              const orderJson = {
                sOrderID: layAwayOrders[i].sOrderID,
                cSClientID: tillData.tillAccess.csClientId,
                cSBunitID: tillData.tillAccess.csBunit.csBunitId,
                created: moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                createdby: layAwayOrders[i].createdBy,
                updated: moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                updatedby: layAwayOrders[i].createdBy,
                csDoctypeId: tillData.tillAccess.csBunit.cwrCsDoctypeId,
                sCustomerId: layAwayOrders[i]?.customer?.sCustomer?.sCustomerID
                  ? layAwayOrders[i].customer.sCustomer.sCustomerID
                  : tillData.tillAccess.csBunit.b2cCustomer.sCustomer.sCustomerID,
                sCustomerBillingId: tillData.tillAccess.csBunit.customerAddress?.sCustomerAddressID,
                sCustomerShippingId: tillData.tillAccess.csBunit.customerAddress?.sCustomerAddressID,
                sPricelistId: tillData.tillAccess.csBunit.cwrSpricelistId,
                documentno: layAwayOrders[i].documentno,
                dateordered: moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                datepromised: layAwayOrders[i].deliveryDate
                  ? moment(layAwayOrders[i].deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                  : moment(layAwayOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                csPaymenttermID: null,
                finPaymentmethodId: maxFinPaymentMethod || null,
                csCurrencyId: csCurrencyId,
                mWarehouseId: tillData.tillAccess.csBunit.mWarehouse.mWarehouseID,
                cwrLongitude: "",
                cwrLatitude: "",
                csUserId: tillData.tillAccess.csUserId,
                cwrB2cCustomerId: layAwayOrders[i].customer.cwrCustomerId,
                orderreference: "",
                cwrPayref: "",
                cwrPayremarks: "",
                description: "",
                isAdvance: layAwayOrders[i].statusType === "layAway" ? "Y" : "N",
                cwrTillId: tillData.tillAccess.cwrTill.cwrTillID,
                redemption: layAwayOrders[i].redemptionPoints || null,
                accumulation: accumulationPoints ?? layAwayOrders[i].accumulationPoints ?? null,
                roundoff: Math.abs(parseFloat(layAwayOrders[i].roundOff)?.toFixed(precision)) || 0,
                cwrProductQty: layAwayOrders[i].totalQty,
                cwrProductCount: layAwayOrders[i].totalQty,
                ofdStatus: "Delivered",
                ofdIspaid: "Y",
                mPricingruleId: layAwayOrders[i].mPricingruleId !== null && layAwayOrders[i].mPricingruleId !== undefined ? layAwayOrders[i].mPricingruleId : null,
                cwrSaletypeId: layAwayOrders[i].saleType.cwrSaletypeId || saleTypeId,
                salesRepId: layAwayOrders[i].salesRepId !== null && layAwayOrders[i].salesRepId !== undefined ? layAwayOrders[i].salesRepId : null,
                discAmount: layAwayOrders[i].discount,
                creditAmount: layAwayOrders[i].creditAmount,
                creditSale: layAwayOrders[i].isCreditSale === "Y" ? "Y" : "N",
                metaData: metaData,
                pricingCoupon: [
                  {
                    mPricingCouponId: layAwayOrders[i].mPricingCouponId || null,
                    redemptionCount: layAwayOrders[i].couponRedemptionCount ? parseInt(layAwayOrders[i].couponRedemptionCount) : null,
                    referenceId: layAwayOrders[i]?.couponInput?.length > 0 ? layAwayOrders[i].couponInput[0].referenceId : null,
                    couponCode: layAwayOrders[i]?.couponInput?.length > 0 ? layAwayOrders[i]?.couponInput?.[0]?.couponCode : null,
                  },
                ],
                companions: companions,
                orderTotal: layAwayOrders[i].total,
                isReturn: layAwayOrders[i].items.filter((f) => f.isReturn === true).length > 0 ? "Y" : "N",
                sOrderReturnId: layAwayOrders[i].items?.[0]?.sOrderReturnId || null,
                layAway: layAwayOrders[i].layAway,
                nettotal: parseFloat(parseFloat(layAwayOrders[i].total - layAwayOrders[i].tax)?.toFixed(precision)),
                taxamt: parseFloat(parseFloat(layAwayOrders[i].tax)?.toFixed(precision)),
                payments: paymentsList,
                line: orderLines,
                revenueCategoryId: JSON.parse(localStorage.getItem("selectedRevenueCategory"))?.revenueCategoryId || null,
              };

              const stringifiedData = JSON.stringify(orderJson);
              const newStringifiedFields = stringifiedData.replace(/\\"/g, '\\"');
              const newStringRequest = JSON.stringify(newStringifiedFields);

              const paramsInput = {
                query: `
                      mutation {
                        confirmPOSLayawayOrder1(
                          tillId: "${tillData.tillAccess.cwrTill.cwrTillID}",
                          orderId: "${layAwayOrders[i].sOrderID}",
                          documentNo: "${layAwayOrders[i].documentno}",
                          orderJson: ${newStringRequest}
                        ) {
                          documentno
                          status
                          message
                        }
                      }
                    `,
              };

              try {
                const response = await confirmPOSLayawayOrder1(paramsInput);
                const result = response.data.data.confirmPOSLayawayOrder1;
                const { status, documentno } = result;
                if (result.status === "200") {
                  if (posConfig?.disableOfflineBilling !== "Y") {
                    console.info(`Order ${layAwayOrders[i].documentno} synced to Server`);
                    db.orders.where("sOrderID").equals(layAwayOrders[i].sOrderID).modify({ isSynced: 1 });
                  } else if (posConfig?.disableOfflineBilling === "Y") {
                    // console.info(`Order ${documentno} synced to Server`);
                    if (posConfig?.disableOfflineBilling !== "Y") {
                      message.success(`Order ${documentno} Created Successfully`);
                    }
                    await processOrderApproved(activeCart.sOrderID, null, 1);
                  }

                  let rfidData = [];
                  if (posConfig?.disableOfflineBilling === "Y" && tillLayout === 4) {
                    Modal.info({
                      icon: null,
                      okText: "Ok",
                      okButtonProps: {
                        style: {
                          display: "inline-block",
                          backgroundColor: "#4285F4",
                          borderColor: "#4285F4",
                          color: "#fff",
                          borderRadius: "4px",
                          padding: "8px 24px",
                          height: "auto",
                          fontWeight: "500",
                        },
                      },
                      content: (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "20px 0",
                          }}
                        >
                          {/* Invoice Icon with Checkmark */}
                          <div style={{ position: "relative", marginBottom: "16px" }}>
                            <div
                              style={{
                                width: "80px",
                                height: "90px",
                                backgroundColor: "#FFF9C4",
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                position: "relative",
                              }}
                            >
                              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <div style={{ width: "40px", height: "4px", backgroundColor: "#4CAF50", borderRadius: "2px" }}></div>
                                <div style={{ width: "30px", height: "4px", backgroundColor: "#E0E0E0", borderRadius: "2px" }}></div>
                                <div style={{ width: "35px", height: "4px", backgroundColor: "#E0E0E0", borderRadius: "2px" }}></div>
                                <div style={{ width: "25px", height: "4px", backgroundColor: "#E0E0E0", borderRadius: "2px" }}></div>
                              </div>
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                bottom: "-5px",
                                right: "-5px",
                                width: "28px",
                                height: "28px",
                                backgroundColor: "#4CAF50",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <span style={{ color: "#fff", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                            </div>
                          </div>

                          {/* Invoice Number */}
                          <p style={{ margin: "8px 0", fontSize: "14px", fontWeight: "400", color: "#666" }}>{documentno}</p>

                          {/* Success Title */}
                          <p style={{ margin: "8px 0", fontSize: "20px", fontWeight: "600", color: "#0F0718" }}>Invoice Completed Successfully</p>

                          {/* Success Message */}
                          <p style={{ margin: "8px 0 24px 0", fontSize: "14px", fontWeight: "400", color: "#999", textAlign: "center" }}>
                            Your bill has been printed successfully.
                            <br />
                            Redirecting to new bill...
                          </p>

                          {/* Total Amount Box */}
                          <div
                            style={{
                              backgroundColor: "#F5F5F5",
                              borderRadius: "8px",
                              padding: "16px 32px",
                              textAlign: "center",
                              minWidth: "180px",
                            }}
                          >
                            <p style={{ margin: "0 0 4px 0", fontSize: "12px", fontWeight: "400", color: "#999" }}>Total Amount</p>
                            <p style={{ margin: "0", fontSize: "22px", fontWeight: "600", color: "#0F0718" }}>
                              {tillData?.tillAccess?.csBunit?.currencies[0]?.currSymbol}{" "}
                              {parseFloat(layAwayOrders[i]?.total?.toString()).toFixed(tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2)}
                            </p>
                          </div>
                        </div>
                      ),
                      centered: true,
                      style: {
                        top: 0,
                      },
                      bodyStyle: {
                        overflow: "hidden",
                      },
                      closable: false,
                    });
                  }
                  await db.rfidData.toArray((products) => {
                    products.map((ele) => {
                      if (ele.tag_status === "SO") {
                        rfidData.push(` {
                                    tagValue: "${ele.tag_value}"
                                    taggingDate: null
                                    batchNumber: null
                                    batchId: null
                                    warehouseId: null
                                    tagStatus: "SO"
                                    lastScannedDate: "${moment(new Date()).format("DD-MM-YYYY HH:mm:ss")}"
                                    scannedBy: null
                                    expirydate: null
                                    customAttribute: null
                                    tagType: null
                                    productCode: "${ele.product_code}"
                                    }`);
                      }
                    });
                  });
                  await RFIDTag(rfidData);
                } else {
                  console.error("Failed Order Sync ====> ", response);
                  const syncFailedCount = parseInt(layAwayOrders[i].syncAttempts) + 1;
                  if (parseInt(layAwayOrders[i].syncAttempts) < 100) {
                    db.layAwayOrders.where("sOrderID").equals(layAwayOrders[i].sOrderID).modify({ syncAttempts: syncFailedCount });
                  } else {
                    db.layAwayOrders.where("sOrderID").equals(layAwayOrders[i].sOrderID).modify({ isSynced: 2 });
                  }
                }
              } catch (error) {
                console.log(error);
              }
            }
          }
        }
      }

      setActiveInput("search");
    }
    if (syncTrigger === "orderHistory") {
      showOrderHistory();
    }
    if (syncTrigger === "exchange") {
      localStorage.removeItem("selectedReturnType");
      localStorage.removeItem("exchangeCartObj");
    }
  };

  useEffect(() => {
    // if (posConfig?.disableOfflineBilling !== "Y") {
    const syncOrdersInterval = setInterval(() => syncOrders(), 10000);
    return () => {
      clearTimeout(syncOrdersInterval);
    };
    // }
  }, []);
  // ORDER SYNC BLOCK END

  const handleCloseModal = () => {
    history.push("/dashboard");
  };

  const confirmDiscardCart = () => {
    if (cart.items.length > 0) {
      Modal.confirm({
        title: "Save Cart Items ?",
        className: "parkedItemsClass",
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            You can retrieve the bill later by selecting the 'Retrieve' option in Parked Bills.
            <br />
            Do you want to continue parking the bill?
          </div>
        ),
        okText: "Yes",
        cancelText: "No",
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        onOk() {
          parkBill();
          setTimeout(() => {
            history.push("/dashboard");
          }, 700);
        },
        onCancel: () => {
          handleCloseModal();
        },
      });
    } else {
      history.push("/dashboard");
    }
  };

  const [couponModalVisible, setCouponModalVisible] = useState(false);
  const [couponInput, setCouponInput] = useState("");

  const closeCouponModal = () => {
    setCouponModalVisible(false);
    setSelectedCoupon(null);
    // setSelectedExternalCouponType("")
    // setExternalCouponTypes([])
    // setManualDiscountInput("")
    setCouponInput("");
    setIsInputFocused(false);
    setAdditionalInfo([]);
    if (searchInputRef?.current) {
      searchInputRef?.current?.focus();
    }
  };

  const handleCouponInput = (value) => {
    if (value === "clear") {
      setCouponInput("");
    } else if (value === "x") {
      setCouponInput(`${couponInput.toString().substring(0, couponInput.toString().length - 1)}`);
    } else {
      setCouponInput(`${couponInput}${value}`);
    }
  };

  const toCamelCase = (str) =>
    str
      .replace(/[^a-zA-Z0-9 ]/g, "") // Remove special chars if needed
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (index === 0 ? word.toLowerCase() : word.toUpperCase()))
      .replace(/\s+/g, "");

  const processCouponApplication = async (verifyCoupons, pricingRules, uniqReferenceId) => {
    const couponData = Array.isArray(verifyCoupons) ? verifyCoupons[0] : verifyCoupons;
    pricingRules = Array.isArray(pricingRules) ? pricingRules : [pricingRules];

    let approvalFlag = true;
    let discountAmt = 0;
    const pricingRule = pricingRules[0];

    cartObj.items.map((item) => {
      let excludingFlag = true;
      const hasApplicableProducts = Array.isArray(pricingRule?.applicableProducts) && pricingRule.applicableProducts.length > 0;

      const isEligibleProduct = hasApplicableProducts ? pricingRule.applicableProducts.some((p) => p?._id === item?.productId) : true;

      if (!isEligibleProduct) {
        return;
      }
      const matchingCategory = pricingRule?.mPricingPcategories?.find((pc) => pc.mProductCategoryId === item.mProductCategoryId);
      if (
        (pricingRule.excludeProductCategories === "Y" && matchingCategory) ||
        (pricingRule.excludeProductCategories !== "Y" && !matchingCategory) ||
        (pricingRule.excludeProductCategories === "N" && pricingRule.mPricingPcategories.length === 0)
      ) {
        excludingFlag = false;
      }

      const matchingBrand = pricingRule?.mPricingBrands?.find((pc) => pc.mBrandId === item.productBrandId);
      if (
        (pricingRule.excludeBrands === "Y" && matchingBrand) ||
        (pricingRule.excludeBrands !== "Y" && !matchingBrand) ||
        (pricingRule.excludeBrands === "N" && pricingRule.mPricingBrands.length === 0)
      ) {
        excludingFlag = false;
      }

      const matchingProductIndex = pricingRule?.mPricingXProducts?.findIndex((op) => op.mProductId === item.productId);
      if (
        (pricingRule.excludeProducts === "Y" && matchingProductIndex !== -1) ||
        (pricingRule.excludeProducts !== "Y" && matchingProductIndex === -1) ||
        (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
      ) {
        excludingFlag = false;
      }

      let pricingRuleFlag = true;

      if (item.discount <= 0 && item.mPricingRulesId !== null && item.mPricingRulesId !== undefined) {
        pricingRule.mPricingXProducts.forEach((res) => {
          if (res.mProductId === item.productId) {
            delete item.priority;
          }
        });
      }

      const saleTypeValidation = pricingRule?.cwrSaletypeId === null || orderType === undefined ? true : pricingRule?.cwrSaletypeId === orderType?.cwrSaletype?.cwrSaletypeId;

      let addToCart = cart.items.filter((item) => pricingRule?.mPricingXProducts?.some((pro) => item.productId === pro.mProductId));

      // let iscoupon = true;

      if (
        saleTypeValidation &&
        excludingFlag &&
        pricingRuleFlag &&
        // (addToCart.productId === item.productId || iscoupon) &&
        (!Array.isArray(pricingRule?.applicableProducts) ||
          pricingRule.applicableProducts.length === 0 ||
          pricingRule.applicableProducts.some((p) => p?._id === item?.productId)) &&
        (item?.priority ? item?.priority < pricingRule.priority : true)
      ) {
        const offerIndex =
          pricingRule?.mPricingXProducts?.length > 0 && pricingRule.excludeProducts === "N"
            ? pricingRule?.mPricingXProducts?.findIndex((op) => op.mProductId === item.productId)
            : pricingRule?.mPricingXProducts?.length > 0 && pricingRule.excludeProducts === "Y"
              ? pricingRule?.mPricingXProducts?.findIndex((op) => op.mProductId !== item.productId)
              : 0;
        const eligibleAmount =
          Number(pricingRule?.eligibleAmount || 0) > 0
            ? Number(pricingRule.eligibleAmount)
            : hasApplicableProducts
              ? cartObj.items
                  .filter((cartItem) => pricingRule.applicableProducts.some((p) => p?._id === cartItem?.productId))
                  .reduce((sum, cartItem) => sum + Number(cartItem?.linegross || cartItem?.nettotal || 0), 0)
              : Number(cart?.total || 0);
        if (offerIndex >= 0 && Math.abs(item.weight) >= pricingRule.minimumQty) {
          // ✅ PRODUCT-SPECIFIC LOGIC
          let eligibleQty = item.weight;

          // if (pricingRule.applicableProducts?.length > 0) {
          //   const matchedProduct = pricingRule.applicableProducts.find((p) => p._id === item.productId);
          //   if (!matchedProduct) return;
          //   eligibleQty = Math.min(item.weight, matchedProduct.quantity);
          // }
          if (hasApplicableProducts) {
            const matchedProduct = pricingRule.applicableProducts.find((p) => p?._id === item?.productId);

            const matchedQty = Number(matchedProduct?.quantity);

            eligibleQty = matchedProduct && matchedQty > 0 ? Math.min(Number(item?.weight || 0), matchedQty) : Number(item?.weight || 0);
          }

          if (Array.isArray(item.children) && item.children.length > 0 && item.companion !== "Y") {
            item.children.forEach((child) => {
              let discount = 0;

              if (pricingRule.discountType === "P" && pricingRule.percentageDiscount) {
                discount = (pricingRule.percentageDiscount / 100) * parseFloat(child.realPrice);
              } else if (pricingRule.discountType === "V" && pricingRule.amountDiscount) {
                // discount = (pricingRule.amountDiscount / cart.total) * parseFloat(child.realPrice);
                discount = eligibleAmount > 0 ? (pricingRule.amountDiscount / eligibleAmount) * parseFloat(child.realPrice) : 0;
              }

              discount = parseFloat(discount).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision);

              discountAmt += parseFloat((discount * Math.min(child.weight, eligibleQty)).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
            });
          } else {
            let discount = 0;

            if (pricingRule.discountType === "P" && pricingRule.percentageDiscount) {
              discount = (pricingRule.percentageDiscount / 100) * parseFloat(item.realPrice);
            } else if (pricingRule.discountType === "V" && pricingRule.amountDiscount) {
              // discount = (pricingRule.amountDiscount / cart.total) * parseFloat(item.realPrice);
              discount = eligibleAmount > 0 ? (pricingRule.amountDiscount / eligibleAmount) * parseFloat(item.realPrice) : 0;
            }

            discount = parseFloat(discount).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision);

            discountAmt += parseFloat((discount * eligibleQty).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          }
        } else {
          item.discount = 0;
          delete item.nextRule;
        }
      }
    });

    // ✅ MAX DISCOUNT CAP
    if (pricingRule.maxDiscount && discountAmt > pricingRule.maxDiscount) {
      discountAmt = pricingRule.maxDiscount;
    }

    if (pricingRule.mPricingApprovals) {
      approvalFlag = await new Promise((resolve) => {
        discountApproval(pricingRule.mPricingApprovals, pricingRule, couponInput, discountAmt, cart?.totalStd, (eventData) => {
          resolve(eventData?.approvalGranted);
        });
      });
    }

    let discardCoupon = false;

    if (pricingRules && approvalFlag) {
      setCouponModalVisible(false);
      setCouponInput("");

      const pricingRule = pricingRules[0];
      let finalObj;

      if (pricingRule.type === "TD" && pricingRule.iscoupon === "Y") {
        if (dateValidator(pricingRule.startDate, pricingRule.endDate)) {
          if (pricingRule.timeSpecific === "Y") {
            const weekDay = currentDay();
            const pStartTime = pricingRule.starttime.substring(11);
            const pEndTIme = pricingRule.endtime !== null ? pricingRule.endtime.substring(11) : moment(new Date()).format("DD-MM-YYYY HH:mm:ss").substring(11);

            const starttime = timeStamp().substring(0, 10) + " " + pStartTime;
            const endtime = timeStamp().substring(0, 10) + " " + pEndTIme;

            if (timeValidator(starttime, endtime) && pricingRule[weekDay] === "Y") {
              finalObj = processBillDiscounts(pricingRule, cart, true, couponInput || couponData?.couponcode, uniqReferenceId, couponData?.mPricingCouponId);
            }
          } else {
            finalObj = processBillDiscounts(pricingRule, cart, true, couponInput || couponData?.couponcode, uniqReferenceId, couponData?.mPricingCouponId);
          }
        }

        if (finalObj && couponData?.crmDiscountType) {
          finalObj.couponInput = (finalObj.couponInput || []).map((item) => {
            if (typeof item !== "object") return item;
            const isMatch =
              (item.mPricingCouponId != null && item.mPricingCouponId === couponData?.mPricingCouponId) || item.couponCode === (couponInput || couponData?.couponcode);

            if (!isMatch) return item;

            return {
              ...item,
              discountType: couponData.crmDiscountType,
              percentageDiscount: couponData.crmPercentageDiscount ?? item.percentageDiscount,
              amountDiscount: couponData.crmAmountDiscount ?? item.amountDiscount,
            };
          });
        }

        if (!isExchange && finalObj) {
          setCart(finalObj);
          localStorage.setItem("cartObj", JSON.stringify(finalObj));
        }

        let filteredCoupon = finalObj?.couponInput?.findIndex((item) => item.mPricingCouponId === couponData?.mPricingCouponId || item.couponcode === couponData?.couponcode);

        if (filteredCoupon >= 0) {
          message.success(`Coupon Applied: ${pricingRule.printedName}`);
          setAdditionalInfo([]);
          setCouponInput("");
        } else {
          discardCoupon = true;
        }
      }

      if (pricingRule.type === "TDF" && pricingRule.iscoupon === "Y") {
        if (dateValidator(pricingRule.startDate, pricingRule.endDate)) {
          if (pricingRule.timeSpecific === "Y") {
            const weekDay = currentDay();
            const pStartTime = pricingRule.starttime.substring(11);
            const pEndTIme = pricingRule.endtime !== null ? pricingRule.endtime.substring(11) : moment(new Date()).format("DD-MM-YYYY HH:mm:ss").substring(11);
            const starttime = timeStamp().substring(0, 10) + " " + pStartTime;
            const endtime = timeStamp().substring(0, 10) + " " + pEndTIme;
            if (timeValidator(starttime, endtime) && pricingRule[weekDay] === "Y") {
              processBillDiscounts(pricingRule, cart, true, couponInput || couponData?.couponcode, uniqReferenceId, couponData?.mPricingCouponId, couponData?.mPricingRulesId);
            }
          } else {
            processBillDiscounts(pricingRule, cart, true, couponInput || couponData?.couponcode, uniqReferenceId, couponData?.mPricingCouponId, couponData?.mPricingRulesId);
          }
        }
      }

      if (pricingRule.type !== "TDF" && pricingRule.iscoupon === "Y" && pricingRule.type !== "TD") {
        let addToCart = cart.items.filter((item) => pricingRule.mPricingXProducts.some((pro) => item.productId === pro.mProductId));

        // Check if the filtered array is empty
        if (addToCart.length === 0 && cart.items.length > 0) {
          addToCart = cart.items[cart.items.length - 1]; // Add the last item of the cart
        } else {
          addToCart = addToCart[0];
        }

        let cartObj = isExchange ? JSON.parse(localStorage.getItem("exchangeCartObj")) : cart;
        let iscoupon = true;
        let expiryDiscount = localStorage.getItem("expiryDiscount") !== null && localStorage.getItem("expiryDiscount") === "Y" ? true : false;

        let updatedCart = expiryDiscount
          ? cartObj
          : await pricingRuleController(
              addToCart,
              cartObj,
              cart,
              setCart,
              cartRef,
              orderType,
              iscoupon,
              selectedCoupon?.externalCoupon === "Y" ? selectedCoupon.name : couponInput || couponData?.couponcode,
              uniqReferenceId,
              verifyCoupons.mPricingCouponId,
              verifyCoupons.mPricingRulesId || verifyCoupons.mPricingrulesId,
              undefined,
              pricingRule
            );
        let updatedTotalTax = 0;
        let updatedTotalPrice = 0;
        let updatedTotalItemsQty = 0;
        let updatedTotalDiscounts = 0;
        for (let i = 0; i < updatedCart.items.length; i += 1) {
          updatedTotalPrice += updatedCart.items[i].nettotal;
          updatedTotalItemsQty += updatedCart.items[i].weight;
          updatedTotalTax += updatedCart.items[i].taxAmount;
          updatedTotalDiscounts += updatedCart.items[i].discount;
          updatedCart.items[i].key = i;
        }

        const updatedRoundOffValue = Math.round(updatedTotalPrice);
        const updatedTotalRoundOff = updatedTotalPrice - updatedRoundOffValue;
        const allItemsInCart = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
        const updatedTotalStd = allItemsInCart.reduce((sum, item) => sum + (item.linestd || 0), 0);
        const rawCouponInfo = JSON.parse(localStorage.getItem("couponAdditionalInfo"));
        const couponInfo = {};
        // Object.entries(rawCouponInfo).forEach(([key, value]) => {
        if (rawCouponInfo && rawCouponInfo["Discount Reason"]) {
          const camelKey = toCamelCase("Discount Reason");
          couponInfo[camelKey] = rawCouponInfo["Discount Reason"];
        }
        // });

        // const updatedCouponInput = updatedCart.couponInput.map((item) => (typeof item === "object" ? { ...item, percentageDiscount: pricingRules[0].percentageDiscount } : item));
        const crmDiscountType = couponData?.crmDiscountType ?? null;
        const crmPercentageDiscount = couponData?.crmPercentageDiscount ?? null;
        const crmAmountDiscount = couponData?.crmAmountDiscount ?? null;

        const updatedCouponInput = updatedCart.couponInput.map((item) => {
          if (typeof item !== "object") return item;
          const isThisCoupon = item.mPricingCouponId === couponData?.mPricingCouponId || item.couponCode === couponData?.couponcode;
          return {
            ...item,
            discountType: isThisCoupon && crmDiscountType ? crmDiscountType : (item.discountType ?? pricingRules[0].discountType),
            percentageDiscount: isThisCoupon && crmPercentageDiscount != null ? crmPercentageDiscount : (item.percentageDiscount ?? pricingRules[0].percentageDiscount),
            amountDiscount: isThisCoupon && crmAmountDiscount != null ? crmAmountDiscount : (item.amountDiscount ?? pricingRules[0].amountDiscount),
          };
        });
        let finalCartObj = {
          ...updatedCart,
          items: [...updatedCart.items],
          couponInput: updatedCouponInput,
          total: parseFloat(parseFloat(updatedTotalPrice)?.toFixed(precision)),
          tax: parseFloat(parseFloat(updatedTotalTax)?.toFixed(precision)),
          discount: parseFloat(parseFloat(updatedTotalDiscounts)?.toFixed(precision)),
          totalQty: updatedTotalItemsQty,
          roundOff: parseFloat(parseFloat(updatedTotalRoundOff)?.toFixed(precision)),
          totalStd: updatedTotalStd,
          discountInfo: couponInfo,
        };
        if (isExchange) {
          localStorage.setItem("exchangeCartObj", JSON.stringify(finalCartObj));
        } else {
          setCart(finalCartObj);
          localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
        }
        let filteredCoupon = finalCartObj?.couponInput?.length > 0 ? finalCartObj?.couponInput?.findIndex((item) => item.mPricingCouponId === verifyCoupons.mPricingCouponId) : -1;
        if (filteredCoupon >= 0) {
          message.success(`Coupon Applied: ${pricingRule.printedName}`);
        } else {
          discardCoupon = true;
        }
      }

      if (discardCoupon) {
        const serverUrl = process.env.REACT_APP_serverUrl;
        const couponsData = [{ couponCode: couponInput || couponData?.couponcode, referenceId: uniqReferenceId }];
        // Function to discard a coupon
        const discardCoupons = async (coupon) => {
          await discardCouponService(coupon.couponCode, coupon.referenceId);
        };
        couponsData.forEach((coupon) => {
          discardCoupons(coupon);
        });
        if (pricingRule.type === "TD" || pricingRule.type === "TDF") {
          if (!finalObj) return;
          finalObj.totalBillDicount = null;
          setCart(finalObj);
        }
      }

      upsertPOSLog(cart, "CUP");
      setAdditionalInfo([]);
      setCouponModalVisible(false);

      if (searchInputRef?.current) {
        searchInputRef?.current?.focus();
      }
    } else {
      message.warning(`${messages.errors.coupons.not_available}`);
    }
  };
  const couponInfo = async (values) => {
    const formatted = {
      ...values,
      DateOfBirth: values.DateOfBirth?.format("DD-MM-YYYY"),
    };
    localStorage.setItem("couponAdditionalInfo", JSON.stringify(formatted));
    await processCouponApplication(couponVerificationData.verifyCoupons, couponVerificationData.pricingRules, couponVerificationData.uniqReferenceId);
    additionalInfoForm.resetFields();
    setShowAdditionalInfo(false);
    setShowCouponApproval(true);
  };

  const checkExternalCoupon = async (coupon) => {
    const providerConfig = coupon?.couponProvider?.[0]?.apiConfig;
    if (!providerConfig) {
      console.error("Missing coupon provider configuration");
      return;
    }
    const parsedConfig = JSON.parse(providerConfig);

    const url = parsedConfig.api_url;
    const token = parsedConfig.api_key;

    const currPrecision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2;
    let discountAmount = 0;
    if (selectedExternalCouponType?.type === "TD") {
      discountAmount = totalBillDiscountData?.discountedAmount?.toFixed(currPrecision) || 0;
    } else {
      const discountAmt = selectedCoupon?.discountType === "V" ? (selectedCoupon?.amountDiscount ?? "") : (selectedCoupon?.percentageDiscount ?? "");
      if (cart.items.length > 0) {
        discountAmount =
          selectedExternalCouponType?.discountType === "P"
            ? (cart.items.reduce((total, item) => total + item.realPrice * item.weight, 0) * (discountAmt / 100)).toFixed(
                tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2
              )
            : discountAmt;
      }
    }

    const userId = couponInput?.includes("HTR?") ? couponInput.split("HTR?")[1] : couponInput;
    const body = {
      perk: 9,
      billAmount: cart.total,
      savings: discountAmount,
      userId: userId,
      type: "perk",
    };

    const result = await externalCoupon(url, token, body);
    if (result && result.error === false) {
      let uniqReferenceId = uuidv4().replace(/-/g, "").toUpperCase();
      processCouponApplication(selectedCoupon, selectedCoupon, uniqReferenceId);
    } else if (result.error === true) {
      message.warning(result?.data?.message);
      setCouponInput("");
      couponInputRef.current?.focus();
    }
  };

  const checkCoupon = async () => {
    if (navigator.onLine) {
      let setAuthTokens;
      if (authHeaders && authHeaders.access_token) {
        setAuthTokens = authHeaders.access_token;
      }
      let uniqReferenceId = uuidv4().replace(/-/g, "").toUpperCase();
      let couponFlag = true;
      cart?.couponInput?.forEach((coupon) => {
        if (coupon.couponCode === couponInput) {
          couponFlag = false;
        }
        // discardCoupon(coupon);
      });
      const mobileNo = cart?.customer?.mobileNo ? cart.customer.mobileNo : null;
      if (couponFlag) {
        try {
          const data = {
            query: `query{
             verifyCoupons(couponcode:"${couponInput}",referenceId: "${uniqReferenceId}",bunitId: "${tillData.tillAccess.csBunit.csBunitId}",contactNo: ${mobileNo ? `"${mobileNo}"` : null}, pricingRuleId: ${selectedCoupon?.mPricingrulesId ? `"${selectedCoupon?.mPricingrulesId}"` : null}
              ){
              mPricingCouponId
              csClientId
              csBunitId
              created
              createdBy
              updated
              updatedBy
              line
              mPricingRulesId
              couponcode
              status
              redemptionCount
              usedDate
              upc
              otp
              additionalInfo {
                fieldName
                fieldType
                mandatory
                sequence
                displayLabel
                validationRule
                }
          }
      }
        `,
          };

          const verifyCouponResponse = await verifyCouponsService(data);

          const verifyCoupons = verifyCouponResponse?.data?.data?.verifyCoupons || [];
          if (verifyCoupons?.length > 0) {
            if (verifyCoupons[0].status === "A") {
              const matchingPricingRules = await db.pricingRules.where("mPricingrulesId").equalsIgnoreCase(verifyCoupons[0].mPricingRulesId).toArray();
              setCouponVerificationData({
                verifyCoupons: verifyCoupons[0],
                pricingRules: matchingPricingRules[0],
                uniqReferenceId,
              });

              if (verifyCoupons[0]?.additionalInfo?.length > 0) {
                // setShowAdditionalInfo(true);
                setAdditionalInfo(verifyCoupons[0].additionalInfo);
                return;
              }
              await processCouponApplication(verifyCoupons[0], matchingPricingRules, uniqReferenceId);
            } else {
              message.warning(`${messages.errors.coupons.coupon_expired}`);
            }
          } else {
            Sentry.captureException(new Error("Coupon code failed"), {
              extra: {
                couponcode: couponInput,
                referenceId: uniqReferenceId,
              },
            });
            message.warning(`${t("coupon_error")}`);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        message.warning(`${messages.errors.coupons.multiple_entries}`);
      }
      setIsInputFocused(false);
    } else {
      errorMessage("Sync Failed", "Please check your network connection and try again");
    }
  };
  const removeCoupon = async (coupon) => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    const discardCoupon = async () => {
      try {
        const response = await discardCouponService(coupon.couponCode, coupon.referenceId);
      } catch (error) {
        console.error(`Error discarding coupon ${coupon.couponCode}:`, error);
      }
    };
    await discardCoupon();
    let latestData = removeAllDiscounts();

    let cartObj = {
      ...latestData,
      customer: selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : defaultCustomer,
    };
    cartObj.couponInput = cartObj.couponInput.filter((couponCode) => couponCode.mPricingCouponId !== coupon.mPricingCouponId);
    let updatedCart = cartObj;
    let cart = cartObj;

    if (cartObj.items.length > 0) {
      await Promise.all(
        cartObj.items.map(async (ele) => {
          let addToCart = ele;
          addToCart.nettotal = parseFloat(parseFloat(addToCart.nettotal)?.toFixed(precision));
          updatedCart = await pricingRuleController(addToCart, cartObj, cartObj, setCart, cartObj, orderType);
          return updatedCart;
        })
      );
    }
    if (cartObj.totalDiscountFlag) {
      await openPaymentModalByCustomer(updatedCart);
    }

    if (updatedCart?.couponInput?.length > 0) {
      let addToCart = cartObj.items[0];
      await Promise.all(
        updatedCart.couponInput.map(async (coupon) => {
          const matchingPricingRules = await db.pricingRules.where("mPricingrulesId").equalsIgnoreCase(coupon.mPricingruleId).toArray();
          if (matchingPricingRules[0].type !== "TD" && matchingPricingRules[0].type !== "TDF") {
            updatedCart = await pricingRuleController(
              addToCart,
              updatedCart,
              cart,
              setCart,
              cartRef,
              orderType,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          } else {
            updatedCart = await processBillDiscounts(
              matchingPricingRules[0],
              updatedCart,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          }
        })
      );
    }

    let updatedTotalTax = 0;
    let updatedTotalPrice = 0;
    let updatedTotalItemsQty = 0;
    let updatedTotalDiscounts = 0;

    updatedCart.items = updatedCart.items.map((item, i) => {
      const nettotalFixed = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      const taxAmountFixed = parseFloat(parseFloat(item.taxAmount)?.toFixed(precision));
      const discountFixed = item.discount ? parseFloat(parseFloat(item.discount)?.toFixed(precision)) : 0;

      // Update aggregated totals
      updatedTotalPrice += nettotalFixed;
      updatedTotalItemsQty += item.weight;
      updatedTotalTax += taxAmountFixed;
      updatedTotalDiscounts += discountFixed;

      // Update individual item properties
      item.discount = discountFixed;
      item.key = i;
      item.nettotal = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));

      if (!item.isGiftCard) {
        let lineTax = item.listPrice * (1 + item.taxRate / 100);
        let unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;
        if (!isFinite(unitPrice)) unitPrice = 0;

        let unitTax = item.taxAmount / item.weight;
        const stdTax = item.sunitprice * (1 + item.taxRate / 100);
        item.sunitprice = taxIncludeFlag === "Y" ? item.sunitprice : parseFloat(parseFloat(item.sunitprice + unitTax)?.toFixed(precision));
        const gross_list = taxIncludeFlag === "Y" ? item.listPrice : item.listPrice * (1 + item.taxRate / 100);
        const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
        const netList =
          taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision)) : item.listPrice;
        const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : parseFloat(parseFloat(stdTax)?.toFixed(precision));
        // const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : item.sunitprice + taxAmountFixed;

        item.listPrice = taxIncludeFlag === "Y" ? item.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision));
        item.linetax = Math.abs(nettotalFixed) > 0 ? taxAmountFixed : 0;
        item.linenet = Math.abs(nettotalFixed) > 0 ? parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision)) : 0;
        item.linegross = Math.abs(nettotalFixed) > 0 ? nettotalFixed : 0;
        item.linestd = Math.abs(nettotalFixed) > 0 ? parseFloat(parseFloat(grossStd * item.weight)?.toFixed(precision)) : 0;
        item.netunit = Math.abs(nettotalFixed) > 0 ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0;
        item.listprice = Math.abs(nettotalFixed) > 0 ? item.listPrice : 0;
        item.grossunit = Math.abs(nettotalFixed) > 0 ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0;
        item.grossstd = Math.abs(nettotalFixed) > 0 ? roundTo(grossStd, precision) : 0;
        item.grosslist = Math.abs(nettotalFixed) > 0 ? roundTo(gross_list, precision) : 0;
        item.netList = Math.abs(nettotalFixed) > 0 ? netList : 0;
        item.unitPrice = Math.abs(nettotalFixed) > 0 ? unitPrice : 0;
        item.taxAmount = Math.abs(nettotalFixed) > 0 ? taxAmountFixed : 0;
      }
      return item;
    });

    const sumLineTotals = (lines) => {
      let totalLineGross = 0;
      let totalLineTax = 0;

      lines.forEach((line) => {
        totalLineGross += line.nettotal;
        totalLineTax += line.taxAmount;
      });

      return { totalLineGross, totalLineTax };
    };
    // Compare and Adjust Order Totals
    const adjustOrderTotals = (order, lines) => {
      const { totalLineGross, totalLineTax } = sumLineTotals(lines);
      let adjustedOrderGross = order.total;
      let adjustedOrderTax = order.tax;

      const grossDifference = totalLineGross - adjustedOrderGross;
      const taxDifference = totalLineTax - adjustedOrderTax;

      if (Math.abs(grossDifference) > 0.01) {
        adjustedOrderGross += grossDifference;
      }

      if (Math.abs(taxDifference) > 0.01) {
        adjustedOrderTax += taxDifference;
      }

      return {
        ...order,
        total: adjustedOrderGross,
        tax: adjustedOrderTax,
      };
    };
    updatedCart = adjustOrderTotals(updatedCart, updatedCart.items);

    let finalCartObj = {
      ...updatedCart,
      items: [...updatedCart.items],
      discount: updatedTotalDiscounts,
      totalQty: updatedTotalItemsQty,
      discountInfo: [],
    };
    if (!isExchange) {
      localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
      setCart({ ...finalCartObj });
    }
    localStorage.removeItem("couponAdditionalInfo");
    setSelectedCoupon(null);
  };

  // Side Menu Drawer Starts //

  const [sideMenuDrawervisible, setSideMenuDrawervisible] = useState(false);
  const openSideMenu = () => {
    setSideMenuDrawervisible(true);
  };
  const onClose = () => {
    setSideMenuDrawervisible(false);
  };

  const [displayReturnOrderSearch, setDisplayReturnOrderSearch] = useState(false);

  const handleSalesReturnFromSideMenu = () => {
    setSideMenuDrawervisible(false);
    setDisplayReturnOrderSearch(true);
  };

  // Side Menu Drawer Ends //

  // OMS Orders Modal Starts //

  const omsOrderDetailsList = JSON.parse(localStorage.getItem("omsOrderDetails"));
  const initialOmsOrderList = omsOrderDetailsList ? omsOrderDetailsList : [];
  const [omsOrdersList, setOmsOrderList] = useState(initialOmsOrderList);

  const omsOrderStatus = [
    {
      title: "New",
      imgSrc: NewWhite,
      selectedImgSrc: New,
      statusValue: "NE",
    },
    {
      title: "Preparing",
      imgSrc: PreparingWhite,
      selectedImgSrc: Preparing,
      statusValue: "UP",
    },
    {
      title: "Ready",
      imgSrc: ReadyWhite,
      selectedImgSrc: Ready,
      statusValue: "PK",
    },
    {
      title: "Today's Orders",
      imgSrc: CompletedWhite,
      selectedImgSrc: Completed,
      statusValue: "DE",
    },
  ];

  const [displayOMSOrderItemsModal, setDisplayOMSOrderItemsModal] = useState(false);
  const [selectedOMSOrderStatus, setSelectedOMSOrderStatus] = useState(omsOrderStatus[0]);

  const [order, setOrder] = useState("");
  const [searchOrders, setSearchOrders] = useState(omsOrdersList);

  const [selectedOrder, setSelectedOrder] = useState({});

  const handleOmsOrders = async () => {
    setSideMenuDrawervisible(false);
    const tokens = JSON.parse(localStorage.getItem("tokens"));
    db.orders
      .orderBy("orderTime")
      .limit(20)
      .reverse()
      .toArray()
      .then((data) => {
        if (data?.length > 0) {
          data?.map((item) => {
            let time = new Date(item.orderTime);
            let newTime = time.toLocaleString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            });
            let newLineItems = item?.items?.map((itemLine) => ({
              ...itemLine,
              price: itemLine?.salePrice || 0,
              quantity: itemLine?.weight || 0,
            }));
            let orderObj = {
              cWCOrderId: item.sOrderID || "",
              customerId: item?.customer?.cwrCustomerId || "",
              customerName: item?.customer?.name || "",
              lineItems: [...newLineItems],
              mobileNo: item?.customer?.mobileNo,
              noOfItems: item?.items?.length,
              orderNo: item.documentno,
              posOrders: "Y",
              status: "NE",
              total: item?.total || 0,
              totalQty: item?.totalQty || 0,
              dateCreated: newTime,
            };
            let findIndexOrder = _.findIndex(omsOrdersList, ["cWCOrderId", orderObj.cWCOrderId]);
            if (findIndexOrder === -1) {
              omsOrdersList.push(orderObj);
            } else {
              omsOrdersList[findIndexOrder] = orderObj;
            }
            return null;
          });
        }
      });
    const paramsInput = {
      query: `query{
          getNewOmsOrders(bunitId:"${tillData.tillAccess.csBunit.csBunitId}"){
          cWCOrderId
          orderNo
          dateCreated
          customerId
          customerName
          mobileNo
          total
          noOfItems
          totalQty
          lineItems{
              productId
              name
              productCode
              quantity
              price
              subTotal
              addOnProducts{
                  id
                  name
                  price
              }
          }
      }
      }`,
    };
    try {
      const response = await getNewOmsOrder(paramsInput);

      const { getNewOmsOrders } = response?.data?.data || {};
      if (getNewOmsOrders) {
        const updatedOmsOrders = [...omsOrdersList];

        for (const item of getNewOmsOrders) {
          const obj = {
            ...item,
            status: "NE",
            noOfItems: item.lineItems.length,
            posOrders: "N",
            dateCreated: new Date(item.dateCreated).toLocaleString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            }),
          };

          const findIndex = _.findIndex(updatedOmsOrders, ["cWCOrderId", item.cWCOrderId]);
          if (findIndex === -1) {
            updatedOmsOrders.push(obj);
          } else {
            updatedOmsOrders[findIndex] = obj;

            const prodCodes = _.map(updatedOmsOrders[findIndex]?.lineItems || [], "productCode");
            const productsFetched = await db.products
              .where("value")
              .startsWithAnyOfIgnoreCase(prodCodes)
              .and((product) => product.isactive === true)
              .and((product) => product.productSegment !== "BG")
              .toArray();
            const fetchedValues = productsFetched.map((p) => p.value?.toLowerCase());
            const missingValues = prodCodes.filter((code) => !fetchedValues.includes(code?.toLowerCase()));

            if (missingValues.length > 0) {
              try {
                console.log("Syncing missing OMS products:", missingValues);

                const syncId = localStorage.getItem("syncId") || uuidv4().replace(/-/g, "").toUpperCase();

                for (const value of missingValues) {
                  await syncSingleProductByValue(tillData, syncId, tillData?.tillAccess?.cwrTill?.cwrTillID, value?.toString().trim());
                }

                // 🔁 Re-fetch after sync
                productsFetched = await db.products
                  .where("value")
                  .startsWithAnyOfIgnoreCase(prodCodes)
                  .and((product) => product.isactive === true)
                  .and((product) => product.productSegment !== "BG")
                  .toArray();
              } catch (err) {
                console.error("OMS product sync failed:", err);
              }
            }

            if (productsFetched?.length > 0) {
              const newLineItems = updatedOmsOrders[findIndex].lineItems.map((lineItem) => {
                const product = productsFetched.find((product) => product.value === lineItem.productCode);
                return product ? { ...lineItem, img: product.imageurl } : { ...lineItem };
              });
              updatedOmsOrders[findIndex].lineItems = newLineItems;
            }
          }
        }

        // Update localStorage and state with the updated orders
        localStorage.setItem("omsOrderDetails", JSON.stringify(updatedOmsOrders));
        setOmsOrderList(updatedOmsOrders);
      }
    } catch (error) {
      console.error("Error processing OMS orders:", error);
    }

    setDisplayOMSOrderItemsModal(true);
  };

  const handleOMSOrderStatusSelection = (record) => {
    setSelectedOMSOrderStatus(record);
  };

  const setOMSStatus = (status) => {
    let newOMSStatus = "";
    switch (status) {
      case "NE":
        newOMSStatus = "UP";
        break;
      case "UP":
        newOMSStatus = "PK";
        break;
      case "PK":
        newOMSStatus = "DE";
        break;
      default:
        newOMSStatus = "NE";
    }
    return newOMSStatus;
  };

  const nextOMSOrderStatus = () => {
    let newOMSOrderStatus = [...omsOrderStatus];
    let statusIndex = _.findIndex(newOMSOrderStatus, (item) => item.title === selectedOMSOrderStatus.title);
    if (statusIndex <= newOMSOrderStatus.length - 1) setSelectedOMSOrderStatus(newOMSOrderStatus[statusIndex + 1]);
  };

  const handleOMSStatusButton = async (record) => {
    const tokens = JSON.parse(localStorage.getItem("tokens"));
    const paramsInput = {
      query: `mutation{
          updateOMSOrderStatus(order:{
              cWCOrderId: "${record.cWCOrderId}"
              status: "${setOMSStatus(record.status)}"
          })
          {
              status
              message
          }
      }`,
    };
    try {
      const response = await updateOmsOrder(paramsInput);

      if (response?.data?.data?.updateOMSOrderStatus?.status === "200") {
        const newOMSOrderDetails = omsOrdersList.map((order) => (order.cWCOrderId === record.cWCOrderId ? { ...order, status: setOMSStatus(record.status) } : order));

        localStorage.setItem("omsOrderDetails", JSON.stringify(newOMSOrderDetails));
        setOmsOrderList(newOMSOrderDetails);
        nextOMSOrderStatus();
      } else {
        console.error("Failed to update OMS order status:", response?.data?.data);
      }
    } catch (error) {
      console.error("Error in updating OMS order status:", error);
    }
  };

  const handleOrderCard = (record) => {
    setSelectedOrder(record);
    handleOMSOrderStatusSelection(_.filter(omsOrderStatus, (statusItem) => statusItem.statusValue === record.status)?.[0]);
  };

  const handleOrderSearchInput = (value) => {
    if (value !== "") {
      const results = omsOrdersList.filter((orderDetails) => {
        return orderDetails.orderNo.startsWith(value);
      });
      setSearchOrders(results);
    } else {
      setSearchOrders(omsOrdersList);
    }
    setOrder(value);
  };

  const omsOrderTotalPrice = _.sumBy(selectedOrder.lineItems, "price");

  // OMS Orders Modal Ends //

  // Sales Representative Modal Starts //
  const [openSalesRep, setOpenSalesRep] = useState({ flag: false, level: "" });
  const [salesRepModalOpen, setSalesRepModalOpen] = useState({
    status: false,
    title: "",
  });
  const [salesRepresent, setSalesRepresent] = useState({});
  const [salesRepresentDefaultLine, setSalesRepresentDefaultLine] = useState({ salesRepresentId: null, name: null });

  const handleSalesRepresentive = (record) => {
    if (salesRepModalOpen.title === "orderSalesRep") {
      setSalesRepresentDefaultLine({ ...record });
      setCart({
        ...cart,
        salesRepId: record.salesRepresentId,
      });
      localStorage.setItem(
        "cartObj",
        JSON.stringify({
          ...cart,
          salesRepId: record.salesRepresentId,
        })
      );
      setSalesRepresent(record);
    } else if (salesRepModalOpen.title === "itemSalesRep" && !_.isEmpty(selectedProductInCart)) {
      setSalesRepresentDefaultLine({ ...record });
      let lineItemsData = [...cart.items];
      const lineItemsIndex = _.findIndex(lineItemsData, (item) => item.productId === selectedProductInCart.productId);
      lineItemsData[lineItemsIndex]["salesRepId"] = record.salesRepresentId;
      lineItemsData[lineItemsIndex]["salesRepName"] = record.name;

      setCart({
        ...cart,
        items: lineItemsData,
      });
      localStorage.setItem(
        "cartObj",
        JSON.stringify({
          ...cart,
          items: lineItemsData,
        })
      );
    }
    setSalesRepModalOpen({ status: false, title: "" });
  };

  const [salesRepresentSearchInput, setSalesRepresentSearchInput] = useState("");
  const salesReprestiveList = tillData.tillAccess.csBunit.salesRep;
  const [filteredSalesRepresentList, setFilteredSalesRepresentList] = useState(salesReprestiveList);

  const handleSalesRepresentSearchInput = (value) => {
    if (value !== "") {
      const results = salesReprestiveList.filter((list) => {
        return list.name.toLowerCase().startsWith(value.toLowerCase());
      });
      setFilteredSalesRepresentList(results);
    } else {
      setFilteredSalesRepresentList(salesReprestiveList);
    }
    setSalesRepresentSearchInput(value);
  };

  const handleKey = (e) => {
    const { altKey, keyCode } = e;
    if (altKey) {
      if (keyCode === 83) {
        if (posConfig?.showLineSalesRep === "Y") {
          setSalesRepModalOpen({ status: true, title: "itemSalesRep" });
          setSalesRepresentSearchInput("");
          setFilteredSalesRepresentList(salesReprestiveList);
        }
      }
      if (keyCode === 67) {
        setSelectedRowKeys((v) => {
          if (v.length > 0) {
            return [];
          } else {
            return [0];
          }
        });
      }
      if (keyCode === 80) {
        openPaymentModal();
      }

      if (keyCode === 79) {
        setDisplayOrderHistory(true);
      }

      if (keyCode === 66) {
        setDisplayParkedBillModal(true);
      }

      if (keyCode === 73) {
        if (selectedRowKeysRef.current.length > 0) {
          setIsQtyUpdate(selectedProductInCartRef.current);
        }
      }

      if (keyCode === 76) {
        parkBill("parkKey");
      }

      if (keyCode === 72) {
        confirmDiscardCart();
      }
    }

    if (keyCode === 115) {
      setTimeout(() => {
        // productSearchInputRef.current.focus();
      }, 100);
    }
    if (keyCode === 27) {
      if ((e.target.id === "productSearchInputId" || e.target.id.search("productCardItem")) >= 0) {
        closeProductPanel();
      }
      setDisplayBatchSelection((b) => {
        if (b) {
          return !b;
        } else {
          return b;
        }
      });
      setSalesRepModalOpen({ status: false, title: "" });
      setSalesRepresentSearchInput("");
      closeCustomerSearch();

      if (paymentModalStateRef.current) {
        closePaymentModal();
      }
    }
    if (keyCode === 38) {
      setSelectedRowKeys((v) => {
        if (v.length > 0 && v[0] > 0) {
          return [v[0] - 1];
        } else {
          return [v[0]];
        }
      });
    }
    if (keyCode === 40) {
      setSelectedRowKeys((v) => {
        if (v.length > 0 && v[0] < cartItemsLengthRef.current - 1) {
          return [v[0] + 1];
        } else {
          return [v[0]];
        }
      });
    }

    if (keyCode === 187 || keyCode === 107) {
      if (selectedRowKeysRef.current.length > 0 && !selectedItemsModalOpen && cart.saleType.value !== "DI") {
        increaseProductQty(selectedProductInCartRef.current);
      }
    }
    if (keyCode === 109 || keyCode === 189) {
      if (selectedRowKeysRef?.current?.length > 0 && !selectedItemsModalOpen && cart.saleType?.value !== "DI") {
        if (parseFloat(selectedProductInCartRef.current.weight) > 1) {
          decreaseProductQty(selectedProductInCartRef.current);
        }
      }
    }
    if (keyCode === 46) {
      if (selectedRowKeysRef.current.length > 0) {
        deleteProduct(selectedProductInCartRef.current);
      }
    }
  };

  const cartItemsLengthRef = useRef(0);
  const [cartObj, setOrderObj] = useState(null);

  // useEffect(() => {
  //   cartItemsLengthRef.current = cart.items.length;
  //   // setAmount((Math.abs(cart.total) - cart.paid)?.toFixed(precision));
  //   setAmount(parseFloat(parseFloat(Math.abs(cart.total) - (cart.paid ?? 0))?.toFixed(precision)));
  //   let flag = tillLayout !== 1 ? true : false;
  //   if (Math.abs(cart.total) <= cart.paid && cart.payments.length > 0 && flag && cart.layAway === "Y" && posConfig?.allowLayawaywithoutPayment === "Y") {
  //     orderState.current = 0;
  //     setPaymentProcessFlag(false);
  //     processOrder(cart.sOrderID);
  //   } else if (Math.abs(cart.total) <= cart.paid && cart.payments.length > 0 && flag && (cart.layAway !== "Y" || cart.preOrder === "Y")) {
  //     orderState.current = 0;
  //     setPaymentProcessFlag(false);
  //     processOrder(cart.sOrderID);
  //   }
  //   try {
  //     const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
  //     if (cartDetails !== null) {
  //       setOrderObj(cartDetails);
  //     }
  //   } catch (error) {
  //     console.error("Error parsing cart details:", error);
  //   }
  //   if (cart.discount) {
  //     upsertPOSLog(cart, "DAP");
  //   }
  // }, [cart]);

  useEffect(() => {
    const exchangeCartData = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
    const returnCartData = JSON.parse(localStorage.getItem("cartObj") || "{}");
    const selectedReturnTypeLocal = localStorage.getItem("selectedReturnType");

    let netTotal = cart.total;
    let totalPaid = cart.paid;

    if (selectedReturnTypeLocal === "EXCHANGE") {
      const exchangeTotal = exchangeCartData.total || 0;
      const returnTotal = returnCartData.total || 0;

      netTotal = exchangeTotal + returnTotal;
      totalPaid = exchangeCartData.paid || 0;
    }
    cartItemsLengthRef.current = cart.items.length;
    // setAmount((Math.abs(cart.total) - cart.paid)?.toFixed(precision));
    // setAmount(parseFloat(parseFloat(Math.abs(cart.total) - (cart.paid ?? 0) + cart?.deiveryCharge + cart?.tip + cart?.serviceCharge + cart?.packingCharge)?.toFixed(precision)));
    // setAmount(
    //   parseFloat(
    //     (Math.abs(cart.total) - (cart.paid ?? 0) + (cart?.deiveryCharge ?? 0) + (cart?.tip ?? 0) + (cart?.serviceCharge ?? 0) + (cart?.packingCharge ?? 0)).toFixed(precision)
    //   )
    // );
    const isExchange = selectedReturnTypeLocal === "EXCHANGE" && exchangeCartData?.items?.length > 0;

    let baseAmount = 0;

    if (isExchange) {
      const exchangeTotal = Math.abs(exchangeCartData.total || 0);
      const returnTotal = Math.abs(returnCartData.total || 0);
      const alreadyPaid = Math.abs(returnCartData.paid || 0);
      const exchangePaid = Math.abs(exchangeCartData.paid || 0);

      baseAmount = exchangeTotal - returnTotal - alreadyPaid - exchangePaid;
    } else {
      baseAmount = Math.abs(cart.total) - (cart.paid ?? 0) + (cart?.deiveryCharge ?? 0) + (cart?.tip ?? 0) + (cart?.serviceCharge ?? 0) + (cart?.packingCharge ?? 0);
    }

    setAmount(parseFloat(baseAmount.toFixed(precision)));

    let flag = tillLayout !== 1 ? true : false;
    if (Math.abs(netTotal) <= totalPaid && cart.payments.length > 0 && flag && cart.layAway === "Y" && posConfig?.allowLayawaywithoutPayment === "Y") {
      orderState.current = 0;
      setPaymentProcessFlag(false);
      processOrder(cart.sOrderID);
    } else if (
      Math.abs(netTotal) <= totalPaid &&
      cart.payments.length > 0 &&
      flag &&
      (cart.layAway !== "Y" || cart.preOrder === "Y") &&
      !isNewGiftCardFlag &&
      !showCustomerWallet
    ) {
      orderState.current = 0;
      setPaymentProcessFlag(false);
      processOrder(cart.sOrderID);
    }
    try {
      const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
      if (cartDetails !== null) {
        setOrderObj(cartDetails);
      }
    } catch (error) {
      console.error("Error parsing cart details:", error);
    }
    if (cart.discount) {
      upsertPOSLog(cart, "DAP");
    }
  }, [cart, localStorage.getItem("exchangeCartObj")]);

  // useEffect(() => {
  //   const exchangeCartData = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
  //   const returnCartData = JSON.parse(localStorage.getItem("cartObj") || "{}");
  //   const selectedReturnTypeLocal = localStorage.getItem("selectedReturnType");

  //   const activeCart =
  //     selectedReturnTypeLocal === "EXCHANGE" && exchangeCartData?.items?.length > 0
  //       ? exchangeCartData
  //       : cart;

  //   cartItemsLengthRef.current = activeCart.items.length;

  //   let netTotal = activeCart.total;
  //   let totalPaid = activeCart.paid;

  //   // ✅ FIX: correct net calculation
  //   if (selectedReturnTypeLocal === "EXCHANGE") {
  //     const exchangeTotal = exchangeCartData.total || 0;
  //     const returnTotal = returnCartData.total || 0;

  //     netTotal = exchangeTotal + returnTotal;
  //     totalPaid = exchangeCartData.paid || 0;
  //   }

  //   // ✅ FIX: correct amount display
  //   const remainingAmount =
  //     Math.abs(netTotal) -
  //     (totalPaid ?? 0) +
  //     (activeCart?.deiveryCharge ?? 0) +
  //     (activeCart?.tip ?? 0) +
  //     (activeCart?.serviceCharge ?? 0) +
  //     (activeCart?.packingCharge ?? 0);

  //   setAmount(parseFloat(remainingAmount.toFixed(precision)));

  //   let flag = tillLayout !== 1;

  //   // ✅ FIX: use netTotal instead of activeCart.total
  //   if (
  //     Math.abs(netTotal) <= totalPaid &&
  //     activeCart.payments.length > 0 &&
  //     flag &&
  //     activeCart.layAway === "Y" &&
  //     posConfig?.allowLayawaywithoutPayment === "Y"
  //   ) {
  //     console.log("✅ Exchange fully paid (layaway)");
  //     orderState.current = 0;
  //     setPaymentProcessFlag(false);
  //     processOrder(activeCart.sOrderID);
  //   } else if (
  //     Math.abs(netTotal) <= totalPaid &&
  //     activeCart.payments.length > 0 &&
  //     flag &&
  //     (activeCart.layAway !== "Y" || activeCart.preOrder === "Y") &&
  //     !isNewGiftCardFlag &&
  //     !showCustomerWallet
  //   ) {
  //     console.log("✅ Exchange fully paid → processing order");
  //     orderState.current = 0;
  //     setPaymentProcessFlag(false);
  //     processOrder(activeCart.sOrderID);
  //   }

  //   try {
  //     const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
  //     if (cartDetails !== null) {
  //       setOrderObj(cartDetails);
  //     }
  //   } catch (error) {
  //     console.error("Error parsing cart details:", error);
  //   }

  //   if (activeCart.discount) {
  //     upsertPOSLog(activeCart, "DAP");
  //   }
  //   }, [cart, localStorage.getItem("exchangeCartObj")]);

  const selectedProductInCartRef = useRef({});
  useEffect(() => {
    selectedProductInCartRef.current = selectedProductInCart;
  }, [selectedProductInCart]);

  const selectedRowKeysRef = useRef([0]);
  useEffect(() => {
    selectedRowKeysRef.current = selectedRowKeys;
    if (selectedRowKeys.length > 0) {
      const cartIndex = cart.items.findIndex((ci) => ci.key === selectedRowKeys[0]);
      // setSelectedProductInCart({ ...cart.items[cartIndex] });
    }
  }, [selectedRowKeys]);

  const paymentModalStateRef = useRef(false);
  useEffect(() => {
    paymentModalStateRef.current = paymentModal;
    if (paymentModal) {
      setSelectedPaymentMethod(tillDataPaymentMethods.filter((item, index) => item.isDefault === "Y")?.[0] || {});
    }
  }, [paymentModal]);

  useEffect(() => {
    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  });

  // Sales Representative Modal Ends //

  const [manualDiscountModalVisible, setManualDiscountModalVisible] = useState(false);
  const [manualDiscountInput, setManualDiscountInput] = useState("");
  const [manualDiscountTypes, setManualDiscountTypes] = useState([]);
  const [selectedManualDiscountType, setSelectedManualDiscountTypeValue] = useState("");
  const [enableManualDiscountInput, setEnableManualDiscountInput] = useState(false);

  const [selectedExternalCouponType, setSelectedExternalCouponTypeValue] = useState("");
  const [externalCouponTypes, setExternalCouponTypes] = useState([]);

  useEffect(() => {
    db.pricingRules.toArray().then((pr) => {
      const bunitId = tillData.tillAccess.csBunit.csBunitId;
      const manualPricingRules = pr.filter((rule) => {
        if (rule.manualDiscount === "Y") {
          if (rule.excludeBusinessUnits === "Y") {
            if (rule.mPricingBUnits.length === 0) return rule;
            const index = rule.mPricingBUnits.findIndex((Bunit) => Bunit.mBunitPricingId !== bunitId);
            if (index !== -1) {
              return rule;
            }
          } else {
            const index = rule.mPricingBUnits.findIndex((Bunit) => Bunit.mBunitPricingId === bunitId);
            if (index >= 0) {
              return rule;
            }
          }
        }
      });
      setManualDiscountTypes([...manualPricingRules]);
    });
  }, [manualDiscountModalVisible]);

  useEffect(() => {
    db.pricingRules.toArray().then((pr) => {
      const bunitId = tillData.tillAccess.csBunit.csBunitId;
      const manualPricingRules = pr.filter((rule) => {
        if (rule.iscoupon === "Y") {
          if (rule.excludeBusinessUnits === "Y") {
            if (rule.mPricingBUnits.length === 0) return rule;
            const index = rule.mPricingBUnits.findIndex((Bunit) => Bunit.mBunitPricingId !== bunitId);
            if (index !== -1) {
              return rule;
            }
          } else {
            const index = rule.mPricingBUnits.findIndex((Bunit) => Bunit.mBunitPricingId === bunitId);
            if (index >= 0) {
              return rule;
            }
          }
        }
      });
      setExternalCouponTypes([...manualPricingRules]);
    });
  }, []);

  useEffect(() => {
    manualDiscountForm.setFieldsValue({
      discountValue: manualDiscountInput,
    });
  }, [manualDiscountInput]);

  const setSelectedExternalCouponType = (value) => {
    if (value !== "") {
      const mdi = externalCouponTypes.findIndex((md) => md.mPricingrulesId === value);
      setSelectedExternalCouponTypeValue(externalCouponTypes[mdi]);
      const discountValue = externalCouponTypes[mdi]?.discountType === "V" ? (externalCouponTypes[mdi].amountDiscount ?? "") : (externalCouponTypes[mdi]?.percentageDiscount ?? "");
      if (discountValue) {
        setManualDiscountInput(discountValue);
        setEnableManualDiscountInput(true);
      } else {
        setManualDiscountInput("");
        setEnableManualDiscountInput(false);
      }
    }
  };

  const setSelectedManualDiscountType = (value) => {
    if (value !== "") {
      const mdi = manualDiscountTypes.findIndex((md) => md.mPricingrulesId === value);
      setSelectedManualDiscountTypeValue(manualDiscountTypes[mdi]);
      const discountValue = manualDiscountTypes[mdi]?.discountType === "V" ? (manualDiscountTypes[mdi].amountDiscount ?? "") : (manualDiscountTypes[mdi]?.percentageDiscount ?? "");
      if (discountValue) {
        setManualDiscountInput(discountValue);
        setEnableManualDiscountInput(true);
      } else {
        setManualDiscountInput("");
        setEnableManualDiscountInput(false);
      }
    }
  };

  const [manualDiscountForm] = Form.useForm();

  const handleManualDiscountKeyPress = (value) => {
    if (!enableManualDiscountInput) {
      if (manualDiscountInput === "" && value === "x") {
        manualDiscountForm.setFieldsValue({ discountValue: "" });
        setManualDiscountInput("");
      } else if (value === "x") {
        const updatedValue = manualDiscountInput.toString().slice(0, -1);
        manualDiscountForm.setFieldsValue({ discountValue: updatedValue });
        setManualDiscountInput(updatedValue);
      } else if (value === "clear") {
        manualDiscountForm.setFieldsValue({ discountValue: "" });
        setManualDiscountInput("");
      } else {
        const newInput = `${manualDiscountInput}${value}`;
        manualDiscountForm.setFieldsValue({ discountValue: newInput });
        setManualDiscountInput(newInput);
      }
    }
  };

  const validateUserPin = async (user, pin) => {
    return pin === "1234";
  };

  const discountInforApplication = async (values) => {
    const formatted = {
      ...values,
      DateOfBirth: values.DateOfBirth?.format("DD-MM-YYYY"),
    };
    localStorage.setItem("discountAdditionalInfo", JSON.stringify(formatted));
    let approvalFlag = true;
    const minValue = discountVerificationData.pricingRule?.mPricingApprovals?.reduce((min, item) => Math.min(min, item.min), Infinity);
    const maxValue = discountVerificationData.pricingRule?.mPricingApprovals?.reduce((max, item) => Math.max(max, item.max), -Infinity);
    if (!discountVerificationData.matchingApproval && discountVerificationData.values.discountValue > minValue) {
      message.warning(`${messages.errors.discounts.approval_required}`);
      return;
    } else if (discountVerificationData.values.discountValue >= minValue && discountVerificationData.values.discountValue <= maxValue) {
      const discountAppliedValues = JSON.parse(localStorage.getItem("discountAppliedData"));
      const discountedAmount = totalBillDiscountData?.discountedAmount > 0 ? totalBillDiscountData.discountedAmount : discountAppliedValues?.discountedAmount;
      const totalBillPrice = totalBillDiscountData?.totalBillPrice > 0 ? totalBillDiscountData.totalBillPrice : discountAppliedValues?.totalBillPrice;
      approvalFlag = await new Promise((resolve) => {
        discountApproval([discountVerificationData.matchingApproval], discountVerificationData.pricingRule, null, discountedAmount, totalBillPrice, (eventData) => {
          resolve(eventData?.approvalGranted);
        });
      });
    } else if (discountVerificationData.values.discountValue > maxValue) {
      return;
    }
    if (!approvalFlag) return;
    await processManualDiscount(discountVerificationData.pricingRule, discountVerificationData.matchingApproval, discountVerificationData.values);
    discountAdditionalInfoForm.resetFields();
    // setManualDiscountModalVisible(false);
  };

  const formatDate = (date = new Date()) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` + `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  };

  const processManualDiscount = async (pricingRule, matchingApproval, values) => {
    const activeCart = selectedReturnTypeLocal === "EXCHANGE" && exchangeCartData?.items?.length > 0 ? exchangeCartData : cart;
    setManualDiscountModalVisible(false);
    const minValue = pricingRule?.mPricingApprovals?.reduce((min, item) => Math.min(min, item.min), Infinity);
    const maxValue = pricingRule?.mPricingApprovals?.reduce((max, item) => Math.max(max, item.max), -Infinity);
    if (posConfig?.saveParkedBills === "Y" && pricingRule?.mPricingApprovals?.length > 0 && values.discountValue >= minValue && values.discountValue <= maxValue) {
      const csBunitId = tillData?.tillAccess?.csBunit?.csBunitId;
      const csUserId = matchingApproval?.userId;
      const cwrStoreDiscountId = uuidv4().replace(/-/g, "").toUpperCase();
      const cwrTillId = tillData?.tillAccess?.cwrTill?.cwrTillID;
      const status = "REQ";
      const cartItems = JSON.parse(localStorage.getItem("cartObj"));
      const source = "POS";
      const requestDate = formatDate();
      const discountType = pricingRule.discountType === "P" ? "PER" : "AMT";
      const discountValue = parseFloat(values.discountValue);
      const discountData = JSON.parse(localStorage.getItem("discountAdditionalInfo"));
      const discountAppliedValues = JSON.parse(localStorage.getItem("discountAppliedData"));
      const billGrossAmount = discountAppliedValues?.totalBillPrice;
      const requestedDiscountAmount = discountAppliedValues?.discountedAmount;
      const billNetAmountAfterDiscount = discountAppliedValues?.finalAmount;
      const reason = discountData?.Reason;

      const upsertStoreDiscountPayload = {
        csBunitId,
        csUserId,
        cwrStoreDiscountId,
        cwrTillId,
        status,
        cartItems,
        source,
        requestDate,
        discountType,
        discountValue,
        billGrossAmount,
        requestedDiscountAmount,
        billNetAmountAfterDiscount,
        reason,
      };

      const response = await upsertStoreDiscount(upsertStoreDiscountPayload);
      if (response?.status === 200) {
        if (response?.data?.data?.upsertStoreDiscount?.status === "200") {
          message.success(response?.data?.data?.upsertStoreDiscount?.message);
          deleteReceipt();
          setDiscountAdditionalInfo([]);
          localStorage.removeItem("discountAppliedData");
          if (searchInputRef?.current) {
            searchInputRef?.current?.focus();
          }
        } else if (response?.data?.data?.upsertStoreDiscount?.status === "201") {
          message.error(response?.data?.data?.upsertStoreDiscount?.message);
        } else {
          message.error("Something is wrong in upsertStoreDiscount service");
        }
      } else {
        message.warning("Something is wrong in upsertStoreDiscount service");
      }
    } else {
      let updatedCart = activeCart;
      if (pricingRule.type === "FD" && Object.keys(selectedProductInCart).length > 0) {
        try {
          const newCart = await CheckoutFlatDiscount(selectedProductInCart, pricingRule, setCart, updatedCart, orderType, updatedCart, values.discountValue, matchingApproval);
          updatedCart = newCart;
        } catch (err) {
          console.error("Error applying flat discount:", err);
        }
      } else if (pricingRule.type === "PD" && Object.keys(selectedProductInCart).length > 0) {
        try {
          const newCart = await CheckoutPercentageDiscount(
            selectedProductInCart,
            pricingRule,
            setCart,
            updatedCart,
            orderType,
            updatedCart,
            values.discountValue,
            matchingApproval
          );
          updatedCart = newCart;
        } catch (err) {
          console.error("Error applying percentage discount:", err);
        }
      } else if (pricingRule.type === "TD") {
        try {
          const newCart = await CheckoutTotalManualDiscount(pricingRule, setCart, updatedCart, orderType, updatedCart, values.discountValue, matchingApproval);
          updatedCart = newCart;
        } catch (err) {
          console.error("Error applying total manual discount:", err);
        }
      }

      const itemsSummery = {
        decimalItems: { totalQty: 0, totalAmount: 0 },
        nonDecimalItems: { totalQty: 0, totalAmount: 0 },
        itemsQty: 0,
        items: 0,
      };

      // Group items by tax rate
      // const allItems = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
      const allItems = (updatedCart.items || [])
        .filter((i) => i?.isCanceled !== "Y")
        .flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));

      const groupedItems = allItems.reduce((acc, item) => {
        const key = item.tax?.rate ?? item.taxRate ?? "0";
        acc[key] = acc[key] || [];
        acc[key].push(item);
        return acc;
      }, {});

      // Calculate tax totals with SGST and CGST
      const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
        const totalTaxAmount = items.reduce((sum, item) => {
          const taxValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.taxAmount : item.taxAmount) || 0;
          return sum + parseFloat(parseFloat(taxValue)?.toFixed(precision));
        }, 0);

        const totalNetTotal = items.reduce((sum, item) => {
          const netValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.nettotal : item.nettotal) || 0;
          return parseFloat(parseFloat(sum).toFixed(precision)) + parseFloat(parseFloat(netValue).toFixed(precision));
        }, 0);

        // Calculate SGST and CGST (assuming they're either explicitly provided or half of total tax)
        const totalSgstAmount = items.reduce((sum, item) => {
          const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
          return sum + parseFloat(parseFloat(sgstValue)?.toFixed(precision));
        }, 0);

        const totalCgstAmount = items.reduce((sum, item) => {
          const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
          return sum + parseFloat(parseFloat(cgstValue)?.toFixed(precision));
        }, 0);

        return {
          taxRate,
          totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount)?.toFixed(precision)),
          totalLinetax: parseFloat(parseFloat(totalTaxAmount)?.toFixed(precision)),
          totalLinegross: parseFloat(parseFloat(totalNetTotal)?.toFixed(precision)),
          totalSgst: parseFloat(parseFloat(totalSgstAmount)?.toFixed(precision)),
          totalCgst: parseFloat(parseFloat(totalCgstAmount)?.toFixed(precision)),
        };
      });

      let updatedTotalTax = 0;
      let updatedTotalPrice = 0;
      let updatedTotalItemsQty = 0;
      let updatedTotalDiscounts = 0;
      updatedCart.items = updatedCart.items.map((item, i) => {
        if (item.isCanceled === "Y") {
          item.discount = 0;
          item.key = i;
          return item;
        }
        const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
        const nettotalFixed = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
        const taxAmountFixed = parseFloat(parseFloat(item.taxAmount)?.toFixed(precision));
        const discountFixed = item.discount ? item.discount : 0;

        // Update totals
        if (item?.isCanceled !== "Y") {
          updatedTotalPrice += nettotalFixed;
          updatedTotalItemsQty += item.weight;
          updatedTotalTax += taxAmountFixed;
          if (item.isCanceled !== "Y") {
            updatedTotalDiscounts += discountFixed;
          }
        }

        item.discount = discountFixed;
        item.key = i;

        if (!item.isGiftCard) {
          const unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;

          const lineTax = item.listPrice * (1 + item.taxRate / 100);
          const stdTax = item.sunitprice * (1 + item.taxRate / 100);
          const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
          const netList =
            taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision)) : item.listPrice;
          const gross_list = taxIncludeFlag === "Y" ? item.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision));
          const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : parseFloat(parseFloat(stdTax)?.toFixed(precision));
          // const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : item.sunitprice + taxAmountFixed;

          Object.assign(item, {
            linetax: nettotalFixed ? taxAmountFixed : 0,
            linenet: nettotalFixed ? parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision)) : 0,
            linegross: nettotalFixed || 0,
            linestd: nettotalFixed ? parseFloat(parseFloat(grossStd * item.weight)?.toFixed(precision)) : 0,
            netunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
            listprice: nettotalFixed ? item.listPrice : 0,
            grossunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0,
            grossstd: nettotalFixed ? grossStd : 0,
            grosslist: nettotalFixed ? roundTo(gross_list, precision) : 0,
            netList: nettotalFixed ? netList : 0,
            unitPrice: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
            taxAmount: nettotalFixed ? taxAmountFixed : 0,
          });
        }

        if (Array.isArray(item.children) && item.children.length > 0 && item.companion !== "Y") {
          item.children = item.children.map((child, i) => {
            const childNettotalFixed = parseFloat(parseFloat(child.nettotal)?.toFixed(precision));
            const childTaxAmountFixed = parseFloat(parseFloat(child.taxAmount)?.toFixed(precision));
            const childDiscountFixed = child.discount ? child.discount : 0;
            child.discount = childDiscountFixed;
            child.key = i;
            if (!child.isGiftCard) {
              const unitPrice = isFinite(child.nettotal / child.weight)
                ? taxIncludeFlag === "Y"
                  ? child.nettotal / child.weight / (1 + child.taxRate / 100)
                  : child.salePrice
                : 0;

              const lineTax = child.listPrice * (1 + child.taxRate / 100);
              const stdTax = child.sunitprice * (1 + child.taxRate / 100);
              const grossUnit = Math.abs(child.sunitprice) - Math.abs(child.discount) / Math.abs(child.weight);
              const netList =
                taxIncludeFlag === "Y"
                  ? child.listPrice - parseFloat(parseFloat(child.listPrice - child.listPrice / (1 + child.taxRate / 100))?.toFixed(precision))
                  : child.listPrice;
              const gross_list = taxIncludeFlag === "Y" ? child.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision));
              const grossStd = taxIncludeFlag === "Y" ? child.sunitprice : parseFloat(parseFloat(stdTax)?.toFixed(precision));

              Object.assign(child, {
                linetax: childNettotalFixed ? childTaxAmountFixed : 0,
                linenet: childNettotalFixed ? parseFloat(parseFloat(child.nettotal - child.taxAmount)?.toFixed(precision)) : 0,
                linegross: childNettotalFixed || 0,
                linestd: childNettotalFixed ? parseFloat(parseFloat(grossStd * child.weight)?.toFixed(precision)) : 0,
                netunit: childNettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
                listprice: childNettotalFixed ? child.listPrice : 0,
                grossunit: childNettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (child.isReturn ? -1 : 1) : 0,
                grossstd: childNettotalFixed ? grossStd : 0,
                grosslist: childNettotalFixed ? gross_list : 0,
                netList: childNettotalFixed ? netList : 0,
                unitPrice: childNettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
                taxAmount: childNettotalFixed ? childTaxAmountFixed : 0,
              });
            }
            return child;
          });
          item.children.forEach((child) => {
            const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
            const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

            itemsSummery.itemsQty += child.weight;
            itemsSummery.items += 1;
            itemsSummery[summaryKey].totalQty += child.weight;
            itemsSummery[summaryKey].totalAmount += parseFloat(parseFloat(child.nettotal)?.toFixed(precision));
          });
        } else {
          const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
          const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

          itemsSummery.itemsQty += item.weight;
          itemsSummery.items += 1;
          itemsSummery[summaryKey].totalQty += item.weight;
          itemsSummery[summaryKey].totalAmount += parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
        }

        return item;
      });

      const sumLineTotals = (lines) => {
        let totalLineGross = 0;
        let totalLineTax = 0;

        lines.forEach((line) => {
          if (line.isCanceled === "Y") return;
          totalLineGross += line.nettotal;
          totalLineTax += line.taxAmount;
        });

        return { totalLineGross, totalLineTax };
      };
      // Compare and Adjust Order Totals
      const adjustOrderTotals = (order, lines) => {
        const { totalLineGross, totalLineTax } = sumLineTotals(lines);
        let adjustedOrderGross = order.total;
        let adjustedOrderTax = order.tax;

        const grossDifference = totalLineGross - adjustedOrderGross;
        const taxDifference = totalLineTax - adjustedOrderTax;

        if (Math.abs(grossDifference) > 0.01) {
          adjustedOrderGross += grossDifference;
        }

        if (Math.abs(taxDifference) > 0.01) {
          adjustedOrderTax += taxDifference;
        }

        return {
          ...order,
          total: adjustedOrderGross,
          tax: adjustedOrderTax,
        };
      };
      updatedCart = adjustOrderTotals(updatedCart, updatedCart.items);
      const allItemsInCart = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
      const updatedTotalStd = allItemsInCart.reduce((sum, item) => sum + (item.linestd || 0), 0);
      let finalCartObj = {
        ...updatedCart,
        items: [...updatedCart?.items],
        discount: updatedTotalDiscounts,
        totalQty: updatedTotalItemsQty,
        subTotal: parseFloat(parseFloat(updatedTotalPrice - updatedTotalTax)?.toFixed(precision)),
        itemsSummery,
        groupedItemsByTaxRate,
        totalStd: updatedTotalStd,
      };
      if (isExchange) {
        localStorage.setItem("exchangeCartObj", JSON.stringify(finalCartObj));
      } else {
        localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
        setCart({ ...finalCartObj });
      }
      if (localStorage.getItem("dineIn") === "Y") {
        const selectedTableData = JSON.parse(localStorage.getItem("tableName"));
        const tableRecord = await db.tableData.get(selectedTableData?.cwrFbTableId);
        let selectedTableRecord = tableRecord;
        const ordersFetched = await db.fbOrderData.where("cwrFbTableId").equals(selectedTableData?.cwrFbTableId).toArray();
        const activeOrder = ordersFetched.find((o) => o.fbOrderStatus === "IP");

        // Always use finalCartObj.items as the source of truth for the recalculated items.
        // Enrich items with dine-in metadata (sendQty, parkedItem, splitTable).
        const enrichedItems = finalCartObj.items.map((line) => ({
          ...line,
          sendQty: line.order === "Y" ? 0 : 1,
          parkedItem: true,
          splitTable: selectedTableRecord?.splitTable || line.splitTable || null,
        }));

        updatedCart = {
          ...finalCartObj,
          tableNo: tableRecord?.name || selectedTableRecord?.name || selectedTableRecord?.tableName,
          splitTable: selectedTableRecord?.splitTable || null,
          items: enrichedItems,
        };

        if (activeOrder) {
          // Update wsData.items with the recalculated discount values from finalCartObj.
          // Use finalCartObj.items (not updatedCart.items which could have been stale)
          // so wsData always reflects the correct post-discount state.
          let updatedWsData = activeOrder.wsData;
          if (updatedWsData && typeof updatedWsData === "object" && Object.keys(updatedWsData).length > 0) {
            if (Array.isArray(updatedWsData.items) && updatedWsData.items.length > 0) {
              updatedWsData = {
                ...updatedWsData,
                items: updatedWsData.items.map((wsItem) => {
                  const matchingItem = finalCartObj.items.find((ci) => ci.fbOrderLineId === wsItem.fbOrderLineId);
                  if (matchingItem) {
                    return {
                      ...wsItem,
                      discount: matchingItem.discount,
                      nettotal: matchingItem.nettotal,
                      taxAmount: matchingItem.taxAmount,
                      salePrice: matchingItem.salePrice,
                      discountName: matchingItem.discountName || "",
                      mPricingruleId: matchingItem.mPricingruleId || "",
                    };
                  }
                  return wsItem;
                }),
                total: finalCartObj.total,
                tax: finalCartObj.tax,
                discount: finalCartObj.discount,
              };
            }
          } else {
            // wsData was empty or missing -- build it from finalCartObj so the
            // table-open logic has valid data on next click.
            updatedWsData = {
              ...finalCartObj,
              items: enrichedItems,
            };
          }

          const updatedLines = (finalCartObj.items || []).map(
            (item) => `{
            fbOrderId: "${activeOrder.fbOrderId}"
            fbOrderLineId: "${item.fbOrderLineId}"
            mPoductId: "${item.productId}"
            mBatchId: null
            description: "good"
            csUomId: "${item.uom}"
            csTaxId: "${item.tax}"
            discount:${item.discount}
            line: 1
            qty: ${item.weight}
            unitPrice: ${item.realPrice}
            listPrice: 30
            lineNet: 2.6
            lineTax: ${item.taxRate}
            lineGross: 30
            sOrderLineId: null
            isOrdered: "Y"
            meta:[]
            }`
          );

          await db.fbOrderData.update(activeOrder.id, {
            cart: updatedCart,
            lines: updatedLines,
            wsData: updatedWsData,
            fbOrderSync: "N",
          });

          // Also update wsData on the table record so handleTable/handleExistingOrder
          // reads the correct state when the table is clicked next.
          await db.tableData.update(selectedTableData?.cwrFbTableId, {
            wsData: updatedWsData,
            tableSync: "N",
          });
        }
      }
      upsertPOSLog("DAP");
      setDiscountAdditionalInfo([]);
      localStorage.removeItem("discountAppliedData");
      if (pricingRule.type === "TD") {
        verifyStock();
      }
      if (searchInputRef?.current) {
        searchInputRef?.current?.focus();
      }
    }
  };

  const applyManualDiscount = async (values) => {
    const activeItems = cart.items.filter((i) => i.isCanceled !== "Y");
    const activeCart = selectedReturnTypeLocal === "EXCHANGE" && exchangeCartData?.items?.length > 0 ? exchangeCartData : cart;
    const activeCartItems = activeCart?.items?.filter((i) => i.isCanceled !== "Y");
    if (activeCartItems.length === 0) {
      message.warning("No active items to apply discount");
      return;
    }
    setManualDiscountInput("");
    setSelectedManualDiscountTypeValue(null);
    if (selectedManualDiscountType && values.discountName && values.discountValue && activeCart.items.length > 0) {
      manualDiscountForm.resetFields();
      // setManualDiscountModalVisible(false);
      const pr = await db.pricingRules.toArray();
      const pricingRule = pr[pr.findIndex((md) => md.mPricingrulesId === values.discountName && md.manualDiscount === "Y")];
      if (pricingRule.discountType === "P" && values.discountValue > 100 && pricingRule.type === "TD") {
        message.error(`${messages.errors.discounts.percentage_exceeds_limit}`);
        return;
      } else if (pricingRule.discountType === "V" && values.discountValue > activeCart.total) {
        message.error(`${messages.errors.discounts.amount_exceeds_total}`);
        return;
      }

      if (values.discountValue > 100 && pricingRule.type === "PD") {
        message.error(`${messages.errors.discounts.percentage_exceeds_limit}`);
        return;
      } else if (values.discountValue > selectedProductInCart.nettotal && pricingRule.type === "FD") {
        message.error(`${messages.errors.discounts.amount_exceeds_total}`);
        return;
      }
      let approvalFlag = true;
      let discountValue = values.discountValue;
      let matchingApproval;
      const minValue = pricingRule?.mPricingApprovals?.reduce((min, item) => Math.min(min, item.min), Infinity);
      const maxValue = pricingRule?.mPricingApprovals?.reduce((max, item) => Math.max(max, item.max), -Infinity);
      if (pricingRule?.mPricingApprovals?.length > 0 && pricingRule?.enableApproval === "Y") {
        matchingApproval = pricingRule.mPricingApprovals.find((approval) => {
          if (approval.type === "P") {
            if (pricingRule.discountType === "V") {
              if (pricingRule.type === "TD") {
                discountValue = (values.discountValue / activeCart.total) * 100;
              } else {
                discountValue = (values.discountValue / selectedProductInCart.nettotal) * 100;
              }
              return discountValue >= approval.min && (approval?.max ? discountValue <= approval.max : true);
            } else {
              return values.discountValue >= approval.min && (approval?.max ? values.discountValue <= approval.max : true);
            }
          } else if (approval.type === "V") {
            if (pricingRule.discountType === "P") {
              if (pricingRule.type === "TD") {
                discountValue = (values.discountValue / 100) * activeCart.total;
              } else {
                discountValue = (values.discountValue / 100) * selectedProductInCart.nettotal;
              }
              return discountValue >= approval.min && (approval?.max ? discountValue <= approval.max : true);
            } else {
              return values.discountValue >= approval.min && (approval?.max ? values.discountValue <= approval.max : true);
            }
          }
        });

        localStorage.setItem("discountAppliedData", JSON.stringify(totalBillDiscountData));

        if (pricingRule?.additionalInfo?.length > 0) {
          setDiscountVerifictionData({
            pricingRule: pricingRule,
            matchingApproval: matchingApproval,
            values: values,
          });
          setDiscountAdditionalInfo(pricingRule.additionalInfo);
          return;
        }
        if (!matchingApproval && discountValue > minValue) {
          message.warning(`${messages.errors.discounts.approval_required}`);
          return;
        } else if (discountValue >= minValue && discountValue <= maxValue) {
          approvalFlag = await new Promise((resolve) => {
            discountApproval([matchingApproval], pricingRule, null, totalBillDiscountData?.discountedAmount, totalBillDiscountData?.totalBillPrice, (eventData) => {
              resolve(eventData?.approvalGranted);
            });
          });
        } else if (discountValue > maxValue) {
          return;
        }
      }

      if (!approvalFlag) return;
      processManualDiscount(pricingRule, matchingApproval, values);
    } else {
      message.warning(`${messages.info.valid_input}`);
    }
  };

  const processLineManualDiscount = () => {
    const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === selectedManualDiscountType)];
    if (pricingRule.type === "V") {
      CheckoutFlatDiscount(cart, setCart, selectedRowKeys, pricingRule, manualDiscountInput, tillaccess);
    }

    if (pricingRule.type === "P") {
      CheckoutPercentageDiscount(cart, setCart, selectedRowKeys, pricingRule, manualDiscountInput, tillaccess);
    }
    setSelectedRowKeys([]);
  };

  const processTotalManualDiscount = (discountParam) => {
    CheckoutTotalManualDiscount(discountParam, setCart, cart, manualDiscountTypes, selectedManualDiscountType, manualDiscountInput, tillaccess);
  };

  const removeAllDiscounts = (discountFlag = false, type = false) => {
    setManualDiscountModalVisible(false);
    setManualDiscountInput(null);
    setSelectedManualDiscountTypeValue(null);
    const cartItems = isExchange && exchangeCartData?.items?.length > 0 ? exchangeCartData?.items : cart.items;
    let updatedCart = isExchange && exchangeCartData?.items?.length > 0 ? exchangeCartData : cart;
    function calculateCartItem(addedToCart) {
      if (addedToCart.isCanceled === "Y") {
        addedToCart.discount = 0;
        return addedToCart;
      }
      if (addedToCart.children && addedToCart.children.length > 0 && addedToCart.companion !== "Y") {
        addedToCart.children = addedToCart.children.map((child) => calculateCartItem(child));
        addedToCart.children.forEach((child, index) => {
          const taxInclude = (child.realPrice * child.taxRate) / 100;
          const sp = ((taxIncludeFlag === "Y" ? child.realPrice : child.realPrice + taxInclude) * child.weight || child.nettotal) - child.discount;
          const tax = sp - sp / (1 + child.taxRate / 100);
          child.nettotal = sp;
          child.taxAmount = tax;
        });
        const childrenNetTotal = addedToCart.children.reduce((sum, child) => sum + (child.nettotal || 0), 0);
        const childrenTaxAmount = addedToCart.children.reduce((sum, child) => sum + (child.taxAmount || 0), 0);

        addedToCart.salePrice = addedToCart.realPrice;
        addedToCart.taxAmount = parseFloat(parseFloat(childrenTaxAmount)?.toFixed(precision));
        addedToCart.nettotal = parseFloat(parseFloat(childrenNetTotal)?.toFixed(precision));
        addedToCart.discount = 0;
        addedToCart.discountName = "";
        addedToCart.nextRule = "N";
        addedToCart.mPricingruleId = "";
        delete addedToCart.priority;
      } else {
        const sp = parseFloat(addedToCart.realPrice);
        const mrp = parseFloat(parseFloat(parseFloat(sp) * addedToCart.weight)?.toFixed(precision));
        const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addedToCart.taxRate / 100) : mrp * (addedToCart.taxRate / 100);
        addedToCart.salePrice = sp;
        addedToCart.taxAmount = parseFloat(parseFloat(tax)?.toFixed(precision));
        addedToCart.mPricingruleId = "";
        addedToCart.nettotal = taxIncludeFlag === "Y" ? parseFloat(parseFloat(mrp)?.toFixed(precision)) : parseFloat(parseFloat(parseFloat(mrp) + tax)?.toFixed(precision));
        addedToCart.discount = 0;
        addedToCart.discountName = "";
        addedToCart.nextRule = "N";
        delete addedToCart.priority;
        const nettotalFixed = addedToCart.nettotal;
        addedToCart.linegross = nettotalFixed;
      }
      return addedToCart;
    }

    const pricingRuleIndex = manualDiscountTypes.findIndex((md) => md.mPricingrulesId === selectedProductInCart?.mPricingruleId);

    cartItems.forEach((addedToCart, i) => {
      if ((pricingRuleIndex === undefined || !manualDiscountTypes[pricingRuleIndex]) && !type) {
        updatedCart.manualDiscountData = {
          totalLevelDiscount: [],
          lineLevelDiscount: updatedCart?.manualDiscountData?.lineLevelDiscount || [],
        };
        addedToCart.allDiscounts = [];
        addedToCart.approval = [];
        cartItems[i] = calculateCartItem(addedToCart);
        return;
      }
      if (discountFlag && manualDiscountTypes[pricingRuleIndex].type !== "TD" && selectedProductInCart.lineId === addedToCart.lineId) {
        updatedCart.manualDiscountData.lineLevelDiscount = updatedCart.manualDiscountData?.lineLevelDiscount?.filter((item) => item.lineId !== addedToCart.lineId);
        addedToCart.allDiscounts = (addedToCart.allDiscounts || [])?.filter((item) => item.mPricingruleId !== manualDiscountTypes[pricingRuleIndex].mPricingrulesId);
        addedToCart.approval = (addedToCart?.approval || [])?.filter((item) => item.mPricingrulesId !== manualDiscountTypes[pricingRuleIndex].mPricingrulesId);
      } else if (
        discountFlag &&
        manualDiscountTypes[pricingRuleIndex].type === "TD" &&
        selectedProductInCart.mPricingruleId === manualDiscountTypes[pricingRuleIndex].mPricingrulesId
      ) {
        updatedCart.manualDiscountData.totalLevelDiscount = updatedCart.manualDiscountData?.totalLevelDiscount?.filter(
          (item) => item.pricingRule !== manualDiscountTypes[pricingRuleIndex].mPricingrulesId
        );
        addedToCart.allDiscounts = (addedToCart.allDiscounts || [])?.filter((item) => item.mPricingruleId !== manualDiscountTypes[pricingRuleIndex].mPricingrulesId);
        addedToCart.approval = (addedToCart?.approval || [])?.filter((item) => item.mPricingrulesId !== manualDiscountTypes[pricingRuleIndex].mPricingrulesId);
      } else if (!discountFlag && Object.keys(selectedProductInCart).length === 0 && !type) {
        updatedCart.manualDiscountData = {};
      }
      cartItems[i] = calculateCartItem(addedToCart);
    });

    let totalTax = 0;
    let totalPrice = 0;
    let totalItemsQty = 0;
    let totalDiscounts = 0;

    for (let i = 0; i < cartItems.length; i += 1) {
      if (cartItems[i].isCanceled === "Y") continue;
      totalPrice += cartItems[i].nettotal;
      totalItemsQty += cartItems[i].weight;
      totalTax += cartItems[i].taxAmount;
      totalDiscounts += cartItems[i].discount;
      cartItems[i].key = i;
    }

    const roundOffValue = Math.round(totalPrice);
    const totalRoundOff = totalPrice - roundOffValue;
    totalPrice = roundOffValue;

    // delete cart["manualDiscountApplied"];
    delete updatedCart["manualDiscountApplied"];

    /* Dine-in DB persist is deferred -- see dineInSyncNeeded flag below.
       We must wait for finalCartObj to be fully computed before writing to DB,
       because `cart` (React state closure) has STALE discount values. */
    const dineInSyncNeeded = tillaccess?.layout === "2" && localStorage.getItem("dineIn") === "Y" && localStorage.getItem("tableName");

    let updatedTotalTax = 0;
    let updatedTotalPrice = 0;
    let updatedTotalItemsQty = 0;
    let updatedTotalDiscounts = 0;

    if (updatedCart?.manualDiscountData?.lineLevelDiscount?.length > 0) {
      updatedCart.manualDiscountData.lineLevelDiscount.map(async (item) => {
        const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
        let productSelected = updatedCart.items.filter((cartItem) => cartItem.productId === item.productId);
        if (pricingRule?.type === "FD") {
          try {
            const newCart = await CheckoutFlatDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying flat discount:", err);
          }
        } else if (pricingRule?.type === "PD") {
          try {
            const newCart = await CheckoutPercentageDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying percentage discount:", err);
          }
        }
      });
    }

    if (updatedCart?.manualDiscountData?.totalLevelDiscount?.length > 0) {
      updatedCart.manualDiscountData.totalLevelDiscount.map(async (item) => {
        const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
        if (pricingRule?.type === "TD") {
          try {
            const newCart = await CheckoutTotalManualDiscount(pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying Total discount:", err);
          }
        }
      });
    }

    const itemSummery = {
      decimalItems: { totalQty: 0, totalAmount: 0 },
      nonDecimalItems: { totalQty: 0, totalAmount: 0 },
      itemsQty: 0,
      items: 0,
    };

    // Group items by tax rate
    const allItems = (updatedCart.items || [])
      .filter((i) => i.isCanceled !== "Y")
      .flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
    const groupedItems = allItems.reduce((acc, item) => {
      const key = item.tax?.rate ?? item.taxRate ?? "0";
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    // Calculate tax totals with SGST and CGST
    const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
      const totalTaxAmount = items.reduce((sum, item) => {
        const taxValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.taxAmount : item.taxAmount) || 0;
        return sum + parseFloat(parseFloat(taxValue)?.toFixed(precision));
      }, 0);

      const totalNetTotal = items.reduce((sum, item) => {
        const netValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.nettotal : item.nettotal) || 0;
        return parseFloat(parseFloat(sum).toFixed(precision)) + parseFloat(parseFloat(netValue).toFixed(precision));
      }, 0);

      // Calculate SGST and CGST (assuming they're either explicitly provided or half of total tax)
      const totalSgstAmount = items.reduce((sum, item) => {
        const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(sgstValue)?.toFixed(precision));
      }, 0);

      const totalCgstAmount = items.reduce((sum, item) => {
        const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(cgstValue)?.toFixed(precision));
      }, 0);

      return {
        taxRate,
        totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount)?.toFixed(precision)),
        totalLinetax: parseFloat(parseFloat(totalTaxAmount)?.toFixed(precision)),
        totalLinegross: parseFloat(parseFloat(totalNetTotal)?.toFixed(precision)),
        totalSgst: parseFloat(parseFloat(totalSgstAmount)?.toFixed(precision)),
        totalCgst: parseFloat(parseFloat(totalCgstAmount)?.toFixed(precision)),
      };
    });

    updatedCart.items = updatedCart.items.map((item, i) => {
      if (item.isCanceled === "Y") {
        item.discount = 0;
        item.key = i;
        return item;
      }
      const nettotalFixed = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      const taxAmountFixed = parseFloat(parseFloat(item.taxAmount)?.toFixed(precision));
      const discountFixed = item.discount ? parseFloat(parseFloat(item.discount)?.toFixed(precision)) : 0;

      // Update aggregated totals
      updatedTotalPrice = parseFloat(parseFloat(updatedTotalPrice + nettotalFixed)?.toFixed(precision));
      updatedTotalItemsQty = parseFloat(parseFloat(updatedTotalItemsQty + item.weight)?.toFixed(precision));
      updatedTotalTax = parseFloat(parseFloat(updatedTotalTax + taxAmountFixed)?.toFixed(precision));
      updatedTotalDiscounts = parseFloat(parseFloat(updatedTotalDiscounts + discountFixed)?.toFixed(precision));

      // Update individual item properties
      item.discount = discountFixed;
      item.key = i;
      item.nettotal = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));

      if (Array.isArray(item.children) && item.children.length > 0 && item.companion !== "Y") {
        item.children.forEach((child) => {
          const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
          const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

          itemSummery.itemsQty += child.weight;
          itemSummery.items += 1;
          itemSummery[summaryKey].totalQty += child.weight;
          itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(child.nettotal)?.toFixed(precision));
        });
      } else {
        const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
        const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

        itemSummery.itemsQty += item.weight;
        itemSummery.items += 1;
        itemSummery[summaryKey].totalQty += item.weight;
        itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      }

      // if (!item.isGiftCard) {
      //   let lineTax = item.listPrice * (1 + item.taxRate / 100);
      //   let unitPrice = item.nettotal / item.weight - (item.nettotal / item.weight / 100) * item.taxRate;
      //   if (!isFinite(unitPrice)) unitPrice = 0;

      //   let unitTax = item.taxAmount / item.weight;
      //   item.sunitprice = item.realPrice;
      //   const gross_list = taxIncludeFlag === "Y" ? item.listPrice : item.listPrice * (1 + item.taxRate / 100);
      //   const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
      //   const netList = taxIncludeFlag === "Y" ? (item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision) : item.listPrice;
      //   item.listPrice = taxIncludeFlag === "Y" ? item.listPrice : parseFloat(lineTax?.toFixed(precision));
      //   item.linetax = Math.abs(nettotalFixed) > 0 ? taxAmountFixed : 0;
      //   item.linenet = Math.abs(nettotalFixed) > 0 ? parseFloat((item.nettotal - item.taxAmount)?.toFixed(precision)) : 0;
      //   item.linegross = Math.abs(nettotalFixed) > 0 ? nettotalFixed : 0;
      //   item.netunit = Math.abs(nettotalFixed) > 0 ? unitPrice?.toFixed(precision) : 0;
      //   item.listprice = Math.abs(nettotalFixed) > 0 ? item.listPrice : 0;
      //   item.grossunit = Math.abs(nettotalFixed) > 0 ? parseFloat(grossUnit?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0;
      //   item.grossstd = Math.abs(nettotalFixed) > 0 ? item.sunitprice : 0;
      //   item.grosslist = Math.abs(nettotalFixed) > 0 ? gross_list : 0;
      //   item.netList = Math.abs(nettotalFixed) > 0 ? netList : 0;
      //   item.unitPrice = Math.abs(nettotalFixed) > 0 ? unitPrice : 0;
      //   item.taxAmount = Math.abs(nettotalFixed) > 0 ? taxAmountFixed : 0;
      // }
      return item;
    });

    const sumLineTotals = (lines) => {
      let totalLineGross = 0;
      let totalLineTax = 0;

      lines.forEach((line) => {
        if (line.isCanceled === "Y") return;
        totalLineGross += line.nettotal;
        totalLineTax += line.taxAmount;
      });

      return { totalLineGross, totalLineTax };
    };
    // Compare and Adjust Order Totals
    const adjustOrderTotals = (order, lines) => {
      const { totalLineGross, totalLineTax } = sumLineTotals(lines);
      let adjustedOrderGross = order.total;
      let adjustedOrderTax = order.tax;

      const grossDifference = totalLineGross - adjustedOrderGross;
      const taxDifference = totalLineTax - adjustedOrderTax;

      if (Math.abs(grossDifference) > 0.01) {
        adjustedOrderGross += grossDifference;
      }

      if (Math.abs(taxDifference) > 0.01) {
        adjustedOrderTax += taxDifference;
      }

      return {
        ...order,
        total: adjustedOrderGross,
        tax: adjustedOrderTax,
      };
    };
    updatedCart = adjustOrderTotals(updatedCart, updatedCart.items);
    const allItemsInCart = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
    const updatedTotalStd = allItemsInCart.reduce((sum, item) => sum + (item.linestd || 0), 0);
    let finalCartObj = {
      ...updatedCart,
      items: [...updatedCart.items],
      discount: updatedTotalDiscounts,
      totalQty: updatedTotalItemsQty,
      total: parseFloat(parseFloat(updatedTotalPrice).toFixed(precision)),
      tax: updatedTotalTax,
      subTotal: parseFloat(parseFloat(updatedTotalPrice - updatedTotalTax)?.toFixed(precision)),
      totalDiscountFlag: !discountFlag || Object.keys(selectedProductInCart).length === 0 ? false : true,
      // itemSummery,
      groupedItemsByTaxRate,
      totalStd: updatedTotalStd,
    };
    // if (discountFlag && !isExchange) {
    //   previousTcsRef.current = 0;
    //   setCart(finalCartObj);
    //   localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
    // }

    if (discountFlag) {
      previousTcsRef.current = 0;

      if (isExchange) {
        localStorage.setItem("exchangeCartObj", JSON.stringify(finalCartObj));
      } else {
        setCart(finalCartObj);
        localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
      }
    }
    /* Dine-in DB persist runs AFTER finalCartObj is fully computed.
       Uses finalCartObj (not stale `cart` closure) so DB gets correct values.
       This is fire-and-forget -- UI is already updated via setCart above. */
    if (dineInSyncNeeded) {
      const tableInfoStr = localStorage.getItem("tableName");
      const tableInfo = JSON.parse(tableInfoStr);
      db.fbOrderData
        .where("cwrFbTableId")
        .equals(tableInfo?.cwrFbTableId)
        .toArray()
        .then((ordersFetched) => {
          if (ordersFetched.length > 0) {
            ordersFetched.map(async (fbOrder) => {
              if (fbOrder.fbOrderStatus === "IP") {
                let orderLines = [];
                // Use finalCartObj (fully recalculated) instead of stale `cart`
                fbOrder.cart = { ...finalCartObj };
                fbOrder.fbOrderSync = "N";
                finalCartObj.items.forEach((item) => {
                  orderLines.push(`{
                    fbOrderId: "${fbOrder.fbOrderId}"
                    fbOrderLineId: "${item.fbOrderLineId}"
                    mPoductId: "${item.productId}"
                    mBatchId: null
                    description: "good"
                    csUomId: "${item.uom}"
                    csTaxId: "${item.tax}"
                    discount:${item.discount}
                    line: 1
                    qty: ${item.weight}
                    unitPrice: ${item.realPrice}
                    listPrice: 30
                    lineNet: 2.6
                    lineTax: ${item.taxRate}
                    lineGross: 30
                    sOrderLineId: null
                    isOrdered: "Y"
                    meta:[]
                    }`);
                });
                fbOrder.lines = orderLines;

                // Update wsData to reflect recalculated discount values
                if (fbOrder.wsData && typeof fbOrder.wsData === "object" && Object.keys(fbOrder.wsData).length > 0) {
                  if (Array.isArray(fbOrder.wsData.items) && fbOrder.wsData.items.length > 0) {
                    fbOrder.wsData = {
                      ...fbOrder.wsData,
                      items: fbOrder.wsData.items.map((wsItem) => {
                        const matchingCartItem = finalCartObj.items.find((ci) => ci.fbOrderLineId === wsItem.fbOrderLineId);
                        if (matchingCartItem) {
                          return {
                            ...wsItem,
                            discount: matchingCartItem.discount,
                            nettotal: matchingCartItem.nettotal,
                            taxAmount: matchingCartItem.taxAmount,
                            salePrice: matchingCartItem.salePrice,
                            discountName: matchingCartItem.discountName || "",
                            mPricingruleId: matchingCartItem.mPricingruleId || "",
                          };
                        }
                        return wsItem;
                      }),
                      total: finalCartObj.total,
                      tax: finalCartObj.tax,
                      discount: finalCartObj.discount,
                    };
                  }
                } else {
                  // wsData was empty -- build from finalCartObj
                  fbOrder.wsData = { ...finalCartObj };
                }

                await db.fbOrderData.put(fbOrder, fbOrder.fbOrderId);

                // Also update wsData on tableData
                await db.tableData.update(tableInfo?.cwrFbTableId, {
                  wsData: fbOrder.wsData,
                  tableSync: "N",
                });

                // SyncData(fbOrder, "upsertFbOrder");
              }
            });
          }
        });
    }

    if (searchInputRef?.current) {
      searchInputRef?.current?.focus();
    }
    return finalCartObj;
  };

  let index = 0;
  const selectPurchaseBillForReturn = (data) => {
    if (index === 0) {
      let returnBillItem = data[0];
      setDisplayReturnOrderSearch(false);
      setReturnSearchType("orderNo");

      const discountValue = returnBillItem.discAmount;
      let grossstdTotal = 0;
      for (let i = 0; i < returnBillItem.line.length; i += 1) {
        grossstdTotal += parseFloat(returnBillItem.line[i].grossstd);
      }
      const zeroDiscountCount = returnBillItem.line.filter((item) => item.discount === 0).length;

      if (zeroDiscountCount === returnBillItem.line.length && discountValue > 0) {
        returnBillItem.line.forEach((addedToCart, index) => {
          const discountAmt = parseFloat((addedToCart.grossstd / grossstdTotal) * discountValue) / addedToCart.qty;
          const sp = parseFloat(addedToCart.grossstd) - discountAmt;
          addedToCart.grossstd = sp;
          addedToCart.linestd = sp * addedToCart?.weight;
          returnBillItem.line[index] = addedToCart;
        });
      }
      const updatedDataSource = [...returnBillItem.line];
      let itemsToReturn = 0;
      let itemsQtyToReturn = 0;
      let returnAmountTotal = 0;

      updatedDataSource.forEach((_, i) => {
        updatedDataSource[i].key = `${i}`;
        updatedDataSource[i].remainingQty = updatedDataSource[i].returnQty > 0 ? updatedDataSource[i].qty - updatedDataSource[i].returnQty : updatedDataSource[i].qty;
        updatedDataSource[i].qtyToReturn = updatedDataSource[i].returnQty > 0 ? updatedDataSource[i].qty - updatedDataSource[i].returnQty : updatedDataSource[i].qty;
        itemsToReturn += 1;
        itemsQtyToReturn += updatedDataSource[i].qtyToReturn > 0 ? updatedDataSource[i].qtyToReturn : updatedDataSource[i].qty;
        if (updatedDataSource[i].linegross && updatedDataSource[i].qty) {
          const unitGross = Math.abs(updatedDataSource[i].linegross) / Math.abs(updatedDataSource[i].qty);
          returnAmountTotal += updatedDataSource[i].qtyToReturn * unitGross;
        } else {
          // Fallback to old calculation (only runs if return data is missing fields)
          returnAmountTotal += updatedDataSource[i].qtyToReturn * parseFloat(updatedDataSource[i].grossstd || 0);
        }
        //returnAmountTotal += (updatedDataSource[i].qtyToReturn > 0 ? updatedDataSource[i].qtyToReturn : updatedDataSource[i].qty) * parseFloat(updatedDataSource[i].grossstd || 0);
      });
      updatedDataSource.itemsToReturn = 0;
      updatedDataSource.itemsQtyToReturn = 0;
      updatedDataSource.returnAmountTotal = 0;

      returnBillItem.itemsToReturn = itemsToReturn;
      returnBillItem.itemsQtyToReturn = itemsQtyToReturn;
      returnBillItem.returnAmountTotal = returnAmountTotal;
      setDataSource([...updatedDataSource]);
      setSelectedReturnOrder({ ...returnBillItem });
      index++;
    }
  };

  const searchReturnHistory = async (documentno, record) => {
    const searchQuery = `${retrunSearchType} : "${documentno}"`;
    const authHeaders = getOAuthHeaders();
    if (authHeaders && authHeaders.access_token) {
      try {
        setLoading(true);
        const data = {
          query: `query {
                    verifyReturn(${searchQuery}) {
                        sOrderID
                        created
                        createdby
                        updated
                        updatedby
                        accumulation
                        redemption
                        documentno
                        salesRepID
                        dateordered
                        totalQty
                        orderTime
                        cwrProductQty
                        taxamt
                        grosstotal
                        discAmount
                        csBUnit {
                            csBunitId
                            name
                        }
                        cwrB2cCustomer {
                            cwrCustomerId
                            code
                            name
                            mobileNo
                            creditLimit
                            iscredit
                            creditBalance
                            creditApproachPercentage
                            pincode
                            email
                            retlLoyaltyBalance
                            loyaltyLevel{
                              cwrLoyaltyLevelId
                              name
                              accumulationRate
                              redemptionRate
                          }
                          b2cCustomerSegment{
                            name
                            cwrB2CCustomerSegmentId
                             }
                            sCustomer {
                                sCustomerID
                                customerCategory {
                                    sCustomerCateforyId
                                    value
                                    name
                                    description
                                }
                            }
                            cwrWallet {
                              balance_Amt
                              wallet_Id
                            }                                
                        }
                        saleType {
                            cwrSaletypeId
                            name
                            value
                        }
                        cwrTill {
                            cwrTillID
                            till
                        }
                        finReceiptPlan {
                            finReceiptPlanDetails {
                                amount
                                cwrPaymentmethod {
                                    cWRPaymentMethodID
                                    finFinancialAccountId
                                    finPaymentmethodId
                                    integratedPayment
                                    isloyalty
                                    paymentProvider
                                }
                            }
                        }
                        line {
                            sOrderlineID
                            sOrderId
                            line
                            description
                            qty
                            netlist
                            netunit
                            linetax
                            unittax
                            linenet
                            linegross
                            grosslist
                            grossstd
                            returnline
                            returnQty
                            discount
                            mBatchId
                            batchNo
                            product {
                                mProductId
                                name
                                value
                                upc
                                hsncode
                                imageurl
                                isManualQty
                                shortDescription
                                returnable
                                returnDays
                            }
                            uom {
                                csUomId
                                name
                            }
                            tax {
                                csTaxID
                                name
                                rate
                            }
                            pricingRule {
                              mPricingrulesId
                              name
                              discount
                            }
                        }
                      metaData { key value }
                    }
                }`,
        };
        const searchData = await verifyReturn(data);
        let matchedRecord = searchData.data.data.verifyReturn.filter((item) => item.sOrderID === record.sOrderID);
        matchedRecord = matchedRecord.map((order) => {
          const tcsMetaData = order.metaData?.find((m) => m.key === "tcsDetails");
          const tcsDetails = tcsMetaData ? JSON.parse(tcsMetaData.value) : [];
          return { ...order, tcsDetails };
        });
        selectPurchaseBillForReturn(matchedRecord);
        setShowReturnPurchase(true);
        return matchedRecord[0];
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const getProductData = (data, itemData) => {
    return new Promise(function (resolve) {
      db.products
        .where("mProductId")
        .equalsIgnoreCase(data)
        .and((product) => product.isactive === true)
        .and((product) => product.productSegment !== "BG")
        .toArray()
        .then(async (product) => {
          if (product.length > 0) {
            const obj = { ...product[0] };
            if (obj.overRideTax === "Y" && obj.sunitprice <= obj.overRideCondition) {
              // prettier-ignore
              const originalPrice = obj.sunitprice - (obj.sunitprice - (obj.sunitprice * (100 / (100 + obj.taxRate))));
              const taxedPrice = originalPrice + (originalPrice * obj.contraRate) / 100;
              obj.sunitprice = taxedPrice;
              obj.cTaxId = obj.contraTaxId;
              obj.taxRate = obj.contraRate;
            }
            const productDefined = {
              batchno: null,
              description: obj.description,
              discount: itemData.discount * -1,
              productSegment: obj?.productSegment || "",
              imageurl: obj.imageurl,
              isDecimal: obj.isDecimal,
              isManualQty: obj.isManualQty || "N",
              restrictPosQtyEdit: obj.restrictPosQtyEdit,
              showAlternateUomInPos: obj?.showAlternateUomInPos || "N",
              posPriceEdit: obj?.posPriceEdit || "N",
              alternateUom: obj?.alternateUom || null,
              companion: obj?.companion || "N",
              isPromoApplicable: false,
              isReturn: true,
              mBatchId: null,
              mPricingruleId: null,
              name: obj.name,
              name2: obj.name2,
              nettotal: itemData.linegross * -1,
              primaryOrderLine: null,
              productId: obj.mProductId,
              realPrice: obj.sunitprice * -1,
              listPrice: obj.slistprice * -1,
              sunitprice: obj.sunitprice * -1,
              returnQty: null,
              salePrice: itemData.grossstd * -1,
              unitTax: itemData.unittax * -1,
              mrpPrice: obj.sunitprice * -1,
              stock: obj.onhandQty,
              taxCategory: obj.taxCategory,
              taxName: obj?.taxName,
              taxFlag: obj?.taxFlag || "N",
              tax: obj.cTaxId,
              taxAmount: itemData.linetax * -1,
              taxRate: obj.taxRate,
              uom: obj.csUomId,
              interTaxId: obj.interTaxId,
              interTaxRate: obj.interTaxRate,
              interTaxName: obj.interTaxName,
              uom_name: obj.uomName,
              isDecimalQty: obj.uomData?.length > 0 ? (obj.uomData[0].decimal === "Y" ? true : false) : false,
              isQtyDesimal: obj.uomData?.length > 0 ? obj.uomData[0].stdprecision : 2,
              upc: obj.upc,
              value: obj.value,
              weight: 0,
              shortDescription: obj.shortDescription,
              hsncode: obj.hsncode,
              csBunitId: obj.csBunitId,
              mProductCategoryId: obj.mProductCategoryId,
              productManufacturerId: obj.productManufacturerId,
              productBrandId: obj.productBrandId,
              productBrandName: obj?.productBrandName,
              batchedProduct: obj.batchedProduct,
              batchedForSale: obj.batchedForSale,
              batchedForStock: obj.batchedForStock,
              multiPrice: obj.multiPrice,
              shelfLife: obj.shelfLife,
              discountName: itemData.pricingRule.name,
              mPricingruleId: itemData.pricingRule.mPricingrulesId,
            };
            resolve(productDefined);
          }
          //  else {
          //   {
          //     message.warning(`${t("product_search_error")}`);
          //   }
          //   resolve(null);
          // }
          else {
            try {
              const productValue = data;

              if (productValue) {
                console.log("Syncing missing product in getProductData:", productValue);

                const syncId = localStorage.getItem("syncId") || uuidv4().replace(/-/g, "").toUpperCase();

                await syncSingleProductByValue(tillData, syncId, tillData?.tillAccess?.cwrTill?.cwrTillID, productValue);

                // 🔁 Re-fetch after sync
                const productAfterSync = await db.products
                  .where("mProductId")
                  .equalsIgnoreCase(data)
                  .and((product) => product.isactive === true)
                  .and((product) => product.productSegment !== "BG")
                  .toArray();

                if (productAfterSync.length > 0) {
                  const obj = { ...productAfterSync[0] };

                  if (obj.overRideTax === "Y" && obj.sunitprice <= obj.overRideCondition) {
                    const originalPrice = obj.sunitprice - (obj.sunitprice - obj.sunitprice * (100 / (100 + obj.taxRate)));
                    const taxedPrice = originalPrice + (originalPrice * obj.contraRate) / 100;

                    obj.sunitprice = taxedPrice;
                    obj.cTaxId = obj.contraTaxId;
                    obj.taxRate = obj.contraRate;
                  }

                  const productDefined = {
                    batchno: null,
                    description: obj.description,
                    discount: itemData.discount * -1,
                    productSegment: obj?.productSegment || "",
                    imageurl: obj.imageurl,
                    isDecimal: obj.isDecimal,
                    isManualQty: obj.isManualQty || "N",
                    restrictPosQtyEdit: obj.restrictPosQtyEdit,
                    showAlternateUomInPos: obj?.showAlternateUomInPos || "N",
                    posPriceEdit: obj?.posPriceEdit || "N",
                    alternateUom: obj?.alternateUom || null,
                    companion: obj?.companion || "N",
                    isPromoApplicable: false,
                    isReturn: true,
                    mBatchId: null,
                    mPricingruleId: null,
                    name: obj.name,
                    name2: obj.name2,
                    nettotal: itemData.linegross * -1,
                    primaryOrderLine: null,
                    productId: obj.mProductId,
                    realPrice: obj.sunitprice * -1,
                    listPrice: obj.slistprice * -1,
                    sunitprice: obj.sunitprice * -1,
                    returnQty: null,
                    salePrice: itemData.grossstd * -1,
                    unitTax: itemData.unittax * -1,
                    mrpPrice: obj.sunitprice * -1,
                    stock: obj.onhandQty,
                    taxCategory: obj.taxCategory,
                    taxName: obj?.taxName,
                    taxFlag: obj?.taxFlag || "N",
                    tax: obj.cTaxId,
                    taxAmount: itemData.linetax * -1,
                    taxRate: obj.taxRate,
                    uom: obj.csUomId,
                    interTaxId: obj.interTaxId,
                    interTaxRate: obj.interTaxRate,
                    interTaxName: obj.interTaxName,
                    uom_name: obj.uomName,
                    isDecimalQty: obj.uomData?.length > 0 ? obj.uomData[0].decimal === "Y" : false,
                    isQtyDesimal: obj.uomData?.length > 0 ? obj.uomData[0].stdprecision : 2,
                    upc: obj.upc,
                    value: obj.value,
                    weight: 0,
                    shortDescription: obj.shortDescription,
                    hsncode: obj.hsncode,
                    csBunitId: obj.csBunitId,
                    mProductCategoryId: obj.mProductCategoryId,
                    productManufacturerId: obj.productManufacturerId,
                    productBrandId: obj.productBrandId,
                    productBrandName: obj?.productBrandName,
                    batchedProduct: obj.batchedProduct,
                    batchedForSale: obj.batchedForSale,
                    batchedForStock: obj.batchedForStock,
                    multiPrice: obj.multiPrice,
                    shelfLife: obj.shelfLife,
                    discountName: itemData.pricingRule.name,
                    mPricingruleId: itemData.pricingRule.mPricingrulesId,
                  };

                  resolve(productDefined);
                  return;
                }
              }
            } catch (err) {
              console.error("Sync failed in getProductData:", err);
            }

            message.warning(`${t("product_search_error")}`);
            resolve(null);
          }
        });
    });
  };

  const handleSaveReturnCartRecord = (data) => {
    let itemsToReturn = 0;
    let itemsQtyToReturn = 0;
    let returnAmountTotal = 0;
    data.forEach((item, i) => {
      if (item.qtyToReturn > 0) {
        itemsToReturn += 1;
        itemsQtyToReturn += item.qtyToReturn;
        returnAmountTotal += item.qtyToReturn * item.grossstd;
      }
    });

    selectedReturnOrder.line = data;
    selectedReturnOrder.itemsToReturn = itemsToReturn;
    selectedReturnOrder.itemsQtyToReturn = itemsQtyToReturn;
    selectedReturnOrder.returnAmountTotal = returnAmountTotal;
    setSelectedReturnOrder({ ...selectedReturnOrder });
  };

  const addSelectedReturnProductsToCart = async () => {
    try {
      let cartItems = [...cart.items];
      for (let index = 0; index < selectedReturnOrder.line.length; index++) {
        const item = { ...selectedReturnOrder.line[index] };
        let giftCardItem = giftCardItems.filter((giftCard) => giftCard.productId === item.product.mProductId);
        const productItem = checkedKeys.includes(item.key) && giftCardItem.length === 0 ? await getProductData(item.product.mProductId, item) : null;
        if (productItem && item.qtyToReturn > 0) {
          productItem.sOrderReturnId = item.sOrderId;
          productItem.sOrderlineReturnId = item.sOrderlineID;
          productItem.wastage = localStorage.getItem("wastageFlag") === "Y" ? "Y" : "N";
          productItem.batchno = item?.batchNo?.split("-:")[0] || item?.batchNo || null;
          productItem.mBatchId = item?.mBatchId || null;
          const tcsDetails = selectedReturnOrder?.tcsDetails || [];
          const matchedTcs = tcsDetails.find((tcs) => tcs.productId === item.product.mProductId);
          if (matchedTcs) {
            const fullQty = item.qty || 1;
            const tcsPerUnit = parseFloat(matchedTcs.amount) / fullQty;
            const returnedQty = item.qtyToReturn || 1;
            productItem.itemTcs = -parseFloat((tcsPerUnit * returnedQty).toFixed(pricePrecision));
          } else {
            productItem.itemTcs = 0;
          }
          if (item.returnQty < item.qty) {
            let discountAmount = productItem.discount / item.qty;
            productItem.weight = -item.qtyToReturn;
            const mrp = parseFloat(Math.abs(productItem.salePrice)) * parseFloat(item.qtyToReturn);
            const tax = productItem.taxAmount / item.qty;
            productItem.discount = discountAmount * item.qtyToReturn;
            productItem.taxAmount = tax * item.qtyToReturn;
            // productItem.realPrice = item.netunit + item.linetax + item.discount;
            productItem.realPrice = item.grossstd > 0 ? item.grossstd : (item.netunit + item.linetax + item.discount) / item.qty;
            // productItem.nettotal = (mrp - parseFloat(productItem.discount ? Math.abs(productItem.discount) : 0)) * -1;
            if (item.linegross) {
              const unitGross = Math.abs(item.linegross) / Math.abs(item.qty);
              productItem.nettotal = -parseFloat(parseFloat(unitGross * item.qtyToReturn).toFixed(precision));
            } else {
              // fallback to old logic (normal sales)
              productItem.nettotal = mrp > 0 ? -Math.abs(mrp - parseFloat(productItem.discount ? Math.abs(productItem.discount) : 0)) : 0;
            }
            let netStd = parseFloat(Math.abs(productItem.sunitprice) - Math.abs(productItem.sunitprice) / (1 + Math.abs(productItem.taxRate) / 100));
            const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData")) || {};
            let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
            productItem.netStd =
              taxIncludeFlag === "Y"
                ? parseFloat(((Math.abs(productItem.sunitprice) - netStd) * -1).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
                : productItem.sunitprice;
            cartItems.push(productItem);
          }
          if (
            db.logConfiguration.toArray().then((fetched) => {
              fetched.map((item) => {
                item.salesReturn.filter((item) => item.log === "Y").length > 0;
              });
            })
          ) {
            posLogActivity(productItem, "SLR");
          }
        }
      }

      const itemsSummery = {
        decimalItems: { totalQty: 0, totalAmount: 0 },
        nonDecimalItems: { totalQty: 0, totalAmount: 0 },
        itemsQty: 0,
        items: 0,
      };

      cartItems.map((item) => {
        if (Array.isArray(item.children) && item.children.length > 0 && item.companion !== "Y") {
          item.children.forEach((child) => {
            const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
            const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

            itemsSummery.itemsQty += child.weight;
            itemsSummery.items += 1;
            itemsSummery[summaryKey].totalQty += child.weight;
            itemsSummery[summaryKey].totalAmount += parseFloat(parseFloat(child.nettotal)?.toFixed(precision));
          });
        } else {
          const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
          const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

          itemsSummery.itemsQty += item.weight;
          itemsSummery.items += 1;
          itemsSummery[summaryKey].totalQty += item.weight;
          itemsSummery[summaryKey].totalAmount += parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
        }

        return item;
      });

      let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
        ? JSON.parse(localStorage.getItem("orderTimeDetails"))
        : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
        orderStartTime: orderTimeDetails.orderStartTime !== "" ? orderTimeDetails.orderStartTime : moment(new Date()).format("DD-MM-YYYY HH:mm:ss"), // Update orderStartTime to current time
      };
      localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));

      let updatedCart = {
        ...cart,
        items: cartItems,
        isReturn: true,
        customer: selectedReturnOrder.cwrB2cCustomer,
      };
      const allItems = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));

      const groupedItems = allItems.reduce((acc, item) => {
        const key = item.tax?.rate ?? item.taxRate ?? "0";
        acc[key] = acc[key] || [];
        acc[key].push(item);
        return acc;
      }, {});
      const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
        const totalTaxAmount = items.reduce((sum, item) => {
          const taxValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.taxAmount : item.taxAmount) || 0;
          return sum + parseFloat(parseFloat(taxValue)?.toFixed(precision));
        }, 0);

        const totalNetTotal = items.reduce((sum, item) => {
          const netValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.nettotal : item.nettotal) || 0;
          return parseFloat(parseFloat(sum).toFixed(precision)) + parseFloat(parseFloat(netValue).toFixed(precision));
        }, 0);

        // Calculate SGST and CGST (assuming they're either explicitly provided or half of total tax)
        const totalSgstAmount = items.reduce((sum, item) => {
          const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
          return sum + parseFloat(parseFloat(sgstValue)?.toFixed(precision));
        }, 0);

        const totalCgstAmount = items.reduce((sum, item) => {
          const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
          return sum + parseFloat(parseFloat(cgstValue)?.toFixed(precision));
        }, 0);

        return {
          taxRate,
          totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount)?.toFixed(precision)),
          totalLinetax: parseFloat(parseFloat(totalTaxAmount)?.toFixed(precision)),
          totalLinegross: parseFloat(parseFloat(totalNetTotal)?.toFixed(precision)),
          totalSgst: parseFloat(parseFloat(totalSgstAmount)?.toFixed(precision)),
          totalCgst: parseFloat(parseFloat(totalCgstAmount)?.toFixed(precision)),
        };
      });
      let updatedTotalTax = 0;
      let updatedTotalPrice = 0;
      let updatedTotalItemsQty = 0;
      let updatedTotalDiscounts = 0;
      let updatedSubtotal = 0;
      for (let i = 0; i < updatedCart.items.length; i += 1) {
        updatedTotalPrice += updatedCart.items[i].nettotal;
        updatedSubtotal += updatedCart.items[i].nettotal;
        updatedTotalItemsQty += updatedCart.items[i].weight;
        updatedTotalTax += updatedCart.items[i].taxAmount;
        updatedTotalDiscounts += updatedCart.items[i].discount ? updatedCart.items[i].discount : 0;
        updatedCart.items[i].key = i;
      }
      const totalTcs = cartItems.reduce((sum, item) => {
        return sum + parseFloat(item.itemTcs || 0);
      }, 0);
      let finalCartObj = {
        ...updatedCart,
        items: [...updatedCart.items],
        documentno: posConfig?.disableOfflineBilling === "Y" ? selectedReturnOrder?.documentno : updatedCart.documentno,
        total: parseFloat(parseFloat(updatedTotalPrice).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)),
        tax: updatedTotalTax,
        discount: updatedTotalDiscounts,
        totalQty: updatedTotalItemsQty,
        subTotal: updatedSubtotal - updatedTotalTax,
        groupedItemsByTaxRate,
        salesRepId: selectedReturnOrder?.salesRepID || null,
        itemsSummery,
        tcs: parseFloat(totalTcs.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)),
      };
      if (!isExchange) {
        localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
        setCart({ ...finalCartObj });
      }
      setLoading(false);
      setKeyValue("2");
    } catch (error) {
      console.error("Error adding selected return products to cart:", error);
    }
  };

  const clearSelectedProductInCart = () => {
    setSelectedProductInCart({});
    // setTimeout(()=>{
    setSelectedRowKeys([]);
    // },100)
  };

  function parseDateTime(dateTimeString) {
    return new Date(dateTimeString.replace(" ", "T") + "Z");
  }

  function calculateDuration(startTime, endTime) {
    const durationMilliseconds = endTime - startTime;
    const totalSeconds = Math.floor(durationMilliseconds / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return { hours, minutes, seconds };
  }

  function formatDuration(duration) {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(duration.hours).padStart(2, "0");
    const minutes = String(duration.minutes).padStart(2, "0");
    const seconds = String(duration.seconds).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const posLogActivity = (record, activity) => {
    const timeMark = timeStamp();
    const currentDate = new Date().toLocaleDateString("zh-Hans-CN");
    let products = "";
    let formattedDuration = "";

    // Calculate duration if orderTimeDetails are present
    if (record.orderTimeDetails) {
      const { orderStartTime, orderEndTime } = record.orderTimeDetails;
      const startTime = parseDateTime(orderStartTime);
      const endTime = parseDateTime(orderEndTime);
      const duration = calculateDuration(startTime, endTime);
      formattedDuration = formatDuration(duration);
    }
    const trxId = uuidv4().replace(/-/g, "").toUpperCase();

    if (_.isArray(record)) {
      record.forEach((item) => {
        products += `SKU: ${item.value}, Qty: ${item.weight}, Unit Price: ${item.salePrice}, `;
      });
    } else {
      products = `SKU: ${record.value}, Qty: ${record.weight}, Unit Price: ${record.salePrice}, `;
    }

    db.logInformation.add({
      type: activity,
      action: "LOG",
      description: activity === "DLN" || activity === "DOR" || activity === "RQT" || activity === "SLR" ? products : activity === "SRD" || activity === "ACT" ? record : "",
      date: currentDate,
      time: timeMark,
      orderNo: `${cart.documentno}`,
      remarks: "",
      transactionId: `${trxId}`,
      status: "SCS",
      duration: formattedDuration ? `"${formattedDuration}"` : null,
    });
  };

  // Paytm QR Code Starts //

  const [paytmQrCodeModalOpens, setPaytmQrCodeModalOpens] = useState(false);
  const [qrCodeResponse, setQrCodeResponse] = useState({});

  const handleVerifyPayment = () => {
    let hostUrl = tillData.tillAccess.cwrTill.hardwareController.imageUrl;
    let verifyPaytmUrl = `${hostUrl}paytm/verifyPayment`;
    const getPaymentSuccessValues = {
      midId: "Excelo34085435005810",
      orderId: `${cart.sOrderID}`,
      merchantKey: "qQUxrwRx@qE6zTxt",
      payUrlForVerify: "https://securegw-stage.paytm.in/v3/order/status",
      clientId: "C11",
      version: "v1",
    };
    Axios({
      url: verifyPaytmUrl,
      method: "POST",
      data: getPaymentSuccessValues,
      headers: {
        "Content-Type": "application/json",
        Authorization: `${authHeaders.access_token}`,
      },
    }).then((response) => {
      if (response.data.body.resultInfo.resultStatus === "TXN_SUCCESS") {
        setPaytmQrCodeModalOpens(false);
        processPayment(selectedPaymentMethod, amount);
      }
    });
  };

  // Paytm QR Code Ends //
  const [customerFlag, setCustomerFlag] = useState(true);

  const removeCutomer = async () => {
    if (cart.payments.length > 0) {
      message.warning(`${messages.errors.cart.delete_payment_first_customer}`);
      return;
    }
    setCustomerFlag(true);
    let latestData = removeAllDiscounts(false, true);
    let cartObj = {
      ...latestData,
      customer: defaultCustomer,
    };
    let updatedCart = cartObj;
    updatedCart = await handleDeleteLoyaltyPayment(updatedCart, latestData.customer);
    if (cartObj.items.length > 0) {
      await Promise.all(
        cartObj.items.map(async (ele) => {
          let addToCart = ele;
          let matchedPriceIndex = [];
          if (defaultCustomer?.cwrCustomerId !== updatedCart?.customer?.cwrCustomerId && addToCart?.priceList?.length > 0) {
            const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData")) || {};
            let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
            // matchedPriceIndex = addToCart?.priceList.filter((i) => i.sPricelistId === updatedCart.customer.sPriceListId);
            // if (matchedPriceIndex.length > 0) {
            //   addToCart.price = matchedPriceIndex[0].pricestd;
            //   addToCart.salePrice = matchedPriceIndex[0].pricestd;
            //   addToCart.realPrice = matchedPriceIndex[0].pricestd;
            //   addToCart.sunitprice = matchedPriceIndex[0].pricestd;
            // } else if (!updatedCart.customer.sPriceListId) {
            //   addToCart.price = ele?.originalPrice || ele?.sunitprice;
            //   addToCart.salePrice = ele?.children?.length > 0 ? ele.realPrice : ele?.originalPrice || ele?.sunitprice;
            //   addToCart.realPrice = ele?.children?.length > 0 ? ele.realPrice : ele?.originalPrice || ele?.sunitprice;
            //   addToCart.sunitprice = ele?.originalPrice || ele?.sunitprice;
            // }
            const selectedPrice = getApplicablePrice({
              priceList: addToCart.priceList,
              selectedUomId: addToCart.uomData[0]?.csUomId,
              sPriceListId: updatedCart.customer.sPriceListId,
              alternateUom: addToCart?.alternateUom || [],
              primaryUomId: addToCart?.uom || null,
            });

            if (selectedPrice) {
              addToCart.price = selectedPrice.pricestd;
              addToCart.salePrice = selectedPrice.pricestd;
              addToCart.realPrice = selectedPrice.pricestd;
              addToCart.sunitprice = selectedPrice.pricestd;
            } else if (!updatedCart.customer.sPriceListId) {
              addToCart.price = ele?.originalPrice || ele?.sunitprice;
              addToCart.salePrice = ele?.children?.length > 0 ? ele.realPrice : ele?.originalPrice || ele?.sunitprice;
              addToCart.realPrice = ele?.children?.length > 0 ? ele.realPrice : ele?.originalPrice || ele?.sunitprice;
              addToCart.sunitprice = ele?.originalPrice || ele?.sunitprice;
            }
            const addOnsPriceSum = _.sumBy(addToCart?.selectedAddons, "price");
            const mrp = (parseFloat(addToCart.salePrice) + addOnsPriceSum * addToCart.weight) * parseFloat(addToCart.weight);
            // const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + (addToCart.taxRate) / 100) : mrp * ((addToCart.taxRate ) / 100);
            let tax;
            if (Array.isArray(ele.children) && ele.children.length > 0) {
              tax = _.sumBy(ele.children, (child) => child.taxAmount);
            } else {
              tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addToCart.taxRate / 100) : mrp * (addToCart.taxRate / 100);
            }
            addToCart.taxAmount = tax;
            addToCart.nettotal =
              taxIncludeFlag === "Y"
                ? parseFloat(parseFloat(mrp - parseFloat(addToCart.discount ? addToCart.discount : 0))?.toFixed(precision))
                : parseFloat(parseFloat(mrp - parseFloat(addToCart.discount ? addToCart.discount : 0))?.toFixed(precision)) + tax;
          }
          addToCart.nettotal = parseFloat(addToCart.nettotal.toFixed(precision));
          updatedCart = await pricingRuleController(addToCart, cartObj, cartObj, setCart, cartObj, orderType);
          return updatedCart;
        })
      );
    } else {
      let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
        ? JSON.parse(localStorage.getItem("orderTimeDetails"))
        : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
      orderTimeDetails = {
        ...orderTimeDetails,
        orderStartTime: "", // Update orderStartTime to current time
      };
      localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
    }

    if (cartObj.totalDiscountFlag) {
      await openPaymentModalByCustomer(updatedCart);
    }

    if (updatedCart?.couponInput?.length > 0) {
      let addToCart = cartObj.items[0];
      await Promise.all(
        updatedCart.couponInput.map(async (coupon) => {
          const matchingPricingRules = await db.pricingRules.where("mPricingrulesId").equalsIgnoreCase(coupon.mPricingruleId).toArray();
          if (matchingPricingRules[0].type !== "TD" && matchingPricingRules[0].type !== "TDF") {
            updatedCart = await pricingRuleController(
              addToCart,
              updatedCart,
              cart,
              setCart,
              cartRef,
              orderType,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          } else {
            updatedCart = await processBillDiscounts(
              matchingPricingRules[0],
              updatedCart,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          }
        })
      );
    }

    if (updatedCart?.manualDiscountData?.lineLevelDiscount?.length > 0) {
      updatedCart.manualDiscountData.lineLevelDiscount.map(async (item) => {
        const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
        let productSelected = updatedCart.items.filter((cartItem) => cartItem.productId === item.productId);
        if (pricingRule?.type === "FD") {
          try {
            const newCart = await CheckoutFlatDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying flat discount:", err);
          }
        } else if (pricingRule?.type === "PD") {
          try {
            const newCart = await CheckoutPercentageDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying percentage discount:", err);
          }
        }
      });
    }

    if (updatedCart?.manualDiscountData?.totalLevelDiscount?.length > 0) {
      updatedCart.manualDiscountData.totalLevelDiscount.map(async (item) => {
        const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
        if (pricingRule?.type === "TD") {
          try {
            const newCart = await CheckoutTotalManualDiscount(pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying Total discount:", err);
          }
        }
      });
    }

    const itemSummery = {
      decimalItems: { totalQty: 0, totalAmount: 0 },
      nonDecimalItems: { totalQty: 0, totalAmount: 0 },
      itemsQty: 0,
      items: 0,
    };

    // Group items by tax rate
    const allItems = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));

    const groupedItems = allItems.reduce((acc, item) => {
      const key = item.tax?.rate ?? item.taxRate ?? "0";
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    // Calculate tax totals with SGST and CGST
    const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
      const totalTaxAmount = items.reduce((sum, item) => {
        const taxValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.taxAmount : item.taxAmount) || 0;
        return sum + parseFloat(parseFloat(taxValue)?.toFixed(precision));
      }, 0);

      const totalNetTotal = items.reduce((sum, item) => {
        const netValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.nettotal : item.nettotal) || 0;
        return parseFloat(parseFloat(sum).toFixed(precision)) + parseFloat(parseFloat(netValue).toFixed(precision));
      }, 0);

      // Calculate SGST and CGST (assuming they're either explicitly provided or half of total tax)
      const totalSgstAmount = items.reduce((sum, item) => {
        const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(sgstValue)?.toFixed(precision));
      }, 0);

      const totalCgstAmount = items.reduce((sum, item) => {
        const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(cgstValue)?.toFixed(precision));
      }, 0);

      return {
        taxRate,
        totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount)?.toFixed(precision)),
        totalLinetax: parseFloat(parseFloat(totalTaxAmount)?.toFixed(precision)),
        totalLinegross: parseFloat(parseFloat(totalNetTotal)?.toFixed(precision)),
        totalSgst: parseFloat(parseFloat(totalSgstAmount)?.toFixed(precision)),
        totalCgst: parseFloat(parseFloat(totalCgstAmount)?.toFixed(precision)),
      };
    });

    let updatedTotalTax = 0;
    let updatedTotalPrice = 0;
    let updatedTotalItemsQty = 0;
    let updatedTotalDiscounts = 0;

    updatedCart.items = updatedCart.items.map((item, i) => {
      const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
      const nettotalFixed = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      const taxAmountFixed = parseFloat(parseFloat(item.taxAmount)?.toFixed(precision));
      const discountFixed = item.discount ? parseFloat(parseFloat(item.discount)?.toFixed(precision)) : 0;

      // Update totals
      updatedTotalPrice += nettotalFixed;
      updatedTotalItemsQty += item.weight;
      updatedTotalTax += taxAmountFixed;
      updatedTotalDiscounts += discountFixed;

      item.discount = discountFixed;
      item.key = i;

      if (!item.isGiftCard) {
        const unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;

        const lineTax = item.listPrice * (1 + item.taxRate / 100);
        const stdTax = item.sunitprice * (1 + item.taxRate / 100);
        const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
        const netList =
          taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision)) : item.listPrice;
        const gross_list = taxIncludeFlag === "Y" ? item.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision));
        const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : parseFloat(parseFloat(stdTax)?.toFixed(precision));
        // const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : item.sunitprice + taxAmountFixed;

        Object.assign(item, {
          linetax: nettotalFixed ? taxAmountFixed : 0,
          linenet: nettotalFixed ? parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision)) : 0,
          linegross: nettotalFixed || 0,
          linestd: nettotalFixed ? parseFloat(parseFloat(grossStd * item.weight)?.toFixed(precision)) : 0,
          netunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
          listprice: nettotalFixed ? item.listPrice : 0,
          grossunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0,
          grossstd: nettotalFixed ? grossStd : 0,
          grosslist: nettotalFixed ? gross_list : 0,
          netList: nettotalFixed ? netList : 0,
          unitPrice: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
          taxAmount: nettotalFixed ? taxAmountFixed : 0,
        });
      }

      // Update summary
      if (Array.isArray(item.children) && item.children.length > 0 && item.companion !== "Y") {
        item.children.forEach((child) => {
          const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
          const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

          itemSummery.itemsQty += child.weight;
          itemSummery.items += 1;
          itemSummery[summaryKey].totalQty += child.weight;
          itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(child.nettotal)?.toFixed(precision));
        });
      } else {
        const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
        const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

        itemSummery.itemsQty += item.weight;
        itemSummery.items += 1;
        itemSummery[summaryKey].totalQty += item.weight;
        itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      }
      return item;
    });

    const sumLineTotals = (lines) => {
      let totalLineGross = 0;
      let totalLineTax = 0;

      lines.forEach((line) => {
        totalLineGross += line.nettotal;
        totalLineTax += line.taxAmount;
      });

      return { totalLineGross, totalLineTax };
    };
    // Compare and Adjust Order Totals
    const adjustOrderTotals = (order, lines) => {
      const { totalLineGross, totalLineTax } = sumLineTotals(lines);
      let adjustedOrderGross = order.total;
      let adjustedOrderTax = order.tax;

      const grossDifference = totalLineGross - adjustedOrderGross;
      const taxDifference = totalLineTax - adjustedOrderTax;

      if (Math.abs(grossDifference) > 0.01) {
        adjustedOrderGross += grossDifference;
      }

      if (Math.abs(taxDifference) > 0.01) {
        adjustedOrderTax += taxDifference;
      }

      return {
        ...order,
        total: adjustedOrderGross,
        tax: adjustedOrderTax,
      };
    };
    updatedCart = adjustOrderTotals(updatedCart, updatedCart.items);
    const allItemsInCart = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
    const updatedTotalStd = allItemsInCart.reduce((sum, item) => sum + (item.linestd || 0), 0);
    let finalCartObj = {
      ...updatedCart,
      items: [...updatedCart.items],
      discount: updatedTotalDiscounts,
      totalQty: updatedTotalItemsQty,
      total: parseFloat(parseFloat(updatedTotalPrice).toFixed(precision)),
      tax: updatedTotalTax,
      totalStd: updatedTotalStd,
    };
    delete finalCartObj.isRetrived;
    delete finalCartObj.parked;
    if (isExchange) {
      localStorage.setItem("exchangeCartObj", JSON.stringify(finalCartObj));
    } else {
      localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
      setCart({ ...finalCartObj });
    }
    hasShownCustomerModalRef.current = false;
    setShowPaymentMethods(false);
    setIsNriBilling(false);
    setIsPanCustomer(false);
    setPanDrawerMode(null);
    setSupplyRegionProceed(false);
    localStorage.removeItem("isB2bEnabled");
    localStorage.removeItem("customerAddressIds");
    localStorage.removeItem("isPanCustomer");
    localStorage.removeItem("isNriBilling");
    localStorage.removeItem("isCreditSale");
    upsertPOSLog(cart, "RCT");
  };

  const handleLoyaltyPayment = async (payment, cartData) => {
    let setAuthTokens;
    const authHeaders = await getOAuthHeaders();
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    const serverUrl = process.env.REACT_APP_serverUrl;
    const tillData = JSON.parse(localStorage.getItem("tillData"));
    let value = parseFloat(parseFloat(payment.amount / cart.customer.redeemptionValue)?.toFixed(precision));
    if (cartData.customer.loyaltyLevel.cwrLoyaltyLevelId) {
      await upsertLoyaltyTransaction(tillData, value * -1, cartData.customer.cwrCustomerId, cartData.referenceId);

      cartData.customer.retlLoyaltyBalance = (cartData?.customer?.retlLoyaltyBalance || 0) + parseFloat(value);
    }
  };

  const handleDeleteLoyaltyPayment = async (updatedCart, customer) => {
    let newCart = JSON.parse(JSON.stringify(updatedCart));
    newCart.customer = customer;
    const matchedPayment = updatedCart.payments.find((pay) => pay.name.toLowerCase() === "loyalty");
    if (!matchedPayment) return updatedCart;
    updatedCart.payments = updatedCart.payments.filter((pay) => pay.name.toLowerCase() !== "loyalty");
    updatedCart.paid = updatedCart.payments.reduce((sum, pay) => sum + parseFloat(pay.amount), 0);
    await handleLoyaltyPayment(matchedPayment, newCart);
    updatedCart.balance = parseFloat(parseFloat(updatedCart.total - updatedCart.paid)?.toFixed(precision));
    return updatedCart;
  };

  // Bill Management //

  const handleManagement = () => {
    // history.push("/bill-management");
    setManagementScreenShow(true);
  };

  const [managementScreenShow, setManagementScreenShow] = useState(false);
  const [orderTypeSelection, setOrderTypeSelection] = useState("Dine In");

  const changeCustomerId = (obj) => {
    let cartDetails = JSON.parse(localStorage.getItem("cartObj"));
    cartDetails.customer.cwrCustomerId = obj.customer.b2cCustomerId;
    if (!isExchange) {
      localStorage.setItem("cartObj", JSON.stringify(cartDetails));
    }
  };

  const rawWalletPayments = JSON.parse(localStorage.getItem("walletPayments")) || [];
  const matchedPayments = rawWalletPayments.map((payment) => {
    const matchedMethod = showPayments.find((method) => method.finPaymentmethodId === payment.finPaymentmethodID);

    return {
      ...matchedMethod,
      ...payment, // overwrite amount from matchedMethod with actual amount
      amount: Number(payment.amount).toFixed(2), // ensure string format like "400.00"
    };
  });

  const handleWalletTopUp = async (amount) => {
    if (!cart?.customer?.cwrCustomerId) {
      message.error(`${messages.errors.customer.not_selected}`);
      return;
    }

    const paymentAmount = Number.parseFloat(amount || 0);
    const storedPayments = JSON.parse(localStorage.getItem("walletPayments"));
    console.log("🔥 storedPayments in handleWalletTopUp:", storedPayments);
    if (!paymentAmount || isNaN(paymentAmount) || paymentAmount <= 0) {
      message.error(`${messages.info.invalid_topup}`);
      return;
    }

    const payload = {
      bunitId: tillData.tillAccess.csBunit.csBunitId,
      customerId: cart.customer.cwrCustomerId,
      trxType: "DP", // assuming DP = Deposit
      trxValue: paymentAmount,
      tillId: tillData?.tillAccess.cwrTill.cwrTillID,
      payments: (storedPayments || []).map(({ count, isBankTransfer, ...p }) => ({
        finPaymentmethodID: p.finPaymentmethodID || p.finPaymentmethodId,
        amount: p.amount,
        ...(p.isBankTransfer === "Y" && {
          financialAccountId: p?.financialAccountId || null,
          transactionTime: p.transactionTime || null,
          imageUrl: p.imageUrl || null,
          transactionId: p?.transactionId || null,
        }),
      })),
      transactionDetails: {
        paymnet: paymentAmount, // typo from original mutation, keep as-is unless it's fixed server-side
      },
    };

    try {
      const response = await upsertWalletTransactionService(payload);

      if (response?.status === "200") {
        await db?.tillEvents
          .where("tillStatus")
          .equals("open")
          .modify((event) => {
            const walletTransactions = [...(event.walletTransactions || [])];

            storedPayments.forEach((payment) => {
              const existingIndex = walletTransactions.findIndex((wt) => wt.finPaymentmethodID === payment.finPaymentmethodID);

              if (existingIndex !== -1) {
                // ✅ If exists → add amount
                walletTransactions[existingIndex].amount += payment.amount;
              } else {
                // ✅ If not exists → add new item
                walletTransactions.push({ ...payment });
              }
            });

            event.walletTransactions = walletTransactions;
          });

        message.success(response.message);
        fetchWalletData();
        setShowTopupModal(false);
        setTopupAmount("");
        setCurrentCashInput("");
        setCurrentCardInput("");
        setCurrentUPIInput("");
        setCashTendered(0);
        setShowCardAmountInput(false);
        cardPaymentForm.resetFields();
        localStorage.removeItem("walletPayments");
        localStorage.removeItem("cardPaymentDetails");
        localStorage.removeItem("walletDataForCardIntegration");
        localStorage.removeItem("giftCardIntegrationTopupData");
      } else {
        message.error(response?.message || `${messages.info.topup_failed}`);
      }
    } catch (err) {
      console.error("Failed to top up wallet:", err);
      message.error(`${messages.info.topup_record_failed}`);
    }
  };

  const currenciesList = tillData?.tillAccess?.csBunit?.currencies;

  const handleWalletRefundComplete = async (amount) => {
    if (!cart?.customer?.cwrCustomerId) {
      message.error("Customer not selected");
      return;
    }

    const paymentAmount = Number.parseFloat(amount || 0);
    const storedPayments = JSON.parse(localStorage.getItem("walletPayments"));

    const payload = {
      bunitId: tillData.tillAccess.csBunit.csBunitId,
      customerId: cart.customer.cwrCustomerId,
      trxType: "WD", // 🔥 REFUND → WD
      trxValue: paymentAmount,
      tillId: tillData?.tillAccess.cwrTill.cwrTillID,
      payments: (storedPayments || []).map(({ count, ...p }) => ({
        finPaymentmethodID: p.finPaymentmethodID || p.finPaymentmethodId,
        amount: -Math.abs(p.amount),
        ...(p.isBankTransfer === "Y" && {
          financialAccountId: p?.financialAccountId || null,
          transactionTime: p.transactionTime || null,
          imageUrl: p.imageUrl || null,
          transactionId: p.transactionId || null,
        }),
      })),
      transactionDetails: {
        payment: paymentAmount,
      },
    };

    try {
      const response = await upsertWalletTransactionService(payload);

      if (response?.status === "200") {
        message.success("Wallet refunded successfully");

        await fetchWalletData();

        setShowRefundModal(false);
        setTopupAmount("");
        setCurrentCashInput("");
        setCurrentCardInput("");
        setDynamicPaymentInput("");
        setCurrentUPIInput("");
        setCashTendered(0);
        cardPaymentForm.resetFields();
        localStorage.removeItem("walletPayments");
        localStorage.removeItem("walletDataForCardIntegration");
        localStorage.removeItem("giftCardIntegrationTopupData");
      } else {
        message.error(response?.message || "Refund failed");
      }
    } catch (err) {
      console.error(err);
      message.error("Refund error");
    }
  };

  const autoFillEnterAmount = (amount, paymentMethod = selectedPaymentMethod) => {
    if (!paymentMethod) return;
    if (amount === "" || isNaN(amount)) return;

    const totalPaid = matchedPayments.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

    const remaining = parseFloat(amount) - totalPaid;
    if (remaining <= 0) return;

    const value = remaining.toString();

    if (paymentMethod.name === "Cash") {
      setCurrentCashInput(value);
    } else if (paymentMethod.name === "Card") {
      setCurrentCardInput(value);
    } else if (paymentMethod.name === "UPI") {
      setCurrentUPIInput(value);
    } else {
      setDynamicPaymentInput(value); // for other methods like NEFT/RTGS
    }
  };

  const handleWalletPostPayment = async (walletData) => {
    const walletDataForCard = JSON.parse(localStorage.getItem("walletDataForCardIntegration"));
    const sourceData = walletDataForCard || walletData || walletFlowData;
    if (!sourceData) return;
    const { paymentAmount, topupTotal, totalPayments, newCashTendered, selectedPaymentMethod, selectedCustomer, customersData, showRefundModal, currenciesList, topupAmount } =
      sourceData;
    // const { paymentAmount, topupTotal, totalPayments, newCashTendered, selectedPaymentMethod, selectedCustomer, customersData, showRefundModal, currenciesList, topupAmount } =
    //   walletFlowData;
    const latestTotalPayments = matchedPayments.reduce((sum, payment) => sum + Number.parseFloat(payment.amount || 0), 0);
    // const updatedTotalPayments = (latestTotalPayments + Number.parseFloat(paymentAmount)).toFixed(2);
    const updatedTotalPayments = (Number.parseFloat(totalPayments) + Number.parseFloat(paymentAmount)).toFixed(2);
    // Create new transaction
    const newTransaction = {
      id: (selectedCustomer?.transactions?.length || 0) + 1,
      date: new Date().toISOString().split("T")[0],
      time: new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true }),
      type: "Credit",
      amount: Number.parseFloat(paymentAmount),
      description: `Wallet Top-up via ${selectedPaymentMethod.name}`,
      reference: `TXN${String(Date.now()).slice(-3)}`,
      balance: (selectedCustomer?.currentBalance || 0) + Number.parseFloat(paymentAmount),
    };

    // Update customer data
    const updatedCustomer = {
      ...selectedCustomer,
      currentBalance: (selectedCustomer?.currentBalance || 0) + Number.parseFloat(paymentAmount),
      lastTransaction: new Date().toISOString().split("T")[0],
      transactions: [newTransaction, ...(selectedCustomer?.transactions || [])],
    };

    if (typeof setCustomersData === "function") {
      if (Array.isArray(customersData)) {
        const updatedCustomers = customersData.map((customer) => (customer?.id === selectedCustomer?.id ? updatedCustomer : customer));
        setCustomersData(updatedCustomers);
      } else {
        setCustomersData(updatedCustomer);
      }
    }

    setSelectedCustomer(updatedCustomer);
    setCurrentCashInput("");
    setCurrentCardInput("");
    setCurrentUPIInput("");
    setCashTendered(newCashTendered);
    const remainingAmount = Number.parseFloat(topupTotal) - Number.parseFloat(updatedTotalPayments);
    if (remainingAmount > 0) {
      // autoFillEnterAmount(remainingAmount.toString());
    } else {
      setCurrentCashInput("");
      setCurrentCardInput("");
      setCurrentUPIInput("");
      setDynamicPaymentInput("");
    }
    // Check if total payments equal topupAmount
    if (Number.parseFloat(updatedTotalPayments) >= Number.parseFloat(topupTotal)) {
      const customerBalance = selectedCustomer?.[0]?.currentBalance || 0;
      if (showRefundModal) {
        const refundAmount = Number.parseFloat(topupAmount || 0);
        const updatedTotal = Number.parseFloat(updatedTotalPayments);
        const customerBalance = selectedCustomer?.[0]?.currentBalance || 0;

        // ❌ Cannot refund more than wallet balance
        if (refundAmount > customerBalance) {
          message.error("Refund amount cannot exceed wallet balance");
          setIsProcessingTopup(false);
          return;
        }

        // ❌ Prevent over refund payment
        if (updatedTotal > refundAmount) {
          message.error("Payment exceeds refund amount");
          setIsProcessingTopup(false);
          return;
        }

        // ✅ Only complete when FULLY PAID
        if (updatedTotal === refundAmount) {
          await handleWalletRefundComplete(refundAmount);
        } else {
          message.success(`${selectedPaymentMethod.name} payment of ${paymentAmount} added. Remaining: ${(refundAmount - updatedTotal).toFixed(2)}`);
          setIsProcessingTopup(false);
        }

        return;
      } else {
        await handleWalletTopUp(topupAmount);
      }
    } else {
      message.success(
        `${selectedPaymentMethod.name} payment of ${currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}${paymentAmount}${
          currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""
        } added. Remaining: ${currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}${(topupTotal - updatedTotalPayments).toFixed(2)}${
          currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""
        }`
      );
      localStorage.removeItem("walletDataForCardIntegration");
      setIsProcessingTopup(false);
    }
  };

  const enterTotalQtyForWallet = async () => {
    if (!selectedPaymentMethod || !selectedPaymentMethod.name) {
      message.warning("Please select a payment method to complete the payment");
      return;
    }

    if (typeof setCart !== "function") {
      console.error("setCart is not a function. Cannot update cart.");
      message.error(`${messages.errors.payments.configuration_payment_failed}`);
      return;
    }

    const currentInput =
      selectedPaymentMethod.name === "Cash"
        ? currentCashInput
        : selectedPaymentMethod.name === "Card"
          ? currentCardInput
          : selectedPaymentMethod.name === "UPI"
            ? currentUPIInput
            : dynamicPaymentInput; // 🔥 for NEFT / RTGS / others

    if (!currentInput || Number.parseFloat(currentInput) <= 0) {
      message.error(`${messages.info.valid_amount}`);
      return;
    }

    if (!topupAmount || Number.parseFloat(topupAmount) <= 0) {
      message.error(`${messages.info.valid_topup_amount}`);
      return;
    }

    const paymentAmount = Number.parseFloat(currentInput).toFixed(2);
    const topupTotal = Number.parseFloat(topupAmount).toFixed(2);
    const newCashTendered = (Number.parseFloat(cashTendered) || 0) + Number.parseFloat(paymentAmount);

    // Calculate total payments from matchedPayments
    const totalPayments = matchedPayments.reduce((sum, payment) => sum + Number.parseFloat(payment.amount || 0), 0).toFixed(2);

    // Check if the new payment amount exceeds the top-up amount
    if (Number.parseFloat(totalPayments) + Number.parseFloat(paymentAmount) > topupTotal) {
      message.error(`${selectedPaymentMethod.name} ${messages.warnings.payment.payment_multiple_check_topup} ${topupTotal - totalPayments}`);
      return;
    }

    setIsProcessingTopup(true);

    try {
      // Validate denomination for cash payments
      if (selectedPaymentMethod.name === "Cash") {
        const filteredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
        if (filteredCurrencies.length > 0) {
          const result = modulo(Number.parseFloat(currentInput || 0), filteredCurrencies[0]?.value || 1);
          if (result !== 0) {
            message.warning(`${messages.warnings.payment.payment_multiple_check} ${filteredCurrencies[0]?.value}`);
            setIsProcessingTopup(false);
            return;
          }
        }
      }
      // Card payment popup logic
      if (selectedPaymentMethod?.name?.toLowerCase() === "card" && selectedPaymentMethod?.integratedPayment && posConfig?.show_card_payment_popup === "Y") {
        if (isValidAmount(paymentAmount)) {
          setShowCardPaymnteModal(true);
        } else {
          message.warning("Kindly enter the amount before proceeding");
        }
      } else if (selectedPaymentMethod?.name?.toLowerCase() === "card" && !selectedPaymentMethod?.integratedPayment && posConfig?.show_card_payment_popup === "Y") {
        if (isValidAmount(paymentAmount)) {
          setPaymentType("manual");
          setCardPaymnetError(true);
          setShowCardPaymnteModal(true);
          const walletDataForCardIntegration = {
            paymentAmount,
            topupTotal,
            totalPayments,
            newCashTendered,
            selectedPaymentMethod,
            selectedCustomer,
            customersData,
            showRefundModal,
            currenciesList,
            topupAmount,
          };
          localStorage.setItem("walletDataForCardIntegration", JSON.stringify(walletDataForCardIntegration));
          return;
        } else {
          message.warning("Kindly enter the amount before proceeding");
        }
      }

      if (
        (selectedPaymentMethod?.name?.toLowerCase() === "card" && selectedPaymentMethod?.integratedPayment) ||
        (selectedPaymentMethod?.name?.toLowerCase() === "upi" && selectedPaymentMethod?.integratedPayment)
      ) {
        setWalletFlowPending(true);
        setWalletFlowData({
          paymentAmount,
          topupTotal,
          totalPayments,
          newCashTendered,
          selectedPaymentMethod,
          selectedCustomer,
          customersData,
          showRefundModal,
          currenciesList,
          topupAmount,
        });
      } else {
        setWalletFlowData({
          paymentAmount,
          topupTotal,
          totalPayments,
          newCashTendered,
          selectedPaymentMethod,
          selectedCustomer,
          customersData,
          showRefundModal,
          currenciesList,
          topupAmount,
        });
      }
      const walletDataForCardIntegration = {
        paymentAmount,
        topupTotal,
        totalPayments,
        newCashTendered,
        selectedPaymentMethod,
        selectedCustomer,
        customersData,
        showRefundModal,
        currenciesList,
        topupAmount,
      };
      localStorage.setItem("walletDataForCardIntegration", JSON.stringify(walletDataForCardIntegration));
      // Call requestPayment with the payment method object
      await requestPayment(selectedPaymentMethod, paymentAmount, undefined, true, walletDataForCardIntegration);

      // if (
      //   (selectedPaymentMethod?.name?.toLowerCase() === "card" && selectedPaymentMethod?.integratedPayment) ||
      //   (selectedPaymentMethod?.name?.toLowerCase() === "upi" && selectedPaymentMethod?.integratedPayment)
      // ) {
      //   return;
      // }

      if (selectedPaymentMethod?.name?.toLowerCase() === "card" || selectedPaymentMethod?.name?.toLowerCase() === "upi") {
        return;
      }

      // Persist cart to localStorage
      localStorage.setItem("cartObj", JSON.stringify(cart));

      handleWalletPostPayment({
        paymentAmount,
        topupTotal,
        totalPayments,
        newCashTendered,
        selectedPaymentMethod,
        selectedCustomer,
        customersData,
        showRefundModal,
        currenciesList,
        topupAmount,
      });
    } catch (error) {
      console.error(`${selectedPaymentMethod.name} top-up error:`, error);
      message.error(`${selectedPaymentMethod?.name || "Payment"} ${messages.errors.payments.wallet_topup_failed}`);
      setIsProcessingTopup(false);
    }
  };

  const rawGiftCardPayments = JSON.parse(localStorage.getItem("walletPayments")) || [];
  const resetGiftCardTopup = () => {
    setShowGiftCardTopup(false);
    setGiftCardTopupAmount("");
    setGiftCardTopupCashInput("");
    setGiftCardTopupCardInput("");
    setGiftCardTopupUPIInput("");
    setGiftCardGenericInput("");
    setGiftCardTopupPaymentPage(0);
    setGiftCardTopupPaymentMethod(null);
    setGiftCardTopupFocusedField("topupAmount");
    setGiftCardTopupDenomKeyboard(false);
    setGiftCardTopupShowCardAmountInput(false);
    giftCardTopupCardForm.resetFields();
    localStorage.removeItem("walletPayments");
    localStorage.removeItem("cardPaymentDetails");
    localStorage.removeItem("walletDataForCardIntegration");
    localStorage.removeItem("giftCardIntegrationTopupData");
  };
  const handleCheckGiftCardBalance = async () => {
    if (!giftCardNumber) {
      message.warning("Please enter Gift Card Number");
      return;
    }
    setIsCheckingBalance(true);
    try {
      const data = {
        query: `query {
          checkGiftCardBalance(cardNo: "${giftCardNumber}", cardPin: ${giftCardPin ? `"${giftCardPin}"` : null}){
              currentBalance
              cardGroup
              status
              message
            }
        }`,
      };
      const giftCardResponse = await checkGiftCard(data);
      if (giftCardResponse.data.data.checkGiftCardBalance.length > 0 && giftCardResponse.data.data.checkGiftCardBalance[0].status === "200") {
        const balance = giftCardResponse.data.data.checkGiftCardBalance[0].currentBalance;
        setGiftCardBalance(balance);
        message.success("Gift Card balance retrieved successfully");
      } else {
        message.error(`${giftCardResponse.data.data.checkGiftCardBalance[0].message}`);
        setGiftCardBalance(null);
      }
    } catch (error) {
      message.error("Failed to check Gift Card balance");
      setGiftCardBalance(null);
    } finally {
      setIsCheckingBalance(false);
    }
  };

  const giftCardMatchedPayments = rawGiftCardPayments.map((payment) => {
    const matchedMethod = showPayments?.find((method) => method.finPaymentmethodId === payment.finPaymentmethodID);
    return {
      ...matchedMethod,
      ...payment,
      amount: Number(payment.amount).toFixed(2),
    };
  });

  const currSymbol = currenciesList?.[0]?.symbolRightSide === "N" ? currenciesList[0].currSymbol : "";
  const currSymbolRight = currenciesList?.[0]?.symbolRightSide === "Y" ? currenciesList[0].currSymbol : "";

  const currentPaymentInput =
    giftCardTopupPaymentMethod?.name?.toLowerCase() === "cash"
      ? giftCardTopupCashInput
      : giftCardTopupPaymentMethod?.name?.toLowerCase() === "card"
        ? giftCardTopupCardInput
        : giftCardTopupPaymentMethod?.name?.toLowerCase() === "upi"
          ? giftCardTopupUPIInput
          : giftCardGenericInput; // ✅ fallback for all other methods

  const giftCardTotalPaid = giftCardMatchedPayments.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

  const giftCardAutoFillAmount = (amount, paymentMethod = giftCardTopupPaymentMethod) => {
    if (!paymentMethod) return;
    if (amount === "" || isNaN(amount)) return;

    const rawPayments = JSON.parse(localStorage.getItem("walletPayments")) || [];

    const totalPaid = rawPayments.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

    const remaining = parseFloat(amount) - totalPaid;
    if (remaining <= 0) return;

    const value = remaining.toString();
    const name = paymentMethod.name?.toLowerCase();

    if (name === "cash") setGiftCardTopupCashInput(value);
    else if (name === "card") setGiftCardTopupCardInput(value);
    else if (name === "upi") setGiftCardTopupUPIInput(value);
    else setGiftCardGenericInput(value);
  };

  const handleGiftCardTopupAmountChange = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, "");
    const parts = sanitizedValue.split(".");

    if (parts.length > 2) return;
    if (parts.length === 2 && parts[1].length > 2) return;

    setGiftCardTopupAmount(sanitizedValue);

    // ✅ clear if empty
    if (sanitizedValue === "") {
      setGiftCardTopupCashInput("");
      setGiftCardTopupCardInput("");
      setGiftCardTopupUPIInput("");
      setGiftCardGenericInput("");
      return;
    }

    // ✅ SAME AS WALLET
    giftCardAutoFillAmount(sanitizedValue);
  };

  const finalizeGiftCardTopup = async (topupTotal) => {
    const currSymbol = currenciesList?.[0]?.symbolRightSide === "N" ? currenciesList[0].currSymbol : "";
    const currSymbolRight = currenciesList?.[0]?.symbolRightSide === "Y" ? currenciesList[0].currSymbol : "";
    try {
      const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;
      const latestPayments = JSON.parse(localStorage.getItem("walletPayments")) || [];
      const latestMatchedPayments = latestPayments.map((payment) => {
        const matchedMethod = showPayments?.find((m) => m.finPaymentmethodId === payment.finPaymentmethodID);
        return { ...matchedMethod, ...payment };
      });
      const paymentsGQL = latestMatchedPayments
        .map(
          (p) => `{
          finPaymentmethodID: "${p.finPaymentmethodId || p.finPaymentmethodID}"
          amount: ${parseFloat(p.amount)}
        }`
        )
        .join(",");

      const upsertData = {
        query: `
        mutation {
          upsertGiftCardTransaction(giftCardTransactions: [{
            cardNo: ${giftCardNumber ? `"${giftCardNumber}"` : null}
            type: "TO"
            referenceNo: "${uuidv4().replace(/-/g, "").toUpperCase()}"
            amount: ${parseFloat(topupTotal)}
            cardPin: ${giftCardPin ? `"${giftCardPin}"` : null}
            tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
            b2c_Customer_Id: ${cart.customer.cwrCustomerId ? `"${cart.customer.cwrCustomerId}"` : null}
            bunitId: "${bunitId}"
            payments: [${paymentsGQL}]
          }]) {
            status
            message
          }
        }`,
      };

      console.log("[v0] Gift Card Topup request:", upsertData);
      const topupResponse = await upsertGiftCardTransaction(upsertData);
      console.log("[v0] Gift Card Topup response:", topupResponse);

      const result = topupResponse?.data?.data?.upsertGiftCardTransaction;
      if (result?.status === "200") {
        message.success(`Gift Card topped up with ${currSymbol}${topupTotal}${currSymbolRight}`);
        localStorage.removeItem("walletPayments");
        resetGiftCardTopup();
        await handleCheckGiftCardBalance();
      } else {
        message.error(result?.message || "Gift Card top-up failed");
        localStorage.removeItem("walletPayments");
        resetGiftCardTopup();
      }
    } catch (topupErr) {
      console.log("[v0] Gift Card Topup error:", topupErr);
      message.error("Gift Card top-up service failed");
      localStorage.removeItem("walletPayments");
      resetGiftCardTopup();
    }
  };

  const handleGiftCardTopupPostPayment = async (giftCardData) => {
    const gitCardDataForCardIntegration = JSON.parse(localStorage.getItem("giftCardIntegrationTopupData"));
    const { paymentValue, topupTotal } = gitCardDataForCardIntegration || giftCardData || {};
    const updatedTotalPaid = (giftCardTotalPaid + paymentValue).toFixed(2);

    setGiftCardTopupCashInput("");
    setGiftCardTopupCardInput("");
    setGiftCardTopupUPIInput("");
    setGiftCardGenericInput("");

    giftCardAutoFillAmount(giftCardTopupAmount);

    if (parseFloat(updatedTotalPaid) >= parseFloat(topupTotal)) {
      // All payments collected — call upsertGiftCardTransaction to finalize topup
      await finalizeGiftCardTopup(topupTotal);
    } else {
      const remaining = (parseFloat(topupTotal) - parseFloat(updatedTotalPaid)).toFixed(2);
      message.success(
        `${giftCardTopupPaymentMethod?.name} payment of ${currSymbol}${paymentValue.toFixed(2)}${currSymbolRight} added. Remaining: ${currSymbol}${remaining}${currSymbolRight}`
      );
      localStorage.removeItem("giftCardIntegrationTopupData");
    }
  };

  const handleEnterTopup = async () => {
    const topupValue = parseFloat(giftCardTopupAmount);
    const paymentValue = parseFloat(currentPaymentInput);

    if (!topupValue || topupValue <= 0) {
      message.warning("Please enter a valid top-up amount");
      return;
    }
    if (!giftCardTopupPaymentMethod) {
      message.warning("Please select a payment method");
      return;
    }
    if (!paymentValue || paymentValue <= 0) {
      message.warning("Please enter a valid payment amount");
      return;
    }

    const topupTotal = parseFloat(topupValue).toFixed(2);

    // Check if adding this payment would exceed the topup amount
    if (giftCardTotalPaid + paymentValue > parseFloat(topupTotal)) {
      const remaining = (parseFloat(topupTotal) - giftCardTotalPaid).toFixed(2);
      message.error(`${giftCardTopupPaymentMethod.name} payment exceeds top-up amount. Remaining: ${currSymbol}${remaining}${currSymbolRight}`);
      return;
    }

    try {
      // Card payment popup logic
      if (giftCardTopupPaymentMethod?.name?.toLowerCase() === "card" && giftCardTopupPaymentMethod?.integratedPayment && posConfig?.show_card_payment_popup === "Y") {
        if (isValidAmount(paymentValue)) {
          setShowCardPaymnteModal(true);
        } else {
          message.warning("Kindly enter the amount before proceeding");
        }
      } else if (giftCardTopupPaymentMethod?.name?.toLowerCase() === "card" && !giftCardTopupPaymentMethod?.integratedPayment && posConfig?.show_card_payment_popup === "Y") {
        if (isValidAmount(paymentValue)) {
          setPaymentType("manual");
          setCardPaymnetError(true);
          setShowCardPaymnteModal(true);
          const giftCardTopupData = {
            paymentValue,
            topupTotal,
            paymentMethod: giftCardTopupPaymentMethod?.name,
            timestamp: Date.now(),
          };
          localStorage.setItem("giftCardIntegrationTopupData", JSON.stringify(giftCardTopupData));
          return;
        } else {
          message.warning("Kindly enter the amount before proceeding");
        }
      }
      // Add this payment to walletPayments in localStorage
      const giftCardTopup = {
        paymentValue,
        topupTotal,
        paymentMethod: giftCardTopupPaymentMethod?.name,
        timestamp: Date.now(),
      };
      localStorage.setItem("giftCardIntegrationTopupData", JSON.stringify(giftCardTopup));
      await requestPayment(giftCardTopupPaymentMethod, paymentValue.toFixed(2), undefined, true);
      if (giftCardTopupPaymentMethod?.name?.toLowerCase() === "card" || giftCardTopupPaymentMethod?.name?.toLowerCase() === "upi") {
        return;
      }
      const giftCardTopupData = {
        paymentValue,
        topupTotal,
      };
      handleGiftCardTopupPostPayment(giftCardTopupData);
    } catch (err) {
      message.error("Gift Card top-up failed");
    }
  };

  const componentProps = {
    selectedInvoiceAddress,
    setSelectedInvoiceAddress,
    selectedDeliveryAddress,
    setSelectedDeliveryAddress,
    showOrderCompleteFlag,
    setShowOrderCompleteFlag,
    debounceRef,
    enterRef,
    calendarContent,
    renderDeliveryDate,
    handleDateSelect,
    calendarVisibleMap,
    setCalendarVisibleMap,
    toggleCalendar,
    setExchangeCart,
    handleWalletPostPayment,
    handleGiftCardTopupPostPayment,
    giftCardTopupPaymentPage,
    setGiftCardTopupPaymentPage,
    giftCardTopupFocusedField,
    setGiftCardTopupFocusedField,
    giftCardTopupDenomKeyboard,
    setGiftCardTopupDenomKeyboard,
    giftCardTopupShowCardAmountInput,
    setGiftCardTopupShowCardAmountInput,
    giftCardTopupCardForm,
    isCheckingBalance,
    setIsCheckingBalance,
    rawGiftCardPayments,
    giftCardMatchedPayments,
    giftCardNumber,
    setGiftCardNumber,
    giftCardPin,
    setGiftCardPin,
    resetGiftCardTopup,
    handleCheckGiftCardBalance,
    giftCardTopupAmount,
    setGiftCardTopupAmount,
    giftCardTopupPaymentMethod,
    setGiftCardTopupPaymentMethod,
    giftCardTopupCashInput,
    setGiftCardTopupCashInput,
    giftCardTopupCardInput,
    setGiftCardTopupCardInput,
    giftCardTopupUPIInput,
    setGiftCardTopupUPIInput,
    giftCardGenericInput,
    setGiftCardGenericInput,
    currentPaymentInput,
    giftCardTotalPaid,
    currSymbol,
    currSymbolRight,
    giftCardAutoFillAmount,
    handleGiftCardTopupAmountChange,
    finalizeGiftCardTopup,
    handleEnterTopup,
    showGiftCardTopup,
    setShowGiftCardTopup,
    cardPaymentForm,
    showCardAmountInput,
    setShowCardAmountInput,
    showTopupModal,
    setShowTopupModal,
    currenciesList,
    handleWalletTopUp,
    handleWalletRefundComplete,
    showRefundModal,
    setShowRefundModal,
    autoFillEnterAmount,
    isProcessingTopup,
    setIsProcessingTopup,
    matchedPayments,
    cashTendered,
    setCashTendered,
    topupAmount,
    setTopupAmount,
    dynamicPaymentInput,
    setDynamicPaymentInput,
    currentUPIInput,
    setCurrentUPIInput,
    currentCashInput,
    setCurrentCashInput,
    enterTotalQtyForWallet,
    currentCardInput,
    setCurrentCardInput,
    bankTransferContext,
    setBankTransferContext,
    supplyRegionProceed,
    setSupplyRegionProceed,
    financialDocUploaded,
    setFinancialDocUploaded,
    financialForm,
    compressImage,
    financialDocs,
    setFinancialDocs,
    financialDocument,
    setFinancialDocument,
    exchangeCartTcs,
    setExchangeCartTcs,
    gstInfo,
    setGstInfo,
    panDrawerMode,
    setPanDrawerMode,
    autoEnableNriBilling,
    autoEnablePanCustomer,
    isCreditSale,
    setIsCreditSale,
    retailCustomerOperationalSettings,
    isNriBilling,
    setIsNriBilling,
    selectedReturnType,
    setSelectedReturnType,
    showReturnOptions,
    setShowReturnOptions,
    isPurchaseReturn,
    setIsPurchaseReturn,
    addonRepeatDisabled,
    setAddonRepeatDisabled,
    addonSourceItem,
    setAddonSourceItem,
    showAddonsCustomizePopup,
    setShowAddonsCustomizePopUp,
    parkedList,
    setParkedList,
    discardGiftCards,
    discardMessage,
    handleOk,
    retrieveParkedData,
    documents,
    setDocuments,
    panCustomerInfo,
    setPanCustomerInfo,
    groupedFields,
    normalizeStaticSelectValue,
    isPanCustomer,
    setIsPanCustomer,
    isParkedBill,
    setIsparkedBill,
    lastSearchedValue,
    setLastSearchedValue,
    selectedB2BCustomer,
    setSelectedB2BCustomer,
    lastSearchedValue,
    setLastSearchedValue,
    syncLoad,
    setSyncLoad,
    isSubmittingCustomer,
    setIsSubmittingCustomer,
    viewCustomerValues,
    setViewCustomerValues,
    toCamelCaseMetaData,
    convertMetaDataToKeyValue,
    isViewMode,
    setIsViewMode,
    switchToggle,
    setSwitchToggle,
    setSelectedEditOldCustomer,
    customerConfig,
    customerConfigData,
    retailCustomerTabs,
    retailCustomerFields,
    retailCustomerGroups,
    retailCustomerRules,
    retailCustomerb2bSettings,
    retailCustomerApiDataSources,
    activeTab,
    setActiveTab,
    activeTabName,
    setActiveTabName,
    isB2BEnabled,
    setIsB2BEnabled,
    formDataCache,
    setFormDataCache,
    expandedGroups,
    setExpandedGroups,
    customerForm,
    cashIn,
    setCashIn,
    cashOut,
    setCashOut,
    pettyCashIn,
    setPettyCashIn,
    pettyCashOut,
    setPettyCashOut,
    bankTransfer,
    setBankTransfer,
    bankTransferDocument,
    setBankTransferDocument,
    uploadingDocs,
    setUploadingDocs,
    clearReturnCartData,
    setCashOut,
    showConfirm,
    discountInforApplication,
    integratedPaymentStatus,
    setIntegratedPaymentStatus,
    couponInputRef,
    totalBillCouponData,
    setTotalBillCouponData,
    checkExternalCoupon,
    selectedExternalCouponType,
    setSelectedExternalCouponType,
    selectedCoupon,
    setSelectedCoupon,
    processCouponApplication,
    cardPaymnetStatusPLB,
    setCardPaymnetStatusPLB,
    showCardPaymnteModal,
    setShowCardPaymnteModal,
    setCustomerLoading,
    customerLoading,
    selectedItemsModalOpen,
    setSelectedItemsModalOpen,
    syncLoad,
    setSyncLoad,
    processTotalManualDiscount,
    cashIn,
    setCashIn,
    cashOut,
    setCashOut,
    pettyCashIn,
    setPettyCashIn,
    pettyCashOut,
    setPettyCashOut,
    bankTransfer,
    setBankTransfer,
    bankTransferDocument,
    setBankTransferDocument,
    uploadingDocs,
    setUploadingDocs,
    clearReturnCartData,
    setCashOut,
    showConfirm,
    showCompleteSaleStock,
    setShowCompleteSaleStock,
    completeSaleStockData,
    setCompleteSaleStockData,
    setTempCart,
    tempCart,
    metaDataRef,
    discountInforApplication,
    discountAdditionalInfoForm,
    discountAdditionalInfo,
    setDiscountAdditionalInfo,
    totalBillDiscountData,
    setTotalBillDiscountData,
    deleteReceipt,
    qtyInputRef,
    searchInputRef,
    activeInput,
    setActiveInput,
    options,
    setOptions,
    couponApprovals,
    setCouponApprovals,
    showCouponApproval,
    setShowCouponApproval,
    couponInfo,
    additionalInfoForm,
    selectedUser,
    setSelectedUser,
    showAdditionalInfo,
    setShowAdditionalInfo,
    additionalInfo,
    setAdditionalInfo,
    showCustomMix,
    setShowCustomMix,
    hasShownCustomerModalRef,
    orderType,
    setOrderType,
    posSaleTypes,
    setPosSaleTypes,
    currenciesData,
    setCurrenciesData,
    groupQty,
    setGroupQty,
    selectedCustomMix,
    setSelectedCustomMix,
    existingGroupItems,
    setExistingGroupItems,
    customMixItems,
    setCustomMixItems,
    firstInputValue,
    setFirstInputValue,
    realPrice,
    setRealPrice,
    splitCarts,
    setSplitCarts,
    tableCards,
    setTableCards,
    keyValue,
    setKeyValue,
    changeCustomerId,
    showProducts,
    setShowProducts,
    handleSelectedSaleTypeForProducts,
    handleSelectedRevenueCategory,
    checkIsManualWeight,
    parkBill,
    openPaymentModal,
    addProduct,
    cart,
    setCart,
    cartObj,
    setOrderObj,
    clearProductSearchResults,
    closeProductPanel,
    confirmDiscardCart,
    decreaseProductQty,
    deleteCart,
    deleteProduct,
    displayClock,
    getMoreProducts,
    getSearchedProducts,
    setIsProductsVisible,
    isProductsVisible,
    getSearchedItem,
    increaseProductQty,
    isProductsFilter,
    isQtyUpdate,
    isSearchProducts,
    loader,
    loading,
    setLoading,
    onBarcodeInput,
    openDisplayParkedBillModal,
    orderType,
    parkedList,
    setAllProductCategories,
    allProductCategories,
    handleBrandCheckboxChange,
    selectCategotyList,
    setSelectCategotyList,
    handleCategoryCheckboxChange,
    setSelectedProductBrand,
    selectedProductBrand,
    productSearchInput,
    filtersFlag,
    setFiltersFlag,
    // productSearchInputRef,
    productsCopy,
    selectProductCategory,
    selectProductInCart,
    selectedProductQty,
    selectProduct,
    selectSalseProduct,
    selectedProductInCart,
    selectedRowKeys,
    setSelectedRowKeys,
    selectedKeys,
    searchHistoryInput,
    setSearchhistoryInput,
    setDisplayCustomerSearch,
    displayUAECustomerSearch,
    setDisplayUAECustomerSearch,
    displayUAECustomer,
    setDisplayUAECustomer,
    setDisplayOrderType,
    setIsProductsFilter,
    setIsQtyUpdate,
    setIsSearchProducts,
    setProductSearchInput,
    setParkedBillSearchInput,
    showOrderHistory,
    tillData,
    displayCustomerSearch,
    closeCustomerSearch,
    setCustomerSearchType,
    customerSearchType,
    handleCustomerSearch,
    customerSearchInput,
    setCustomerSearchResults,
    setCloseCustomerFlag,
    setCustomerSearchInput,
    customerSearchResults,
    selectCustomer,
    showEditOldCustomerFields,
    showAddNewCustomerFields,
    showAddNewUAECustomerFields,
    setDisplayAddNewCustomer,
    displayAddNewCustomer,
    form,
    UAECustomerForm,
    addNewCustomer,
    setDisplayEditOldCustomer,
    displayEditOldCustomer,
    editFlag,
    setEditFlag,
    editOldCustomer,
    displayOrderHistory,
    setDisplayOrderHistory,
    changeOrderHistorySearchType,
    searchOrderHistory,
    setOrderHistoryInput,
    orderHistoryDetails,
    showOrderHistoryLine,
    selectedOrderHistoryLine,
    isPrintModeXML,
    syncOrders,
    displayParkedBillModal,
    closeParkedBillModal,
    handleParkedBillSearchInput,
    searchParkedBill,
    parkedBillSearchInput,
    salesHistoryCustomerSearchInput,
    salesHistoryDocumentNoSearchInput,
    setSalesHistoryCustomerSearchInput,
    setSalesHistoryDocumentNoSearchInput,
    filterdParkedList,
    parkedList,
    setFilterdParkedList,
    discardParkedBill,
    selectParkedBill,
    selectLayAwayOrder,
    paymentModal,
    tillDataPaymentMethods,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    requestPayment,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    setCouponModalVisible,
    closePaymentModal,
    paymentModalLoyalityMessages,
    amount,
    onChangeAmount,
    processOrder,
    handleAmount,
    handleCashPayment,
    overPayedAmount,
    setOverPayedAmount,
    handleTotalQty,
    handleRealPrice,
    enterTotalQty,
    enterRealPrice,
    showPaymentMethods,
    setShowPaymentMethods,
    onChangeTotalQuantity,
    displaySetOrderType,
    posSaleTypes,
    changeOrderType,
    displayOfferProductSelectiton,
    offerProductsList,
    selectOfferProduct,
    displayBatchSelection,
    setDisplayBatchSelection,
    batchSetAvailable,
    selectProductToCart,
    displayManualQtyWeightInput,
    setDisplayManualQtyWeightInput,
    setDefaultImage,
    currentWeightSelectedProduct,
    productWeightModalInput,
    onProductModalChangeWeight,
    addManualWeightToProduct,
    couponModalVisible,
    closeCouponModal,
    checkCoupon,
    couponInput,
    setCouponInput,
    handleCouponInput,
    loyalityOtpModalVisible,
    setLoyalityOtpModalVisible,
    processOtpInput,
    loyaltyInputValue,
    setLoyaltyInputValue,
    handleLoyalityInput,
    checkLoyality,
    loyaltyPaymentOtp,
    setLoyaltyPaymentOtp,
    currencyType,
    setCurrencyType,
    setDisplayClock,
    pickProduct,
    addDefinedProduct,
    handleWeightManual,
    selectedProductCategory,
    filterDrawer,
    setFilterDrawer,
    // OMS Order MOdal and Side menu drawer//,
    openSideMenu,
    onClose,
    displayOMSOrderItemsModal,
    omsOrderStatus,
    selectedOMSOrderStatus,
    setSelectedOrder,
    handleOMSOrderStatusSelection,
    order,
    handleOrderSearchInput,
    searchOrders,
    selectedOrder,
    handleOrderCard,
    handleOmsOrders,
    setDisplayOMSOrderItemsModal,
    handleOMSStatusButton,
    omsOrderTotalPrice,
    sideMenuDrawervisible,
    setDisplayOfferProductSelection,
    // Sales Representative Modal //
    salesRepModalOpen,
    setSalesRepModalOpen,
    handleSalesRepresentive,
    salesRepresent,
    setSalesRepresent,
    salesRepresentSearchInput,
    setSalesRepresentSearchInput,
    handleSalesRepresentSearchInput,
    salesReprestiveList,
    filteredSalesRepresentList,
    setFilteredSalesRepresentList,
    prevProductsListRef,
    prevHistoryRef,
    manualDiscountModalVisible,
    setManualDiscountModalVisible,
    manualDiscountInput,
    setManualDiscountInput,
    manualDiscountTypes,
    setManualDiscountTypes,
    handleManualDiscountKeyPress,
    applyManualDiscount,
    manualDiscountForm,
    selectedManualDiscountType,
    setSelectedManualDiscountType,
    enableManualDiscountInput,
    setEnableManualDiscountInput,
    removeAllDiscounts,
    clearSelectedProductInCart,
    setProductWeightModalInput,
    productListCardRef,
    paymentModalByCustomerState,
    posLogActivity,
    upsertPOSLog,
    // Paytm QR Code //
    paytmQrCodeModalOpens,
    setPaytmQrCodeModalOpens,
    qrCodeResponse,
    setQrCodeResponse,
    handleVerifyPayment,
    removeCutomer,
    handleDeleteLoyaltyPayment,
    handleLoyaltyPayment,
    posConfig,
    displayReturnOrderSearch,
    setDisplayReturnOrderSearch,
    handleSalesReturnFromSideMenu,
    // Bill Management //
    handleManagement,
    managementScreenShow,
    setManagementScreenShow,
    orderTypeSelection,
    setOrderTypeSelection,
    // Cash Management
    setAddCashFlag,
    addCashFlag,
    paymentModal,
    tillDataPaymentMethods,
    setSelectedPaymentMethod,
    setCouponModalVisible,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    setSelectedKeys,

    // payment
    setQtyNumberFlag,
    setAmount,
    setNumb,
    amount,
    onChangeAmount,
    processOrder,
    paymentModalLoyalityMessages,
    paymentModalInputRef,
    quantityInputRef,
    // Cash Management
    setCashAddInFlag,
    cashAddInFlag,
    handleCahInOut,
    cashManagementForm,
    cashIn,
    onChangeCheckbox,
    setSelectedProductInCart,
    // kiosk Screen
    kioskUI,
    setKioskUI,
    kioskLogin,
    layoutType,
    setLayoutType,
    kioskFilteredProducts,
    // gift card
    giftCardFlag,
    setGiftCardFlag,
    isGiftCardFlag,
    setIsGiftCardFlag,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    giftCardItems,
    CardPaymentForm,
    setGiftCardItems,
    setAddToBagProducts,
    setAddToBagFlag,
    addToBagFlag,
    addToBagProducts,
    giftCardType,
    setGiftCardType,
    selectGiftCardItem,
    setSelectGiftCardItem,
    validateGiftCard,
    setValidateGiftCard,
    validateGiftCardForm,
    giftCardBalance,
    setGiftCardBalance,
    handleGiftCardDetails,
    redeemGiftCard,
    giftCardData,
    setGiftCardData,
    handleGiftCard,
    giftCardForm,
    // keybord
    setKeyboardType,
    keyboardType,
    layout,
    setLayout,
    inputName,
    setInputName,
    keyboardInputFields,
    setKeyboardInputFields,
    keyboardParkbill,
    keyboardRef,
    keyboardProduct,
    handleKeyboardInput,
    handleKeyPress,
    orderHistorySearchInputRef,
    orderHistoryInput,
    setLoader,
    openPaymentModalByCustomer,
    paymentProcessFlag,
    setPaymentProcessFlag,
    selectedEditOldCustomer,
    setIsInputFocused,
    isInputFocused,
    inputFocused,
    setInputFocused,
    handleSelectProduct,
    getCategoryProducts,
    setSalesHistoryType,
    salesHistoryType,
    setStartRowData,
    setFilterdDate,
    startRowData,
    setOrderHistoryDetails,
    setOrdersCopy,
    ordersCopy,
    documentSequence,
    setDocumnetSequence,
    customerFlag,
    setCustomerFlag,
    notesValue,
    setNotesValue,
    selectedProductForNotes,
    setSelectedProductForNotes,
    productsData,
    orderDelay,
    setOrderDelay,
    setProductsData,
    stockList,
    setStockList,
    // restaurantProductCategory,
    removeCoupon,
    // product add on
    setDisplayAddOnSelection,
    displayAddOnSelection,
    handleAddOnValue,
    handleQty,
    handleAdd,
    addOnsList,
    handleAddOnModalClose,
    selectedAddons,
    selectedProduct,
    setSelectedProduct,
    isUpdatingAddon,
    setIsUpdatingAddon,
    addDefinedProductWithAddons,
    handleAddOnModal,
    dynamicForm,
    setDynamicForm,
    dynamicModalForm,
    submitCustomAttributs,
    isSubmitting,
    setIsSubmitting,
    showSaleType,
    setShowSaleType,
    isSaleTypeFlag,
    setIsSaleTypeFlag,
    selectedSaleType,
    setSelectedSaleType,
    selectedSaleTypeData,
    setSelectedSaleTypeData,
    isRevenueCategoryFlag,
    setIsRevenueCategoryFlag,
    selectedRevenueCategoryName,
    setSelectedRevenueCategoryName,
    openSalesRep,
    setOpenSalesRep,
    verifyStock,
    isStockModal,
    setIsStockModal,
    showPayments,
    setShowPayments,
    setStartIndex,
    startIndex,
    getFilteredPaymentMethods,
    handleCartTotalClick,
    isShowingAll,
    setIsShowingAll,
    filteredPaymentMethods,
    initialShowPayments,
    tempCart,
    setTempCart,
    callGetWeightAPI,
    open,
    setOpen,
    productSearchInputRef,
    layoutName,
    setLayoutName,
    giftCardRef,
    searchTerm,
    setSearchTerm,
    salesRepRef,
    salesRepValue,
    setSalesRepValue,
    customerSearchInputRef,
    processBillDiscounts,
    currentInput,
    setCurrentInput,
    inputValues,
    setInputValues,
    refs,
    currenciesData,
    selectedDocumentType,
    setSelectedDocumentType,
    showDocumentPopup,
    setShowDocumentPopup,
    documentTypes,
    keyboard,
    getSalesHistoryData,
    setSelectedManualDiscountTypeValue,
    saleTypeProducts,
    setSaleTypeProducts,
    cardPaymnetStatus,
    setCardPaymnetStatus,
    cardPaymnetError,
    setCardPaymnetError,
    isCardPaymentLoading,
    setIsCardPaymentLoading,
    modifyProductList,
    calendarVisible,
    setCalendarVisible,
    selectedDate,
    setSelectedDate,
    setProductStock,
    saleType,
    setSaleType,
    showCustomerWallet,
    setShowCustomerWallet,
    customersData,
    setCustomersData,
    selectedCustomer,
    setSelectedCustomer,
    handleDeletePayment,
    fetchWalletData,
    setTillLink,
    tillLink,
    isWalletFlag,
    setIswalletFlag,
    isNewGiftCardFlag,
    setIsNewGiftCardFlag,
    isRefundWalletOpen,
    setIsRefundWalletOpen,
    isBankTransferOpen,
    setIsBankTransferOpen,
    customerSearchTrigger,
    setCustomerSearchTrigger,
    walletFunc,
    bankTransferFunc,
    getFilteredPaymentMethods,
    notesValue,
    setNotesValue,
    exchangeNotesValue,
    setExchangeNotesValue,
    activeCartTable,
    setActiveCartTable,
    dateRange,
    setDateRange,
    getDisplayDate,
    content,
    setPopoverVisible,
    isPopoverVisible,
    dateRef,
    mapParkedList,
    callCenterVisible,
    setCallCenterVisible,
    isCallCenterFlow,
    setIsCallCenterFlow,
    history,
    showCallCenterPage,
    setShowCallCenterPage,
    holdQueue,
    setHoldQueue,
    redeemNumberRef,
    loyaltyInputRef,
    isOnline,
    setIsOnline,
    setSelectedAddons,
    handleCopyKOT,
    guestForm,
    copyKOTVisible,
    setCopyKOTVisible,
    groupedFiredItems,
    setGroupedFiredItems,
    openCopyKOTModal,
    selectedCopyItems,
    setSelectedCopyItems,
    onlineBatches,
    setOnlineBatches,
    fetchOnlineBatches,
    pendingRefundCustomer,
    setPendingRefundCustomer,
    isRefundCustomerEdit,
    setIsRefundCustomerEdit,
    addSelectedReturnProductsToCart,
    selectedReturnOrder,
    setSelectedReturnOrder,
    checkedKeys,
    setCheckedKeys,
    getProductData,
    dataSource,
    setDataSource,
    handleSaveReturnCartRecord,
    showReturnPurchase,
    setShowReturnPurchase,
    selectPurchaseBillForReturn,
    retrunSearchType,
    setReturnSearchType,
    searchReturnHistory,
    setAddOnsList,
    addOnsList,
    notesPopup,
    setNotesPopup,
    handleShift,
    rejectQuotation,
    setRejectQuotation,
    setModalEditState,
    modalEditState,
    returnProcessRef,
    handlePayment,
    paymentType,
    setPaymentType,
    uploadedDocuments,
    setUploadedDocuments,
    uploadModalVisible,
    setUploadModalVisible,
    isPanUpdateMode,
    setIsPanUpdateMode,
    previousTcsRef,
    tableList,
    setTableList,
    occupiedDataTablesData,
    setOcupiedTablesData,
    reservedTablesData,
    setReservedTablesData,
    isValidAmount,
    couponOtp,
    setCouponOtp,
    couponOtpError,
    setCouponOtpError,
    couponResendTimer,
    setCouponResendTimer,
    couponCanResend,
    setCouponCanResend,
    verificationCouponStatus,
    setVerificationCouponStatus,
    showCouponOtpPopup,
    setShowCouponOtpPopup,
    couponVerificationData,
    setCouponVerificationData,
    processCouponApplication,
  };

  const errorMessage = (modalTitle, modalContent, user) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
    });
  };

  return (
    <div>
      <RenderComponent {...componentProps} />
      <CoreModals {...componentProps} />
      <ReturnBill {...componentProps} />
      <PointOfSuperMarketModals {...componentProps} />

      {/* Print Template Selection Modal */}
      <Modal
        visible={showPrintTemplateModal}
        getContainer={false}
        zIndex={2000}
        title={<span style={{ fontSize: "16px", fontWeight: 600, color: "#1f1f1f" }}>Select Receipt Template</span>}
        onCancel={handlePrintTemplateCancel}
        footer={
          <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
            <Button
              style={{
                height: "36px",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: 500,
                border: "1px solid #d9d9d9",
                color: "#333",
                padding: "0 20px",
              }}
              onClick={handlePrintTemplateCancel}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              style={{
                height: "36px",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: 500,
                backgroundColor: "#2d3748",
                borderColor: "#2d3748",
                padding: "0 20px",
              }}
              onClick={handlePrintTemplateConfirm}
              disabled={!selectedPrintTemplate}
            >
              Print Receipt
            </Button>
          </div>
        }
        centered
        width={480}
        bodyStyle={{ padding: "16px 24px", maxHeight: "400px", overflowY: "auto" }}
        maskClosable={false}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Radio.Group
            value={selectedPrintTemplate}
            onChange={(e) => {
              setSelectedPrintTemplate(e.target.value);
            }}
            style={{ width: "100%" }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {printTemplates.map((template) => (
                <div
                  key={template.cwr_printtemplate_id}
                  style={{
                    border: selectedPrintTemplate === template.cwr_printtemplate_id ? "1px solid #2d3748" : "1px solid #e8e8e8",
                    borderRadius: "6px",
                    padding: "12px 14px",
                    cursor: "pointer",
                    backgroundColor: selectedPrintTemplate === template.cwr_printtemplate_id ? "#f7fafc" : "#fff",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => {
                    setSelectedPrintTemplate(template.cwr_printtemplate_id);
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Radio value={template.cwr_printtemplate_id} />
                    <span style={{ fontWeight: 500, fontSize: "14px", color: "#1f1f1f" }}>{template.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </Radio.Group>
        </div>
      </Modal>

      <Modal
        visible={showAddonsCustomizePopup}
        footer={null}
        closable={false}
        centered
        width={420}
        style={{
          textAlign: "center",
        }}
        bodyStyle={{
          padding: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
          }}
        >
          <p
            style={{
              margin: 0,
              fontSize: "1.4em",
              fontWeight: 600,
              color: "#0F0718",
            }}
          >
            Item has Add-ons
          </p>
          <p
            style={{
              margin: "4px 0 12px 0",
              fontSize: "1em",
              fontWeight: 400,
              color: "rgba(15,7,24,0.7)",
              textAlign: "center",
              lineHeight: "1.4em",
            }}
          >
            Would you like to repeat the same add-on or customize the add-ons for this additional unit?
          </p>
          <div
            style={{
              width: "100%",
              borderRadius: "8px",
              border: "1px solid #E5E5E5",
              padding: "12px",
              cursor: addonRepeatDisabled ? "not-allowed" : "pointer",
              textAlign: "left",
              opacity: addonRepeatDisabled ? 0.5 : 1,
              backgroundColor: addonRepeatDisabled ? "#f5f5f5" : "#ffffff",
            }}
            onClick={() => {
              if (addonRepeatDisabled || !addonSourceItem) return;
              // addProductToCart(addonSourceItem, 1, false, 0, false, true);
              addProductToCart(
                addonSourceItem,
                1,
                false,
                cart,
                setCart,
                setSelectedProductInCart,
                deleteCart,
                processTotalManualDiscount,
                setLoader,
                salesRepresentDefaultLine,
                tillData,
                cartRef,
                productsCopy,
                salesRepresent,
                orderType,
                processBillDiscounts,
                undefined,
                setSelectedRowKeys,
                setOrderTimeDetails,
                setDisplayAddOnSelection,
                displayAddOnSelection,
                handleAddOnModal,
                manualDiscountTypes,
                CheckoutFlatDiscount,
                CheckoutPercentageDiscount,
                CheckoutTotalManualDiscount,
                setProductStock,
                selectedProductInCart,
                setTableCards,
                dispatchItemSelection,
                searchInputRef,
                false,
                setShowCompleteSaleStock,
                setCompleteSaleStockData,
                TotalBillDiscount,
                tillLayout,
                false,
                setManualDiscountInput,
                setSelectedManualDiscountTypeValue,
                removeAllDiscounts,
                setSelectedPaymentMethod,
                selectedReturnType,
                false,
                setProductBOMStock,
                setProductBOMStockData
              );
              setShowAddonsCustomizePopUp(false);
              setAddonSourceItem(null);
            }}
          >
            <p style={{ margin: 0, fontWeight: 600, color: "#0F0718" }}>Repeat</p>
            <p style={{ margin: "4px 0", fontSize: "0.95em", color: "rgba(15,7,24,0.7)" }}>Use the same add-ons for this additional unit</p>
          </div>

          <div
            style={{
              width: "100%",
              borderRadius: "8px",
              border: "1px solid #E5E5E5",
              padding: "12px",
              cursor: "pointer",
              textAlign: "left",
            }}
            onClick={() => {
              setAddonRepeatDisabled(false);
              setShowAddonsCustomizePopUp(false);
              setTimeout(() => {
                setDisplayAddOnSelection(true);
              }, 10);
            }}
          >
            <p style={{ margin: 0, fontWeight: 600, color: "#0F0718" }}>Customize</p>
            <p style={{ margin: "4px 0", fontSize: "0.95em", color: "rgba(15,7,24,0.7)" }}>Select different add-ons for this additional unit</p>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
              marginTop: "16px",
            }}
          >
            <button
              onClick={() => {
                (setAddonRepeatDisabled(false), setShowAddonsCustomizePopUp(false));
              }}
              style={{
                padding: "6px 16px",
                borderRadius: "6px",
                border: "1px solid #D9D9D9",
                backgroundColor: "#FFFFFF",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        visible={productStock}
        footer={null}
        closable={false}
        centered
        zIndex={2000}
        style={{
          textAlign: "center",
          width: "150px",
          height: "70vh",
        }}
        bodyStyle={{
          padding: 0,
        }}
      >
        <div
          style={{
            fontSize: "18px",
            fontWeight: "500",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: 0,
            fontSize: "1vw",
          }}
        >
          <img src={NotFoundImg} alt="Stock Unavailable" style={{ width: "120px", height: "100px", marginBottom: "5px", marginTop: "10px" }} />
          <p style={{ margin: "5px 0", fontSize: "2em", fontWeight: "600", color: "#0F0718" }}>Stock is not available</p>
          <hr style={{ width: "70%", color: "rgba(146,144,152,0.5)" }} />
          <p
            style={{
              color: "#0F0718",
              fontWeight: 400,
              fontSize: "1.25em",
              padding: "15px 15px 0 15px",
            }}
          >
            The item is not available in stock.
          </p>
        </div>
      </Modal>

      <Drawer
        visible={showCompleteSaleStock && completeSaleStockData?.length > 0}
        onClose={() => {
          (setShowCompleteSaleStock(false), setCompleteSaleStockData([]));
        }}
        placement="bottom"
        closable={false}
        height="80vh"
        mask={true}
        maskStyle={{ background: "#000000a6" }}
        maskClosable="false"
        style={{
          textAlign: "center",
        }}
        bodyStyle={{
          padding: "5px 30px", // Increased padding on left and right
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            fontSize: "18px",
            fontWeight: "500",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: 0,
            fontSize: "1vw",
          }}
        >
          <img src={NotFoundImg} alt="Stock Unavailable" style={{ width: "60px", height: "50px", marginTop: "5px" }} />
          <p style={{ margin: "2px 0", fontSize: "1.8em", fontWeight: "600", color: "#0F0718" }}>Stock is not available</p>
          <p
            style={{
              color: "#6c757d",
              fontWeight: 400,
              fontSize: "1.1em",
            }}
          >
            {`The following ${
              completeSaleStockData?.filter((item) => item.availabilityStatus !== "Yes" && item.availableQty < item.orderQty).length
            } items are not available in sufficient stock`}
          </p>
        </div>
        <Table
          className="sm-stock-check-table"
          pagination={false}
          style={{ height: "50vh" }} // Increased table height to utilize more space
          scroll={{ y: "43vh" }} // Adjusted scroll height to match increased table size
          columns={[
            {
              title: "Item Name",
              dataIndex: "name",
              key: "name",
              width: "30%",
              render: (text, record) => (
                <div>
                  <div style={{ fontWeight: 500 }}>{text}</div>
                  <div style={{ fontSize: "12px", color: "#888" }}>{record.productId}</div>
                </div>
              ),
            },
            { title: "Required", dataIndex: "orderQty", key: "orderQty", width: "25%" },
            { title: "Available", dataIndex: "availableQty", key: "availableQty", width: "25%" },
            {
              title: "Shortfall",
              key: "shortfall",
              width: "25%",
              render: (_, record) => {
                const diff = record.orderQty - record.availableQty;
                return (-Math.abs(diff)).toFixed(precision);
              },
            },
          ]}
          dataSource={completeSaleStockData.filter((item) => item.availabilityStatus !== "Yes" && item.availableQty < item.orderQty)}
          rowKey="productId"
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "2vh",
            paddingRight: "1px",
          }}
        >
          <button
            style={{
              width: "25%",
              padding: "6px 12px",
              backgroundColor: "#2F3856",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              (setShowCompleteSaleStock(false), setCompleteSaleStockData([]));
              localStorage.removeItem("productSegment");
            }}
          >
            OK
          </button>
        </div>
      </Drawer>

      <Drawer
        visible={productBOMStock && productBOMStockData?.length > 0}
        onClose={() => {
          setProductBOMStock(false);
          setProductBOMStockData([]);
        }}
        placement="bottom"
        closable={false}
        height="80vh"
        mask={true}
        maskStyle={{ background: "#000000a6" }}
        maskClosable={false}
        style={{ textAlign: "center" }}
        bodyStyle={{
          padding: "5px 30px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1vw",
          }}
        >
          <img src={NotFoundImg} alt="Stock Unavailable" style={{ width: "60px", height: "50px", marginTop: "5px" }} />
          <p style={{ margin: "2px 0", fontSize: "1.8em", fontWeight: "600" }}>Stock is not available</p>
          <p style={{ fontWeight: 400, fontSize: "1.1em" }}>
            {`The following ${
              productBOMStockData?.filter((item) => item.availabilityStatus !== "Yes" && item.availableQty < item.orderQty).length
            } items are not available in sufficient stock`}
          </p>
        </div>

        <Table
          className="sm-stock-check-table"
          pagination={false}
          style={{ height: "50vh" }}
          scroll={{ y: "43vh" }}
          columns={[
            {
              title: "Item Name",
              dataIndex: "name",
              key: "name",
              width: "30%",
              render: (text, record) => (
                <div>
                  <div style={{ fontWeight: 500 }}>{text}</div>
                  <div style={{ fontSize: "12px", color: "#888" }}>{record.productId}</div>
                  {/* BOM Items */}
                  {record.billOfMaterials && record.billOfMaterials.length > 0 && (
                    <div style={{ marginTop: "5px" }}>
                      {record.billOfMaterials.map((bom) => (
                        <div key={bom.value} style={{ fontSize: "12px" }}>
                          BOM: {bom.value}, Qty on Hand: <span style={{ color: "#FF0000" }}>{bom.qtyOnHand.toFixed(2)}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ),
            },
            {
              title: "Required",
              dataIndex: "orderQty",
              key: "orderQty",
              width: "20%",
              render: (val) => <span>{val}</span>,
            },
            {
              title: "Available",
              dataIndex: "availableQty",
              key: "availableQty",
              width: "20%",
              render: (val) => <span>{val.toFixed(2)}</span>,
            },
            {
              title: "Shortfall",
              key: "shortfall",
              width: "20%",
              render: (_, record) => {
                const diff = record.orderQty - record.availableQty;
                return <span style={{ color: "#FF0000" }}>{(-Math.abs(diff)).toFixed(2)}</span>;
              },
            },
          ]}
          dataSource={productBOMStockData.filter((item) => item.availabilityStatus !== "Yes" && item.availableQty < item.orderQty)}
          rowKey="productId"
        />

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "2vh", paddingRight: "1px" }}>
          <button
            style={{
              width: "25%",
              padding: "6px 12px",
              backgroundColor: "#2F3856",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              setProductBOMStockData([]);
              setProductBOMStock(false);
            }}
          >
            OK
          </button>
        </div>
      </Drawer>

      <Drawer
        placement="bottom"
        height="53vh"
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "2vh",
              fontSize: "1vw",
            }}
          >
            <p
              style={{
                fontSize: "1.5em",
                marginTop: "3vh",
                fontWeight: "500",
                color: "#0F0718",
                flex: 1,
                textAlign: "center",
              }}
            >
              {selectedProductForNotes !== null ? "Add Notes for Item" : "Add Notes for Order"}
            </p>
            <img
              src={Close}
              onClick={() => {
                setNotesPopup(false);
                setIsInputFocused(false);
              }}
              // style={{ marginLeft: "auto", paddingBottom: "4vh", cursor: "pointer" }}
              style={{
                marginLeft: "auto",
                paddingBottom: "4vh",
                paddingTop: "2vh",
                cursor: "pointer",
                width: "1.5vw",
              }}
            />
          </div>
        }
        closeIcon={null}
        className="filter"
        bodyStyle={{ paddingTop: 0 }}
        visible={notesPopup}
        closable={true}
        onClose={() => {
          setNotesPopup(false);
          setIsInputFocused(false);
        }}
        footer={null}
      >
        <Row style={{ padding: "0 5vw", fontSize: "1vw" }}>
          <Col span={11}>
            <TextArea
              id="notes-input"
              ref={notesInputRef}
              style={{ resize: "none" }}
              maxLength={200}
              onKeyDown={handleKeyDown}
              onChange={(e) => onChangeInputKeyboard(e)}
              value={activeCartTable === "EXCHANGE" ? exchangeNotesValue : notesValue}
              rows={11}
            />
            <span
              style={{
                fontFamily: "Inter",
                fontSize: "0.8em",
                color: "#929098",
                fontWeight: 500,
              }}
            >
              Max Characters : 200
            </span>
          </Col>
          <Col span={12} offset={1}>
            <Keyboard
              theme={"hg-theme-default aprvl"}
              onChange={(input) => onChange(input)}
              keyboardRef={(r) => (keyboardRef.current = r)}
              onKeyPress={(button) => {
                if (button === "{shift}" || button === "{lock}") handleShift();
                if (button === "{number}") {
                  setLayoutName("number");
                }
                if (button === "{numbers}") {
                  setLayoutName("numbers");
                }
                if (button === "{small}") {
                  setLayoutName("shift");
                }
                if (button === "{caps}") {
                  setLayoutName("default");
                }
                if (button === "{enter}") {
                  onAddNotes();
                }
              }}
              layoutName={layoutName}
              display={{
                "{abc}": "ABC",
                "{smileys}": "\uD83D\uDE03",
                "{back}": "Enter",
                "{numbers}": "123",
                "{number}": "123",
                "{bksp}": "backspace",
                "{backspace}": "⌫",
                "{shift}": "⇧",
                "{tab}": "tab",
                "{lock}": "lock",
                "{enter}": "Enter",
                "{space}": "Space",
                "{caps}": "ABC",
                "{small}": "abc",
              }}
              layout={{
                shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
                numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
                number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
                default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
              }}
            />
          </Col>
        </Row>
      </Drawer>

      <Drawer
        placement="bottom"
        height="72vh"
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "2vh",
              fontSize: "1vw",
            }}
          >
            <p
              style={{
                fontSize: "1.5em",
                marginTop: "3vh",
                fontWeight: "500",
                color: "#0F0718",
                flex: 1,
                textAlign: "center",
              }}
            >
              Reject Quotation
            </p>
            <img
              src={Close}
              onClick={() => {
                setRejectQuotation(false);
                // setIsInputFocused(false);
              }}
              // style={{ marginLeft: "auto", paddingBottom: "4vh", cursor: "pointer" }}
              style={{
                marginLeft: "auto",
                paddingBottom: "4vh",
                paddingTop: "2vh",
                cursor: "pointer",
                width: "1.5vw",
              }}
            />
          </div>
        }
        closeIcon={null}
        className="filter"
        bodyStyle={{ paddingTop: 0 }}
        visible={rejectQuotation}
        closable={true}
        onClose={() => {
          setRejectQuotation(false);
          // setIsInputFocused(false);
        }}
        footer={null}
      >
        <Row style={{ padding: "0 5vw", fontSize: "1vw", paddingTop: "2vh" }}>
          <Col span={11}>
            <span
              style={{
                fontFamily: "Inter",
                fontSize: "1.25em",
                color: "#0F0718",
                fontWeight: 500,
              }}
            >
              Reject Notes
            </span>
            <TextArea
              id="notes-input"
              style={{ resize: "none", paddingTop: "2vh" }}
              maxLength={200}
              placeholder="Type Here"
              // onKeyDown={handleKeyDown}
              // onChange={(e) => onChangeInputKeyboard(e)}
              // value={notesValue}
              rows={11}
            />
          </Col>
          <Col span={12} offset={1} style={{ marginTop: "4vh" }}>
            <Keyboard
              theme={"hg-theme-default aprvl"}
              onChange={(input) => onChange(input)}
              keyboardRef={(r) => (keyboardRef.current = r)}
              onKeyPress={(button) => {
                if (button === "{shift}" || button === "{lock}") handleShift();
                if (button === "{number}") {
                  setLayoutName("number");
                }
                if (button === "{numbers}") {
                  setLayoutName("numbers");
                }
                if (button === "{small}") {
                  setLayoutName("shift");
                }
                if (button === "{caps}") {
                  setLayoutName("default");
                }
                if (button === "{enter}") {
                  onAddNotes();
                }
              }}
              layoutName={layoutName}
              display={{
                "{abc}": "ABC",
                "{smileys}": "\uD83D\uDE03",
                "{back}": "Enter",
                "{numbers}": "123",
                "{number}": "123",
                "{bksp}": "backspace",
                "{backspace}": "⌫",
                "{shift}": "⇧",
                "{tab}": "tab",
                "{lock}": "lock",
                "{enter}": "Enter",
                "{space}": "Space",
                "{caps}": "ABC",
                "{small}": "abc",
              }}
              layout={{
                shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
                numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
                number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
                default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: "2.3vh", fontSize: "1vw" }} gutter={[16]}>
          <Col span={12} />
          <Col span={5} style={{ textAlign: "right", marginLeft: "1.6vw" }}>
            <Button
              style={{ width: "100%", height: "7.5vh", fontSize: "1.5em", fontWeight: "500", color: "#000", borderRadius: "5px" }}
              onClick={() => setShowReturnPurchase(false)}
              disabled={loader}
            >
              Cancel
            </Button>
          </Col>
          <Col span={5} style={{ textAlign: "right" }}>
            <Button
              style={{ width: "100%", height: "7.5vh", fontSize: "1.5em", fontWeight: "500", color: "#fff", background: "#2F3856", borderRadius: "5px" }}
              ref={returnProcessRef}
              disabled={modalEditState || loader}
              className="focusDashboardCard"
            >
              Confirm
            </Button>
          </Col>
        </Row>
      </Drawer>

      <Modal
        visible={showManualBatchPopup}
        centered
        width="26%"
        footer={null}
        closable={true}
        getContainer={false}
        zIndex={2000}
        onCancel={() => setShowManualBatchPopup(false)}
        bodyStyle={{
          padding: "28px",
          borderRadius: "12px",
          background: "#FFFFFF",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
          <div
            style={{
              fontSize: "1.1em",
              fontWeight: 600,
              fontFamily: "Inter",
              color: "#0F0718",
            }}
          >
            Enter Batch Number
          </div>

          <Input
            placeholder="Enter Batch No"
            value={manualBatchNo}
            onChange={(e) => setManualBatchNo(e.target.value)}
            onPressEnter={addManualBatchProduct}
            autoFocus
            style={{
              height: "42px",
              borderRadius: "8px",
              fontSize: "0.95em",
            }}
          />

          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "5px" }}>
            <Button
              onClick={addManualBatchProduct}
              style={{
                backgroundColor: "#273856",
                borderColor: "#273856",
                color: "#FFFFFF",
                height: "40px",
                padding: "0 20px",
                fontWeight: 500,
                fontSize: "0.9em",
                borderRadius: "8px",
              }}
            >
              Add to Cart
            </Button>
          </div>
        </div>
      </Modal>

      <Modal visible={showIRNModal} footer={null} closable={false} centered width={500} className="irn-status-modal">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "10px 0",
          }}
        >
          {/* Success Icon */}
          <div
            style={{
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              background: "#E8F7EE",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "16px",
            }}
          >
            <CheckCircleFilled
              style={{
                fontSize: "55px",
                color: "#52C41A",
              }}
            />
          </div>

          {/* Heading */}
          <div
            style={{
              fontSize: "22px",
              fontWeight: 500,
              marginBottom: "8px",
              textAlign: "center",
            }}
          >
            Order Completed Successfully
          </div>

          {/* Document Number */}
          <div
            style={{
              fontSize: "16px",
              color: "#8C8C8C",
              marginBottom: "30px",
            }}
          >
            {cart?.documentno}
          </div>

          {/* Status Container */}
          <div
            style={{
              width: "100%",
              background: "#FAFAFA",
              borderRadius: "12px",
              padding: "20px",
              border: "1px solid #F0F0F0",
            }}
          >
            {/* Invoice Processing */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                Invoice Processing
              </span>

              {invoiceProcessing === "SUCCESS" ? (
                <CheckCircleFilled
                  style={{
                    color: "#52C41A",
                    fontSize: "22px",
                  }}
                />
              ) : (
                <Spin />
              )}
            </div>

            {/* Invoice Printed */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                Invoice Printed
              </span>

              {invoicePrinted === "SUCCESS" ? (
                <CheckCircleFilled
                  style={{
                    color: "#52C41A",
                    fontSize: "22px",
                  }}
                />
              ) : (
                <Spin />
              )}
            </div>

            {/* IRN Generating */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                IRN Generating
              </span>

              {irnGenerating === "SUCCESS" ? (
                <CheckCircleFilled
                  style={{
                    color: "#52C41A",
                    fontSize: "22px",
                  }}
                />
              ) : irnGenerating === "FAILED" ? (
                <CloseCircleFilled
                  style={{
                    color: "#FF4D4F",
                    fontSize: "22px",
                  }}
                />
              ) : (
                <Spin />
              )}
            </div>

            {irnGenerating === "FAILED" && irnFailureMessage && (
              <div
                style={{
                  width: "100%",
                  marginTop: "-8px",
                  marginBottom: "20px",
                  padding: "12px",
                  background: "#FFF2F0",
                  border: "1px solid #FFCCC7",
                  borderRadius: "8px",
                  color: "#CF1322",
                  fontSize: "14px",
                  fontWeight: 500,
                  textAlign: "center",
                }}
              >
                {irnFailureMessage}
              </div>
            )}

            {/* IRN Download */}
            {/* <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                IRN Download
              </span>

              {irnDownloadReady === "SUCCESS" ? (
                <CheckCircleFilled
                  style={{
                    color: "#52C41A",
                    fontSize: "22px",
                  }}
                />
              ) : (
                <Spin />
              )}
            </div> */}
          </div>

          {/* IRN Number */}
          {irnNumber && (
            <div
              style={{
                marginTop: "25px",
                fontSize: "16px",
                fontWeight: 600,
                color: "#262626",
              }}
            >
              IRN Number : {irnNumber}
            </div>
          )}

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "16px",
              marginTop: "35px",
              width: "100%",
            }}
          >
            <Button
              size="large"
              style={{
                width: "160px",
                height: "45px",
                borderRadius: "10px",
              }}
              onClick={() => {
                setShowIRNModal(false);
                setPendingIRNOrderId(null);
              }}
            >
              Close
            </Button>

            <Button
              type="primary"
              size="large"
              disabled={!irnPdfUrl}
              style={{
                width: "200px",
                height: "45px",
                borderRadius: "10px",
                background: "#1677FF",
              }}
              onClick={() => {
                window.open(irnPdfUrl, "_blank");
                setPendingIRNOrderId(null);
              }}
            >
              Download IRN
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
// PointOfSale Component End

export default PointOfsaleCore;
